// http://stackoverflow.com/a/22564291/292787
if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

//the work around from https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, length) {
        length = length || this.length;
        return this.substr(length - searchString.length, searchString.length) === searchString;
    };
}

//the work around from https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        if (this == null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return i;
            }
        }
        return -1;
    };
}

//the work around from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }
  
        var to = Object(target);
  
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
  
          if (nextSource !== null && nextSource !== undefined) { 
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
}

Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
}

/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

// work around for the android virtual keyboard
function isAndroid() {
    return navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
}

function iOS() {
    return /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
}

function isMobileOrRipple() {
    return window.cordova || (window.parent && window.parent.ripple);
}

function getIosVersion(){
    /**
     * returns iOS version as array. for example, for iOS 6.1.6 returns ["6", "1", "6"]
     */
    return ((
        //"Mozilla/5.0 (iPod; CPU iPhone OS 6_1_6 like Mac OS X) AppleWebKit/536.26 (KHTML, like Gecko) Version/6.0 Mobile/10B500 Safari/8536.25"
        navigator.userAgent
        .match(/OS ((\d+_?){2,3})\s/)||[''])[0]
        .match(/((\d+_?){2,3})\s/)||[''])[0]
        .split('_');
}

function getIosVersionFloat() {
    /**
     * returns iOS version as float. for example, for iOS 6.1.6 returns 6.1
     */
    var iOsVersion = getIosVersion();
    return iOsVersion.length > 1 ? parseFloat(iOsVersion[0] + '.' + iOsVersion[1]) : -1;
}

function isLandscape() {
    if (window.orientation == undefined)
        return false;
    return window.orientation == 90 || window.orientation == -90;
}

function isPortrait() {
    if (window.orientation == undefined)
        return true;
    return window.orientation == 0 || window.orientation == 180;
}

// work around, details: http://getbootstrap.com/getting-started/#support-ie10-width
// Copyright 2014-2015 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
function getAndroidVersion(ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

function loadCss(url) {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.getElementsByTagName('head')[0].appendChild(link);
}

// http://stackoverflow.com/a/17907562/292787
function getInternetExplorerVersion() {
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    else if (navigator.appName == 'Netscape') {
        var ua = navigator.userAgent;
        var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    return rv;
}

var isIE = getInternetExplorerVersion() > 0;

// this function is necessary to avoid /../ in url
// the problem with /../ in url is that it can accumulate during navigation in cordova
// and produce urls like 'x-wmapp0:www/Pages/SignUp/../SignUp/../SignUp/../SignUp/../SignUp/../Welcome.html'
// after 10 transitions between SignUp and Welcome it stops to work completely and page can't be displayed
function getAbsoluteUrl(base, relative) {
    // remove everything after #
    var hashPosition = base.indexOf('#');
    if (hashPosition > 0) {
        base = base.slice(0, hashPosition);
    }

    // the rest of the function is taken from http://stackoverflow.com/a/14780463
    // http://stackoverflow.com/a/25833886 - this doesn't work in cordova
    // http://stackoverflow.com/a/14781678 - this doesn't work in cordova
    var stack = base.split("/"),
        parts = relative.split("/");
    stack.pop(); // remove current file name (or empty string)
    // (omit if "base" is the current folder without trailing slash)
    for (var i = 0; i < parts.length; i++) {
        if (parts[i] == ".")
            continue;
        if (parts[i] == "..")
            stack.pop();
        else
            stack.push(parts[i]);
    }
    return stack.join("/");
}

function isNumberFormatCorrect(numberStr) {
    // '^\.$' - '.'
    // '^(?=.+)(?:\d*)?(?:\.)?$' - '12.';
    // '^(?=.+)(?:\d*)?(?:\.\d+)?$' - '1' or '1.1' or '.3'
    var reg = /^\.$|^(?=.+)(?:\d*)?(?:\.)?$|^(?=.+)(?:\d*)?(?:\.\d+)?$/;
    return reg.test(numberStr);
}

function getPositiveAmountString(value){
    var amount = parseFloat(value);
    if(amount < 0) {
        amount = Math.abs(amount);
    }
    return amount.toFixed(2);
}

function documentWrite(data) {
    if (deviceIsWindowsPhone) {
        MSApp.execUnsafeLocalFunction(function () {
            document.writeln(data);
        });
    } else {
        document.write(data);
    }
}

var utilli = utilli || {};

utilli.getMaskedPhoneNumberValue = function (rawValue) {
    if (rawValue.length == 10) {
        // this fix is needed because there is a bug in input.mask function. see WGLCX-639.
        // the bug is that if rawValue length is 10 and the first character is '1' then it results in empty input.val()
        var countyCode = utilli.getCountryPhoneNumberCode();
        rawValue = countyCode + rawValue;
    }
    var input = $('<input>').val(rawValue);
    input.mask(Config.phoneNumberMask);
    var maskedPhoneNumber = input.val();
    return maskedPhoneNumber;
};

utilli.roles = {
    Administrator: 'Administrator',
    Agent: 'Agent',
    Assistant: 'Assistant',
    PropertyManager: 'PropertyManager',
    CSR: 'CSR',
    CSRAdmin: 'CSR-Admin',
    FieldServiceEngineer: 'FieldServiceEngineer',
    SystemUser: 'SystemUser',
    DataExporter: 'DataExporter',
    AdminManager: 'AdminManager',
    CashReceipt: 'CashReceipt'
}

utilli.paymentStatuses = {
    Successful: 0,
    FailedInPaymentGateway: 1,
    FailedInBackend: 2,
    Submitted: 3,
    FailedInBackendAndSubmittedToAch: 4,
    CanceledByAdmin: 5,
    Refunded: 6,
    Voided: 7,
    FailedByTimeout: 8,
    VoidFailedInBackend: 9,
    RefundFailedInBackend: 10,
    ChargebackSucceeded: 11,
    ChargebackFailed: 12,
    Created: 13,
    Failed: 14,
    NeededToVoid: 15
}

utilli.paymentMethods = {
    Card: 1,
    Check: 2,
    Btc: 3,
    Apple: 4,
    Google: 5
}

utilli.scrollTop = function() {
    $('.mainPageScroll').scrollTop(0);
};

utilli.scrollToFirstError = function() {
    var topElementOffset = Math.abs($('.restrict-width ').offset().top);
    var targetElementOffset = Math.abs($('.has-error:not(.ng-hide)').offset().top);
    var offset = topElementOffset - targetElementOffset;
    $('.mainPageScroll').scrollTop(offset);
};

/* scrolls current page to the bottom
 * @param delay - sometimes it's required to postpone scroll till content gets updated (rendered)
 */
utilli.scrollBottom = function (delay) {
    setTimeout(function() {
        $('.mainPageScroll').each(function (index, item) {
            //http://stackoverflow.com/a/270628
            $(item).scrollTop(item.scrollHeight);
        });
    }, delay);
};

utilli.clearLocalStorage = function () {
    //localStorage.removeItem('ApiUrl'); - do not remove! I need this for touch id
    //localStorage.removeItem('ServiceProviderName'); - do not remove! I need this for touch id
    //localStorage.removeItem('CurrentAccountNumber'); - do not remove! I need this for touch id
    localStorage.removeItem('BusinessPartner');
    //localStorage.removeItem('current_user'); - do not remove! I need this for touch id
    localStorage.removeItem('SecurityToken');
    localStorage.removeItem('email');
    localStorage.removeItem('CurrentUtilityType');
    localStorage.removeItem('currentAggregation');
    localStorage.removeItem('PropertyManager');
    localStorage.removeItem('PropertyManagerTour');
    localStorage.removeItem('PropertyManagerFirstTour');
};

utilli.aggregationTypes = {
    property: 'property',
    group: 'group'
}

utilli.addUserName = function (state, params) {
    params = params || {};
    params.userName = utilli.isAdmin ? state.params.userId :
        (params.userName ? params.userName : '');
    return params;
};

//return property or group object (depend on "Group View" or "Property View" was clicked)
utilli.getCurrentAggregation = function() { 
    var json = localStorage.getItem('currentAggregation');
    if (!json) 
        return null;
    return JSON.parse(json);
}

utilli.clearCurrentAggregation = function () { 
    localStorage.removeItem('currentAggregation')
}

utilli.getCurrentGroupId = function () {
    var aggregation = utilli.getCurrentAggregation();
    if (aggregation && aggregation.Type === 'group')
        return aggregation.Id;
    return null;
}

utilli.getCurrentPropertyId = function () {
    var aggregation = utilli.getCurrentAggregation();
    if (aggregation && aggregation.Type === 'property')
        return aggregation.Id;
    return null;
}

utilli.handleAjaxResponse = function (response, ModalServiceExt, successCallbackFn) {
    if (response == undefined || response.HasErrors == undefined) {
        ModalServiceExt.showServerError();
        return;
    }
    if (response.HasErrors) {
        ModalServiceExt.showError(response.Errors[0]);
    }
    else {
        if (successCallbackFn)
            successCallbackFn();
    }
};

utilli.downloadFile = function (apiUrl, fileName) {
    var link = document.createElement("a");
    link.href = apiUrl;
    link.style.visibility = false;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

//todo: remove, use utilli.validatePassword instead of this
utilli.isPasswordValid = function (userName, passwd, passwdConf, passwdMinLength) {
    if (!passwdMinLength)
        passwdMinLength = Config.passwdMinLength;
    var result = passwd
        && passwd.length >= passwdMinLength
        && utilli.hasDigits(passwd)
        && utilli.hasLetters(passwd)
        && passwd != userName;
    return result;
};

utilli.validatePassword = function (password, userName, passRequirements, paswdMinLength, oldPassword, minUserIdLength) {
    if(!minUserIdLength)
        minUserIdLength = 1;
    var requirement = findRequirementByName(passRequirements, 'PasswordLength');
    var passwordErrors = [];
    if (requirement && (!password || password.length < paswdMinLength))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'DigitsNumber')) && !utilli.hasDigits(password))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'NotCurrentPassword')) && oldPassword == password)
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'Letters'))
        && (!utilli.hasLowerCaseLetters(password) || !utilli.hasUpperCaseLetters(password)))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'SpecialSymbols')) && !utilli.hasSpecialSymbols(password))
        passwordErrors.push(requirement.ErrorText);
    if ((requirement = findRequirementByName(passRequirements, 'NotUserID')) && userName === password)
        passwordErrors.push(requirement.ErrorText);
    if (password !== userName && (requirement = findRequirementByName(passRequirements, 'NotContainUserID')) 
        && password && userName && minUserIdLength <= userName.length && password.indexOf(userName) !== -1) {
            passwordErrors.push(requirement.ErrorText);
        }
    return passwordErrors;
}

function findRequirementByName(list, key) {
    return _.find(list, function (item) { return item.Key === key; });
}

utilli.hasDigits = function(password) {
    return /\d/.test(password);
};

utilli.hasLowerCaseLetters = function (password) {
    return /[a-z]/.test(password);
};

utilli.hasUpperCaseLetters = function (password) {
    return /[A-Z]/.test(password);
};

utilli.hasLetters = function(password) {
    return /[a-zA-Z]/.test(password);
};

utilli.hasSpecialSymbols = function (password) {
    var regex = /[-!$%^&#*()_+|~=`{}\[\]:";'<>?,.\/@]/;
    var result = regex.test(password);
    return result;
};

utilli.getFileUrlWithToken = function(token) {
    var url = localStorage.getItem('ApiUrl') + 'api/GeneratedFiles/GetFile?token=' + token;
    return url;
};

utilli.emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
utilli.formatDecimal = function (decimal) {
    var formatted = Math.round(parseFloat(decimal) * 100) / 100;
    formatted = formatted.toString();
    if (formatted.indexOf('.') == -1) formatted += '.';
    while (formatted.length < formatted.indexOf('.') + 3)
        formatted += '0';
    return formatted;
}

utilli.hasAdminOrCsrRole = function (token) {
    if (!token) {
        token = localStorage.getItem('SecurityToken');
    }
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.Administrator || role === utilli.roles.CSRAdmin || role === utilli.roles.CSR;
    });

    return result;
};


utilli.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

utilli.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

utilli.setWindowLocation = function (url) {
    console.log('redirect to new url: ' + url);
    if (utilli.isSafari){
        //// https://stackoverflow.com/a/31223302/292787 - this fix stopped to work. maybe because of a safari update
        //setTimeout(function(){ document.location.href = url; }, 1);
        // new fix is based on a global flag disableNoConnectionPage. my understanding of the problem is that when we
        // change location.url then safari current ajax requests are terminated. we have an angular response error
        // interceptor (see responseInterceptor.responseError in utilliApp.js) that identifies ajax termination as 
        // absence of the internet connection and makes a redirect to the no connection page. in chrome this 
        // redirect to NoConnection page doesn't cancel original redirect that we did with location.href change. but
        // in safari it does cancel our redirect and lands user on NoConnection page. for example if admin user is 
        // logged in and opens the root page in a new tab then we redirect him to /admin/index.html but the user gets
        // landed on NoConnection page. the flag disableNoConnectionPage is used to cancel redirect to NoConnection 
        // page.
        window.disableNoConnectionPage = true;
    }
    document.location.href = url;
}

/**
 * Return true ONLY if it is mobile browser AND NOT cordova/ripple.
 */
utilli.isMobileBrowserNotCordova = function () {
    return utilli.isMobileBrowser() && !isMobileOrRipple();
}

/**
 * Returns true if it's mobile browser.
 * based on https://stackoverflow.com/a/11381730
 */
utilli.isMobileBrowser = function () {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * If user is already logged-in then redirect to the default page based on user role.
 * @param {} $state 
 * @returns {} true if redirect should happen
 */
utilli.goesToDefaultPage = function($state, setApiUrl) {
    var goToAdmin = function() {
        var adminUrl = utilli.getAdminUrl();
        utilli.setWindowLocation(adminUrl);
    }
    var token = localStorage.getItem('SecurityToken');
    if (token) {
        if (utilli.hasAdminOrCsrRole(token) || utilli.hasCashReceiptRole(token)) {
            // check if this is the customer view
            if (utilli.hasPropertyManagerRole()) {
                $state.goMainLayout('PropertyList');
                return true;
            }
            if (setApiUrl){
                setApiUrl(goToAdmin);
            }
            else{
                goToAdmin();
            }
        }
        else if (utilli.hasAgentRole())
            $state.goMainLayout('Search');
        else if (utilli.hasPropertyManagerRole())
            $state.goMainLayout('PropertyList');
        else if (utilli.hasFieldServiceEngineerRole())
            $state.goMainLayout('WorkCenters');
        else
            $state.goMainLayout('Dashboard');
        return true;
    }
    return false;
}

utilli.getAdminUrl = function () {
    var adminUrl = window.location.origin + window.location.pathname;
    if(isMobileOrRipple()) {
        var indexOfIndex = adminUrl.indexOf('index.html');
        if (indexOfIndex > 0) {
            adminUrl = adminUrl.substr(0, indexOfIndex);
        }
        adminUrl = adminUrl + 'Admin/index.html/#/';
    }
    else {
        adminUrl = adminUrl.endsWith("index.html") ? adminUrl + '/' : adminUrl;
        adminUrl = adminUrl + 'Admin/#/';
    }
    return adminUrl;
}

utilli.getRootUrl = function() {
    // to make it work on http://localhost/utilli
    var pathname = window.location.pathname;
    var index = pathname.indexOf("Admin");
    pathname = index >= 0 ? pathname.substring(0, index) : pathname;
    var rootUrl = window.location.origin + pathname;
    return rootUrl;
}

utilli.hasAgentRole = function (token) {
    return utilli.hasRole(utilli.roles.Agent, token);
}

utilli.hasAssistantRole = function (token) {
    return utilli.hasRole(utilli.roles.Assistant, token);
}

utilli.notAgentOrAssistant = function (token) {
    return !utilli.hasAgentRole(token) && !utilli.hasAssistantRole(token);
}

utilli.hasPropertyManagerRole = function (token) {
    if (!token)
        token = localStorage.getItem('SecurityToken');
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.PropertyManager;
    });

    if (!result && utilli.isAdmin) {
        var value = localStorage.getItem('PropertyManager');
        if (value)
            result = true;
    }

    return result;
}

utilli.hasDataExporterRole = function (token) {
    return utilli.hasRole(utilli.roles.DataExporter, token);
};

utilli.hasCashReceiptRole = function (token) {
    return utilli.hasRole(utilli.roles.CashReceipt, token);
};

utilli.hasAdminManagerRole = function (token) {
    return utilli.hasRole(utilli.roles.AdminManager, token) || utilli.hasRole(utilli.roles.Administrator, token);
};

utilli.hasAdminRole = function (token) {
    if (!token) {
        token = localStorage.getItem('SecurityToken');
    }
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;

    var result = _.some(payload.roles, function (role) {
        return role === utilli.roles.Administrator || role === utilli.roles.CSRAdmin;
    });

    return result;
};

utilli.hasCsrAdminRole = function (token) {
    return utilli.hasRole(utilli.roles.CSRAdmin, token);
};

utilli.hasSuperAdminRole = function (token) {
    return utilli.hasRole(utilli.roles.Administrator, token);
};

utilli.hasFieldServiceEngineerRole = function (token) {
    if (!token)
        token = localStorage.getItem('SecurityToken');

    return utilli.hasRole(utilli.roles.FieldServiceEngineer, token);
};

utilli.hasRole = function(role, token){
    if (!token)
        token = localStorage.getItem("SecurityToken");
    var payload = utilli.getPayload(token);
    if (!payload)
        return false;
    var result = _.some(payload.roles, function (r) {
        return r === role;
    });
    return result;
}

utilli.isDemo = function() {
    return DeploymentSettings.deploymentEnvironment === "Demo"
    || DeploymentSettings.deploymentEnvironment === "Demo2"
    || DeploymentSettings.deploymentEnvironment === "Debug"
    || DeploymentSettings.deploymentEnvironment === "Dev";
}

utilli.getCurrentUserName = function () {
    var token = localStorage.getItem("SecurityToken");
    var payload = utilli.getPayload(token);
    if (!payload)
        return null;

    return payload.userName;
}

utilli.getPayload = function(token) {
    if (!token)
        return null;

    var parts = token.split('.');
    var encoded = parts[1];
    // I don't know what the next line of code does but it fixes WGLCX-684. I just copy pasted it from :
    // https://github.com/auth0/jwt-decode/blob/master/lib/base64_url_decode.js
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/");
    var json = atob(encoded);
    var payload = JSON.parse(json);
    return payload;
}

/* returns cell phone number that starts with 1 and has 11 digits.
* @param maskPhoneNumber - 10 digit cell phone number extracted from ui-mask
*/
utilli.getFullPhoneNumber = function(maskPhoneNumber) {
    return Config.phoneNumberMask[1] + maskPhoneNumber;
}

utilli.registerGoogleAnalytics = function(win, rootScope, location) {
    if (!win || !win.ga || !rootScope || !location) return;
    win.ga('create', 'UA-91827657-1', 'auto');
    var isMobile = isMobileOrRipple();
    if (isMobile) {
        // http://stackoverflow.com/a/35057298/292787
        win.ga('set', 'checkProtocolTask', function () { });
    }
    win.ga('set', 'dimension1', DeploymentSettings.currentServiceProvider);// ServiceProvider
    win.ga('set', 'dimension2', DeploymentSettings.deploymentEnvironment);// DeploymentEnvironment
    win.ga('set', 'dimension3', isMobile ? 'mobile' : 'web');// ClientType
    rootScope.$on('$stateChangeSuccess', function (event) {
        var relativeUrl = utilli.isAdmin ? '/Admin/#' + location.path() : '/#' + location.path();
        win.ga('send', 'pageview', relativeUrl);
    });
}

// initialize so that utilli.localizationDictionary[key] will not fail with undefined error
utilli.localizationDictionary = {};

utilli.isLanguagePackEnabled = function() {
    if(window.location.href.indexOf("WelcomeAgent") !== -1)
    {
        // no languages for Agents Welcome
        return false;
    }

    if(window.location.href.indexOf("/Admin") !== -1)
    {
        // no languages for Admins
        return false;
    }

    if (isMobileOrRipple())
        return Config.enableLanguagePack;

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        var enableLanguagePack = Config.providers[DeploymentSettings.currentServiceProvider].EnableLanguagePack;
        return enableLanguagePack;
    }

    return false;
}

function getCurrentLanguage() {

    if (utilli.isLanguagePackEnabled()) {
        var language = localStorage.getItem('language');
        console.log('language: ' + language);
        if (utilli.checkDefinedValue(language))
            return language;
    }

    return 'en';
}

utilli.registerLocalization = function (rootScope, resource) {

    var language = getCurrentLanguage();
    localStorage.setItem('language', language);
    utilli.changeLanguage(resource, language);
    rootScope._t = utilli._t;
}

utilli._t = function (key) {
    var localized = utilli.localizationDictionary[key];
    return localized ? localized : key;
};


utilli.maxExcelRows = 1048576;// max number of rows that Excel can have
utilli.maxExcelRowsWithoutHeader = utilli.maxExcelRows - 1;
utilli.maxExcelRowsErrorMessage = utilli._t("Excel file cannot have more than %maxExcelRows% rows." +
    " Please reduce the number of records for export by applying filters.")
    .replace('%maxExcelRows%', utilli.maxExcelRowsWithoutHeader);

utilli.checkDefinedValue = function (value) {
    if (value === null || value === 'null' || value === 'undefined' || value === undefined || value === '')
        return false;
    return true;
}

utilli.changeLanguage = function (resource, language, callback) {
    console.log('changeLanguage() language: ' + language);
    if (!utilli.isLanguagePackEnabled())
        return;
    if (!utilli.checkDefinedValue(language))
        language = 'en';
    var filePath = 'languages/' + language + '.json' + DeploymentSettings.currentVersion;
    if (utilli.isAdmin)
        filePath = '../' + filePath;
    resource(filePath).get(function (data) {
        utilli.localizationDictionary = data;

        var _t = utilli._t;

        utilli.errors.serverErrorMessage = _t('Server error. Try again later.');
        utilli.errors.validationErorrsMessage = _t('Please correct your information.');

        localStorage.setItem('language', language);

        var urlPrefixKendoLib = '';
        if(utilli.isAdmin)
        {
            urlPrefixKendoLib = '../';
        }   
        if(!utilli.isWglcxPortal()) {
            if(language == 'en') {
                $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.en-US.min.js", function () {});
                kendo.culture('en-US'); 
            }
            else if (language == 'es') {      
                $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.es-US.min.js", function () {}); 
                kendo.culture('es-US');
            }
            else  if(language == 'ko') {   
                $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.ko-KR.min.js", function () {});
                kendo.culture('ko-KR');  
            }
            else  if(language == 'zh') {   
                $.getScript(urlPrefixKendoLib + "libs/kendo/Languages/kendo.messages.zh-CN.min.js", function () {});
                kendo.culture('zh-CN');
            }
        }

        if (callback)
            callback(language);
    });
}

//English - English
//Espanol - Spanish
//Deutsch - German
//Русский - Russian
//සිංහල - Sinhalese
//中文 - Chinese
//नहीं - Hindi

//utilli.languages = [
//    { name: 'English', abbreviation: 'en' },
//    { name: 'Espanol (Spanish)', abbreviation: 'es' },
//    { name: 'Français (French)', abbreviation: 'fr' },
//    { name: 'Deutsch (German)', abbreviation: 'de' },
//    { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
//    { name: '中文 (Chinese)', abbreviation: 'zh' },
//    { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
//    { name: 'Afrikaans', abbreviation: 'af' },
//    { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
//    { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
//    { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
//    { name: 'मराठी (Marathi)', abbreviation: 'mr' },
//    { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
//    { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
//    { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
//    { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
//    { name: 'Русский (Russian)', abbreviation: 'ru' } ];

utilli.languages = {
    "wgl": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' }
    ],
    "px": [
        { name: 'English', abbreviation: 'en' },
    ],
    "gni": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: 'Français (French)', abbreviation: 'fr' },
        { name: 'Deutsch (German)', abbreviation: 'de' },
        { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
        { name: '中文 (Chinese)', abbreviation: 'zh' },
        { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
        { name: 'Afrikaans', abbreviation: 'af' },
        { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
        { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
        { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
        { name: 'मराठी (Marathi)', abbreviation: 'mr' },
        { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
        { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
        { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
        { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
        { name: '조선말ة‎‎ (Korean)', abbreviation: 'ko' },
        { name: 'Беларуская мова (Belarusian)', abbreviation: 'be' },
        { name: 'Русский (Russian)', abbreviation: 'ru' }
    ],

    "demo": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: 'Français (French)', abbreviation: 'fr' },
        { name: 'Deutsch (German)', abbreviation: 'de' },
        { name: 'සිංහල (Sinhalese)', abbreviation: 'si' },
        { name: '中文 (Chinese)', abbreviation: 'zh' },
        { name: 'Nederlands (Dutch)', abbreviation: 'nl' },
        { name: 'Afrikaans', abbreviation: 'af' },
        { name: 'हिन्दी (Hindi)', abbreviation: 'hi' },
        { name: 'ગુજરાતી (Gujarati)', abbreviation: 'gu' },
        { name: 'ಕನ್ನಡ (Kannada)', abbreviation: 'kn' },
        { name: 'मराठी (Marathi)', abbreviation: 'mr' },
        { name: 'ਪੰਜਾਬੀ (Punjabi)', abbreviation: 'pa' },
        { name: 'தமிழ் (Tamil)', abbreviation: 'ta' },
        { name: 'తెలుగు (Telugu)', abbreviation: 'te' },
        { name: 'العَرَبِيَّة‎‎ (Arabic)', abbreviation: 'ar' },
        { name: '조선말ة‎‎ (Korean)', abbreviation: 'ko' },
        { name: 'Беларуская мова (Belarusian)', abbreviation: 'be' },
        { name: 'Русский (Russian)', abbreviation: 'ru' }
    ],

    "hc": [
        { name: 'English', abbreviation: 'en' },
        { name: 'Espanol (Spanish)', abbreviation: 'es' },
        { name: '조선말ة‎‎ (Korean)', abbreviation: 'ko' },
        { name: '中文 (Chinese)', abbreviation: 'zh' }
    ]
};

utilli.getCountryPhoneNumberCode = function () {
    return Config.phoneNumberMask[1]; // +1 999... -> 1 or +7 999 ... -> 7
};

utilli.datePickerOptions = {
    formatYear: 'yyyy',
    startingDay: 1,
    showWeeks: false
};

utilli.isAuthorized = function () {
    if (localStorage.getItem('SecurityToken'))
        return true;
    return false;
}

utilli.errors = {
    serverErrorMessage: utilli._t('Server error. Try again later.'),
    validationErorrsMessage: utilli._t('Please correct your information.')
};

utilli.getApplicationService  = function (serviceName) {
    var elem = angular.element(document.querySelector('[ng-app]'));
    var injector = elem.injector();
    var result = injector.get(serviceName);
    return result;
}

utilli.mobilePlatforms = {
    unknown: 'Unknown',
    android: 'Android',
    iOs: 'IOs',
    windowsPhone: 'WindowsPhone',
}

utilli.getPlatformName = function () {
    var result = utilli.mobilePlatforms.unknown;
    if(deviceIsWindowsPhone)
        result = utilli.mobilePlatforms.windowsPhone;
    else if(isAndroid())
        result = utilli.mobilePlatforms.android;
    else if(iOS())
        result = utilli.mobilePlatforms.iOs;
    return result;
}

/**
 * Formats number to be displayed on UI.
 * For example, in US we need separate thousands with comma and have 2 fraction digits
 * @param {} num a number that needs to be presented as a string
 * @returns {} formatted string
 */
utilli.formatNumber = function(num) {
    return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/**
 * Same as formatNumber but for currency - with leading $ and minimum 2 decimal places
 * @param {float} num a number that needs to be presented as currency
 */
utilli.formatCurrency = function(num){
    if (num == null || num === '')
        return 'N/A';
    if (typeof(num) === 'string')
        num = Number(num);
    return '$ ' + num.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}

/**
 * Removes float numbers after the second number.
 * For example, 0.123 -> 0.12
 * @param {} num a number that needs to be changed
 * @returns {} trimmed value
 */
utilli.trimFloat2 = function (num) {
    return parseFloat((num).toFixed(2));;
}

utilli.localStorageItemNotNull =  function (name) {
    var item = localStorage.getItem(name);
    var result = item != null && item != "null";
    return result;
}

/**
 * Returns positive number or zero.
 * Returns zero for NaNs, undefined, etc.
 * @param {string} num number
 */
utilli.parsePositiveFloat = function (num){
    var parsed = parseFloat(num);
    return parsed > 0 ? parsed : 0;
}

/**
 * timeout value in ms for refreshing Energy Star status
 */
utilli.propertyRefreshTimeout = 5 * 1000; // 5 sec

utilli.getCurrentProviderConfigValue = function (key, defaultValue) {
    if (!DeploymentSettings.currentServiceProvider || DeploymentSettings.currentServiceProvider.length === 0
        || !Config.providers[DeploymentSettings.currentServiceProvider][key])
        return defaultValue;
    return Config.providers[DeploymentSettings.currentServiceProvider][key];
}

utilli.getHelpEmail = function () {
    return utilli.getCurrentProviderConfigValue("HelpEmail", "help@utilli.com");
}

utilli.getSupportPhoneNumber = function () {
    return utilli.getCurrentProviderConfigValue("SupportPhoneNumber", "330-701-8398");
}

utilli.isPropertyManagerApp = function () {
    return DeploymentSettings.providersGroupShortName && 
        (DeploymentSettings.providersGroupShortName.toUpperCase() === 'WGL' || DeploymentSettings.providersGroupShortName.toUpperCase() === 'PX');
}

utilli.isPx = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() === 'PX';
}

utilli.isWglcx = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() 
    === Config.wglcxProviderName.toUpperCase();
}

utilli.isWglcxPortal = function () { 
    var result = utilli.isWglcx && !isMobileOrRipple();
    return result;
}

utilli.getQuickPayName = function (){
    var quickPayName = utilli.isWglcx() ? 'SmartPay' : utilli._t('Login Page QuickPay');
    return quickPayName;
}

utilli.isHc = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() === 'HC';
}

utilli.isGni = function () {
    return DeploymentSettings.providersGroupShortName && DeploymentSettings.providersGroupShortName.toUpperCase() === 'GNI';
}

utilli.adjustPhoneNumber = function (phoneNumber) {
    if (!phoneNumber)
        return null;

    if (phoneNumber.length > Config.phoneNumberLengthWithoutCountryCode)
        return phoneNumber.substr(Config.countryCodeLength);

    return phoneNumber;
}

utilli.fixSelectElementForMobile = function  () {
    // this hack fixes a select element behavior in mobile (changing selected options).
    var allSelectElements = document.getElementsByTagName('select');
    for (var i = 0; i < allSelectElements.length; i++) {
        allSelectElements[i].addEventListener('touchstart', function (e) {
            //This is the important line
            e.stopPropagation();
        }, false);
    }
}

utilli.clientEnum = {
    mobileApp: 1,
    portal: 2
};

utilli.pm = {
    meterErrorCodes: {
        serviceAddressMismatch: 3
    }
};

utilli.getStateNameWithoutLayout = function (fullStateName) {
    var index = fullStateName.indexOf('.');
    var state = '';
    if (index >= 0)
        state = fullStateName.substr(index + 1);
    else
        state = fullStateName;
    return state;
}

utilli.togglePasswordVisibility = function (pswId, iconId) {
    var elemPassword = $('#' + pswId);
    if (elemPassword.attr('type') === 'password')
        elemPassword.attr('type', 'text');
    else
        elemPassword.attr('type', 'password');

    $('#' + iconId).toggleClass('glyphicon-eye-close').toggleClass('glyphicon-eye-open');
}

utilli.getStringForComparison = function (source) {
    //https://stackoverflow.com/questions/3286874/remove-all-multiple-spaces-in-javascript-and-replace-with-single-space?answertab=votes#tab-top
    var result = source.toUpperCase().replace(/ +(?= )/g,'');
    return result;
}

utilli.notificationTypes = {
    sms: 1,
    email: 2,
    smsAndEmail: 3
}

utilli.paymentTypes = {
    card: 1,
    check: 2
}

utilli.hideColumnByTitle = function (grid, fieldName) {
    for (var i = 0; i < grid.columns.length; i++){
        if (grid.columns[i].title == fieldName){
            grid.hideColumn(i);
            return;
        }
    }
}

utilli.arePhoneNumbersEqual = function (phone1, phone2){
    return utilli.adjustPhoneNumber(phone1) == utilli.adjustPhoneNumber(phone2);
}

utilli.emptyAccountStatus = '--'

utilli.fillAccountStatuses = function(accountInfo) {
    var result = [];
    if(accountInfo.Tax && accountInfo.Tax != utilli.emptyAccountStatus)
        result.push(accountInfo.Tax);
    if(accountInfo.CheckStatus && accountInfo.CheckStatus != utilli.emptyAccountStatus)
        result.push(accountInfo.CheckStatus);
    if(accountInfo.HardshipIndicator && accountInfo.HardshipIndicator != utilli.emptyAccountStatus)
        result.push(accountInfo.HardshipIndicator);
    if(accountInfo.MeterStatus && accountInfo.MeterStatus != utilli.emptyAccountStatus 
        && accountInfo.MeterStatus != '06')// 06 - Active. i think that there is no need to show Active status
        result.push(accountInfo.MeterStatusDescription);
    if(accountInfo.CashOnlyCustomer && accountInfo.CashOnlyCustomer != utilli.emptyAccountStatus)
        result.push(accountInfo.CashOnlyCustomer);
    return result;
}

utilli.getDateWithoutTime = function (dateTime){
    dateTime = dateTime || new Date();
    return new Date(dateTime.setHours(0,0,0,0));
}

utilli.hcMeterStatuses = {
    notInstalled: "01",
    installedRelevantToTech: "02",
    allocatedToInstallation: "03",
    meterDisconnected: "04",
    inActive: "05",
    active: "06"
}
utilli.yearMonthToString = function(yearMonth){
    return yearMonth.toString().substring(0, 4) + '-' + yearMonth.toString().substring(4, 6);
}

utilli.getDateWithoutTime = function (dateTime){
    dateTime = dateTime || new Date();
    return new Date(dateTime.setHours(0,0,0,0));
}

utilli.templateTypes = {
    emailTemplate: 'Email',
    smsTemplate: 'Sms'
}

utilli.getCurrentUserName = function () {
    var result = utilli.getPayload(localStorage.getItem('SecurityToken')).userName;
    return result;
}

utilli.savePayUrl = function(token){
    if (!token){
        return;
    }
    var tokenPayload = utilli.getPayload(token);
    if (tokenPayload.PayUrl) {
        localStorage.setItem('PayUrl', tokenPayload.PayUrl);
    }
    else{
        localStorage.removeItem('PayUrl');
    }
}

/**
 * The function is used to save current grid parameters into the page URL and later restore page parameters from the URL.
 * @param {*} $location AngularJs location service is used to save 'path' param into the URL of the current page.
 * @param {*} webapi Kendo webapi object is used to do mapping of grid options to parameters that are compatible with
 * dotnet backend.
 * @param {*} options Kendo options with current filters/sorts that are passed to the data loading function.
 * @param {*} grid Kendo grid.
 */
utilli.getGridParameters = function ($location, webapi, options, grid) {
    var params = webapi.parameterMap(options.data);
    var isFirstLoad = !grid.initialParams;
    if (isFirstLoad) {
        // save initial grid parameters. Later it will allow to understand that the gird is in initial state
        // and remove serialized filter from the URL
        grid.initialParams = Object.assign({}, params);
        // if we are loading the first page of the grid then we need to check 'path' param in the current URL.
        var filterString = $location.search()['path'];
        if (filterString) {
            // if the 'path' param exists then use this saved filtering for the grid loading
            params = JSON.parse(decodeURI(filterString), dateReviver);
            if (grid && params.pathFilter) {
                // grid.dataSource.filter with params.pathFilter param will trigger another grid reload that will be
                // put into a queue by kendo. without this reload the grid will not render saved filters on top of the
                // grid
                grid.dataSource.query({ 
                    filter: params.pathFilter,
                    sort: params.pathSort,
                    page: params.page,
                    pageSize: params.pageSize 
                });
                // options.success below completes the current grid loading. if options.success is not called
                // then grid continues to spin its spinner and doesn't proceed to the next queued reload.
                options.success({ PageData: [], Count: 0 });
                // return null as a flag to stop data loading because the grid will be reloaded.
                return null;
            }
        }
    }
    else {
        // if the gird is in the initial state then remove the serialized filter from the URL
        var initialParams = grid.initialParams;
        if (initialParams && initialParams.sort === params.sort && initialParams.page === params.page 
            && initialParams.pageSize === params.pageSize && initialParams.filter === params.filter 
            && initialParams.group === params.group) {
            $location.search('path', null);
        }
        else {
            // if the grid is not in the initial state and we are loading not the first page then we need to just save 
            // params to the URL path param.
            // the code below saves the current filter object into the pathFilter field so that it will be possible to 
            // use it later when the page will be reloaded or navigated back/forth.
            params.pathFilter = grid.dataSource.filter();
            params.pathSort = grid.dataSource.sort();
            $location.search('path', encodeURI(JSON.stringify(params)));
        }
    }
    return params;
}

function isString( value ) {
    return({}.toString.call(value) === "[object String]");
}
function isSerializedDate( value ) {
    // Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
    var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return (isString(value) && datePattern.test(value));
}

function dateReviver( key, value ) {
    if (isSerializedDate(value)) {
        return(new Date(value));
    }
    // If it's not a date-string, we want to return the value as-is. If we fail to return
    // a value, it will be omitted from the resultant data structure.
    return (value);
}

utilli._currentServiceProviderDeffered = jQuery.Deferred();

utilli.resolveServiceProviderApiDeffered = function (apiUrl) { 
    utilli._currentServiceProviderDeffered.resolve(apiUrl);
}

utilli.rejectServiceProviderApiDeffered = function (e) { 
    utilli._currentServiceProviderDeffered.reject(e);
}

utilli.getServiceProviderApiDeffered = function () { 
    return utilli._currentServiceProviderDeffered.promise();
}

utilli.getUrlParameter = function getUrlParameter(p) {
    var pageURL = window.location.hash.substring(1),
        urlVariables = pageURL.split('&'),
        parameterName,
        i;

    for (i = 0; i < urlVariables.length; i++) {
        parameterName = urlVariables[i].split('=');

        if (parameterName[0] === p) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
};

utilli.getSafariPushNotificationPermissionData = function () {
    var permissionData = utilli.isSafari 
        ? window.safari.pushNotification.permission('web.com.utilli.mobile')
        : null;
    return permissionData;
}

utilli.checkSafariRemotePermission = function ($scope, apiUrl, authToken) {
    var pd = utilli.getSafariPushNotificationPermissionData();
    var checkFn = function (permissionData) {
        if (permissionData.permission === 'default') {
            // This is a new web service URL and its validity is unknown.
            window.safari.pushNotification.requestPermission(
                apiUrl.slice(0, -1), // The web service URL.
                'web.com.utilli.mobile',     // The Website Push ID.
                {
                    "token": authToken
                }, // Data that you choose to send to your server to help you identify the user.
                checkFn         // The callback function.
            );
        }
        else if (permissionData.permission === 'denied') {
            // The user said no.
        }
        else if (permissionData.permission === 'granted') {
            $scope.$apply();
            console.log('we have a device token')
        }
    }
    checkFn(pd);
}

utilli.blankEmailTemplate = {
    "page": {
      "title": "",
      "description": "",
      "template": {
        "name": "template-base",
        "type": "basic",
        "version": "0.0.1"
      },
      "body": {
        "type": "mailup-bee-page-proprerties",
        "container": {
          "style": {
            "background-color": "#FFFFFF"
          }
        },
        "content": {
          "style": {
            "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
            "color": "#000000"
          },
          "computedStyle": {
            "linkColor": "#0068A5",
            "messageBackgroundColor": "transparent",
            "messageWidth": "500px"
          }
        }
      },
      "rows": [
        {
          "type": "one-column-empty",
          "container": {
            "style": {
              "background-color": "transparent"
            }
          },
          "content": {
            "style": {
              "background-color": "transparent",
              "color": "#000000",
              "width": "500px"
            }
          },
          "columns": [
            {
              "grid-columns": 12,
              "modules": [
                {
                  "type": "mailup-bee-newsletter-modules-empty",
                  "descriptor": {}
                }
              ],
              "style": {
                "background-color": "transparent",
                "padding-top": "5px",
                "padding-right": "0px",
                "padding-bottom": "5px",
                "padding-left": "0px",
                "border-top": "0px dotted transparent",
                "border-right": "0px dotted transparent",
                "border-bottom": "0px dotted transparent",
                "border-left": "0px dotted transparent"
              }
            }
          ]
        }
      ]
    }
};
$(function() {
    var thresholdIosVersion = 6;
    var allInputCssSelectors = 'input[type="text"]:not([readonly]),input[type="number"]:not([readonly]),input[type="password"]:not([readonly]),input[type="email"]:not([readonly]),input[type="tel"]:not([readonly]), textarea:not([readonly])';
    var allInputAndSelectCssSelectors = allInputCssSelectors + ', select:not([readonly])';
    var handleOrientationChange = function(){
        window.onorientationchange = function () {
            if ($(allInputCssSelectors).is(':focus'))
                setTimeout(fixHeight, 900); //Need at least 800 milliseconds
        }
    }
    if (isAndroid()) {
        $(document).on('focus', allInputCssSelectors, fixHeight);
        $(document).on('focusout', allInputCssSelectors, resetHeightFix);
        handleOrientationChange();
    }

    if (iOS()) {
        // for new iOS we apply the fix only when the keyboard is opened
        // but for old iOS we apply the fix permanently
        if (getIosVersionFloat() > thresholdIosVersion) {
            handleOrientationChange();
            $(document).on('focus', allInputAndSelectCssSelectors, function () {
                //applyTopMenuFix(); // i think that after the last iOS update this fix doesn't change anything
                fixHeight.call(this);
            });
            $(document).on('focusout', allInputCssSelectors, resetHeightFix);
            $(document).on('blur', allInputAndSelectCssSelectors, function () {
                var topMenuElement = getTopMenu();
                topMenuElement.css({
                    'position': '',
                    'top': ''
                });
                var bottomMenuElement = getBottomMenu();
                bottomMenuElement.css({
                    'position': '',
                    'top': ''
                });
            });
        }
        else {
            applyTopMenuFix();
        }
    }

    function getTopMenu() {
        return $('.navbar.navbar-fixed-top');
    }

    function getBottomMenu() {
        return $('.navbar.navbar-fixed-bottom');
    }

    /**
     * changes position CSS of the top menu to absolute to avoid issues on iPhone when keyboard is opened
     */
    function applyTopMenuFix(){
        var topMenuElements = getTopMenu();
        topMenuElements.css({
            'position': 'absolute',
            'top': '0'
        });
        var bottomMenuElement = getBottomMenu();
        bottomMenuElement.css({
            'position': 'absolute',
            'top': document.height - getBottomMenu().height() + 'px'
        });
    }

    function fixHeight() {
        var me = this;
        if (me.id){
            // if there is a label for the input then scroll to the label
            var labels = $('label[for^="' + me.id + '"]');
            var scrollToElement = labels.length > 0 ? labels[0] : me;
        }
        // wrap it in a timeout so that if a user goes from one input into another
        // then first focus-out is fired with it's own timeout
        // later focus is fired with a timeout that is bigger than the one that is set in focus-out.
        // this is why here the timeout value is 10, while in resetHeightFix the timeout value is 1,
        // it is to ensure that the code in fixHeight will be executed after the code in resetHeightFix
        setTimeout(function(){
            var element = $('.main-ui-view');
            if ($('#virtualKeyboardPlace').length == 0)
                element.append('<div id="virtualKeyboardPlace"><div>');
            $('#virtualKeyboardPlace').height(getHeightKeyboardPlace());
            // scroll current element to the top of the page
            if (scrollToElement)
                scrollToElement.scrollIntoView(true);
            // move scroll so that current element will be below the top menu
            var topMenuHeight = getTopMenu().height();
            $('body').scrollTop($('body').scrollTop() - topMenuHeight);
        }, 10);
    }

    function resetHeightFix() {
        // wrap it in a timeout so that if a user presses a button then button click will fire first
        setTimeout(function(){
            $('#virtualKeyboardPlace').height(0);
        }, 1);
    }

    function getHeightKeyboardPlace() {
        var result = 1;
        if(iOS() && getIosVersionFloat() > thresholdIosVersion) 
            return result;
        if (isLandscape())
            result = $('html').height() * 0.6;
        if (isPortrait())
            result = $('html').height() * 0.5;
        return result;
    }
});
function hideSplashScreen(){
    if (navigator.splashscreen) {
        if (parseFloat(getAndroidVersion()) > 4.3)
        {
            // for android 4.4+ splashscreen plugin switches app to just full-screen mode while we want immersiveMode.
            // immersiveMode avoids the top system bar to appear when keyboard is active
            AndroidFullScreen.immersiveMode(function () {
                console.log("switched to immersiveMode");
            }, function () {
                console.log("failed to switch to immersiveMode");
            });
        }
        navigator.splashscreen.hide();
    }
}

var utilli = utilli || {};

utilli.createResendTimer = function ($scope) {
    var timer = {};

    timer.isResendTimerVisible = function () {
        return timer.canShowTimer && !timer.sendSmsCodeError;
    }

    var tickTimer = function () {
        if (timer.timeout != 0) {
            timer.timeout--;
            setTimeout(tickTimer, 1000);
        } else {
            timer.canRequestVerificationCode = true;
            timer.canShowTimer = false;
            if($scope != undefined && !$scope.$$phase) //https://stackoverflow.com/a/12859093/6160271
                $scope.$apply();
            return;
        }

        var secInMinute = 60;
        timer.canShowTimer = true;
        timer.timeoutStr = '' + (timer.timeout % secInMinute); //60 seconds in 1 minute
        if (timer.timeoutStr.length < 2) {
            timer.timeoutStr = '0' + timer.timeoutStr;
        }
        timer.timeoutStrMinutes = '' + Math.floor(timer.timeout / secInMinute);
        if (timer.timeoutStrMinutes.length < 1) {
            timer.timeoutStrMinutes = '0';
        }
        if($scope != undefined && !$scope.$$phase) //https://stackoverflow.com/a/12859093/6160271
            $scope.$apply();
    }

    timer.startSmsConfirmationTimer = function startSmsConfirmationTimer (remainedTime) {
        if(remainedTime)
            timer.timeout = remainedTime;
        else
            timer.timeout = 31;

        tickTimer();
    }

    return timer;
}
'use strict';
/* Global configuration settings */
if (!window.Config) {

    localStorage.setItem('CurrentUtilityType', 'Electricity'); // this is for demo for PX

    window.Config =
    {
        version: "0.4.1",
        Debug: false,
        serverErrorMsg: "Service unavailable, please try again later.",
        consumptionUnits: {
            // numbers mean multipliers on which consumption must be multiplied
            // to get consumption in that units.
            // CCF: 1 means that we get consumption from the backend in CCFs
            // and do not need to multiply anything to show consumption in CCFs
            // Gallons: 748.05 means that we get consumption from the backend in CCFs
            // and need to multiply it by 748.05 to show consumption in Gallons
            Water: { CCF: 1, Gallons: 748.05 },
            Electricity: { kWh: 1 },
            Gas: { MCF: 1, CCF: 10, Therms: 10.28 }
        },
        /**
         * Gets consumption units that are currently configured
         */
        getCurrentConsumptionUnits: function() {
            var utilliType = localStorage.getItem('CurrentUtilityType');
            utilliType = !utilliType || utilliType === 'null' || utilliType === 'undefined' ? "Gas" : utilliType;
            return Config.consumptionUnits[utilliType];
        },
        /**
         * Gets multiplier for the specified consumption unit
         */
        getConsumptionUnitFraction: function(unitsType) {
            return Config.getCurrentConsumptionUnits()[unitsType];
        },
        /**
         * If false, hide the View button and the Understand Your Bill button.
         */
        enableBillDownload: true,
        smallConvenienceFee: 2.95,
        largeConvenienceFee: 12.95,
        largeConvenienceFeeBorder: 600,

        phoneNumberMask: "+1 (999) 999-9999",
        contractAccountMask: "999999999999",
        phoneNumberLengthWithoutCountryCode: 10,
        countryCodeLength: 1,
        ccNumberMask: "9999 9999 9999? 9999 999",
        contractAccountMaxLength: 12,
        passwdMinLength: 8,

        zipCodeRegexp: /^(\d{5})?$|^$|^(\d{5}-\d{4})?$/,
        emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

        // value for mobile app
        enableLanguagePack: "calculated below",

        maxMetersOnStackedDashboard: 15,
        wglProviderName: 'Wgl',
        wglcxProviderName: 'Wglcx',
        hcProviderName: 'Hc',
        pxProviderName: 'Px',

        // the below info exists on server and it's not good to duplicate it here,
        // but i want welcome page to load fast, so i don't want to pull these data from server
        providers: {
            "Neo": {
                "Name": "NEO Natural Gas",
                "SiteName": "Northeast Ohio Natural Gas",
                "HelpEmail": "billpay@neogas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": false,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Orwell": {
                "Name": "Orwell Natural Gas",
                "SiteName": "Orwell Natural Gas",
                "HelpEmail": "billpay@orwellgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": false,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Ewst": {
                "Name": "Ewst Natural Gas",
                "SiteName": "Energy West Montana",
                "HelpEmail": "billpay@ewst.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": false,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Wgl": {
                "Name": "Washington Gas",
                "SiteName": "Washington Gas",
                "HelpEmail": "aggregateddata@washgas.com",
                "EnablePhoneNumbersOnLoginPage": false,
                "EnableLanguagePack": true,
                "EnablePropertyManagerLink": DeploymentSettings.deploymentEnvironment !== "Prod",
                "SupportPhoneNumber": "123-123-1234",
                "providersGroupShortName": "wgl"
            },
            "Wglcx": {
                "Name": "Washington Gas",
                "SiteName": "Washington Gas",
                "HelpEmail": "aggregateddata@washgas.com",
                "EnablePhoneNumbersOnLoginPage": false,
                "EnableLanguagePack": true,
                "EnablePropertyManagerLink": DeploymentSettings.deploymentEnvironment !== "Prod",
                "SupportPhoneNumber": "123-123-1234",
                "providersGroupShortName": "wglcx"
            },
            "Px": {
                "Name": "Property Experience",
                "SiteName": "Utilli PX",
                "HelpEmail": "px@utilli.com",
                "EnablePhoneNumbersOnLoginPage": false,
                "EnableLanguagePack": true,
                "EnablePropertyManagerLink": DeploymentSettings.deploymentEnvironment !== "Prod",
                "SupportPhoneNumber": "123-123-1234",
                "providersGroupShortName": "px"
            },
            "Bangor": {
                "Name": "Bangor Natural Gas",
                "SiteName": "Bangor Natural Gas",
                "HelpEmail": "billpay@bangorgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": false,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Frontier": {
                "Name": "Frontier Natural Gas",
                "SiteName": "Frontier Natural Gas",
                "HelpEmail": "billpay@frontiernaturalgas.com",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableOutageMap": false,
                "EnableLanguagePack": false,
                "providersGroupShortName": "gni"
            },
            "Hc": {
                "Name": "Howard County",
                "SiteName": "Howard County",
                "HelpEmail": "billing@howardcountymd.gov",
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
                "providersGroupShortName": "hc"
            },
            "DemoProvider": {
                "Name": "Utilli Demo",
                "SiteName": "Utilli Demo",
                "HelpEmail": "info@utilli.com",
                "EnableOutageMap": true,
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
            },
            "SapDemoProvider": {
                "Name": "Utilli SAP Demo",
                "SiteName": "Utilli SAP Demo",
                "HelpEmail": "info@utilli.com",
                "EnableOutageMap": true,
                "EnablePhoneNumbersOnLoginPage": true,
                "EnableLanguagePack": true,
            }
        },
        appUrls: {
            android: "https://play.google.com/store/apps/details?id=com.utilli.UtilliMobile",
            iOs: "https://itunes.apple.com/us/app/howard-county-utilli/id905053011",
            winPhone: "https://www.microsoft.com/en-us/store/apps/utilli-mobile/9nblggh5k7fw"
        }
        
    };

    Config.wglProvidersGroupShortName = Config.providers[Config.wglProviderName].providersGroupShortName;
    Config.hcProvidersGroupShortName = Config.providers[Config.hcProviderName].providersGroupShortName;
    Config.pxProvidersGroupShortName = Config.providers[Config.pxProviderName].providersGroupShortName;
    Config.ProdDeploymentType = 'Prod';
    Config.QaDeploymentType = 'Qa';
    Config.StagingDeploymentType = 'Staging';
    Config.DevDeploymentType = 'Dev';
}

window.Config.states = [
{ name: 'ALABAMA', abbreviation: 'AL' },
{ name: 'ALASKA', abbreviation: 'AK' },
{ name: 'AMERICAN SAMOA', abbreviation: 'AS' },
{ name: 'ARIZONA', abbreviation: 'AZ' },
{ name: 'ARKANSAS', abbreviation: 'AR' },
{ name: 'CALIFORNIA', abbreviation: 'CA' },
{ name: 'COLORADO', abbreviation: 'CO' },
{ name: 'CONNECTICUT', abbreviation: 'CT' },
{ name: 'DELAWARE', abbreviation: 'DE' },
{ name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
{ name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
{ name: 'FLORIDA', abbreviation: 'FL' },
{ name: 'GEORGIA', abbreviation: 'GA' },
{ name: 'GUAM', abbreviation: 'GU' },
{ name: 'HAWAII', abbreviation: 'HI' },
{ name: 'IDAHO', abbreviation: 'ID' },
{ name: 'ILLINOIS', abbreviation: 'IL' },
{ name: 'INDIANA', abbreviation: 'IN' },
{ name: 'IOWA', abbreviation: 'IA' },
{ name: 'KANSAS', abbreviation: 'KS' },
{ name: 'KENTUCKY', abbreviation: 'KY' },
{ name: 'LOUISIANA', abbreviation: 'LA' },
{ name: 'MAINE', abbreviation: 'ME' },
{ name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
{ name: 'MARYLAND', abbreviation: 'MD' },
{ name: 'MASSACHUSETTS', abbreviation: 'MA' },
{ name: 'MICHIGAN', abbreviation: 'MI' },
{ name: 'MINNESOTA', abbreviation: 'MN' },
{ name: 'MISSISSIPPI', abbreviation: 'MS' },
{ name: 'MISSOURI', abbreviation: 'MO' },
{ name: 'MONTANA', abbreviation: 'MT' },
{ name: 'NEBRASKA', abbreviation: 'NE' },
{ name: 'NEVADA', abbreviation: 'NV' },
{ name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
{ name: 'NEW JERSEY', abbreviation: 'NJ' },
{ name: 'NEW MEXICO', abbreviation: 'NM' },
{ name: 'NEW YORK', abbreviation: 'NY' },
{ name: 'NORTH CAROLINA', abbreviation: 'NC' },
{ name: 'NORTH DAKOTA', abbreviation: 'ND' },
{ name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
{ name: 'OHIO', abbreviation: 'OH' },
{ name: 'OKLAHOMA', abbreviation: 'OK' },
{ name: 'OREGON', abbreviation: 'OR' },
{ name: 'PALAU', abbreviation: 'PW' },
{ name: 'PENNSYLVANIA', abbreviation: 'PA' },
{ name: 'PUERTO RICO', abbreviation: 'PR' },
{ name: 'RHODE ISLAND', abbreviation: 'RI' },
{ name: 'SOUTH CAROLINA', abbreviation: 'SC' },
{ name: 'SOUTH DAKOTA', abbreviation: 'SD' },
{ name: 'TENNESSEE', abbreviation: 'TN' },
{ name: 'TEXAS', abbreviation: 'TX' },
{ name: 'UTAH', abbreviation: 'UT' },
{ name: 'VERMONT', abbreviation: 'VT' },
{ name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
{ name: 'VIRGINIA', abbreviation: 'VA' },
{ name: 'WASHINGTON', abbreviation: 'WA' },
{ name: 'WEST VIRGINIA', abbreviation: 'WV' },
{ name: 'WISCONSIN', abbreviation: 'WI' },
{ name: 'WYOMING', abbreviation: 'WY' }
];
String.prototype.getTime = function () {
    var dateString = this;
    var date = dateString.split("/");
    // month in JS is index in array of 12 months. Transform the month number to the index.
    var month = parseInt(date[0]) - 1;
    return (new Date(date[2], month, date[1])).getTime();
};

String.prototype.getPositiveAmount = function () {
    var amountString = this;
    var amount = parseFloat(amountString);
    if(amount < 0) {
        amount = Math.abs(amount);
    }
    return amount.toString();
};

if (!String.prototype.repeat) {
    String.prototype.repeat = function(count) {
      'use strict';
      if (this == null) {
        throw new TypeError('can\'t convert ' + this + ' to object');
      }
      var str = '' + this;
      count = +count;
      if (count != count) {
        count = 0;
      }
      if (count < 0) {
        throw new RangeError('repeat count must be non-negative');
      }
      if (count == Infinity) {
        throw new RangeError('repeat count must be less than infinity');
      }
      count = Math.floor(count);
      if (str.length == 0 || count == 0) {
        return '';
      }
      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) {
        throw new RangeError('repeat count must not overflow maximum string size');
      }
      var maxCount = str.length * count;
      count = Math.floor(Math.log(count) / Math.log(2));
      while (count) {
         str += str;
         count--;
      }
      str += str.substring(0, maxCount - str.length);
      return str;
    }
}

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}
'use strict';
var provide;
var dependencies =  ['credit-cards', 'infinite-scroll',
    'angularSpinner', 'angularModalService', 'ngSanitize', 'ngIOS9UIWebViewPatch',
    'commonServices', 'ui.router', 'ct.ui.router.extras', 'ui.mask',
    'ui.bootstrap', 'ngResource'];
if(!utilli.isWglcxPortal())
    dependencies.push('kendo.directives');
angular.module('utilliApp', dependencies)
    .factory('authorizeInterceptor', function () {
        return {
            request: function (config) {

                // IMPORTANT: for static resources such as maintenance.html don't add params because the template can 
                // be embedded into index.html and angular will not resolve it when parameters are added and will try
                // to download from the server while the server can be down
                if (!config.url.startsWith('http://') && !config.url.startsWith('https://'))
                    return config;

                config.params = config.params || {};
                config.params['clientVersion'] = DeploymentSettings.clientVersion;
    
                var language = localStorage.getItem('language');
                if (utilli.checkDefinedValue(language)) {
                    config.params['lang'] = language;
                } else {
                    config.params['lang'] = 'en';
                }

                var token = localStorage.getItem('SecurityToken');
                var apiUrl = localStorage.getItem('ApiUrl');
                if (token && !config.withoutAuthentication 
                    // we need to add token only if the user is already logged in (ApiUrl exists in localStorage then)
                    // and the request is to api (not providers web api)
                    && apiUrl && config.url.startsWith(apiUrl)) {
                    config.headers['Authorization'] = token;
                }
                return config;
            }
        }
    })
    .factory('httpInterceptor', ['$q', '$injector', 'RequestService', function ($q, $injector, RequestService) {
        function saveEmptyParametersOf(request) {
            if (request.params && angular.isObject(request.params)) {
                var keys = Object.keys(request.params);
                angular.forEach(keys, function (item) {
                    var value = request.params[item];
                    if (value === null || angular.isUndefined(value)) {
                        // assign null or undefined properties with empty string - 
                        // in that case empty params are included into the url.
                        request.params[item] = '';
                    }
                });
            }
        }

        function notAuthenticatedRequest(url) {
            //if url starts with null it means localStorage.getItem('ApiUrl') is null 
            //that means it is not authenticated user
            var result = url.startsWith('null');
            return result;
        }

        function isZeroStatusResponse(response) {
            var result = response.status <= 0
                && (!response.config.timeout || response.config.timeout.status != 499) //499 - client cancelled request, it is initialized in RequestService.abort().
                && !notAuthenticatedRequest(response.config.url);
            return result;
        }

        function pingProvidersApi(fnCallback) {
            $.ajax({
                url: DeploymentSettings.providersServiceUrl + 'Version/Ping',
                method: 'GET'
            })
            .fail(function (e) {
                console.log(e);
                if(fnCallback)
                    fnCallback();
            });
        }

        var reload = function(state, newUrl) {
            newUrl = newUrl ? newUrl : '';
            // i use window.location here instead of state.go because i want to force BROWSER 
            // to reload the whole page and get source code updates from our web server.
            // note: state.current.url returns not full relative url, for example, for 
            // the view "TopMenuLayout.SignUpPropertyManager.Step2" it returns "/SignUpPropertyManagerStep2"
            // instead of "#/SignUpPropertyManager/SignUpPropertyManagerStep2"
            var indexOfIndex = window.location.href.indexOf('index.html');
            var newLocation = window.location.href;
            if (indexOfIndex > 0) {
                newLocation = newLocation.substr(0, indexOfIndex);
            }
            else {
                var relativeUrl = state.href(state.current.name);
                var indexOfRelativeUrl = newLocation.indexOf(relativeUrl);
                if (indexOfRelativeUrl > 0) {
                    newLocation = newLocation.substr(0, indexOfRelativeUrl);
                }
            }
            if (utilli.isAdmin) {
                var indexOfAdmin = newLocation.indexOf('Admin/');
                if (indexOfAdmin > 0) {
                    newLocation = newLocation.substr(0, indexOfAdmin);
                }
            }
            utilli.setWindowLocation(newLocation + newUrl);
        }

        //find web api url that match with current request url
        //for example the current request url is https://apidev.utilli.com/hc/api/System/Check
        //we get the https://apidev.utilli.com/hc/api/ as result
        var getServiceProviderUrl = function (requestUrl) {
            var deferred = $q.defer();

            $.ajax({
                url: DeploymentSettings.providersServiceUrl + 'Providers/GetProvidersAvailability',
                method: 'GET'
            })
            .done(function (providers) {
                if (!providers || providers.length == 0) {
                    deferred.reject("We cannot get providers list from web api providers.");
                    return;
                }
                var providerInfo = _.find(providers, function(provider){ 
                    return requestUrl.indexOf(provider.ApiUrl) !== -1; 
                });

                deferred.resolve(providerInfo);
            })
            .fail(function (e) {
                deferred.reject(e);
            });

            return deferred.promise;
        }

        var responseInterceptor = {
            request: function (request) {
                if (notAuthenticatedRequest(request.url)) {
                    RequestService.forcedAbort(request);
                    utilli.clearLocalStorage();
                    var stateService = $injector.get('$state');
                    stateService.goToSignIn(true);
                    return request;
                }
                if (request.url.indexOf(".html") != -1 && !$injector.get('$templateCache').get(request.url))
                    request.url += DeploymentSettings.currentVersion;
                RequestService.add(request);
                saveEmptyParametersOf(request);
                return request;
            },
            response: function (response) {

                // if generation was not changed on the server the value of 'ValidGeneration' header is 'Valid'.
                // Otherwise header is 'NotValid'. If header is null then generation was not checked on the server.
                var header = response.headers('ValidGeneration');
                if (header != null && header !== 'Valid') {
                    var modalService = $injector.get('ModalServiceExt');
                    modalService.showMessage(
                        utilli._t('Notification'), 
                        utilli._t('Your session has expired. You must login again to continue.'), 
                        function () {
                            var state = $injector.get('$state');
                            if (isMobileOrRipple()) {
                                state.goToSignIn();
                                return response;
                            }
                            console.log('Redirect to login page because security token generation is obsolete.');
                            RequestService.abort();
                            utilli.clearLocalStorage();
                            reload(state);
                            return response;
                        }
                    );
                }

                return response;
            },
            responseError: function (response) {

                var stateService = $injector.get('$state');

                // 401 error code is thrown when user is not authorized (token is wrong or expired).
                if (response.status == 401) {
                    var modalService = $injector.get('ModalServiceExt');
                    modalService.showMessage(utilli._t('Notification'), utilli._t('You are not logged in or your session has expired. Please login to continue.'), function () {
                        console.log('Redirect to login page because security token is not valid.');
                        RequestService.abort();

                        //Yuriy Sokha: I want this redirect to always work. It is required for Bot Authorization.
                        stateService.goToSignIn(true);

                        utilli.clearLocalStorage();
                        return response;
                    });
                }

                if (response.status == 403) {
                    var header = response.headers('Client-Version');
                    if (header != null && header === 'not-valid') {
                        //setTimeout(function(){
                        var modalService = $injector.get('ModalServiceExt');
                        modalService.showMessage(
                            utilli._t('Notification'), 
                            utilli._t("Current page is outdated. Please refresh to continue."), 
                            function () {
                                var state = $injector.get('$state');
                                if (isMobileOrRipple()) {
                                    localStorage.setItem('forcedUpdateMobile', true);
                                    reload(state, 'UpdateMobile.html');
                                    return response;
                                }
                                console.log('Refreshing because page is outdated.');
                                RequestService.abort();
                                reload(state);
                                return response;
                            }
                        );
                    //}, 100);
                    }
                }

                // 503 error code is thrown when maintenance is required.
                if (response.status == 503) {
                    console.log('Redirect to maintenance page.');
                    RequestService.abort();
                    stateService.goToMaintenance();
                    return response;
                }

                if(isZeroStatusResponse(response))
                {
                    var usSpinnerService = $injector.get('usSpinnerService');
                    getServiceProviderUrl(response.config.url)
                        .then(function(providerInfo) {
                            if (!providerInfo.IsAvailable) {
                                console.log('Redirect to maintenance page.');
                                usSpinnerService.stop('spinner-1');
                                usSpinnerService.stop('spinner-admin');
                                RequestService.abort();
                                stateService.goToMaintenance();
                            }
                        }, function (e) {
                            console.log(e);
                            pingProvidersApi(function () {
                                usSpinnerService.stop('spinner-1');
                                usSpinnerService.stop('spinner-admin');
                                if (!window.disableNoConnectionPage){
                                    stateService.go('NoConnection');
                                }
                            });
                        });

                }

                return $q.reject(response);
            }
        }

        return responseInterceptor;
    }
    ])
    .config(['$compileProvider', '$stateProvider', '$urlRouterProvider', '$stickyStateProvider', '$httpProvider',
        '$locationProvider',
        function ($compileProvider, $stateProvider, $urlRouterProvider, $stickyStateProvider, $httpProvider, 
            $locationProvider) {
            //$location.hashPrefix('');
            $locationProvider.html5Mode(false).hashPrefix('');

        $stickyStateProvider.enableDebug(true);
        // http://stackoverflow.com/a/23110108/292787
        // http://stackoverflow.com/questions/24246464/display-images-through-html-img-tag-with-angularjs-and-ionic
        // for windows phone also x-wmapp: http://stackoverflow.com/a/29625730/292787
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|file|ms-appx|x-wmapp.?):/);

        $httpProvider.interceptors.push('httpInterceptor');
        $httpProvider.interceptors.push('authorizeInterceptor');

        // routing configuration below uses angular-ui-router, and ui-router-extras
        // see examples at :
        // http://plnkr.co/edit/bEdJczNwYEfTI7joyh9h?p=preview
        // http://plnkr.co/edit/bFMLqLENmPFfCD0XCz8V?p=preview
        // http://plnkr.co/edit/rIxTa9DyOB2jsk8lpE1h?p=preview
        if (!utilli.isAdmin) {
            $urlRouterProvider.otherwise('/');
        }

        function isParamsArray(params) {
            var result = Object.prototype.toString.call(params) === '[object Array]';
            return result;
        }

        function getCommonHeaderViewsConfiguration(stateName, parentFolder) {
            var pagesPath = utilli.isAdmin ? '../' : '';
            parentFolder = parentFolder ? parentFolder += '/' : ''
            return {
                "top-menu": {
                    templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: pagesPath + 'Pages/' + parentFolder + stateName + '/' + stateName + '.html',
                    controller: stateName + 'Controller'
                }
            };
        }

            var registerForLayoutStateWithCommonHeader = function (stateName, params, layout, parentFolder) {
                var url = utilli.isAdmin ? '/Customer/:userId/:contractAccountNumber/:propertyManager/' + stateName
                    : '/' + stateName;
                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }
                $stateProvider.state(layout + '.' + stateName, {
                    url: url,
                    views: getCommonHeaderViewsConfiguration(stateName, parentFolder),
                    params: isParamsArray(params) ? null : params
                });
            };

            var registerPropertyManagerRoute = function (stateName, params, parentFolder) {
                var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                var url = utilli.isAdmin ? '/PropertyManager/:userId/:propertyManager/' + stateName
                    : '/' + stateName;
                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }
                $stateProvider.state(layout + '.' + stateName, {
                    url: url,
                    views: getCommonHeaderViewsConfiguration(stateName, parentFolder),
                    params: isParamsArray(params) ? null : params
                });
            };

        function registerRelative(mainFolder, stateName, params) {
            var pagesPath = utilli.isAdmin ? '../' : '';
            var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
            var url = utilli.isAdmin ? '/Customer/:userId/:contractAccountNumber/:propertyManager/' + stateName
                : '/' + stateName;
            $stateProvider.state(layout + '.' + stateName, {
                url: url,
                views: {
                    "top-menu": {
                        templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: pagesPath + 'Pages/' + mainFolder + '/' + stateName + '.html',
                        controller: stateName + 'Controller'
                    }
                },
                params: params
            });
        }

        var registerStateWithCommonHeader = function (stateName, params, parentFolder) {
            var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
            registerForLayoutStateWithCommonHeader(stateName, params, layout, parentFolder);
        };

        var registerForTopMenuLayout = function (stateName, params) {
            registerForLayoutStateWithCommonHeader(stateName, params, 'TopMenuLayout');
        };

        var registerForgotPasswordRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotPassword', {
                url: '/ForgotPassword',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotPassword/ForgotPasswordHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotPassword/ForgotPassword.html',
                        controller: 'ForgotPasswordController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Step1', {
                url: '/ForgotPasswordStep1',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Step1.html',
                        controller: 'ForgotPasswordStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Step2', {
                url: '/ForgotPasswordStep2',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Step2.html',
                        controller: 'ForgotPasswordStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPassword.Success', {
                url: '/ForgotPasswordSuccess',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPassword/Success.html'
                    }
                }
            });
        }

        var registerForgotPasswordByEmailRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail', {
                url: '/ForgotPasswordByEmail',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/ForgotPasswordByEmailHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/ForgotPasswordByEmail.html',
                        controller: 'ForgotPasswordByEmailController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail.Step1', {
                url: '/ForgotPasswordByEmailStep1/?from',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/Step1.html',
                        controller: 'ForgotPasswordByEmailStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotPasswordByEmail.Success', {
                url: '/ForgotPasswordByEmailSuccess',
                views: {
                    "ForgotPasswordSteps": {
                        templateUrl: 'Pages/ForgotPasswordByEmail/Success.html',
                        controller: 'ForgotPasswordByEmailSuccessController'
                    }
                }
            });
        }

        var registerForgotUserIdRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotUserId', {
                url: '/ForgotUserId',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotUserId/ForgotUserIdHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotUserId/ForgotUserId.html',
                        controller: 'ForgotUserIdController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Step1', {
                url: '/ForgotUserIdStep1',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Step1.html',
                        controller: 'ForgotUserIdStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Step2', {
                url: '/ForgotUserIdStep2',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Step2.html',
                        controller: 'ForgotUserIdStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserId.Success', {
                url: '/ForgotUserIdSuccess',
                views: {
                    "ForgotUserIdSteps": {
                        templateUrl: 'Pages/ForgotUserId/Success.html',
                        controller: 'ForgotUserIdSuccessController'
                    }
                }
            });
        }

        var registerForgotUserIdByEmailRoutes = function () {
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail', {
                url: '/ForgotUserIdByEmail',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/ForgotUserIdByEmailHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/ForgotUserIdByEmail.html',
                        controller: 'ForgotUserIdByEmailController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail.Step1', {
                url: '/Step1/?from',
                views: {
                    "ForgotUserIdByEmailSteps": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/Step1.html',
                        controller: 'ForgotUserIdByEmailStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.ForgotUserIdByEmail.Success', {
                url: '/Success',
                views: {
                    "ForgotUserIdByEmailSteps": {
                        templateUrl: 'Pages/ForgotUserIdByEmail/Success.html',
                        controller: 'ForgotUserIdByEmailSuccessController'
                    }
                }
            });
        }

        if (!utilli.isAdmin) {
            $stateProvider.state('TopMenuLayout', {
                views: {
                    "body-view": {
                        templateUrl: 'Pages/TopMenuLayout.html'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Languages', {
                url: '/WelcomeLanguages',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Languages/Languages.html',
                        controller: 'LanguagesController'
                    }
                }
            });
            $stateProvider.state('MainLayout', {
                views: {
                    "body-view": {
                        templateUrl: 'Pages/MainLayout.html',
                        controller: 'MainLayoutController'
                    }
                }
            });
        }
        registerStateWithCommonHeader('Dashboard');
        registerStateWithCommonHeader('PayNow', ['AccountNumber']);//we use this url in TaksRunner
        registerStateWithCommonHeader('Usage');
        registerStateWithCommonHeader('BillsAndPayments');
        registerStateWithCommonHeader('BillDetails', ['billNumber']);
        registerStateWithCommonHeader('PaymentOptions');
        registerStateWithCommonHeader('AddCard');
        registerStateWithCommonHeader('AddBankAccount');
        registerStateWithCommonHeader('BankAccount', ['Id']);
        registerStateWithCommonHeader('Card', ['Id']);
        registerStateWithCommonHeader('PayByCard');
        registerStateWithCommonHeader('PayByBtc');
        registerStateWithCommonHeader('PayByCheck');
        registerStateWithCommonHeader('PayByCheckConfirmation');
        registerStateWithCommonHeader('NotificationDetails', ['Id']);
        registerStateWithCommonHeader('UserNotifications');
        registerStateWithCommonHeader('AccountList', ['redirectIfSingle']);
        registerStateWithCommonHeader('MoveService');
        registerStateWithCommonHeader('CancelService');
        registerStateWithCommonHeader('CancelSuccess');
        registerStateWithCommonHeader('ChangePassword');
        registerStateWithCommonHeader('DonationHistory');
        registerStateWithCommonHeader('BudgetBillingLearnMore');
        registerStateWithCommonHeader('BudgetBilling');
        registerStateWithCommonHeader('AddAccount');
        registerStateWithCommonHeader('EditAccounts');
        registerStateWithCommonHeader('Faqs', ['directDebitParam', 'donationParam']);
        registerStateWithCommonHeader('EnrollCardMessage', ['Id']);
        registerStateWithCommonHeader('EnrollBankAccountMessage', ['Id']);
        registerStateWithCommonHeader('UnenrollCardMessage', ['Id']);
        registerStateWithCommonHeader('UnenrollBankAccountMessage', ['Id']);
        registerStateWithCommonHeader('Profile');
        registerStateWithCommonHeader('MobilePhoneConfirmation', ['forProgramEnrollments', 'forProgramEnrollmentsLearnMore', 'phoneNumber']);
        registerStateWithCommonHeader('Avatars', ['forAgent', 'forAssistant', 'forPropertyManager']);
        registerStateWithCommonHeader('OutageCenter');
        registerStateWithCommonHeader('OutageMap');
        registerStateWithCommonHeader('TurnOffMap');
        registerStateWithCommonHeader('OutageList');
        registerStateWithCommonHeader('OutageSafety');
        registerStateWithCommonHeader('OutageHistory');
        registerStateWithCommonHeader('ReportOutage');
        registerStateWithCommonHeader('OpenOutageReport', ['Id', 'mode']);
        registerStateWithCommonHeader('MeterData');
        registerForTopMenuLayout('TermsAndConditions');//we use this url in TaksRunner
        registerForTopMenuLayout('SystemInfo');
        registerStateWithCommonHeader('AboutUs');
        registerStateWithCommonHeader('EnergyEfficiency');
        registerStateWithCommonHeader('Languages');

        registerStateWithCommonHeader('WorkCenters', ['redirectIfSingle']);
        registerStateWithCommonHeader('LookUp');
        registerStateWithCommonHeader('LookUpLog');
        registerStateWithCommonHeader('PaymentHistory');
        registerStateWithCommonHeader('WorkOrders');

        $stateProvider.state('MainLayout.TurnOffQuickPay', {
            // parent: 'MainLayout',
            url: '/QuickPay',
            views:
            {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/QuickPay/Step2.html',
                    controller: 'QuickPayStep2Controller'
                }
            }
        });

        registerProgramEnrollmentsRoutes();

        function registerProgramEnrollmentsRoutes() {

            registerStateWithCommonHeader('ProgramEnrolments');

            registerRelative('ProgramEnrolments', 'DonationLearnMore');
            registerRelative('ProgramEnrolments', 'SmsNotificationsLearnMore');
            registerRelative('ProgramEnrolments', 'EmailNotificationsLearnMore');
            registerRelative('ProgramEnrolments', 'EBillingLearnMore');

            createWizard()
                .registerWizardRoot('DonationEnrollment','DonationEnrollmentSteps', 'ProgramEnrolments', { program: null })
                .registerWizardStep('DonationEnrollment', 'Step1')
                .registerWizardStep('RoundUpEnrollment', 'Success')
                .registerWizardStep('FixedAmountEnrollment', 'Step2')
                .registerWizardStep('FixedAmountEnrollment', 'Success')
                .registerWizardStep('PercentageEnrollment', 'Step2')
                .registerWizardStep('PercentageEnrollment', 'Success');
        }

        function createWizard() {
            var Wizard = function() {
                this.parentView = '';
                this.wizardRootStateName = '';
                this.parentDirectory = '';
            };

            Wizard.prototype.registerWizardRoot = function(wizardRoot, parentView, parentDirectory, params) {
                this.parentView = parentView;
                this.wizardRootStateName = wizardRoot;
                this.parentDirectory = parentDirectory;

                var pagesPath = utilli.isAdmin ? '../' : '';
                $stateProvider.state('MainLayout.' + this.wizardRootStateName, {
                    url: '/' + this.wizardRootStateName,
                    views: {
                        "top-menu": {
                            templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: 'Pages/' + parentDirectory + '/' +  this.wizardRootStateName + '/' + this.wizardRootStateName + '.html',
                            controller:  this.wizardRootStateName + 'StepsController'
                        }
                    },
                    params: params || {}
                });
                return this;
            };

            Wizard.prototype.registerWizardStep = function(stateName, stepNumber, params) {
                var templateUrl = this.parentDirectory
                    ? 'Pages/' + this.parentDirectory + '/'
                    : 'Pages/';
                var views = {};
                views[this.parentView] = {
                    templateUrl: templateUrl + this.wizardRootStateName + '/' + stateName + stepNumber + '.html',
                    controller: stateName + stepNumber + 'Controller'
                }
                //MainLayout.DonationEnrollment.FixedAmountEnrollmentStep2
                $stateProvider.state('MainLayout.' + this.wizardRootStateName + '.' + stateName + stepNumber, {
                    url: '/' + stateName + stepNumber,
                    views: views,
                    params: params || {}
                });
                return this;
            };

            var result = new Wizard();
            return result;
        }

        $stateProvider.state('TopMenuLayout.BotAuthorize', {
            url: '/BotAuthorize/:channelId/:clientId/:conversationId/:logoutRequired/:serviceUrl',
            views: {
                "main-content": {
                    templateUrl: 'Pages/BotAuthorize/BotAuthorize.html',
                    controller: 'BotAuthorizeController'
                },
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                 },
            }
        });

        $stateProvider.state('ResetPassword', {
            url: '/ResetPassword/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ResetPassword/ResetPassword.html',
                    controller: 'ResetPasswordController'
                }
            }
        });

        $stateProvider.state('ChallengeEmailSucceed', {
            url: '/ChallengeEmailSucceed/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ChallengeEmailSucceed/ChallengeEmailSucceed.html',
                    controller: 'ChallengeEmailSucceedController'
                }
            }
        });
        $stateProvider.state('NonSupported', {
            url: '/NonSupported',
            views: {
                "body-view": {
                    templateUrl: 'Pages/NonSupported/NonSupported.html',
                    controller: 'NonSupportedController'
                }
            }
        });
        $stateProvider.state('UpdateApp', {
            url: '/UpdateApp',
            views: {
                "body-view": {
                    templateUrl: 'Pages/UpdateApp/Update.html',
                    controller: 'UpdateAppController'
                }
            }
        });

        $stateProvider.state('Subscription', {
            url: '/Subscription/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/Subscription/Subscription.html',
                    controller: 'SubscriptionController'
                }
            }
        });

        $stateProvider.state('VerifyEmailOld', {
            url: '/VerifyEmail/:token', //VerifyEmail is used in EbapService
            views: {
                "body-view": {
                    templateUrl: 'Pages/VerifyEmail/VerifyEmail.html',
                    controller: 'VerifyEmailController'
                }
            }
        });
        $stateProvider.state('VerifyEmail', {
            url: '/VerifyEmail?token', //VerifyEmail is used in EbapService
            views: {
                "body-view": {
                    templateUrl: 'Pages/VerifyEmail/VerifyEmail.html',
                    controller: 'VerifyEmailController'
                }
            }
        });

        $stateProvider.state('ViewBillAccessOld', { //ViewBillAccess is used in BillUrlService
            url: '/ViewBillAccess/:token/:emailId',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ViewBillAccess/ViewBillAccess.html',
                    controller: 'ViewBillAccessController'
                }
            },
            params: {
                emailId: { squash: true, value: null }
            }
        });

        $stateProvider.state('SmartPayLayout.ViewBillAccess', { //ViewBillAccess is used in BillUrlService
            url: '/ViewBillAccess?token&emailId',
            views: {
                "main-content": {
                    templateUrl: 'Pages/ViewBillAccess/ViewBillAccess.html',
                    controller: 'ViewBillAccessController'
                }
            }
        });

        $stateProvider.state('ViewBill', {
            url: '/ViewBill?token&emailId',
            views: {
                "body-view": {
                    templateUrl: 'Pages/ViewBill/ViewBill.html',
                    controller: 'ViewBillController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.InstallmentPlan', {
            //bbp=true if redirected from budget billing plan enrollment page and need to continue to bbp
            url: '/InstallmentPlan?token?bbp?directSrc?src?ct?lang',
            views: {
                "main-content": {
                    templateUrl: 'Pages/InstallmentPlan/InstallmentPlan.html',
                    controller: 'InstallmentPlanController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.BudgetBillingWglcx', {
            url: '/BudgetBillingWglcx?token?directSrc?src?ct?lang',
            views: {
                "main-content": {
                    templateUrl: 'Pages/BudgetBillingWglcx/BudgetBillingWglcx.html',
                    controller: 'BudgetBillingWglcxController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.BudgetBillingWglcxUnenrollment', {
            url: '/BudgetBillingWglcxUnenrollment?token?src?ct',
            views: {
                "main-content": {
                    templateUrl: 'Pages/BudgetBillingWglcxUnenrollment/BudgetBillingWglcxUnenrollment.html',
                    controller: 'BudgetBillingWglcxUnenrollmentController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.Budget', {
            url: '/Budget?src?ct?lang',
            views: {
                "main-content": {
                    templateUrl: 'Pages/Budget/Budget.html',
                    controller: 'BudgetController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.AgentPayments', {
            url: '/agent-payments?installationId',
            views: {
                "main-content": {
                    templateUrl: 'Pages/AgentPayments/AgentPayments.html',
                    controller: 'AgentPaymentsController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.Dpp', {
            url: '/dpp?src?ct?lang',
            views: {
                "main-content": {
                    templateUrl: 'Pages/Dpp/Dpp.html',
                    controller: 'DppController'
                }
            }
        });

        $stateProvider.state('BudgetReport', {
            url: '/BudgetReport',
            views: {
                "body-view": {
                    templateUrl: 'Pages/BudgetReport/BudgetReport.html',
                    controller: 'BudgetReportController'
                }
            }
        });

        $stateProvider.state('SmartPayLayout.CustomerValidation', {
            url: '/CustomerValidation?token',
            views: {
                "main-content": {
                    templateUrl: 'Pages/CustomerValidation/CustomerValidation.html',
                    controller: 'CustomerValidationController'
                }
            }
        });

        $stateProvider.state('NotMeOld', { //NotMe is used in EbapService
            url: '/NotMe/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/NotMe/NotMe.html',
                    controller: 'NotMeController'
                }
            }
        });
        $stateProvider.state('NotMe', { //NotMe is used in EbapService
            url: '/NotMe?token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/NotMe/NotMe.html',
                    controller: 'NotMeController'
                }
            }
        });

        $stateProvider.state('EnrollEBill', { // EnrollEBill is used in EbapService
            url: '/EnrollEBill/:token/:contractAccountNumber',
            views: {
                "body-view": {
                    templateUrl: 'Pages/EnrollEBill/EnrollEBill.html',
                    controller: 'EnrollEBillController'
                }
            }
        });

        $stateProvider.state('EnrollEBillAfterNotification', { 
            url: '/EnrollEBillAfterNotification/:token',
            views: {
                "body-view": {
                    templateUrl: 'Pages/EnrollEBillAfterNotification/EnrollEBillAfterNotification.html',
                    controller: 'EnrollEBillAfterNotificationController'
                }
            }
        });

        registerPropertyManagersRoutes();

        function registerPropertyManagersRoutes() {
            registerWelcomePropertyManagersRoutes();
            registerSignUpPropertyManagersRoutes();
            registerPropertyManagerRoute('GroupStackedDashboard', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyStackedDashboard', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyBarDashboard', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyDetailedDashboard', ['selectedPeriodString'], 'PropertyManagers');
            registerPropertyManagerRoute('PropertyManagerUsage', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyGroupList', null, 'PropertyManagers');
            registerPropertyManagerRoute('AddPropertyGroup', null, 'PropertyManagers');
            registerPropertyManagerRoute('EditPropertyGroup', ['propertyGroupId'], 'PropertyManagers');
            registerPropertyManagerRoute('Property', ['propertyId'], 'PropertyManagers');
            registerPropertyManagerRoute('EditProperty', ['id', 'showAuthorizationMetersWarning'], 'PropertyManagers');
            registerPropertyManagerRoute('PropertyList', null, 'PropertyManagers');
            registerPropertyManagerRoute('ReasonsForNoScore', ['propertyId'], 'PropertyManagers');
            registerPropertyManagerRoute('PropertyManagerProfile', null, 'PropertyManagers');
            registerPropertyManagerRoute('Billing', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyManagerBills', null, 'PropertyManagers');
            registerPropertyManagerRoute('PropertyManagerBillDetails', ['id'], 'PropertyManagers');
            registerPropertyManagerRoute('PropertyManagerEnergyEfficiency', null, 'PropertyManagers');
            registerPropertyManagerRoute('SendInvitation', ['propertyId'], 'PropertyManagers');
            registerPropertyManagerRoute('Authorizations', null, 'PropertyManagers');
            registerPropertyManagerRoute('Invitations', ['propertyId'], 'PropertyManagers');
            registerPropertyManagerRoute('RecipientInvitationView', ['id', 'meterNumber'], 'PropertyManagers');
            registerPropertyManagerRoute('AddProperty', null, 'PropertyManagers');
            registerPropertyManagerRoute('SharedAccounts', null, 'PropertyManagers');
            registerPropertyManagerRoute('SendSharingAccountRequest', null, 'PropertyManagers');
            registerPropertyManagerRoute('SendSharingAccountRequestEmail', ['email'], 'PropertyManagers');
            registerPropertyManagerRoute(
                'MeterNeedsApproval',
                ['propertyId', 'meterId', 'meterNumber', 'mode', 'stepsCount', 'step', 'from'],
                'PropertyManagers');

            registerAddPropertyRoute('PropertyOverview');
            registerAddPropertyRoute('PropertyType');
            registerAddPropertyRoute('PropertyDetails', ['type']);
            registerAddPropertyRoute('AddMeters', ['topMeter']);
            registerAddPropertyRoute('AddGreenButtonMeters');
            registerAddPropertyRoute('BulkMetersInput');
            registerAddPropertyRoute('FailedMeters', ['topMeter']);
            registerAddPropertyRoute('Authorization');
            // code and state DataCustodianAuthorization parameters are optional and used when the user
            // gets redirected back to Utilli portal from Data Custodian web site.
            // code parameter is a secret that allows to get refresh and access tokens. 
            // state parameter is used to identify user.
            registerAddPropertyRoute('DataCustodianAuthorization', ['code', 'state']);

            function registerAddPropertyRoute(stateName, params) {
                var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                var url = '/' + stateName + '/:id/:mode/:stepsCount/:step';

                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }

                var pagesPath = utilli.isAdmin ? '../' : '';

                $stateProvider.state(layout + '.AddProperty.' + stateName, {
                    url: url,
                    views: {
                        "AddPropertySteps": {
                            templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/' + stateName + '.html',
                            controller: stateName + 'Controller'
                        }
                    },
                    params: isParamsArray(params) ? null : params
                });
            }

            function registerAddPropertyErrorsRoute(stateName, params) {
                var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';

                var url = utilli.isAdmin ? '/PropertyManager/:userId/:propertyManager/' + stateName + '/:propertyId/:meterId/:mode/:stepsCount/:step'
                    : '/' + stateName + '/:propertyId/:meterId/:mode/:stepsCount/:step/:from';

                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }

                var pagesPath = utilli.isAdmin ? '../' : '';

                $stateProvider.state(layout + '.' + stateName, {
                    url: url,
                    views: {
                        "top-menu": {
                            templateUrl: pagesPath + 'Pages/CommonHeader/CommonHeader.html',
                            controller: 'CommonHeaderController'
                        },
                        "main-content": {
                            templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/Errors/' + stateName + '.html',
                            controller: stateName + 'Controller'
                        }
                    },
                    params: isParamsArray(params) ? null : params
                });
            }

            registerAddPropertyErrorsRoute('MeterDoesNotExist');
            registerAddPropertyErrorsRoute('MeterDuplicated');
            registerAddPropertyErrorsRoute('MeterIsUsed');
            registerAddPropertyErrorsRoute('MultipleTiedMeters');
            registerAddPropertyErrorsRoute('ClaimMeter');
            registerAddPropertyErrorsRoute('ServiceAddressMismatches');

            function registerImportPropertyRoute(stateName, params, templateName) {
                var layout = utilli.isAdmin ? 'AdminMainLayout.Customer.CustomerLayout' : 'MainLayout';
                var url = '/' + stateName + '/:id/:stepsCount/:step';

                if (isParamsArray(params)) {
                    //we use it for keeping parameters into url
                    if (params && params.length > 0) {
                        params.forEach(function (item) {
                            url += '/:' + item;
                        });
                    }
                }

                var pagesPath = utilli.isAdmin ? '../' : '';
                var template = templateName ? templateName : stateName;

                $stateProvider.state(layout + '.AddProperty.' + stateName, {
                    url: url,
                    views: {
                        "AddPropertySteps": {
                            templateUrl: pagesPath + 'Pages/PropertyManagers/AddProperty/' + template + '.html',
                            controller: stateName + 'Controller'
                        }
                    },
                    params: isParamsArray(params) ? null : params
                });
            }

            registerImportPropertyRoute('LinkEnergyStarAccount');
            registerImportPropertyRoute('LinkEnergyStarAccountInstructions');
            registerImportPropertyRoute('LinkEnergyStarAccountForPropertyImport');
            registerImportPropertyRoute('LinkEnergyStarAccountForPropertyImportInstructions', null, 'LinkEnergyStarAccountInstructions');
            registerImportPropertyRoute('ShareExistingEnergyStarPropertyInstructions');
            registerImportPropertyRoute('PropertySharingResults');

            $stateProvider.state('TopMenuLayout.MeterDoesNotExist', {
                url: '/MeterDoesNotExist/:meterId/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MeterDoesNotExist.html',
                        controller: 'MeterDoesNotExistController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.MeterDuplicated', {
                url: '/MeterDuplicated/:meterId/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MeterDuplicated.html',
                        controller: 'MeterDuplicatedController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.ServiceAddressMismatches', {
                url: '/ServiceAddressMismatches/:propertyId/:meterId/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/ServiceAddressMismatches.html',
                        controller: 'ServiceAddressMismatchesController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.MultipleTiedMeters', {
                url: '/MultipleTiedMeters/:meterId/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/MultipleTiedMeters.html',
                        controller: 'MultipleTiedMetersController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.ClaimMeter', {
                url: '/ClaimMeter/:meterId/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/AddProperty/Errors/ClaimMeter.html',
                        controller: 'ClaimMeterController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.SendDataSharingInvitation', {
                url: '/SendDataSharingInvitation/:token/:useCachedMeters',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/SendDataSharingInvitation/SendDataSharingInvitation.html',
                        controller: 'SendDataSharingInvitationController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.RevokeMeterSharing', {
                url: '/RevokeMeterSharing/:token',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/RevokeMeterSharing/RevokeMeterSharing.html',
                        controller: 'RevokeMeterSharingController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.RequestMeterSharingRevoke', {
                url: '/RequestMeterSharingRevoke',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/RequestMeterSharingRevoke/RequestMeterSharingRevoke.html',
                        controller: 'RequestMeterSharingRevokeController'
                    }
                }
            });
        }

        // below are routes for not logged in users
        // in admin on Customer View we show only the part of the app 
        // that is visible only for logged in users, hence we don't need
        // these routes for admin
        if (utilli.isAdmin)
            return;
        // if running in mobile app then use a custom welcome page for mobile
        if (isMobileOrRipple()) 
            registerWelcomeMobileRoutes();
        else 
            registerWelcomeRoutes();

        function getMainRootRoute() {
            return utilli.isPropertyManagerApp()
                ? '/WelcomeMain/?from' 
                : '/?from';
        }

        function registerWelcomeRoutes() {
            if (utilli.isWglcx()) {
                $stateProvider.state('WelcomeWglcx', {
                    url: '/',
                    views: {
                        "body-view": {
                            templateUrl: 'Pages/WelcomeWglcx/WelcomeWglcx.html',
                            controller: 'WelcomeWglcxController'
                        }
                    }
                });
                return;
            }

            if(DeploymentSettings.currentServiceProvider === 'Orwell') {
                $stateProvider.state('WelcomeOrwellRedirect', {
                    url: '/',
                    views: {
                        "body-view": {
                            templateUrl: 'Pages/WelcomeOrwellRedirect/WelcomeOrwellRedirect.html',
                            controller: 'WelcomeOrwellRedirectController'
                        }
                    }
                });
                return;
            }

            $stateProvider.state('TopMenuLayout.WelcomeAlexa', {
                url: '/WelcomeAlexa',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/WelcomeAlexa/WelcomeAlexa.html',
                        controller: 'WelcomeAlexaController'
                    }
                }
            });

            $stateProvider.state('TopMenuLayout.Welcome', {
                url: getMainRootRoute(),
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Welcome/Welcome.html',
                        controller: 'WelcomeController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.SignIn.Providers', {
                url: '/Providers',
				// for not mobile sign in we also need login,passwd to use it on common portals (like portalqa.utilli.com)
                params: { signInParams: { from: null, login: null, passwd: null } },
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        function registerSignUpPropertyManagersRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager', {
                url: '/SignUpPropertyManager',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/SignUp.html',
                        controller: 'SignUpPropertyManagerController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step1', {
                url: '/SignUpPropertyManagerStep1/:email',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step1.html',
                        controller: 'SignUpPropertyManagerStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step2', {
                url: '/SignUpPropertyManagerStep2',
                params: { email: null },
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step2.html',
                        controller: 'SignUpPropertyManagerStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Step3', {
                url: '/SignUpPropertyManagerStep3',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Step3.html',
                        controller: 'SignUpPropertyManagerStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpPropertyManager.Success', {
                url: '/SignUpPropertyManagerSuccess',
                views: {
                    "SignUpPropertyManagerSteps": {
                        templateUrl: 'Pages/PropertyManagers/SignUp/Success.html',
                        controller: 'SignUpPropertyManagerSuccessController'
                    }
                }
            });
        }

        function getPropertyManagerRootRoute () {
            return utilli.isPropertyManagerApp()  
                ? '/?from' 
                : '/WelcomePropertyManager/?from';
        }

        function registerWelcomePropertyManagersRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager', {
                url: getPropertyManagerRootRoute(),// we use this url in email sending service
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/PropertyManagers/Welcome/Welcome.html',
                        controller: 'WelcomePropertyManagerController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            }
            );
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomePropertyManager.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        function registerAgentsRoutes() {
            registerWelcomeAgentsRoutes();
            registerSignUpAgentsRoutes();
            registerStateWithCommonHeader('Search', null, 'Agents');
            registerStateWithCommonHeader('AgentProfile', null, 'Agents');
            registerStateWithCommonHeader('SearchHistory', null, 'Agents');
            registerStateWithCommonHeader('SettlementProperty', ['AccountNumber', 'Address'], 'Agents');
        }

        function registerSignUpAgentsRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpAgent', {
                url: '/SignUpAgent',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/Agents/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Agents/SignUp/SignUp.html',
                        controller: 'SignUpAgentController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step1', {
                url: '/SignUpAgentStep1',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step1.html',
                        controller: 'SignUpAgentStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step2', {
                url: '/SignUpAgentStep2',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step2.html',
                        controller: 'SignUpAgentStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Step3', {
                url: '/SignUpAgentStep3',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Step3.html',
                        controller: 'SignUpAgentStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAgent.Success', {
                url: '/SignUpAgentSuccess',
                views: {
                    "SignUpAgentSteps": {
                        templateUrl: 'Pages/Agents/SignUp/Success.html',
                        controller: 'SignUpAgentSuccessController'
                    }
                }
            });
        }

        function registerWelcomeAgentsRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomeAgent', {
                url: '/WelcomeAgent',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Agents/Welcome/Welcome.html',
                        controller: 'WelcomeAgentController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAgent.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        registerAgentsRoutes();


        function registerAssistantsRoutes() {
            registerWelcomeAssistantsRoutes();
            registerSignUpAssistantsRoutes();
            registerStateWithCommonHeader('AssistantSearch', null, 'Assistants');
            registerStateWithCommonHeader('AssistantProfile', null, 'Assistants');
            registerStateWithCommonHeader('Delinquents', null, 'Assistants');
            registerStateWithCommonHeader('AssistantSearchHistory', null, 'Assistants');
        }

        function registerSignUpAssistantsRoutes() {
            $stateProvider.state('TopMenuLayout.SignUpAssistant', {
                url: '/SignUpAssistant',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/Assistants/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Assistants/SignUp/SignUp.html',
                        controller: 'SignUpAssistantController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step1', {
                url: '/SignUpAssistantStep1',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step1.html',
                        controller: 'SignUpAssistantStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step2', {
                url: '/SignUpAssistantStep2',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step2.html',
                        controller: 'SignUpAssistantStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Step3', {
                url: '/SignUpAssistantStep3',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Step3.html',
                        controller: 'SignUpAssistantStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUpAssistant.Success', {
                url: '/SignUpAssistantSuccess',
                views: {
                    "SignUpAssistantSteps": {
                        templateUrl: 'Pages/Assistants/SignUp/Success.html',
                        controller: 'SignUpAssistantSuccessController'
                    }
                }
            });
        }

        function registerWelcomeAssistantsRoutes() {
            $stateProvider.state('TopMenuLayout.WelcomeAssistant', {
                url: '/WelcomeAssistant',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/Assistants/Welcome/Welcome.html',
                        controller: 'WelcomeAssistantController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn', {
                sticky: true,
                dsr: true,
                views: {
                    "SignIn": {
                        templateUrl: 'Pages/SignIn/SignInPart.html',
                        controller: 'SignInPartController'
                    },
                    "footer": {
                        templateUrl: 'Pages/WelcomeFooter/WelcomeFooter.html',
                        controller: 'WelcomeFooterController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.WelcomeAssistant.SignIn.Providers', {
                url: '/Providers?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });
        }

        registerAssistantsRoutes();

        function registerWelcomeMobileRoutes() {
            $stateProvider.state('WelcomeMobile', {
                url: '/',
                views: {
                    "body-view": {
                        templateUrl: 'Pages/WelcomeMobile/WelcomeMobile.html',
                        controller: 'WelcomeMobileController'
                    }
                }
            });
        }

        function registerSignInRoutes() {
            $stateProvider.state('TopMenuLayout.SignIn', {
                url: '/SignIn?from',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/SignIn/SignIn.html',
                        controller: 'SignInPartController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignIn.Credentials', {
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignIn.Providers', {
                url: '/Providers',
                params: { signInParams: { from: null, login: null, passwd: null } },
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Providers.html',
                        controller: 'ProvidersController'
                    }
                }
            });    
        }

        function registerWglCxSignInRoutes() {
            $stateProvider.state('TopMenuLayout.SignIn', {
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                        controller: 'CommonHeaderController'
                    },
                    "main-content": {
                        templateUrl: 'Pages/SignIn/SignIn.html',
                        controller: 'SignInPartController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignIn.Credentials', {
                url: '/Login?from',
                views: {
                    "SignInSteps": {
                        templateUrl: 'Pages/SignIn/Credentials.html',
                        controller: 'CredentialsController'
                    }
                }
            });
        }

        if(utilli.isWglcx()) 
            registerWglCxSignInRoutes();
        else
            registerSignInRoutes();
        registerForgotPasswordRoutes();
        registerForgotPasswordByEmailRoutes();
        registerForgotUserIdRoutes();
        registerForgotUserIdByEmailRoutes();
        registerSignUpRoutes();
        
        function registerSignUpRoutes() {
            $stateProvider.state('TopMenuLayout.SignUp', {
                url: '/SignUp?accountnumber&customerfullname&zip&email&token&user&psw&question&answer',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/SignUp/SignUpHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/SignUp/SignUp.html',
                        controller: 'SignUpController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step1', {
                url: '/SignUpStep1', //we use this url in EmailService templates
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step1.html',
                        controller: 'SignUpStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step2', {
                url: '/SignUpStep2',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step2.html',
                        controller: 'SignUpStep2Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Step3', {
                url: '/SignUpStep3',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Step3.html',
                        controller: 'SignUpStep3Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.SignUp.Success', {
                url: '/SignUpSuccess',
                views: {
                    "SignUpSteps": {
                        templateUrl: 'Pages/SignUp/Success.html',
                        controller: 'SignUpSuccessController'
                    }
                }
            });
        }

        //registerForTopMenuLayout('Maintenance');

        $stateProvider.state('SmartPayLayout.Maintenance', {
            url: '/Maintenance',
            views: {
                'main-content': {
                    templateUrl: 'maintenance.html',
                    controller: 'MaintenanceController'
                }
            }
        });

        $stateProvider.state('NoConnection', {
            url: '/NoConnection',
            views: {
                'body-view': {
                    templateUrl: 'noconnection.html',
                    controller: 'NoConnectionController'
                }
            }
        });

        function registerWelcomeQuickPay() {
            $stateProvider.state('TopMenuLayout.Welcome.QuickPay', {
                sticky: true,
                dsr: true,
                views: {
                    "QuickPay": {
                        templateUrl: 'Pages/QuickPay/QuickPayPart.html',
                        controller: 'QuickPayController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.QuickPay.Step1', {
                views: {
                    "QuickPaySteps": {
                        templateUrl: 'Pages/QuickPay/Step1.html',
                        controller: 'QuickPayStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.Welcome.QuickPay.Step2', {
                views: {
                    "QuickPaySteps": {
                        templateUrl: 'Pages/QuickPay/Step2.html',
                        controller: 'QuickPayStep2Controller'
                    }
                }
            });

        }

        registerWelcomeQuickPay();
        
        function registerStandaloneQuickPay  () {
            $stateProvider.state('TopMenuLayout.QuickPay', {
                url: '/QuickPay',
                views: {
                    "top-menu": {
                        templateUrl: 'Pages/QuickPay/QuickPayHeader.html'
                    },
                    "main-content": {
                        templateUrl: 'Pages/QuickPay/QuickPay.html',
                        controller: 'QuickPayController'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.QuickPay.Step1', {
                url: '/QuickPayStep1',
                views: {
                    "QuickPaySteps": {
                        templateUrl: 'Pages/QuickPay/Step1.html',
                        controller: 'QuickPayStep1Controller'
                    }
                }
            });
            $stateProvider.state('TopMenuLayout.QuickPay.Step2', {
                url: '/QuickPayStep2?contractAccountNumber?emailId?billAmount?email?invoiceNumber?phoneNumber?token',
                views: {
                    "QuickPaySteps": {
                        templateUrl: 'Pages/QuickPay/Step2.html',
                        controller: 'QuickPayStep2Controller'
                    }
                }
            });
        }

        function registerStandaloneSmartPay() {
            $stateProvider.state('SmartPayLayout', {
                views: {
                    "body-view": {
                        templateUrl: 'Pages/SmartPayLayout.html',
                        controller: 'SmartPayLayoutController'
                    }
                }
            });
            function registerSmartPay(urlPageName, stateName) {
                $stateProvider.state('SmartPayLayout.' + stateName, {
                    url: '/' + urlPageName + '?emailId?token?billAmount',
                    views: {
                        "main-content": {
                            templateUrl: 'Pages/SmartPay/SmartPay.html',
                            controller: 'SmartPayController'
                        }
                    }
                });
            }

            registerSmartPay('QuickPay/QuickPayStep2', 'QuickPay');// old url because we have users with the old link
            registerSmartPay('SmartPay', 'SmartPay');// new url

            $stateProvider.state('SmartPayLayout.SmartPayResult', {
                url: '/SmartPayResult?paymentGuid',
                views: {
                    "main-content": {
                        templateUrl: 'Pages/SmartPayResult/SmartPayResult.html',
                        controller: 'SmartPayResultController'
                    }
                }
            });

            $stateProvider.state('SmartPayLayout.SmartPayLeave', {
                url: '/SmartPayLeave?notificationLogId?installmentPlanToken',
                views: {
                    "main-content": {
                        templateUrl: 'Pages/SmartPayLeave/SmartPayLeave.html',
                        controller: 'SmartPayLeaveController'
                    }
                }
            });

            $stateProvider.state('SmartPayLayout.Preferences', {
                url: '/SmartPayPreferences?token',
                views: {
                    "main-content": {
                        templateUrl: 'Pages/SmartPayPreferences/SmartPayPreferences.html',
                        controller: 'SmartPayPreferencesController'
                    }
                }
            });
        }

        if(utilli.isWglcx())
            registerStandaloneSmartPay();
        else 
            registerStandaloneQuickPay();

        $stateProvider.state('TopMenuLayout.DocuSign', {
            url: '/DocuSign?contractAccountNumber?billAmount?email?phoneNumber?event?bcaId?bcaManagerEmail?token?orderNumber',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/DocuSign/DocuSign.html',
                    controller: 'DocuSignController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.DocuSignStart', {
            url: '/DocuSignStart?contractAccountNumber?billAmount?email?phoneNumber?orderNumber?bcaId?bcaManagerEmail?token',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/DocuSignStart/DocuSignStart.html',
                    controller: 'DocuSignStartController'
                }
            }
        });
        
        $stateProvider.state('TopMenuLayout.AdobeSign', {
            url: '/AdobeSign?contractAccountNumber?billAmount?email?phoneNumber?event?bcaId?bcaManagerEmail?token?orderNumber',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/AdobeSign/AdobeSign.html',
                    controller: 'AdobeSignController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.AdobeSignStart', {
            url: '/AdobeSignStart?contractAccountNumber?billAmount?email?phoneNumber?orderNumber?bcaId?bcaManagerEmail?token',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/AdobeSignStart/AdobeSignStart.html',
                    controller: 'AdobeSignStartController'
                }
            }
        });


        $stateProvider.state('TopMenuLayout.LinkShortener', {
            url: '/s/:key',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/LinkShortener/LinkShortener.html',
                    controller: 'LinkShortenerController'
                }
            },
            params: {
                key: {
                    value: null,
                    squash: true
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageCenter', {
            url: '/Outages?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageCenter/OutageCenter.html',
                    controller: 'OutageCenterController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.PublicFaqs', {
			//we use this url in TaksRunner
            url: '/PublicFaqs', 
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/Faqs/Faqs.html',
                    controller: 'FaqsController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageMap', {
            url: '/OutageMapSignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageMap/OutageMap.html',
                    controller: 'OutageMapController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.TurnOffMap', {
            url: '/TurnOffMap',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/FieldServiceEngineer/TurnOffMap/TurnOffMap.html',
                    controller: 'TurnOffMapController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageList', {
            url: '/OutageListSignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageList/OutageList.html',
                    controller: 'OutageListController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OpenOutageReport', {
            url: '/OpenOutageSignedOut?Id&mode&anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OpenOutageReport/OpenOutageReport.html',
                    controller: 'OpenOutageReportController'
                }
            }
        });

        $stateProvider.state('TopMenuLayout.OutageSafety', {
            url: '/OutageSafetySignedOut?anonymous',
            views: {
                "top-menu": {
                    templateUrl: 'Pages/CommonHeader/CommonHeader.html',
                    controller: 'CommonHeaderController'
                },
                "main-content": {
                    templateUrl: 'Pages/OutageSafety/OutageSafety.html',
                    controller: 'OutageSafetyController'
                }
            }
        });
    }])
    .config(['$provide', function ($provide) {
        // add fixedFinally to all $q promises https://stackoverflow.com/a/17889426/292787
        $provide.decorator('$q', ["$delegate", function ($delegate) {
            var promisePatcher = function (promise){
                promise.fixedFinally = function (fn) {
                    return promise['finally'](fn);
                };
                // then also should return fixed object
                var originalThen = promise.then;
                promise.then = function () {
                    var self = this;
                    var originalThenResult = originalThen.apply(self, arguments);
                    originalThenResult.fixedFinally = function (fn) {
                        return originalThenResult['finally'](fn);
                    };
                    return originalThenResult;
                };
            }

            var originalDefer = $delegate.defer;
            $delegate.defer = function () {
                var deferred = originalDefer();
                promisePatcher(deferred.promise);
                return deferred;
            };
            // apply the patch also to $q.resolve()
            var originalResolve = $delegate.resolve;
            $delegate.resolve = function(){
                var self = this;
                var resolvedPromise = originalResolve.apply(self, arguments);
                promisePatcher(resolvedPromise);
                return resolvedPromise;
            }
            return $delegate;
          }]);
        
        $provide.decorator('$http', ["$delegate", function ($delegate) {
            var $http = $delegate;

            // status === 0 or -1 - means that request was cancelled.
            // requests cancelling happens when we move from one page to another.
            // if a request was cancelled then we skip error handling to avoid modal 
            // pop-ups with messages after user already moved to another page.
            var skippingErrorStatusCodeHandling = 0;

            // "finally" may not work in old android browsers, because "finally" was a reserved keyword in javascript.
            // here i add wrapper method 'fixedFinally' to be used instead of 'finally'
            function fixFinally(promise){
                if (!promise || !promise['then']) // if it's not a promise then just return whatever it is
                    return promise;
                promise.fixedFinally = function (fn) {
                    return promise['finally'](fn);
                };
                return promise;
            }

            /** adds method apiThen in addition to regular then */
            function addApiThen(ajaxPromise){
                /** same as regular 'then' but with built-in error handling */
                ajaxPromise['apiThen'] = function(successCallback, errorHandler){
                    // errorHandler can be either ModalServiceExt or $scope.errors
                    var scopeErrors = $.isArray(errorHandler) ? errorHandler : null;
                    var ModalServiceExt = errorHandler.showAjaxError ? errorHandler : null;
                    var errorCallback = typeof errorHandler === "function" ? errorHandler : null;
                    return ajaxPromise.then(function(response){
                        // if $scope.errors is passed then check ApiResponse for errors and return Data
                        if (scopeErrors)
                            scopeErrors.length = 0;
                        if (!response.data.Errors || !response.data.Errors.length)
                            return successCallback(response.data.Data);
                        console.error(response.data.Errors[0]);
                        if (scopeErrors) {
                            _.forEach(response.data.Errors, function(item){
                                scopeErrors.push(item);
                            });
                        }
                        else if (ModalServiceExt) {
                            ModalServiceExt.showError(response.data.Errors[0]);
                        }
                        else if (errorCallback)
                            errorCallback(response.data.Errors);
                    }, function(error) {
                        console.error(error);
                        if (ModalServiceExt){
                            ModalServiceExt.showAjaxError(error);
                        }
                        else if (scopeErrors) {
                            scopeErrors.push(error);
                        }
                        if (errorCallback)
                            errorCallback(error);
                    });
                };
            }
            
            // ajaxPromise - a promise returned by $http or a shortcut like $http.get, $http.post etc
            var fixHttpPromise = function (ajaxPromise) {
                // fix the deprecated method 'error'
                var originalErrorMethod = ajaxPromise['error'];
                ajaxPromise['error'] = function utilliErrorWrapper() {
                    if (arguments.length === 0)
                        return originalErrorMethod.apply(ajaxPromise, arguments);
                    var originalErrorHandler = arguments[0];
                    var errorHandlerWrapper = function () {
                        if (arguments.length > 1 && arguments[1] <= skippingErrorStatusCodeHandling)
                            return null;
                        return originalErrorHandler.apply(originalErrorHandler, arguments);
                    };
                    return originalErrorMethod.apply(ajaxPromise, [errorHandlerWrapper]);
                }
                ajaxPromise['success'] = function utilliSuccessShim(successCallback) {
                    var e = null;

                    originalThenMethod.apply(ajaxPromise, [function(data){
                        if (successCallback)
                            successCallback(data.data);
                    }, function(error){
                        if (e && error.status > skippingErrorStatusCodeHandling)
                            e(error);
                    }]);

                    return {
                        error: function(errorCallback){
                            e = errorCallback;
                        }
                    }
                }
                // fix the method 'then' of the ajax promise
                var originalThenMethod = ajaxPromise['then'];
                ajaxPromise['then'] = function utilliThenWrapper() {
                    // if error handler method is not specified in 'then'.
                    if (arguments.length === 1){
                        return fixFinally(originalThenMethod.apply(ajaxPromise, arguments));
                    }
                    // if both success and error handlers are specified
                    var thenSuccessHandler = arguments[0];
                    var originalThenErrorHandler = arguments[1];
                    var thenErrorHandlerWrapper = function () {
                        if (arguments.length == 1 && arguments[0].status <= skippingErrorStatusCodeHandling)
                            return null;
                        return fixFinally(originalThenErrorHandler.apply(originalThenErrorHandler, arguments));
                    };
                    return fixFinally(originalThenMethod.apply(ajaxPromise, [thenSuccessHandler, thenErrorHandlerWrapper]));
                };
                addApiThen(ajaxPromise);
                return ajaxPromise;
            }

            // apply the fix to the function $http itself to handle such calls like $http({url: url, method: "GET"})...
            var wrapper = function () {
                var promise = $http.apply($http, arguments);
                return fixHttpPromise(promise);
            };

            // apply the fix to all shortcuts: $http.get, $http.head, $http.post, $http.put, $http.delete, $http.jsonp, $http.patch
            Object.keys($http).filter(function (key) {
                return (typeof $http[key] === 'function');
            }).forEach(function (key) {
                wrapper[key] = function () {
                    var promise = $http[key].apply($http, arguments);
                    return fixHttpPromise(promise);
                };
            });
            return wrapper;
        }]);
    }])
    .config([
        '$httpProvider', function ($httpProvider) {
            // see http://stackoverflow.com/a/20276775
            // and also http://www.bennadel.com/blog/2615-posting-form-data-with-http-in-angularjs.htm
            // Use x-www-form-urlencoded Content-Type
            $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

            /**
         * The workhorse; converts an object to x-www-form-urlencoded serialization.
         * @param {Object} obj
         * @return {String}
         */
            var param = function (obj) {
                var query = '', name, value, fullSubName, subName, subValue, innerObj, i;

                for (name in obj) {
                    value = obj[name];

                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + '[' + i + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    } else if (value instanceof Object) {
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    } else if (value !== undefined && value !== null)
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                }

                return query.length ? query.substr(0, query.length - 1) : query;
            };

            // Override $http service's default transformRequest
            $httpProvider.defaults.transformRequest = [
                function (data) {
                    return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
                }
            ];
        }
    ])
    .run(['$rootScope', '$state', '$http', '$window', '$location', '$document', 'RequestService', 'CheckVersionService',
        'ServerCacheService', 'ModalServiceExt', '$resource', 'productTourService',
        function ($rootScope, $state, $http, $window, $location, $document, RequestService, CheckVersionService,
            ServerCacheService, ModalServiceExt, $resource, productTourService) {

            utilli.registerGoogleAnalytics($window, $rootScope, $location);

            $document.bind('keyup', function(e) {
                $rootScope.$broadcast('keyup', e);
            });

            //https://stackoverflow.com/a/39621112/292787
            function _arrayBufferToBase64(buffer) {
                var binary = '';
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            }

            //because it couldn't be loaded when we don't have an internet connection.
            function preLoadNoConnectionPageLogo() {
                var url = 'Images/Utilli-logo.png';
                if (utilli.isAdmin) {
                    if (DeploymentSettings.providersGroupShortName === 'wgl'
                        || DeploymentSettings.providersGroupShortName === 'wglcx')
                        url = '../Images/Wgl-logo.png';
                    else 
                        url = '../Images/Utilli-logo.png';
                }
                else {
                    if (DeploymentSettings.providersGroupShortName === 'wgl'
                        || DeploymentSettings.providersGroupShortName === 'wglcx')
                        url = 'Images/Wgl-logo.png';
                }
                $http({
                    method: 'GET',
                    url: url,
                    responseType: 'arraybuffer'
                }).then(function (r) {
                    utilli.logoBase64 = 'data:image/png;base64,' + _arrayBufferToBase64(r.data);
                });
            }
			
			preLoadNoConnectionPageLogo();

            utilli.registerLocalization($rootScope, $resource);

            // if it was refresh (F5 pressed) then send request to refresh server cache.
            ServerCacheService.clearServerCache();

            //it is work around of https://issues.apache.org/jira/browse/CB-11751
            //we must delete this code after it will be fixed
            if (!$window.extendedSplashScreen)
                $window.extendedSplashScreen = {};

            if(!utilli.isWglcxPortal())
                FastClick.attach(document.body);

            var lastLocationChangeTimestamp;
            // this is the mechanism how to detect browser's back/forward button pressed. The feature is: when back button is pressed the 
            // $locationChangeSuccess event is fired the first, then $watch for $location.path() is called. 
            // When a user uses links or buttons except 'back button' then $watch is called the first and after that $locationChangeStart is fired.
            // see http://stackoverflow.com/questions/15813850/detect-history-back-using-angular
            $rootScope.$on('$locationChangeSuccess', function () {
                $rootScope.actualLocation = $location.path();
                lastLocationChangeTimestamp = new Date();
                ModalServiceExt.clear();
            });

            $rootScope.$watch(function () { return $location.path(); }, function (newLocation) {
                if ($rootScope.actualLocation === newLocation) {
                    // back button was pressed.
                    RequestService.abort(lastLocationChangeTimestamp);
                }
            });


            $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
                if (!utilli.isAdmin && !utilli.isWglcxPortal() && productTourService.isTourActive())
                    productTourService.pauseTour();

                var isAccountDataValid = itemNotNull('CurrentAccountNumber') && itemNotNull('CurrentUtilityType');
                if (utilli.hasAgentRole() && isProtectedPage(toState) && !isAccountDataValid) {
                    if(fromState.name)
                        e.preventDefault();
                    else {
                        e.preventDefault();
                        $state.goMainLayout('Search');
                    }
                }
            });

            function hasAgentsAccess() {
                var isAccountDataValid = itemNotNull('CurrentAccountNumber') && itemNotNull('CurrentUtilityType'); 
                utilli.hasAgentRole() && isProtectedPage(toState) && !isAccountDataValid
            }

            function itemNotNull(name) {
                var result = localStorage.getItem(name) != null && localStorage.getItem(name) != "null";
                return result;
            }
            
            function isProtectedPage (toState) {
                var result = toState.name == 'MainLayout.Dashboard' || toState.name  == 'MainLayout.BillsAndPayments' || toState.name  == 'MainLayout.MeterData';
                return result;
            }

            // state extensions
            $state.goMainLayout = function (stateName, params, options) {
                var fullStateName = $state.getMainLayoutStateName(stateName);
                if (utilli.isAdmin) {
                    params = params || {};

                    if (options && options.reload === stateName)
                        options.reload = fullStateName;

                    params.userId = $state.params.userId;
                    params.propertyManager = $state.params.propertyManager;
                    params.contractAccountNumber = $state.params.contractAccountNumber;
                    $state.go(fullStateName, params, options);
                } else {
                    if (options && options.reload === stateName)
                        options.reload = fullStateName;
                    $state.go(fullStateName, params, options);
                }
                //utilli.scrollTop(); // on some pages (Profile for example) scroll top doesn't happen automatically. why?
            };

            $state.getMainLayoutStateName = function(stateName) {
                if (utilli.isAdmin) {
                    return 'AdminMainLayout.Customer.CustomerLayout.' + stateName;
                } else {
                    return 'MainLayout.' + stateName;
                }
            }

            $state.goTopMenuLayout = function (stateName) {
                $state.go('TopMenuLayout.' + stateName);
            };

            $state.goToWelcome = function (params) {
                if (isMobileOrRipple()) {
                    $state.go('WelcomeMobile', params);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    if (utilli.hasAgentRole())
                        $state.goToAgentsWelcome(params);
                    else if (utilli.hasAssistantRole())
                        $state.goToAssistantsWelcome(params);
                    else if (utilli.hasPropertyManagerRole() || utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(params);
                    else
                        $state.go('TopMenuLayout.Welcome', params, { reload: true });
                }
            };

            $state.goToMaintenance = function(){
                if (utilli.isWglcx() && !utilli.isAdmin){
                    $state.go('SmartPayLayout.Maintenance');
                } else {
                    $state.go('Maintenance');
                }
            }

            $state.goToAgentsWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomeAgent', params, { reload: true });
            }

            $state.goToAssistantsWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomeAssistant', params, { reload: true });
            }

            $state.goToPropertyManagersWelcome = function (params) {
                $state.go('TopMenuLayout.WelcomePropertyManager', params, { reload: true });
            }

            /**
             * Changes current state to 'SignIn'.
             * @param {bool} withRedirect When true then it remembers the current state and 
             * will redirect to it after login
             */
            $state.goToSignIn = function (withRedirect) {
                if (withRedirect){
                    console.log('redirect from ' + this.current.name);
                }
                // note: this.params.from may already exist if we redirected the user explicitly to sign in.
                // it may happen for example if the user comes to the PayNow page by a direct link from email.
                // in this case if he is not logged in then we redirect him explicitly from PayNow to SignIn
                // so that he will land on SignIn.
                var redirectedFrom = withRedirect && !this.params.from // if from already exists then don't replace it
                    ? { from: JSON.stringify({ stateName: this.current.name, stateParams: this.params }) }
                    : null;
                if (isMobileOrRipple()) {
                    if (utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(redirectedFrom);
                    else
                        $state.go('TopMenuLayout.SignIn.Credentials', redirectedFrom);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    if (utilli.isPropertyManagerApp())
                        $state.goToPropertyManagersWelcome(redirectedFrom);
                    if (utilli.isWglcx()) {
                        if (utilli.isAdmin) 
                            $state.goToWelcome(redirectedFrom);
                        else
                            $state.go('TopMenuLayout.SignIn.Credentials');
                    }
                        
                    else
                        $state.go('TopMenuLayout.Welcome', redirectedFrom, { reload: true });
                }
            };

            $state.goToSignUp = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.SignUpPropertyManager.Step1');
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    $state.go('TopMenuLayout.SignUp.Step1');
                }
            }

            $state.goToForgotPassword = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.ForgotPasswordByEmail.Step1');
                } else {
                    $state.go('TopMenuLayout.ForgotPassword.Step1');
                }
            }

            $state.goToForgotUserID = function () {
                if (isMobileOrRipple() && utilli.isPropertyManagerApp()) {
                    $state.go('TopMenuLayout.ForgotUserIdByEmail.Step1');
                } else {
                    $state.go('TopMenuLayout.ForgotUserId.Step1');
                }
            }

            $state.goToSignInWithRedirectTo = function (to) {

                var redirectTo = to ? { from: JSON.stringify({ stateName: to }) } : null;

                if (isMobileOrRipple()) {
                    $state.go('TopMenuLayout.SignIn.Credentials', redirectTo);
                } else {
                    // if add a reload then it loads child states
                    // but looses current child states
                    $state.go('TopMenuLayout.Welcome', redirectTo, { reload: true });
                }
            };

            $state.includesChild = function (childStateName) {
                return $state.current.name.indexOf(childStateName) >= 0;
            }

            $state.goFromWelcomeTo = function (stateName, params) {
                if (isMobileOrRipple()) {
                    return $state.go('TopMenuLayout.' + stateName, params);
                } else {
                    return $state.go('TopMenuLayout.Welcome.' + stateName, params);
                }
            };
            $state.goRelativeTo = function (parentName, childName, params) {
                var parentPos = $state.current.name.indexOf(parentName);
                if (parentPos < 0)
                    return $state;

                var topRoute = $state.current.name.slice(0, parentPos);
                return $state.go(topRoute + parentName + '.' + childName, params);
            };

            // check app version compatibility with deployed back-end system
            if (isMobileOrRipple()) {
                CheckVersionService
                    .checkVersion()
                    .then(function (result) {
                        if (CheckVersionService.isVersionWrong(result))
                            $state.go('UpdateApp');
                            // result should be either correct or wrong,
                            // otherwise it's unexpected result and most probably
                            // the internet connection is just missing or
                            // our server (ProvidersWebApi project) is completely down
                        else if (!CheckVersionService.isVersionCorrect(result)){
                            if (!window.disableNoConnectionPage) {
                            $state.go('NoConnection');
                            }
                        }
                    });
            }
        }])
    .directive('ngBindHtmlDynamic', ["$compile", function($compile) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngBindHtmlDynamic, function(html) {
                    element[0].innerHTML = html;
                    $compile(element.contents())(scope);
                });
            }
        };
    }])
    .directive('showFocus', ["$timeout", function($timeout) {
        return function(scope, element, attrs) {
          scope.$watch(attrs.showFocus, 
            function (newValue) { 
              $timeout(function() {
                  newValue && element.focus();
              });
            },true);
        };    
    }])
    // restrict user to enter into an input only digits
    .directive('restrictCurrency', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var fixNumberFormat = function (element) {
                    if (element.value == '') {
                        return;
                    }
                    if (!isNumberFormatCorrect(element.value)) {
                        element.value = Number(0).toFixed(2);
                        return;
                    }
                    // format as 0.00
                    element.value = Number(element.value).toFixed(2);
                };

                $(element).keyup(function () {
                    // NOTE: when input type is 'number' there is an issue:
                    // https://docs.angularjs.org/api/ng/input/input%5Bnumber%5D
                    // see 'Issues with HTML5 constraint validation'
                    // !this.value - this is necessary to allow a user to enter dot first
                    // because when a user enters dot this.value is empty here
                    if (!this.value || !this.value.trim() || isNumberFormatCorrect(this.value))
                        return;
                    this.value = this.oldValue;// we can't do just slice, because user can be entering in the middle
                });
                $(element).keydown(function (e) {
                    if (e.keyCode === 13) {
                        fixNumberFormat(this);
                        e.preventDefault();
                        return;
                    }
                    this.oldValue = this.value;// save for future use in key-up
                });
                $(element).focusout(function () {
                    fixNumberFormat(this);
                });
            }
        };
    })
    // restrict user to enter the cell phone number in the +1 (999) 999-9999 format
    .directive('phoneTemplate', ['$timeout', '$window', function ($timeout, $window) {
        return {
            link: function ($scope, element) {
                $window.$(element).mask(Config.phoneNumberMask);
            }
        };
    }])
    .directive('ccNumberTemplate', ['$timeout', '$window', function ($timeout, $window) {
        return {
            link: function ($scope, element) {
                $window.$(element).mask(Config.ccNumberMask, { placeholder: "" });
            }
        };
    }]);

'use strict';

angular.module('utilliApp')
    .controller('CommonHeaderController', [
        '$scope', 'CommonHeaderService',
        function ($scope, CommonHeaderService) {
            $scope.CommonHeaderService = CommonHeaderService;
        }
    ]);
'use strict';
angular.module('utilliApp').factory('CommonHeaderService', [
// ReSharper disable InconsistentNaming
    '$window', '$state', 'HeaderServiceFactory', function ($window, $state, HeaderServiceFactory) {
// ReSharper restore InconsistentNaming
        var baseService = HeaderServiceFactory.getHeaderSerivce();
        return baseService;
    }
]);
'use strict';
/** Service to maintain state between page moves */
angular.module('utilliApp').service('SmartPayStateService', function () {
    var _t = utilli._t;
    var svc = {};
    var model = {};
    svc.model = model;
    model.paymentMethod = 'card';
    model.receipt = {};
    model.isPayByCard = function () {
        return model.paymentMethod === 'card';
    }
    model.isPayByCheck = function () {
        return model.paymentMethod === 'eCheck';
    }
    model.isPayByWallet = function () {
        return model.paymentMethod === 'wallet';
    }
    model.isPayAndSaveCardWithConfirmation = function () { 
        return model.isPayByCard() && model.saveThisCard
            && !model.useSavedCard && !isVerifiedPhoneNumber();
    }
    model.isPayAndSaveCheckWithConfirmation = function () { 
        return model.isPayByCheck() && model.saveThisBankAccount
            && !model.useSavedBankAccount && !isVerifiedPhoneNumber();
    }
    model.isConfirmationCodeKnown = function () {
        var isPayBySaveCardWithCvv = model.isPayByCard() && model.useSavedCard && model.isCvvConfirmationTypeActive;
        return model.smsCodeSent || isPayBySaveCardWithCvv;
    }
    model.isPayBySavedCard = function () { 
        return model.isPayByCard() && model.useSavedCard;
    }
    model.isPayBySavedCheck = function () { 
        return model.isPayByCheck() && model.useSavedBankAccount;
    }
    model.isResendTimerVisible = function () {
        return (model.saveThisCard || model.useSavedCard) && model.canShowTimer && !model.sendSmsCodeError;
    }
    model.resetResendButton = function () {
        model.canShowTimer = false;
        model.sendSmsCodeError = null;
        model.smsCodeSent = false;
        model.timeout = 0;
    }
    model.needToUseCvvValidation = function () { 
        return model.isCvvConfirmationTypeActive && model.useSavedCard && model.isPayByCard();
    }
    model.resetPaymentOptionsAttributes = function () {
        model.nameOnCard = '';
        model.cardNumber = '';
        model.expirationDate = '';
        model.saveThisCard = false;

        model.nameOnAccount = '';
        model.routingNumber = '';
        model.bankAccountNumber = '';
        model.reenterBankAccountNumber = '';
        model.saveThisBankAccount = false;

        model.useSavedBankAccount = false;
        model.useSavedCard = false;
        model.verificationCode = '';
        model.canRequestVerificationCode = true;
        model.isCvvConfirmationTypeActive = false;
        model.smsCodeSent = false;
    }
    function isVerifiedPhoneNumber() { 
        if (!model.allPhoneNumbers)
            return false;
        var verified = _.filter(model.allPhoneNumbers, function(p){
            return p.PhoneNumber == model.phoneNumber && p.IsVerified;
        });
        return verified.length > 0;
    }
    return svc;
});


'use strict';
/** Service to share state between SmartPayLayout and other pages. */
angular.module('utilliApp').service('SmartPayLayoutService', function () {
    var svc = {};
    return svc;
});

'use strict';
angular.module('utilliApp').controller('SmartPayLayoutController', 
    ["$rootScope", "$scope", "SmartPayLayoutService", "$state", "ServiceProvidersService", "ModalServiceExt", "$resource", function ($rootScope, $scope, SmartPayLayoutService, $state,
        ServiceProvidersService, ModalServiceExt,$resource) 
{
    $rootScope.getBodyClass = function () {
        return { 'smart-pay': true };
    }
    $scope.svc = SmartPayLayoutService;

    //  $scope.languageT=localStorage.getItem("language");
    
    $rootScope.$on("languageChangedOutside", function(evt,data){ 
        $scope.languageT=localStorage.getItem("language");
     });

     $scope.languageSwitch=false;
     $rootScope.$on("enableLanguageSwitch", function(evt,data){ 
        $scope.languageSwitch=true;
     });
    var firebaseWebPushService;
    var apiUrl;
    ServiceProvidersService.getCurrentProvider()
        .then(function (providerData) {
            apiUrl = providerData.ApiUrl;

            if(utilli.isFirefox) {
                firebaseWebPushService = createFirebaseWebPushService(apiUrl);
            }        
        })
        .catch(function(){
            ModalServiceExt.showServerError();
        });

    $scope.isWebPushBellBoxVisible = function () {
        var result = (utilli.isFirefox && Notification.permission == "default")
            || (utilli.isSafari 
                && 'safari' in window 
                && 'pushNotification' in window.safari
                && utilli.getSafariPushNotificationPermissionData().permission === 'default');
        
        return result;
    };

    $scope.askPermissionsForWebPush = function () { 
        if(utilli.isFirefox) {
            firebaseWebPushService.subscribe($scope);
        }
        else if ('safari' in window && 'pushNotification' in window.safari) {
            utilli.checkSafariRemotePermission($scope, apiUrl, $state.params.token);
        }
    }

    $scope.changeLanguage = function (data) { 
        $scope.languageT=data;
        localStorage.setItem('language', $scope.languageT);
        utilli.registerLocalization($rootScope, $resource);
        $rootScope.$broadcast("languageChanged",$scope.languageT);
    };
}]);


'use strict';
angular.module('utilliApp')
.controller('ChallengeEmailSucceedController', ['$scope', '$http', '$stateParams', '$sce', '$state', '$location',
        'ServiceProvidersService', 'usSpinnerService',
    // ReSharper disable InconsistentNaming
    function ($scope, $http, $stateParams, $sce, $state, $location, ServiceProvidersService, usSpinnerService) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming
        $scope.validateToken = function ()
        {
            $scope.status = _t('Email verification...');
            if (!$stateParams.token)
            {
                $scope.errors = [utilli.errors.serverErrorMessage];
                usSpinnerService.stop('spinner-1');
                return;
            }
            setWelcomePageLink($stateParams.token);
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
                .then(
                function(providerData){
                    var url = providerData.ApiUrl + 'api/Registration/ChallengeEmail';
                    $http({
                        url: url,
                        method: 'GET',
                        params: { verificationToken: $stateParams.token },
                        withoutAuthentication: true
                    }).success(function(data) {
                        usSpinnerService.stop('spinner-1');
                        if (data.Errors && data.Errors.length > 0) {
                            $scope.errors = data.Errors;
                            return;
                        }
                        $scope.status = _t('Your Email Has Been Verified');
                        $scope.html = $sce.trustAsHtml(data.Data.Html);
                    }).error(function() {
                        usSpinnerService.stop('spinner-1');
                        $scope.errors =  [utilli.errors.serverErrorMessage];
                    });
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    $scope.errors = [utilli.errors.serverErrorMessage];
                });
        };

        function setWelcomePageLink(token) {

            var roles = utilli.getPayload(token).roles;
            if (roles) {
                var isAgent = _.some(roles, function (role) {
                    return role === utilli.roles.Agent;
                });
                var isPropertyManager = _.some(roles, function (role) {
                    return role === utilli.roles.PropertyManager;
                });
                if (isAgent)
                    $scope.welcomePath = 'TopMenuLayout.WelcomeAgent';
                else if (isPropertyManager)
                    $scope.welcomePath = 'TopMenuLayout.WelcomePropertyManager';
                else
                    $scope.welcomePath = 'TopMenuLayout.Welcome';
            }

        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('MobilePhoneConfirmationController', ['$scope', '$http', '$state', '$stateParams', '$sce', '$timeout',
    '$location', 'ServiceProvidersService', 'ModalServiceExt', 'usSpinnerService', 'NotificationBoxService',
    'CommonHeaderService', 'LeftMenuService',
    function ($scope, $http, $state, $stateParams, $sce, $timeout, $location, ServiceProvidersService,
        ModalServiceExt, usSpinnerService, NotificationBoxService, CommonHeaderService, LeftMenuService) {
        NotificationBoxService.setTemporarilyHide(true);
        LeftMenuService.show();
        CommonHeaderService.setUpBackButton($scope._t('Confirmation'));

        $scope.forProgramEnrollments = $stateParams.forProgramEnrollments;
        $scope.forProgramEnrollmentsLearnMore = $stateParams.forProgramEnrollmentsLearnMore;

        $scope.phoneNumberMask = Config.phoneNumberMask;
        var countryCode = utilli.getCountryPhoneNumberCode();
        $scope.confirmationCodeMask = "9999";
        $scope.phoneNumber = $stateParams.phoneNumber;

        $scope.verificationCodeRequested = false;
        $scope.canRequestVerificationCode = true;

        (function () {
            usSpinnerService.spin("spinner-1");
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/StaticData/GetPhoneNumberConfirmationDisclamer',
                method: 'GET'
            }).success(function (data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                $scope.errors = [ $scope._t('Server error. Try again later.') ];
            });
        })();

        $scope.timeout = 15;
        $scope.timeoutStr = '' + $scope.timeout;

        var tickTimer = function () {
            if ($scope.timeout != 0) {
                $scope.timeout--;
                $timeout(tickTimer, 1000);
            } else {
                $scope.canRequestVerificationCode = true;
            }

            $scope.timeoutStr = '' + $scope.timeout;
            if ($scope.timeoutStr.length < 2) {
                $scope.timeoutStr = '0' + $scope.timeoutStr;
            }
        }

        $scope.sendVerificationCode = function () {
            $scope.errors = [];
            if (validatePhoneNumber()) {
                $scope.canRequestVerificationCode = false;

                $scope.timeout = 15;
                $scope.timeoutStr = '' + $scope.timeout;

                $timeout(tickTimer, 1000);

                usSpinnerService.spin('spinner-1');
                var url = localStorage.getItem('ApiUrl') + 'api/Profile/GenerateNewPhoneConfirmationCode';
                var requestData = {
                    phoneNumber: countryCode + $scope.phoneNumber
                };
                utilli.addUserName($state, requestData);
                usSpinnerService.spin('spinner-1');
                $http({
                    url: url,
                    method: 'GET',
                    params:requestData
                }).success(function (data) {
                    if (data.Errors && data.Errors.length > 0) {
                        $scope.errors = data.Errors;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    usSpinnerService.stop('spinner-1');
                    $scope.verificationCodeRequested = true;
                }).error(function () {
                    $scope.errors = [$scope._t('Server error. Try again later.')];
                    usSpinnerService.stop('spinner-1');
                });
            }
        }

        $scope.confirmPhone = function () {
            $scope.errors = [];
            if (validateConfirmationCode()) {
                var url = localStorage.getItem('ApiUrl') + 'api/Profile/ConfirmPhoneNumber';
                usSpinnerService.spin('spinner-1');
                var requestData = {
                    phoneNumber: countryCode + $scope.phoneNumber,
                    code: $scope.confirmationCode
                }
                utilli.addUserName($state, requestData);
                $http({
                    url: url,
                    method: 'GET',
                    params: requestData
                }).success(function (data) {
                    if (data.Errors && data.Errors.length > 0) {
                        $scope.errors = data.Errors;
                        usSpinnerService.stop('spinner-1');
                        return;
                    } else {
                        NotificationBoxService.setSubscribeSmsVisibilityServerFlag(false);
                        var maskedPhone = utilli.getMaskedPhoneNumberValue(countryCode + $scope.phoneNumber);
                        var popupMessage = $scope._t('Your cell phone number') + ' ' + maskedPhone + ' ' + $scope._t('has been successfully verified for Utilli SMS notifications.');
                        ModalServiceExt.showMessage($scope._t('SMS Notifications'), popupMessage, function() {
                            if ($scope.forProgramEnrollments)
                                $state.goMainLayout('ProgramEnrolments');
                            else if ($scope.forProgramEnrollmentsLearnMore)
                                $state.goMainLayout('SmsNotificationsLearnMore');
                            else
                                $state.goMainLayout('Profile');
                        });
                        usSpinnerService.stop('spinner-1');
                    }
                }).error(function () {
                    $scope.errors = [ $scope._t('Server error. Try again later.') ];
                    usSpinnerService.spin('spinner-1');
                });
            }
        }

        function validatePhoneNumber() {
            var valid = true;
            $scope.phoneNumberError = false;

            if (!$scope.phoneNumber) {
                $scope.phoneNumberError = true;
                valid = false;
            }

            return valid;
        }

        function validateConfirmationCode() {
            var valid = true;
            $scope.confirmationCodeError = false;

            if (!$scope.confirmationCode) {
                $scope.confirmationCodeError = true;
                valid = false;
            }

            return valid;
        }

        $scope.back = function () {
            if ($scope.forProgramEnrollments)
                $state.goMainLayout('ProgramEnrolments');
            else if ($scope.forProgramEnrollmentsLearnMore)
                $state.goMainLayout('SmsNotificationsLearnMore');
        }

        $scope.$on('$destroy', function () {
            NotificationBoxService.setTemporarilyHide(false);
        });
    }]);
'use strict';
angular.module('utilliApp')
.controller('TermsAndConditionsController', ['$scope', '$http', '$sce', 'usSpinnerService',
    'ServiceProvidersService', 'CommonHeaderService',
    // ReSharper disable InconsistentNaming
    function ($scope, $http, $sce, usSpinnerService, ServiceProvidersService, CommonHeaderService) {
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        CommonHeaderService.setUpBackButton(_t('Terms and Conditions'), true);
        $scope.loadContent = function () {
            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function(providerData) {
                    var provider = providerData;
                    var url = provider.ApiUrl + 'api/StaticData/GetTermsAndConditions';
                    $http({
                        url: url,
                        method: 'GET'
                    }).success(function(data) {
                        $scope.html = $sce.trustAsHtml(data);

                        usSpinnerService.stop("spinner-1");
                    }).error(function() {
                        usSpinnerService.stop("spinner-1");
                        $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                    });
                },
                function() {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors = [{ key: 'Error', Message: utilli.errors.serverErrorMessage }];
                }
            );
        }
}]);
'use strict';
angular.module('utilliApp')
    .controller('SystemInfoController', [
        '$scope', '$http', 'usSpinnerService', 'ServiceProvidersService', 'CommonHeaderService', 'ModalServiceExt',
        // ReSharper disable InconsistentNaming
        function ($scope, $http, usSpinnerService, ServiceProvidersService, CommonHeaderService, ModalServiceExt) {
            // ReSharper restore InconsistentNaming
            CommonHeaderService.setUp();

            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function(providerData) {
                    var provider = providerData;

                    $http({
                        method: 'GET',
                        url: provider.ApiUrl + 'api/System/GetDbInfo'
                    }).success(function(resp) {
                        usSpinnerService.stop('spinner-1');
                        if (!resp || !resp.Data) {
                            ModalServiceExt.showInfo("No response.");
                            return;
                        }

                        $scope.dbInfo = resp.Data;
                    }).error(function() {
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showInfo("Unexpected error.");
                    });

                    $scope.applyMigrations = function() {
                        usSpinnerService.spin('spinner-1');
                        $http({
                            method: 'POST',
                            url: provider.ApiUrl + 'api/System/UpdateDb'
                        }).success(function() {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showInfo("Success.");
                        }).error(function() {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showInfo("Unexpected error.");
                        });
                    };
                });
        }
    ]);
'use strict';
angular.module('utilliApp')
.controller('WelcomeController', ['$scope', '$state',
    'ServiceProvidersService', '$sce', 'usSpinnerService', '$http', 'CommonHeaderService',
function ($scope, $state, ServiceProvidersService, $sce,
    usSpinnerService, $http, CommonHeaderService) {
    CommonHeaderService.setUp();

    $scope.isMultipleProviders = !DeploymentSettings.currentServiceProvider;
    $scope.appUrls = Config.appUrls;
    $scope.enableOutageMap = false;

    if (utilli.goesToDefaultPage($state)) 
        return;

    $state.goFromWelcomeTo('SignIn.Credentials')
        .then(function () {
            $state.goFromWelcomeTo('QuickPay.Step1');
        });

    $scope.goToQuickPay = function (){
        $state.go('TopMenuLayout.SmartPay.Step1');
    };

    $scope.goToOutages = function () {
        $state.go('TopMenuLayout.OutageCenter', { anonymous: true });
    };

    if (DeploymentSettings.currentServiceProvider.length > 0) {
        $scope.serviceProviderName = Config.providers[DeploymentSettings.currentServiceProvider].SiteName;
        $scope.helpEmail = Config.providers[DeploymentSettings.currentServiceProvider].HelpEmail;
        $scope.showPhoneNumbers = Config.providers[DeploymentSettings.currentServiceProvider].EnablePhoneNumbersOnLoginPage;
        $scope.enableOutageMap = Config.providers[DeploymentSettings.currentServiceProvider].EnableOutageMap;
    }
    else {
        $scope.serviceProviderName = 'Utilli';
        $scope.helpEmail = 'help@utilli.com';
    }
    $scope.phoneNumbers = $scope._t('loading...');
    $scope.loadPhoneNumbers = function (){
        ServiceProvidersService.getProviders()
            .then(
                function(providers) {
                    if (!providers || providers.length == 0) {
                        $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                        return;
                    }

                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    if (currentServiceProvider.length == 0) {
                        $scope.phoneNumbers = $scope._t("Configuration error: can't get current service provider.");
                        return;
                    }

                    var currentProviderName = Config.providers[currentServiceProvider].Name;

                    var providersFiltered = $.grep(providers, function(item) {
                        return item.Name == currentProviderName;
                    });

                    if (!providersFiltered || providersFiltered.length !== 1) {
                        $scope.phoneNumbers = $scope._t("Configuration error: can't get current service provider.");
                        return;
                    }

                    $http({
                        url: providersFiltered[0].ApiUrl + 'api/StaticData/GetInqueriesPhoneNumbers',
                        method: "GET",
                    }).success(function(data) {
                        $scope.phoneNumbers = $sce.trustAsHtml(data);
                    }).error(function() {
                        $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                    });
                },
                function() {
                    $scope.phoneNumbers = $scope._t("Server error. Try again later.");
                });
    }
}]);
'use strict';
angular.module('utilliApp')
.factory('SignInService', ['$http', '$rootScope', '$q', 'usSpinnerService', '$state', 'DueReminderService',
    'CommonDataService',
    function ($http, $rootScope, $q, usSpinnerService, $state, DueReminderService, CommonDataService) {
        var svc = {};
        svc.services = [];
        svc.errors = {};
        svc.showResentVerificationEmailField = false;

        svc.resetErrors = function() {
            svc.errors.errorFromServerReturned = false;
            svc.errors.serverErrorInformation = null;
            svc.errors.serverErrors = null;
            svc.errors.showServerErrors = false;
            svc.showResentVerificationEmailField = false;
        }

        function getFromPart(fromAddress) {
            if (utilli.isDebug)
                console.log('redirection from SignInService to Admin portal page ' + fromAddress);

            var redirectedFrom = JSON.parse(fromAddress);
            var fromPart = redirectedFrom.stateName

            if (redirectedFrom.stateParams) {
                _.each(redirectedFrom.stateParams, function (param) {
                    fromPart += '/' + param;
                });
            }

            return fromPart;
        }

        function redirect(state, defaulState) {
            var redirectTo = JSON.parse(state);
            // We need this check for scenario when user tried to enter admin portal by direct url in browser without loging in.
            // After this user will be redirected to sign in page with 'from' part in the url. But after being redirected to 'sign in' page 
            // user desided to log in as regular user (not admin). 
            // In this case 'from' state does not exist for user portal and we should ignore it.
            var checkState = $state.get(redirectTo.stateName);
            if (checkState) {
                if (utilli.isDebug)
                    console.log('redirection from SignInService to ' + state);
                $state.go(redirectTo.stateName, redirectTo.stateParams);
            }
            else {
                $state.goMainLayout(defaulState);
            }
        }

        function _getCurrentProviderName () { 
            var serviceProviderName = localStorage.getItem('ServiceProviderName');
            if(!utilli.checkDefinedValue(serviceProviderName))
                return null;
            for (var providerName in Config.providers){
                var provider = Config.providers[providerName];
                if (provider.Name && provider.Name == serviceProviderName)
                     return providerName;
            }
            return null;
        }

        /**
         * Sets on the scope touchIdAvailable field
         * @param {angularJs scope} scope 
         */
        svc.setIsTouchIdAvailable = function(scope){
            try {
                if (isMobileOrRipple()){
                    if (isAndroid()) {
                        FingerprintAuth.isAvailable(isAvailableSuccess, isAvailableError);
                    } else if (iOS()) {
                        window.plugins.touchid.isAvailable(isAvailableSuccess, isAvailableError);
                    }
                }
            }
            catch (e) {
                console.error('Failed to check if finger print API is available: ' + JSON.stringify(e));
            }

            function isAvailableSuccess(result) {
                console.log("FingerprintAuth available: " + JSON.stringify(result));
                if (isAndroid()) {
                    scope.touchIdAvailable = result.isAvailable && result.hasEnrolledFingerprints;
                }
                else if (iOS()) {
                    scope.touchIdAvailable = true;
                }
            }

            function isAvailableError(message) {
                console.log("isAvailableError(): " + message);
                scope.touchIdAvailable = false;
            }
        }

        svc.signIn = function (login, passwd, apiUrl, serviceProviderName, fromAddress, 
            isTouchIdAvailable, touchIdRefreshToken) {
            var result = $q.defer();
            usSpinnerService.spin('spinner-1');
            var parameters = {
                userNameOrEmail: $.trim(login),
                password: $.trim(passwd),
                client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                mobilePlatform: isMobileOrRipple() ? utilli.getPlatformName() : '',
                rememberMe: false,
                mobileDeviceToken: isMobileOrRipple() ? utilli.getDeviceToken() : '',
                isTouchIdAvailable: isTouchIdAvailable ? true : false,
                touchIdRefreshToken: touchIdRefreshToken
            };
            $http({
                url: apiUrl + 'api/Account/LogOn/',
                method: "POST",
                params: parameters
            }).success(function (response) {
                if (!response) {
                    var errorMessage = $rootScope._t("Server error. Try again later.");
                    result.reject(errorMessage);
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = errorMessage;
                }
                else if (response.ERROR_LIST.length > 0) {
                    svc.errors.showServerErrors = true;
                    svc.errors.serverErrors = response.ERROR_LIST;
                    if (response.ERROR_LIST[0].key == "IncompleteRegistrationError"){
                        svc.showResentVerificationEmailField = true;
                        CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                            $rootScope.contactPhoneNumber = commonData.SupportPhone;
                            $rootScope.workingHours = commonData.WorkingHours;
                            $rootScope.billingEmailTo = commonData.BillingEmailTo;
                            $rootScope.serviceProviderName = commonData.CompanyName;
                            result.reject(response.ERROR_LIST[0].Message);
                            usSpinnerService.stop('spinner-1');
                        });
                        return;// return because the spinner must spin until common data is received
                    }
                    else {
                        svc.showResentVerificationEmailField = false;
                    }
                    result.reject(response.ERROR_LIST[0].Message);
                }
                else if (response.Valid != 1) {
                    var errorMessage = $rootScope._t("We cannot check your credentials. Please try again later.");
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = errorMessage;
                    result.reject(errorMessage);
                }
                else {
                    result.resolve();
                    svc.errors.errorFromServerReturned = false;
                    svc.errors.showServerErrors = false;

                    if (isTouchIdAvailable){
                        localStorage.setItem('touchIdData', JSON.stringify({
                            lastApiUrl: apiUrl,
                            lastServiceProviderName: serviceProviderName,
                            refreshToken: response.TouchIdRefreshToken
                        }));
                    }
                    localStorage.setItem('SecurityToken', response.SecurityToken);
                    localStorage.setItem('ApiUrl', apiUrl);
                    localStorage.setItem('ServiceProviderName', serviceProviderName);
                    localStorage.setItem('language', response.Language);

                    if (!DeploymentSettings.currentServiceProvider) 
                        DeploymentSettings.currentServiceProvider = _getCurrentProviderName();

                    if (!isMobileOrRipple() && response.IsAdmin) {
                        var basePath = window.location.origin + window.location.pathname;
                        if (basePath.indexOf('smart-pay.html') > 0){
                            basePath = basePath.substr(0, basePath.indexOf('smart-pay.html'));
                        }
                        var adminUrl = basePath + 'Admin/#/';
                        if (fromAddress)
                            adminUrl += getFromPart(fromAddress);
                        utilli.setWindowLocation(adminUrl);
                        return;
                    }

                    localStorage.setItem('CurrentAccountNumber', response.CurrentAccountNo);
                    localStorage.setItem('BusinessPartner', response.BusinessPartner);
                    localStorage.setItem('current_user', response.UserName);
                    localStorage.setItem('email', response.Email);

                    if (response.CurrentAccountNo) {
                        DueReminderService.unmarkAsShown();
                        if (fromAddress) {
                            redirect(fromAddress, 'Dashboard');
                        } else
                            $state.goMainLayout('Dashboard');
                    }
                    else if (utilli.hasAgentRole())
                        $state.goMainLayout('Search');
                    else if (utilli.hasAssistantRole())
                        $state.goMainLayout('AssistantSearch');
                    else if (utilli.hasFieldServiceEngineerRole())
                        $state.goMainLayout('WorkCenters');
                    else if (utilli.hasPropertyManagerRole()) {
                        localStorage.setItem('showEsScoreInfoPopup', 'true');
                        if (fromAddress) {
                            redirect(fromAddress, 'PropertyList');
                        } else {
                            $state.goMainLayout('PropertyList');
                        }
                    }
                }
                usSpinnerService.stop('spinner-1');
            }).error(function (e) {
                var errorMessage = $rootScope._t("Server error. Try again later.");
                result.reject(errorMessage);
                svc.errors.errorFromServerReturned = true;
                svc.errors.serverErrorInformation = errorMessage;
                usSpinnerService.stop('spinner-1');
            });
            return result.promise;
        };

        svc.resendVerificationEmail = function (login, passwd, apiUrl, serviceProviderName) {
            usSpinnerService.spin('spinner-1');
            var parameters = {
                userNameOrEmail: $.trim(login),
                password: $.trim(passwd),
            };
            $http({
                url: apiUrl + 'api/Account/SendChallengeEmail/',
                method: "POST",
                params: parameters
            }).success(function (response) {
                  usSpinnerService.stop('spinner-1');
                }).error(function (e) {
                    svc.errors.errorFromServerReturned = true;
                    svc.errors.serverErrorInformation = $rootScope._t("Server error. Try again later.");
                    usSpinnerService.stop('spinner-1');
            });
        };

        svc.showResendVerificationEmail = function () {
            return svc.showResentVerificationEmailField;
        }

        return svc;
    }]);

'use strict';
var app = angular.module('utilliApp');

app.controller('SignInPartController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.setUp();
        $rootScope.errorFromServerReturned = false;
        $rootScope.showServerErrors = false;
        $rootScope.serverErrorInformation = '';
        $rootScope.serverErrors = [];

        $scope.back = function() {
            $state.go('Welcome');
        };
    }]);
'use strict';
var app = angular.module('utilliApp');

app.controller('CredentialsController', ['$rootScope', '$scope', '$state', '$http', 'usSpinnerService', 'SignInService', 
    '$stateParams', 'CommonHeaderService', 'CheckVersionService', '$q',
    function ($rootScope, $scope, $state, $http, usSpinnerService, SignInService, $stateParams, CommonHeaderService,
            CheckVersionService, $q) {

            $rootScope.getBodyClass = function () {
                return { 'smart-pay': false };
            }
            
            if(utilli.isWglcx() && utilli.goesToDefaultPage($state)){
                return;
            }
            var touchIdClientId = "UtilliTouchIdClientId";
            $scope.touchIdAvailable = false;
            SignInService.setIsTouchIdAvailable($scope);
            $scope.hasTouchIdData = localStorage.getItem('touchIdData') != null;

            $scope.loginWithTouchId = function () {
                if (!isMobileOrRipple())
                    return;
                if (isAndroid()) {
                    FingerprintAuth.encrypt({ clientId: touchIdClientId }, fingerPrintSuccess, fingerPrintError);
                } else if (iOS()) {
                    window.plugins.touchid.verifyFingerprint(
                        'Scan your fingerprint please', // this will be shown in the native scanner popup
                        fingerPrintSuccess, fingerPrintError
                    );
                }
            }

            function fingerPrintSuccess() {
                var touchIdDataString = localStorage.getItem('touchIdData');
                var touchIdData = touchIdDataString == null ? null : JSON.parse(touchIdDataString);
                SignInService.signIn(null, null,
                    touchIdData.lastApiUrl,
                    touchIdData.lastServiceProviderName,
                    $stateParams.from, $scope.touchIdAvailable, touchIdData.refreshToken);
            }

            function fingerPrintError(error) {
                console.log("FingerprintAuth Error: " + error);
            }

            var checkVersionPromise = CheckVersionService.checkVersion();
            localStorage.removeItem('ServiceProviderName');

            CommonHeaderService.hideMenuToggleButton();
            $scope.stepName = 'Login';
            $scope.errors = SignInService.errors;
            $scope.showResentVerificationEmail = function () {
                return SignInService.showResendVerificationEmail();
            }
            $scope.showResentVerificationEmailDone = false;

            var _lastLoginWithRequiredEmail;

            $scope.togglePassword = function (pswId, iconId) {
                utilli.togglePasswordVisibility(pswId, iconId);
            }

            $scope.$watch('credentials.login', function () {
                if ($scope.emailRequired)
                    $scope.emailRequired = false;
                if (_lastLoginWithRequiredEmail != undefined && $scope.credentials.login == _lastLoginWithRequiredEmail)
                    $scope.emailRequired = true;
            });

            if (!$scope.credentials) {
                $scope.credentials = {};
                if (Config.debug) {
                    $scope.credentials.login = 'testUser';
                    $scope.credentials.email = 'max.suhinin+63@gmail.com';
                    $scope.credentials.password = 'online123';
                }
            }

            var gotoAfterVersionChecking = function (state, params) {
                usSpinnerService.spin('spinner-1');
                checkVersionPromise.then(function () {
                    $state.go(state, params);
                    usSpinnerService.stop('spinner-1');
                });
            }

            $scope.goToForgotPassword = function () {
                var state = '';
                var params = null;
                if (utilli.isWglcx()) {
                    state = 'TopMenuLayout.ForgotPasswordByEmail.Step1';
                }
                else if ($state.current.name.indexOf('WelcomeAgent') > 0 || utilli.isPropertyManagerApp()) {
                    state = 'TopMenuLayout.ForgotPasswordByEmail.Step1';
                    params = { from: $state.current.name }
                } 
                else {
                    state = 'TopMenuLayout.ForgotPassword.Step1';
                }
                gotoAfterVersionChecking(state, params);
            }

            $scope.goToForgotUserId = function () {
                var state = '';
                var params = null;
                if (utilli.isWglcx()) {
                    state = 'TopMenuLayout.ForgotUserIdByEmail.Step1';
                }
                else if ($state.current.name.indexOf('WelcomeAgent') > 0 || utilli.isPropertyManagerApp()) {
                    state = 'TopMenuLayout.ForgotUserIdByEmail.Step1';
                    params = { from: $state.current.name }
                } 
                else {
                    state = 'TopMenuLayout.ForgotUserId.Step1';
                }
                gotoAfterVersionChecking(state, params);
            }

            $scope.backVisible = isMobileOrRipple();

            $scope.back = function () {
                $state.goToWelcome();
            };

            $scope.resentVerificationEmail = function () {
                var copyServices = SignInService.services.slice();

                SignInService.resendVerificationEmail($scope.credentials.login,
                    $scope.credentials.password,
                    copyServices[0].ApiUrl,
                    copyServices[0].Name);

                $scope.showResentVerificationEmailDone = true;
            }

            $scope.next = function () {
                SignInService.resetErrors();
                $scope.submitted = true;
                if (!$scope.loginForm.$valid || $scope.emailRequired && !$scope.credentials.email) {
                    return;
                }
                if (SignInService.services.length > 0 && $scope.emailRequired)
                {
                    var copyServices = SignInService.services.slice();
                    var i = 0;
                    var isMaintenance = _.any(copyServices, function (item) { return !item.IsAvailable })
                    while (i < copyServices.length)
                    {
                        if (!copyServices[i].UserData && isMaintenance) {
                            i++;
                            continue;
                        }
                        if ($scope.credentials.email.toUpperCase() != copyServices[i].UserData.Email.toUpperCase())
                        {
                            copyServices.splice(i, 1);
                            continue;
                        }
                        i++;
                    }

                    if (copyServices.length == 0)
                    {
                        // wrong email
                        $scope.emailError = 'There is no registered users with such email address.';
                    }
                    else if (copyServices.length == 1)
                    {
                        SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            copyServices[0].ApiUrl,
                            copyServices[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    }
                    else
                    {
                        SignInService.services = copyServices;
                        $state.goFromWelcomeTo('SignIn.Providers', {
                            signInParams: {
                                from: $stateParams.from,
                                login: $scope.credentials.login,
                                passwd: $scope.credentials.password
                            }
                        });
                    }

                    return;
                }

                var checkProvidersPromise =  checkServiceProviders();
                $q.all([checkVersionPromise, checkProvidersPromise]).then(function (data) {
                    var checkVersionResult = data[0];
                    var checkProvidersSuccess = data[1];
                    if (CheckVersionService.isVersionCorrect(checkVersionResult)) {
                        if (checkProvidersSuccess) {
                            loginByProvider();
                        }
                    }
                    else if (CheckVersionService.isVersionWrong(checkVersionResult)) {
                        $state.go('UpdateApp');
                    }
                    else {
                        if (!window.disableNoConnectionPage) {
                            $state.go('NoConnection');
                        }
                    }
                }, function (err) {
                    setError(err && err.Message
                        ? err.Message
                        : err ? err : utilli.errors.serverErrorMessage);
                });
            };

            function resetErrors() {
                $scope.errors.errorFromServerReturned = false;
                $scope.errors.showServerErrors = false;
                $scope.errors.serverErrorInformation = '';
                $scope.errors.serverErrors = [];
                $scope.showResentVerificationEmailDone = false;
            }

            function setError(message) {
                $scope.errors.errorFromServerReturned = true;
                $scope.errors.serverErrorInformation = message;
            }

            function setErrors(errors, isVisible) {
                $scope.errors.serverErrors = errors;
                $scope.errors.showServerErrors = isVisible;
            }

            function checkServiceProviders() {
                usSpinnerService.spin('spinner-1');

                var deferred = $q.defer();

                $scope.submitted = false;
                resetErrors();

                var login = { login: $scope.credentials.login };
                var providersApiUrl = DeploymentSettings.providersServiceUrl;

                // most devices replace the first letter in login to capital case,
                // but login names are case insensitive, so Appreviewer is also correct
                if ($scope.credentials.login && $scope.credentials.login.toLowerCase() == 'appreviewer') {
                    if(DeploymentSettings.providersGroupShortName == Config.wglProvidersGroupShortName )
                        providersApiUrl = "https://apistaging.utilli.com/wgl-providers/api/";
                    else if (DeploymentSettings.providersGroupShortName == Config.hcProvidersGroupShortName)
                        providersApiUrl = "https://apistaging.utilli.com/hc-providers/api/";
                    else if (DeploymentSettings.providersGroupShortName == Config.pxProvidersGroupShortName)
                        providersApiUrl = "https://apistaging.utilli.com/px-providers/api/";
                    else
                        providersApiUrl = "https://apiqa.utilli.com/api/";
                }

                var url = providersApiUrl + 'Providers/GetProviders';
                $http({
                    url: url,
                    method: 'GET',
                    params: login
                }).success(function (data) {
                    if (!data) {
                        setError("Server error. Try again later.");
                        deferred.reject();
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    // if there is no items then userid wasn't found
                    if (data.length == 0) {
                        setError($scope._t("Login name") + " '" + login.login + "' " +  $scope._t("is not registered."));
                        deferred.reject($scope._t("Login name") + " '" + login.login + "' " + $scope._t("is not registered."));
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    SignInService.services = data;
                    usSpinnerService.stop('spinner-1');
                    localStorage.setItem("UserName", $scope.credentials.login);
                    deferred.resolve(data);
                }
                ).error(function () {
                    setError("Server error. Try again later.");
                    deferred.reject("Server error. Try again later.");
                    usSpinnerService.stop('spinner-1');
                });
                return deferred.promise;
            }

            function loginByProvider() {
                // if it's a regular portal then we should use only the provider that is relevant for the current portal
                if (!!DeploymentSettings.currentServiceProvider) {
                    var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                    var currentProviderName = Config.providers[currentServiceProvider].Name;
                    var providersFiltered = $.grep(SignInService.services, function (item) {
                        return item.Name == currentProviderName;
                    });
                    if (!providersFiltered || providersFiltered.length !== 1) {
                        setError($scope._t("Login name") + " '" + $scope.credentials.login + "' " + $scope._t("is not registered."));
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    if (SignInService.services && SignInService.services.length == 1 
                        && !SignInService.services[0].IsAvailable) {
                        
                        usSpinnerService.stop('spinner-1');
                        $state.goToMaintenance();
                        return;
                    }
                    SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            providersFiltered[0].ApiUrl,
                            providersFiltered[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    return;
                }
                // if we are here then it's not a regular portal. it's either mobile/ripple or common portal (like portal.utilli.com).
                // and at least one result is found.
                // if it is only one result then just try login, since it's the case when
                // on mobile for a given user id we have only one user.
                // there is no need to ask into which service provider he wants to login
                if (SignInService.services.length == 1) {

                    SignInService.signIn($scope.credentials.login,
                            $scope.credentials.password,
                            SignInService.services[0].ApiUrl,
                            SignInService.services[0].Name,
                            $stateParams.from, $scope.touchIdAvailable);
                    return;
                }
                // if we are here then there are more than one users for different companies
                // if they all are registered using the same email then just go to the page
                // where this user can select company into which he wants to login
                if (!isEmailRequired(SignInService.services)) {
                    usSpinnerService.stop('spinner-1');
                    $state.goFromWelcomeTo('SignIn.Providers', {
                        signInParams: {
                            from: $stateParams.from,
                            login: $scope.credentials.login,
                            passwd: $scope.credentials.password
                        }
                    });
                }
                // if we are here then there are at least 2 emails for one userid
                // this can be a case when 2 users choosed one userid independently during
                // registration on portals where we don't check uniqueness of the userid
                // across all portals. hence we need to ask this user to specify his email
                // so that we will be able to identify his company.
                // idea is that such userid collisions will be very rare all not happen.
                // and if they happen then for such users it will be more convenient to login
                // using email
                $scope.credentials.email = '';
                $scope.emailRequired = true;
                _lastLoginWithRequiredEmail = $scope.credentials.login;
                usSpinnerService.stop('spinner-1');// stop the spinner to allow user to enter email
            }

            function isEmailRequired(data) {
                if (_.any(data, function (item) { return !item.IsAvailable })) {
                    return true;
                }
                //if all email is the same we return false
                var email = data[0].UserData.Email;
                for (var i = 1; i < data.length; i++) {
                    if (data[i].UserData.Email.toUpperCase() === email.toUpperCase())
                        continue;
                    else 
                        return true;
                }
                return false;
            }
        }
    ]).directive('capsLock', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {

                scope.capsLockFlags = [];
                scope.resetCapsLockFlags = function() {
                    scope.capsLockFlags.forEach(function(item) {
                        scope[item] = false;
                    });
                }

                // If element lost focus - hide warning
                element.bind('blur', function(e) {
                    scope.resetCapsLockFlags();
                });

                element.bind('keypress', function(e) {
                    // If letter is from a to z, set false
                    if (e.which >= 97 && e.which <= 122) {
                        scope.resetCapsLockFlags();
                        scope.$apply();
                    }
                    // If letter from A to Z and shift is not on, set true
                    else if (e.which >= 65 && e.which <= 90 && !e.shiftKey) {
                        scope[attr.capsLock] = true;
                        if (!scope.capsLockFlags.includes(attr.capsLock))
                            scope.capsLockFlags.push(attr.capsLock);
                        scope.$apply();
                    }
                });

                element.bind('keydown', function(e) {
                    if (e.which === 20) {
                        scope.resetCapsLockFlags();
                        scope.$apply();
                    }
                });
            }
        }
    });

'use strict';
var app = angular.module('utilliApp');

app.controller('ProvidersController', ['$scope', 'SignInService', '$state', '$stateParams',
    function ($scope, SignInService, $state, $stateParams) {
        $scope.stepName = 'Select Service Provider';
        $scope.services = SignInService.services;
        var selectedService = -1;
        $scope.touchIdAvailable = false;
        SignInService.setIsTouchIdAvailable($scope);

        $scope.radioClick = function(index)
        {
            if (selectedService >= 0)
            {
                $('#service' + selectedService).removeClass('service-active');
                $("input[name='radio" + selectedService + "']").prop('checked', false);
            }

            $('#service' + index).addClass('service-active');
            $("input[name='radio" + index + "']").prop('checked', true);
            selectedService = index;
            var provider = SignInService.services[selectedService];
            SignInService.signIn($stateParams.signInParams.login,
                            $stateParams.signInParams.passwd,
                            provider.ApiUrl,
                            provider.Name,
                            $stateParams.signInParams.from, 
                            $scope.touchIdAvailable).
                then(function () { }, function (error) {
                    $scope.error = error;
                    resetErrors();
                });
        }

        function resetErrors() {
            SignInService.errors.errorFromServerReturned = false;
            SignInService.errors.showServerErrors = false;
            SignInService.errors.serverErrorInformation = '';
            SignInService.errors.serverErrors = [];
        }

        $scope.back = function () {
            $state.goFromWelcomeTo('SignIn.Credentials');
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('SignUpController', ['$scope', '$state', 'CommonHeaderService', 'RegistrationInfoService', '$stateParams',
    function ($scope, $state, CommonHeaderService, RegistrationInfoService, $stateParams) {
        CommonHeaderService.hideMenuToggleButton();

        tryToInitRegistrationInfoService();
        $scope.cancel = function () {
            $state.goToWelcome();
        };
        function tryToInitRegistrationInfoService(){
            RegistrationInfoService.userInfo.accountnumber = $stateParams.accountnumber;
            RegistrationInfoService.userInfo.zip = $stateParams.zip;
            RegistrationInfoService.userInfo.token = $stateParams.token;
            RegistrationInfoService.userInfo.customerfullname = $stateParams.customerfullname;
        }
    }])
.controller('SignUpStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'usSpinnerService', 'ServiceProvidersService', '$stateParams', 'CheckVersionService', '$q', 'RegistrationInfoService',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ServiceProvidersService,
        $stateParams, CheckVersionService, $q, RegistrationInfoService) {

        utilli.fixSelectElementForMobile();

        var checkVersionPromise = CheckVersionService.checkVersion();
        $scope.accountMaxLength = Config.contractAccountMaxLength;
        $scope.providers = [];
        $scope.provider = {};
        $scope.errors = [];
        $scope.isProviderListVisible = false;

        getProviderInfo();

        $scope.initForm = function () {
            var isDataExist = RegistrationInfoService.userInfo.accountnumber != undefined 
                && RegistrationInfoService.userInfo.zip != undefined
                && RegistrationInfoService.userInfo.customerfullname != undefined;
            if (isDataExist) {
                $scope.AccountNumber = RegistrationInfoService.userInfo.accountnumber;
                $scope.ZipCode = RegistrationInfoService.userInfo.zip;
                $scope.FullName = RegistrationInfoService.userInfo.customerfullname;
            }
        };

        $scope.submit = function () {
            ServiceProvidersService.setCurrentProvider($scope.provider);
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();

            if (!$scope.formAccountInfo.$valid) {
                $scope.submitted = true;
                usSpinnerService.stop("spinner-1");
                return;
            }

            $rootScope.serviceUrl = $scope.provider.ApiUrl + 'api/Registration/Register/';
            $rootScope.webServicesUrl = $scope.provider.ApiUrl;
            var checkAccountInfoPromise = checkAccountInfo();

            $q.all([checkVersionPromise, checkAccountInfoPromise]).then(function (data) {
                var checkVersionResult = data[0];
                var checkAccountInfoResult = data[1];
                if (CheckVersionService.isVersionCorrect(checkVersionResult)) {
                    if (checkAccountInfoResult) {
                        RegistrationInfoService.userInfo.accountnumber = $.trim($scope.AccountNumber);
                        RegistrationInfoService.userInfo.zip = $.trim($scope.ZipCode);
                        RegistrationInfoService.userInfo.customerfullname = $.trim($scope.FullName);
                        RegistrationInfoService.userInfo.token = $scope.token;
                        $state.goRelativeTo('SignUp', 'Step2');
                    }
                }
                else if (CheckVersionService.isVersionWrong(checkVersionResult)) {
                    $state.go('UpdateApp');
                }
                else {
                    if (!window.disableNoConnectionPage) {
                        $state.go('NoConnection');
                    }
                }
            }, function (err) {
                $scope.errors.push(err && err.Message ? err.Message : utilli.errors.serverErrorMessage);
            });
        };

        function getProviderInfo () { 
            usSpinnerService.spin("spinner-1");
            if (!DeploymentSettings.currentServiceProvider) {
                ServiceProvidersService.getProviders()
                    .then(
                        function(allProviders) {
                            usSpinnerService.stop("spinner-1");
                            $scope.isProviderListVisible = allProviders.length > 1;
                            $scope.providers = allProviders;
                            $scope.provider = allProviders[0];
                        },
                        function() {
                            usSpinnerService.stop("spinner-1");
                            $scope.errors.push(utilli.errors.serverErrorMessage);
                        }
                    );
            }
            else {
                ServiceProvidersService.getCurrentProvider()
                    .then(function (providerData) {
                        usSpinnerService.stop("spinner-1");
                        $scope.provider = providerData;
                    },
                    function () {
                        usSpinnerService.stop("spinner-1");
                        $scope.errors.push(utilli.errors.serverErrorMessage);
                    }
                );
            }
        }

        function checkAccountInfo() {
            var deferred = $q.defer();
            var data = {
                AccountNumber: $scope.AccountNumber,
                ZipCode: $scope.ZipCode,
                FullName: $scope.FullName,
                Step: 1,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal
            }
            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                usSpinnerService.stop("spinner-1");
                if (response) {
                    if (response.Errors != null && response.Errors.length > 0) {
                        $scope.errors = response.Errors;
                        deferred.resolve(false);
                    }
                    else {
                        $scope.token = response.Token;
                        $scope.AccountNumber = response.NonLegacyAccount;
                        $scope.serviceProvider = $scope.provider;
                        deferred.resolve(true);
                    }
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                    deferred.resolve(false);
                }
            }).error(function () {
                deferred.reject();
                $scope.errors.push(utilli.errors.serverErrorMessage);
                usSpinnerService.stop("spinner-1");
            });
            return deferred.promise;
        }
    }])
.controller('SignUpStep2Controller', ['$scope', '$rootScope', '$http', '$state', 'CommonDataService', 
    'usSpinnerService', '$stateParams', 'ServiceProvidersService', 'RegistrationInfoService', '$q',
    // ReSharper disable InconsistentNaming
    function ($scope, $rootScope, $http, $state, CommonDataService, usSpinnerService, $stateParams,
        ServiceProvidersService, RegistrationInfoService,$q) {
        
        var _t = $scope._t;
        // ReSharper restore InconsistentNaming

        if ($stateParams.email) {
            $scope.Email = $stateParams.email;
            $scope.Email2 = $stateParams.email;
        }

        var loadingText = _t('Loading...');
        $scope.errors = [];
        $scope.passRequirements = [{ Value: loadingText }];
        $scope.SecurityQuestions = [loadingText];
        $scope.SecurityQuestion = loadingText;

        init();
        initForm();

        utilli.fixSelectElementForMobile();

        $scope.isUserDataCorrect = function () { 
            var result = !$scope.formAccountInfo.UserID.$error.required && 
                !$scope.formAccountInfo.Email.$error.required &&
                !$scope.formAccountInfo.SecurityAnswer.$error.required &&
                $scope.UserID.length >= $scope.minUserIdLength;
            return result;
        }

        $scope.isPasswdValid = function () { 
            $scope.passwdErrors = utilli.validatePassword($scope.Password, $scope.UserID, $scope.passRequirements, $scope.paswdMinLength, null, $scope.minUserIdLength);
            $scope.passwordsNotMatch = $scope.Password && $scope.Password !== $scope.ConfirmPassword 
                ? $scope._t('Passwords do not match.')
                : null;
            var result = $scope.passwdErrors.length == 0 && !$scope.passwordsNotMatch;
            return result;
        }

        $scope.submit = function () {
            usSpinnerService.spin('spinner-1');
            $scope.errors = [];
            
            var isUserDataCorrect = $scope.isUserDataCorrect();
            var isPasswdValid = $scope.isPasswdValid();

            if (!$scope.formAccountInfo.$valid || !isUserDataCorrect || !isPasswdValid) {
                $scope.errors.push(utilli.errors.validationErorrsMessage);
                utilli.scrollTop();
                $scope.submitted = true;
                usSpinnerService.stop('spinner-1');
                return;
            }
            
            var data = {
                AccountNumber: RegistrationInfoService.userInfo.accountnumber,
                ZipCode: RegistrationInfoService.userInfo.zip,
                Token: RegistrationInfoService.userInfo.token,
                UserName: $.trim($scope.UserID),
                Email: $.trim($scope.Email.toLowerCase()),
                Password: $scope.Password,
                ConfirmPassword: $scope.ConfirmPassword,
                SecurityQuestion1: $scope.SecurityQuestion,
                SecurityAnswer1: $scope.SecurityAnswer,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                Step: 2
            }

            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                if (response) {
                    if (response.Errors != null && response.Errors.length > 0) {
                        $scope.errors = response.Errors;
                    }
                    else {
                        usSpinnerService.spin('spinner-1');
                        CommonDataService.getCommonData($rootScope.webServicesUrl, true)
                            .then(function () {
                                RegistrationInfoService.userInfo.token = response.Token;
                                RegistrationInfoService.userInfo.user = $.trim($scope.UserID);
                                RegistrationInfoService.userInfo.email = $.trim($scope.Email.toLowerCase());
                                RegistrationInfoService.userInfo.psw = $scope.Password;
                                RegistrationInfoService.userInfo.question = $scope.SecurityQuestion;
                                RegistrationInfoService.userInfo.answer = $scope.SecurityAnswer;
                                $state.goRelativeTo('SignUp', 'Step3');
                                usSpinnerService.stop('spinner-1');
                            }, function () {
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                                usSpinnerService.stop('spinner-1');
                            });
                    }
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $scope.errors.push(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        };

        function initForm() {
            $scope.UserID = RegistrationInfoService.userInfo.user;
            $scope.Email = RegistrationInfoService.userInfo.email;
            $scope.Email2 = RegistrationInfoService.userInfo.email;
            $scope.SecurityAnswer = RegistrationInfoService.userInfo.answer;
            $scope.SecurityQuestion = RegistrationInfoService.userInfo.question;
        };

        function init () {
            usSpinnerService.spin("spinner-1");
            ServiceProvidersService.getCurrentProvider().then(
                function (providerData) {
                    $rootScope.webServicesUrl = providerData.ApiUrl;
                    $rootScope.serviceUrl = providerData.ApiUrl + 'api/Registration/Register/';
                    CommonDataService.getCommonData($rootScope.webServicesUrl)
                        .then(function(data) {
                                usSpinnerService.stop('spinner-1');
                                $scope.paswdMinLength = data.PasswordLength;
                                $scope.passRequirements = data.PasswordRequirements;
                                $scope.minUserIdLength = data.MinUserIdLength;
                            },
                            function() {
                                usSpinnerService.stop("spinner-1");
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                            });
    
                    $http.get(providerData.ApiUrl + 'api/StaticData/GetSecurityQuestions/')
                        .then(function(resp) {
                                var sequrityQeuestions = JSON.parse(resp.data);
                                $scope.SecurityQuestions = sequrityQeuestions;
                                $scope.SecurityQuestion = RegistrationInfoService.userInfo.question 
                                    ? RegistrationInfoService.userInfo.question
                                    : $scope.SecurityQuestions[0];
                            },
                            function() {
                                $scope.errors.push(utilli.errors.serverErrorMessage);
                            });
                },
                function() {
                    usSpinnerService.stop("spinner-1");
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                });
        }
    }])
.controller('SignUpStep3Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'usSpinnerService', '$sce', 'RegistrationInfoService',
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, usSpinnerService, $sce,
        RegistrationInfoService) {
        
        $scope.errors = [];
        $scope.emailNotificationsAccepted = true;

        $scope.loadTermsAndConditions = function () {
            if($rootScope.webServicesUrl)
                getTermsAndConditions($rootScope.webServicesUrl);
            else
                $state.go('TopMenuLayout.SignUp.Step1');
        }

        function getTermsAndConditions(baseUrl) { 
            usSpinnerService.spin("spinner-1");
            $http({
                url: baseUrl + 'api/StaticData/GetTermsAndConditions',
                method: 'GET'
            }).success(function(data) {
                usSpinnerService.stop("spinner-1");
                $scope.html = $sce.trustAsHtml(data);
            }).error(function() {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }

        $scope.TermAndConditionsFormSubmit = function () {
            usSpinnerService.spin("spinner-1");
            $moduleServices.hideKeyboard();
            checkTermAndConditionsFormSubmit();
        };

        function checkTermAndConditionsFormSubmit() {

            var language = localStorage.getItem('language');
            if (!language)
                language = 'en';

            var data = {
                AccountNumber: RegistrationInfoService.userInfo.accountnumber,
                ZipCode: RegistrationInfoService.userInfo.zip,
                Fullname: RegistrationInfoService.userInfo.customerfullname,
                UserName: RegistrationInfoService.userInfo.user,
                Email: RegistrationInfoService.userInfo.email,
                Password: RegistrationInfoService.userInfo.psw,
                SecurityQuestion1: RegistrationInfoService.userInfo.question,
                SecurityAnswer1: RegistrationInfoService.userInfo.answer,
                Token: RegistrationInfoService.userInfo.token,
                TermsAndConditions: $scope.termsAccepted,
                EmailNotificationsAccepted: $scope.emailNotificationsAccepted,
                Language: language,
                Client: isMobileOrRipple() ? utilli.clientEnum.mobileApp : utilli.clientEnum.portal,
                Step: 3
            };

            $http({
                url: $rootScope.serviceUrl,
                method: "POST",
                data: data
            }).success(function (response) {
                if (response) {
                    if (response.Errors && response.Errors.length > 0) 
                        $scope.errors = response.Errors;
                    else 
                        $state.goRelativeTo('SignUp', 'Success');
                }
                else {
                    $scope.errors.push(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop("spinner-1");
            }).error(function () {
                usSpinnerService.stop("spinner-1");
                $scope.errors.push(utilli.errors.serverErrorMessage);
            });
        }
    }])
.controller('SignUpSuccessController', ['$scope', '$rootScope', 'CommonDataService', 
    'usSpinnerService', '$state',
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $state) {
        $scope.errors = [];
        CommonDataService.getCommonData($rootScope.webServicesUrl)
            .then(function (commonData) {
                $scope.companyNameLong = commonData.CompanyNameLong;
                $scope.companyNameLongWithoutTrailingPeriod = commonData.CompanyNameLongWithoutTrailingPeriod;
                $scope.helpEmail = commonData.CompanyHelpEmail;
                usSpinnerService.stop('spinner-1');

                $scope.SuccessOk = function () {
                    $state.goToWelcome();
                }
            });
    }]);
'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayController', ['$scope', '$state', 'CommonHeaderService',
    function ($scope, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        if ($state.is('QuickPay')) {
            $state.go('.Step1');
        }
    }]);



'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayStep1Controller', ['$scope', '$state',
    function ($scope, $state) {

        $scope.goToStep2 = function (){
            $state.goRelativeTo("QuickPay", "Step2");
        };

        $scope.goToWelcome = function () {
            $state.goToWelcome();
        };
    }]);

'use strict';
var app = angular.module('utilliApp');

app.controller('QuickPayStep2Controller', ['$scope', '$timeout', '$state', '$http', 'usSpinnerService', 'LeftMenuService',
    'CommonDataService', '$q', 'ServiceProvidersService', 'ModalServiceExt', 'PaymentVerificationService',
    function ($scope, $timeout, $state, $http, usSpinnerService, LeftMenuService, CommonDataService, $q, 
        ServiceProvidersService, ModalServiceExt, PaymentVerificationService) {

    var _t = $scope._t;
    LeftMenuService.setCurrentTab('QuickPay');

    $scope.phoneNumberMask = Config.phoneNumberMask;
    var apiUrl = '';
    
    function initPage() {
        $scope.imagesPath = utilli.isAdmin
            ? "../Images"
            : "Images";

        $scope.btcFee = 0;

        $scope.isWglCx = utilli.isWglcx();
        $scope.isAdmin = utilli.isAdmin;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.zip = '';

        $scope.address = {};

        $scope.onlyNumbers = /^\d+$/;
        $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
        $scope.emailPattern = utilli.emailPattern;

        $scope.stepName = 'find';
        $("#cardCodeCvv").mask("999?9", { placeholder: "" });
        $scope.quickPayValidationType = 'InvoiceNumber'; // Can be: InvoiceNumber, BusinessPartnerNumber
        $scope.quickPayValidationCaption = $scope._t('Invoice Number');
    $scope.validationTypes = [
        { name: _t('Invoice Number'), value: "InvoiceNumber" },
        { name: _t('Customer Number'), value: "CustomerNumber" }
    ];
    $scope.selectedValidationType = $scope.validationTypes[0].value;
    $scope.isFeeEnabled = false;

        $scope.isFeeEnabled = false;
        
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                if (!providerData){
                    ModalServiceExt.showServerError();
                    return;
                }
                apiUrl = providerData.ApiUrl;
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                    $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                    $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                    $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                    $scope.paymentInfoText = commonData.FeeInformation;
                    $scope.commomData = commonData;
                    $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                    $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                    $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                    $scope.quickPayValidationType = commonData.QuickPayValidationType;
                    $scope.isFeeEnabled = commonData.IsFeeEnabled;
                    if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                        $scope.quickPayValidationCaption = $scope._t('Invoice or Customer Number');
                    }
                },
                function () {
                    ModalServiceExt.showServerError();
                });
            },
            function() {
                ModalServiceExt.showServerError();
            }
        );

        if ($state.params.contractAccountNumber) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
                .then(function (providerData) {
                    if (!providerData) {
                        ModalServiceExt.showServerError();
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    apiUrl = providerData.ApiUrl;
                    var searchRequest = {
                        accountNumber: $state.params.contractAccountNumber,
                        isAdmin: $scope.isAdmin,
                        billAccessToken: $state.params.token
                    };
                    CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        var url = apiUrl + 'api/Payment/FindAccounts';
                        $http({
                            url: url,
                            method: "GET",
                            params: searchRequest
                        }).success(function (data) {
                            if (!data.length){
                                usSpinnerService.stop('spinner-1');
                                $scope.errorFromServerReturned = true;
                                $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                                return;
                            }
                            $scope.selectAccount(data[0]);
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            $scope.errorFromServerReturned = true;
                            $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                        });
                    });
            });
        }
    }

    initPage();

    $scope.back = function () {
        $state.goRelativeTo('QuickPay', 'Step1');
    };

    $scope.cancel = function () {
        $state.goToWelcome();
    };

    function getSavedInvoiceNumber(contractAccountNumber) {
        var deviceInfo = getSavedDeviceInfo(contractAccountNumber);
        return deviceInfo ? deviceInfo.invoiceNumber : '';
    }

    function getSavedDeviceToken(contractAccountNumber) {
        var deviceInfo = getSavedDeviceInfo(contractAccountNumber);
        return deviceInfo ? deviceInfo.deviceToken : '';
    }

    var deviceInfoKey = 'quick-pay-device-infos';

    function getSavedDeviceInfo(contractAccountNumber) {
        try {
            var deviceInfosJson = localStorage.getItem(deviceInfoKey);
            if (!deviceInfosJson)
                return null;
            var deviceInfos = JSON.parse(deviceInfosJson);
            return deviceInfos ? deviceInfos[contractAccountNumber] : null;
        }
        catch (e) {
            console.error('failed to get deviceInfo. ' + e);
            return null;
        }
    }

    function saveDeviceInfo(contractAccountNumber, invoiceNumber, deviceToken) {
        var savedInvoiceNumbers = {};
        try {
            var savedInvoiceNumbersString = localStorage.getItem(deviceInfoKey);
            if (savedInvoiceNumbersString)
                savedInvoiceNumbers = JSON.parse(savedInvoiceNumbersString);
        } catch (e) {
            console.error('failed to save device info. ' + e);
        }
        savedInvoiceNumbers[contractAccountNumber] = { invoiceNumber: invoiceNumber, deviceToken: deviceToken };
        localStorage.setItem(deviceInfoKey, JSON.stringify(savedInvoiceNumbers));
    }

    $scope.clear = function () {
        $scope.findResultVisible = false;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.invoiceNumber = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    $scope.find = function () {
        $scope.findResultVisible = false;
        $scope.amountDue = '';

        if ($scope.accountNumber == '') {
            if ($scope.houseNumber == '' || $scope.streetName == '' || $scope.zip == '') {
                $scope.informationMessage = $scope._t('Account # or House #, Street Name and Zip must be filled') + '.';
                $scope.isInformationMessageShown = true;
                return;
            }
        }

        usSpinnerService.spin('spinner-1');

        $scope.informationMessage = '';
        $scope.isInformationMessageShown = false;
        $scope.showProceedAnyway = false;
        $scope.errorFromServerReturned = false;

        $scope.outputSearchType = 'address';

        if ($scope.accountNumber == '') {
            $scope.outputSearchType = 'accountNumber';
        }

        var searchRequest = {
            accountNumber: $scope.accountNumber,
            streetNumber: $scope.houseNumber,
            streetName: $scope.streetName,
            apartmentNumber: $scope.appartment,
            state: $scope.state,
            zip: $scope.zip,
            isAdmin: $scope.isAdmin
        };
        
        CommonDataService.getCommonData(apiUrl).then(function (commonData) {
            var url = apiUrl + 'api/Payment/FindAccounts'; //commonData.QuickPayAccountSearchUrl;
            $http({
                url: url,
                method: "GET",
                params: searchRequest
            }).success(function (jsondata) {
                if (jsondata) {
                    if (jsondata.message == 'too many results') {
                        $scope.informationMessage = $scope._t('Too many results. Please add more search criteria') + '.';
                        $scope.isInformationMessageShown = true;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    else if (jsondata.IsSuccessful == false) {
                        $scope.informationMessage = jsondata.Message;
                        $scope.isInformationMessageShown = true;
                        usSpinnerService.stop('spinner-1');
                        return;
                    }
                    else if (jsondata.length == 0) {
                        $scope.informationMessage = $scope._t('Search returned no results') + '.';
                        $scope.isInformationMessageShown = true;
                    }
                    $scope.findResultList = jsondata;
                    usSpinnerService.stop('spinner-1');
                    $scope.findResultVisible = true;
                    utilli.scrollBottom(500);
                } else {
                    usSpinnerService.stop('spinner-1');
                    $scope.errorFromServerReturned = true;
                    $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                }
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                $scope.errorFromServerReturned = true;
                $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
            });
        });
    };

    $scope.iKnowAccountNumberClick = function () {
        clearAddressSearch();
        $scope.radioSearchType = 'searchByAccount';
    };

    $scope.iKnowServiceAddressClick = function () {
        clearAccountSearch();
        $scope.radioSearchType = 'searchByAddress';
    };

    $scope.selectAccount = function (account) {
        clearPaymentSettings();
        $scope.isAuthForEBill = account.AuthorizedForEBill;
        $scope.currentAccount = account;
        $scope.stepName = $scope.isWglcx ? 'payByCard' : 'selectPaymentOption';

        // account.PhoneNumber may be empty if wglcx user is not authorized to view bills.
        // phone number is used for bills authorization and we don't disclose the phone number
        // to those users who have not passed authorization yet.
        $scope.phone = account.PhoneNumber ? account.PhoneNumber : $scope.phone;
        $scope.email = account.Email ? account.Email : $scope.email;

        usSpinnerService.spin('spinner-1'); // stop - inside of function getConvFeeInfo
        getConvFeeInfo(account);

        $scope.amountDue = $scope.currentAccount.TotalOpenBallance;
        updateConvinienceFee();
        //$scope.convinienceFee = $scope.currentAccount.ConvenienceFee;

        if ($scope.amountDue < 0) {
            $scope.amountDue = 0;
            $scope.totalAmount = "";
        } else {
            $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee) + parseFloat($scope.btcFee));
        }

        $scope.formatTotalAmount();
    }

    $scope.onAmountChange = function () {
        if ($scope.amountDue == '-') {
            return;
        }
        if ($scope.amountDue == '' || $scope.amountDue == undefined) {
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        if ($scope.amountDue.slice(-1) == '.') {
            return;
        }

        if (isNaN($scope.amountDue) || isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        updateConvinienceFee();

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee) + parseFloat($scope.btcFee));
    }

    $scope.cancelPaymentOptionSelection = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.selectPayByCard = function () {
        $scope.stepName = 'payByCard';
        updateConvinienceFee();
    }

    $scope.selectPayByBankAccount = function () {
        $scope.stepName = 'payByBankAccount';
        updateConvinienceFee();
    }

    $scope.selectPayByBtc = function () {
        $scope.stepName = 'payByBtc';
        updateConvinienceFee();
    }

    var onModalWillEnterCallback = function() {
        // $scope.clear();
        // $scope.stepName = 'find';
    }

    var onModalWillLeaveCallback = function() {
        $scope.clear();
        $scope.stepName = 'find';
        $scope.$apply();
    }

    $scope.payNowBtc = function () {

        $scope.btcFormSubmitted = true;

        if (!$scope.payBtc_form.$valid
            || $scope.isPaymentInfoAgreeBtc == false && $scope.isFeeEnabled
            || utilli.isAdmin && $scope.proceededWithoutSearch && $scope.selectedCompany.companyCode == "0") {
            return;
        }

        $scope.btcFormSubmitted = false;


        var invoiceId = '';
        var url = apiUrl + 'api/Payment/GenerateBtcInvoice';

          var btcInvoiceRequest = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amount: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            PaymentPage: utilli.isAdmin ? 3 : 1
        };

        $http({
            url: url,
            method: "GET",
            params: btcInvoiceRequest
        }).success(function (data) {
            invoiceId = data;
            window.btcpay.onModalWillEnter(onModalWillEnterCallback);
            window.btcpay.onModalWillLeave(onModalWillLeaveCallback);
            window.btcpay.showInvoice(invoiceId);
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            $scope.errorFromServerReturned = true;
            $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
        });
    }

    $scope.formatTotalAmount = function () {
        if ($scope.amountDue == undefined) {
            $scope.totalAmount = '';
            return;
        }

        if (isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            return;
        }
        $scope.amountDue = formatDecimal(parseFloat($scope.amountDue));
    }

    $scope.cancelPayment = function () {
        $scope.bankAccountFormSubmitted = false;
        $scope.cardFormSubmitted = false;
        $scope.clear();
        clearPaymentSettings();
        $scope.stepName = $scope.isWglcx ? 'find' : 'selectPaymentOption';
    }

    $scope.payNow = function () {
        $scope.stepName = 'processingPayment';
        usSpinnerService.spin('spinner-1');
        $scope.$apply();
        $timeout(function () {
            usSpinnerService.stop('spinner-1');
            $scope.stepName = 'paymentResult';
        }, 3000);
    }

    function checkPaymentAmountWglcx() {
        if(!$scope.isWglcx)
            return true;
        var maxOverpayment = -500;

        if($scope.currentAccount.TotalOpenBallance - $scope.amountDue < maxOverpayment) {
            var exceededLimit = parseFloat($scope.amountDue) + maxOverpayment - $scope.currentAccount.TotalOpenBallance;
            ModalServiceExt.showInfo(
                $scope._t("Maximum overpayment allowed is $500, current payment amount exceeds this limit by $" 
                    + exceededLimit.toFixed(2)));
            return false;
        }
        return true;
    }

    $scope.isCcTypeNotValid = function () {
        var result = $scope.payCardAccount_form.cardNumber.$ccType == 'JCB'
            || ($scope.isWglcx && $scope.payCardAccount_form.cardNumber.$ccType == 'American Express')
            || $scope.payCardAccount_form.cardNumber.$ccType == 'Diners Club';
        return result;
    }

    $scope.payNowCard = function () {
        $scope.cardFormSubmitted = true;

        if (!$scope.payCardAccount_form.$valid
            || $scope.isCcTypeNotValid()
            || $scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled
            || utilli.isAdmin && $scope.proceededWithoutSearch && $scope.selectedCompany.companyCode == "0") {
            return;
        }

        if(!checkPaymentAmountWglcx())
            return;

        $scope.cardFormSubmitted = false;

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                PaymentVerificationService.verifyPaymentInfoNew(commonData, $scope.amountDue, 
                    checkInvoiceAndPayByCard);
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    function checkInvoiceAndPayByCard() {
        usSpinnerService.spin('spinner-1');
        validateInvoiceNumber().then(function (isInvoiceValid) { 
            $scope.invoiceNumberError = !isInvoiceValid;
            if ($scope.invoiceNumberError) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showMessage($scope._t('Error'), 
                    $scope._t('Invalid Invoice Number.'));
                return;
            }
            payByCreditCardInternal()
        });
    }

    $scope.payNowBankAccount = function () {
        if (!$scope.payBankAccount_form.$valid
            || $scope.bankCheckingAccountNumber != $scope.bankCheckingAccountNumber2
            || $scope.isPaymentInfoAgreeBank == false && $scope.isFeeEnabled
            || $scope.payBankAccount_form.bankRoutingNumber == $scope.payBankAccount_form.bankCheckingAccountNumber) {
            return;
        }

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                PaymentVerificationService.verifyPaymentInfoNew(commonData, $scope.amountDue, 
                    validateRoutingNumberAndPayByCheck);
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    function validateRoutingNumberAndPayByCheck () {
        usSpinnerService.spin('spinner-1');
        validateRoutingNumber().then(function (isRoutingNumberValid) {
            $scope.routNumError = !isRoutingNumberValid;
            if ($scope.routNumError){
                ModalServiceExt.showMessage($scope._t('Error'), 
                    $scope._t('Invalid Routing Number.'));
                usSpinnerService.stop('spinner-1');
                return;
            }
            bankAccountPay();
        });
    }

    $scope.paymentOk = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.printConfirmation = function () {
        window.print();
    }

    $scope.viewUnderstandYourBill = function () {
        var viewurl = apiUrl + 'api/Bills/GetUnderstandMyBill';
        window.open(viewurl, '_blank');
    }

    $scope.proceedToRegistration = function () {
        $state.go('TopMenuLayout.SignUp.Step1', { 
            accountnumber: $scope.currentAccount.AccountNumber, 
            customerfullname: $scope.currentAccount.CustomerFullName, 
            zip: $scope.currentAccount.Zip.substring(0, 5) 
        });
    }

    function clearAccountSearch () {
        $scope.findResultVisible = false;
        $scope.accountNumber = '';
        $scope.informationMessage = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    function clearAddressSearch () {
        $scope.findResultVisible = false;
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.invoiceNumberError = false;
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
    };

    function clearPaymentSettings() {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';

        $scope.billToAddress = '';
        $scope.billToCity = '';
        $scope.billToState = '';
        $scope.billToZip = '';
        $scope.cardCode = '';

        $scope.checkNameOnAccount = '';
        $scope.bankRoutingNumber = '';
        $scope.bankCheckingAccountNumber = '';
        $scope.bankCheckingAccountNumber2 = '';
        $scope.driversLicenseNumber = '';
        $scope.checkPaymentState = '';
        
        $scope.phone = $state.params.phoneNumber;
        $scope.email = $state.params.email ? $state.params.email : '';
        $scope.invoiceNumber = $state.params.invoiceNumber ? $state.params.invoiceNumber : '';
    }

    function getConvFeeInfo (account) {
        if (!$scope.isFeeEnabled){
            usSpinnerService.stop('spinner-1');
            return;
        }
        var searchObject = {
            accountNumber: account.AccountNumber,
        };
        $http({
            url: apiUrl + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: searchObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.convFeeInfo = jsondata;
                updateConvinienceFee();
                if ($scope.convFeeInfo.Disconnected == $scope._t('Account Disconnected')) {
                    ModalServiceExt.showMessage($scope._t('Account is disconnected'), 
                    $scope._t('Your account is currently disconnected. After making the payment please contact Customer Service at')
                    + ' ' 
                    + $scope.convFeeInfo.SupportPhoneNumber);
                }
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (data) {
            ModalServiceExt.showMessage($scope._t('Error'), $scope._t('Server error. Please, try again later.'));
            $scope.stepName = 'find';
            usSpinnerService.stop('spinner-1');
        });
    }

    function updateConvinienceFee() {
        if ($scope.amountDue == null || isNaN($scope.amountDue) || $scope.amountDue == '') {
            $scope.convinienceFee = '';
            return;
        }

        var info = $scope.convFeeInfo;

        if ($scope.isFeeEnabled) {
        if ($scope.stepName == 'payByCard') {
            if (info.FeeType == "percent") {
                $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmount);
            } else if (info.FeeType == "flat") {
                $scope.convinienceFee = formatDecimal(info.FeeAmount);
            }
            } else if ($scope.stepName == 'payByBankAccount') {
                if (info.FeeTypeAch == "percent") {
                    $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmountAch);
                } else if (info.FeeTypeAch == "flat") {
                    $scope.convinienceFee = formatDecimal(info.FeeAmountAch);
                }
            } else if ($scope.stepName == 'payByBtc') {
                if (info.FeeTypeAch == "percent") {
                    $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmountAch);
                } else if (info.FeeTypeAch == "flat") {
                    $scope.convinienceFee = formatDecimal(info.FeeAmountAch);
                }

                $scope.btcFee = formatDecimal((parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee)) * 0.1);
            }
        }
        else {
            $scope.convinienceFee = 0;
        }

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee) + parseFloat($scope.btcFee));

    }

    function formatDecimal (decimal) {

        var formated = Math.round(parseFloat(decimal) * 100) / 100;

        formated = formated.toString();
        if (formated.indexOf('.') == -1) formated += '.';
        while (formated.length < formated.indexOf('.') + 3) formated += '0';

        return formated;
    }

    $scope.onAmountChange = function () {
        if ($scope.amountDue == '-') {
            return;
        }
        if ($scope.amountDue == '' || $scope.amountDue == undefined) {
            $scope.totalAmount = '';
            $scope.updateConvinienceFee();
            return;
        }

        if ($scope.amountDue.slice(-1) == '.') {
            return;
        }

        if (isNaN($scope.amountDue) || isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            $scope.updateConvinienceFee();
            return;
        }

        $scope.updateConvinienceFee();

        $scope.totalAmount = $scope.formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
    }

    $scope.cancelPaymentOptionSelection = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }


    $scope.selectPayByCard = function () {
        $scope.stepName = 'payByCard';
        $scope.invoiceNumber = getSavedInvoiceNumber($scope.currentAccount.AccountNumber);
        $scope.updateConvinienceFee();
    }

    $scope.selectPayByBankAccount = function () {
        $scope.stepName = 'payByBankAccount';
        $scope.updateConvinienceFee();
    }

    $scope.formatTotalAmount = function () {
        if ($scope.amountDue == undefined) {
            $scope.totalAmount = '';
            return;
        }

        if (isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            return;
        }
        $scope.amountDue = $scope.formatDecimal(parseFloat($scope.amountDue));
    }

    $scope.cancelPayment = function () {
        $scope.bankAccountFormSubmitted = false;
        $scope.cardFormSubmitted = false;
        $scope.clear();
        $scope.clearPaymentSettings();
        $scope.stepName = 'selectPaymentOption';
    }

    $scope.payNow = function () {
        $scope.stepName = 'processingPayment';
        usSpinnerService.spin('spinner-1');
        $scope.$apply();
        $timeout(function () {
            usSpinnerService.stop('spinner-1');
            $scope.stepName = 'paymentResult';
        }, 3000);
    }

    function validateInvoiceNumber() {
        var deferred = $q.defer();

        if (utilli.isAdmin) {
            deferred.resolve(true);
            return deferred.promise;
        }

        var requestParams = {
            accountNum: $scope.currentAccount.AccountNumber,
            invoiceNum: $scope.quickPayValidationType == 'InvoiceNumber' ? $scope.invoiceNumber : null,
            businessPartnerNum: $scope.quickPayValidationType == 'InvoiceNumber' ? $scope.invoiceNumber : null
        };
        var requestUrl = $scope.quickPayValidationType == 'InvoiceNumber'
            ? 'api/Payment/IsInvoiceValid'
            : 'api/Payment/IsBusinessPartnerValid';
        var deviceToken = getSavedDeviceToken($scope.currentAccount.AccountNumber);

        if ($scope.quickPayValidationType == 'InvoiceNumber' || $scope.selectedValidationType == 'InvoiceNumber') {
            requestParams =  { 
                accountNum: $scope.currentAccount.AccountNumber, 
                invoiceNum: $scope.invoiceNumber, 
                deviceToken: deviceToken 
            };
            requestUrl = 'api/Payment/IsInvoiceValid';
        }
        else {
            requestParams = { 
                accountNum: $scope.currentAccount.AccountNumber,
                businessPartnerNum: $scope.invoiceNumber,
                deviceToken: deviceToken
            };
            requestUrl = 'api/Payment/IsBusinessPartnerValid';
        }

        $http({
            url: apiUrl + requestUrl,
            method: "GET",
            params: requestParams
        }).success(function(response) {
            if (response.Errors && response.Errors.length > 0) {
                console.log(response.Errors[0]);
                deferred.reject(false);
            } else {
                var deviceToken = response.Data;
                var isValid = deviceToken != 'invalid';
                if (isValid)
                    saveDeviceInfo($scope.currentAccount.AccountNumber, $scope.invoiceNumber, response.Data);
                else
                    saveDeviceInfo($scope.currentAccount.AccountNumber, '', '');
                deferred.resolve(isValid);
            }
        }).error(function() {
            console.log($scope._t('Server error. Try again later.'));
            deferred.resolve(false);
        });

        return deferred.promise;
    }

    function validateRoutingNumber() {
        //$scope.stepName = 'processingPayment';
        var deferred = $q.defer();
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/RoutingNumberValidate', //$scope.commomData.CheckRoutingNumberUrl, //window.OneTimePayments.checkRoutingNumberUrl,
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                alert(response.Errors[0]);
                deferred.reject(requestResult);
            }
            else {
                requestResult = response.Data;
                deferred.resolve(response.Data);
            }
            $scope.stepName = 'payByBankAccount';
        }).error(function () {
            alert("Server error. Try again later.");
            deferred.resolve(requestResult);
            $scope.stepName = 'payByBankAccount';
        });
        return deferred.promise;
    }

    function bankAccountPay() {
        $scope.bankAccountFormSubmitted = false;

        var companyCode = $scope.currentAccount.CompanyCode;
        if ($scope.proceededWithoutSearch) {
            companyCode = $scope.selectedCompany.companyCode;
        }

        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            nameOnAccount: $scope.checkNameOnAccount,
            bankRoutingNumber: $scope.bankRoutingNumber,
            checkingAccountNumber: $scope.bankCheckingAccountNumber,
            companyCode: companyCode,
            address: {
                HouseNumber: $scope.address.HouseNumber,
                AddressLine: $scope.address.AddressLine,
                City: $scope.address.City,
                HouseNoSupplement: $scope.address.HouseNoSupplement,
                State: $scope.address.State,
                Zip: $scope.address.Zip,
            }
        };

        if (utilli.isAdmin) {
            paymentObject.PaymentPage = 3;
        }
        else {
            paymentObject.PaymentPage = 1;
        }

        $http({
            url: apiUrl + 'api/Payment/QuickPayByBankAccount', //$scope.commomData.BankAccountPayUrl, //window.OneTimePayments.bankAccountPayUrl,
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            } else {
            }
        }).error(function (data) {
            $scope.paymwntResult = data.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    }

    function payByCreditCardInternal() {
        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            cardNumber: $scope.cardNumber,
            nameOnCard: $scope.nameOnCard,
            expirationDateYear: $scope.cardExpiryYear,
            expirationDateMonth: $scope.cardExpiryMonth,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            billToAddress: $scope.billToAddress,
            billToCity: $scope.billToCity,
            billToState: $scope.billToState,
            billToZip: $scope.billToZip,
            cardCode: $scope.cardCode,
            invoiceNumber: utilli.isAdmin ? '0' : $scope.invoiceNumber,
            PaymentPage: utilli.isAdmin ? 3 : 1
        };

        $http({
            url: apiUrl + 'api/Payment/QuickPayUsingCard',
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            }
        }).error(function (data) {
            var jsondata = data;
            $scope.paymentResult = jsondata.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    };

}]);
angular.module('utilliApp')
    .service('ApplePayService', ["usSpinnerService", "ModalServiceExt", "$http", "$q", function(usSpinnerService, ModalServiceExt, $http, $q) {
        var me = this;
        var getPaymentData = null;
        var processPayResult = null;

        function init(apiUrl, processPayResultFn, getPaymentDataFn) { 
          me.apiUrl = apiUrl;
          getPaymentData = getPaymentDataFn;
          processPayResult = processPayResultFn
        }

        var isPayButtonSupported = function () { 
          var result = window.ApplePaySession && ApplePaySession.canMakePayments();
          return result;
        }

        var onClickEvent = function () {
          var paymentData = getPaymentData();
          var amount = Number(paymentData.amount);
          if (paymentData.hasCollectionFee) {
            amount += Number(paymentData.collectionFee);
          }
          amount = Number(amount).toFixed(2);
          var paymentRequest = {
            "countryCode": "US",
            "currencyCode": "USD",
            "merchantCapabilities": [
              "supports3DS"
            ],
            "supportedNetworks": [
              "visa",
              "masterCard",
              "discover"
            ],
            "total": {
              "label": "Washington Gas Bill Payment",
              "amount": amount
            }
          }
          
          var appleApiVersion = 1;
          var session = new ApplePaySession(appleApiVersion, paymentRequest);
          
          session.onvalidatemerchant = function (event) {
            var promise = performValidation(event.validationURL);
            
            promise.then(function (merchantSession) {
              session.completeMerchantValidation(merchantSession);
            }, function () {
              session.abort();
            }); 
          }

          session.onpaymentauthorized = function (event) {
            let paymentData = getPaymentData();
            let amount = Number(paymentData.amount);
            if (paymentData.hasCollectionFee) {
              amount += Number(paymentData.collectionFee);
            }
            amount = Number(amount).toFixed(2);
            usSpinnerService.spin('spinner-1');
            $http({
              url: me.apiUrl + 'api/SmartPay/CompleteApplePaySession',
              method: 'POST',
              data: {
                amount: amount,
                hasCollectionFee: paymentData.hasCollectionFee,
                tokenTimestamp: paymentData.tokenTimestamp,
                accountNumber: paymentData.accountNumber,
                email: paymentData.email,
                phoneNumber: paymentData.phoneNumber,
                applePaymentTokenData: event.payment.token,
                notificationLogId: paymentData.notificationLogId,
                wantSmsReceipt: paymentData.wantSmsReceipt,
                wantEbill: paymentData.wantEbill
              }
            }).success(function(response) {
              usSpinnerService.stop('spinner-1');
              
              if (response == undefined || response.HasErrors == undefined) {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                ModalServiceExt.showServerError();
                return;
              }
              if (response.HasErrors) {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                ModalServiceExt.showError(response.Errors[0]);
              }
              else {
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                response.Data.WalletCardInfo = event.payment.token.paymentMethod.displayName;
                response.Data.MethodId = utilli.paymentMethods.Apple;
                processPayResult(response.Data, true);
              }
            }).error(function(error) {
              usSpinnerService.stop('spinner-1');
              
              session.completePayment(ApplePaySession.STATUS_FAILURE);
              ModalServiceExt.showServerError()
              console.error(error);
            });
          }
        
          session.begin();
        }     

        function performValidation(valURL) {
          var paymentData = getPaymentData();
          
          usSpinnerService.spin('spinner-1');
          var deferred = $q.defer();
          $http({
            url: me.apiUrl + 'api/SmartPay/StartApplePaySession',
            method: 'GET',
            params: { 
              validationUrl: valURL,
              amount: paymentData.amount,
              accountNumber: paymentData.accountNumber
            }
          }).success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
              ModalServiceExt.showServerError();
              deferred.reject(null);
              return;
            }
            if (response.HasErrors) {
              ModalServiceExt.showError(response.Errors[0]);
              deferred.reject(null);
            }
            else {
              deferred.resolve(JSON.parse(response.Data))
            }
          }).error(function(error) {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
            console.error(error);
            deferred.reject(null);
          });
          return deferred.promise;
        }


        return {
            init: init,
            onClickEvent: onClickEvent,
            isPayButtonSupported: isPayButtonSupported
        };
}]);

angular.module('utilliApp')
    .service('GooglePayService', ["$rootScope", "ModalServiceExt", "$http", "usSpinnerService", "$q", function ($rootScope, ModalServiceExt, $http,
    usSpinnerService, $q) {

    var me = this;
        me.isGooglePayScriptLoaded = false;
    var processPayResult = null;
    var getPaymentData = null;
    var paymentsClient = null;
    var supportButtonPromise = $q.defer();

    function getBaseRequest() {
        var result = {
            apiVersion: 2,
            apiVersionMinor: 0
        };
        return result;
    }

    function getTokenizationSpecification(orderId) {
        var result = {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                "gateway": "vantiv",
                    "vantiv:merchantPayPageId": DeploymentSettings.isProd()
                        ? 'oxUVH9QQPUXzNs8S'
                        : 'SLmKwDHurBDvL4kK',
                "vantiv:merchantOrderId": orderId.toString(),
                "vantiv:merchantTransactionId": orderId.toString(),
                "vantiv:merchantReportGroup": "Default Report Group"
            }
        };
        return result;
    }

    function getBaseCardPaymentMethod() {
        var result = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                allowedCardNetworks: ["MASTERCARD", "VISA", "DISCOVER"]
            }
        };
        return result;
    }

    function getCardPaymentMethod(orderId) {
        var result = Object.assign(
            {},
            getBaseCardPaymentMethod(),
            {
                tokenizationSpecification: getTokenizationSpecification(orderId)
            }
        );

        return result;
    }

    function init(getPaymentDataFn, apiUrl, processPayResultFn) {

        me.apiUrl = apiUrl;
        getPaymentData = getPaymentDataFn;
        processPayResult = processPayResultFn

            if(!me.isGooglePayScriptLoaded) {
        var script = document.createElement('script');
        script.onload = onGooglePayLoaded;
        script.src = 'https://pay.google.com/gp/p/js/pay.js';

        document.body.appendChild(script);
                me.isGooglePayScriptLoaded = true;
    }
        }

    function getGooglePaymentsClient() {
        var environment = DeploymentSettings.isProd()
            ? 'PRODUCTION'
            : 'TEST';
        if (paymentsClient === null) {
            paymentsClient = new google.payments.api.PaymentsClient({
                environment: environment,
                paymentDataCallbacks: {
                    onPaymentAuthorized: onPaymentAuthorized
                }
            });
        }
        return paymentsClient;
    }

    function onGooglePayLoaded() {
        var paymentsClient = getGooglePaymentsClient();
        paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
            .then(function (response) {
                if (response.result)
                    supportButtonPromise.resolve(response.Data);
                else
                    supportButtonPromise.reject(response);
            })
            .catch(function (err) {
                supportButtonPromise.reject(err);
                console.error(err);
            });
    }

    function getGoogleIsReadyToPayRequest() {
        return Object.assign(
            {},
            getBaseRequest(),
            {
                allowedPaymentMethods: [getBaseCardPaymentMethod()]
            }
        );
    }

    function onGooglePaymentButtonClicked(orderId) {
        var paymentDataRequest = getGooglePaymentDataRequest(orderId);
        var paymentsClient = getGooglePaymentsClient();
        paymentsClient.loadPaymentData(paymentDataRequest);
    }

    function getGooglePaymentDataRequest(orderId) {
        var paymentDataRequest = Object.assign({}, getBaseRequest());
        paymentDataRequest.allowedPaymentMethods = [getCardPaymentMethod(orderId)];
        paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
        paymentDataRequest.merchantInfo = {
            merchantId: DeploymentSettings.isProd() 
                ? 'BCR2DN6T3PZNLYTJ'
                : undefined,
            merchantName: 'Washington Gas'
        };
        paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];

        return paymentDataRequest;
    }

    function onPaymentAuthorized(paymentData) {
        return new Promise(function (resolve, reject) {
            processPayment(paymentData)
                .then(function (data) {
                    processPayResult(data, true);
                    resolve({ transactionState: 'SUCCESS' });
                })
                .catch(function (e) {
                    console.error(e);
                    resolve({
                        transactionState: 'ERROR',
                        error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                                message: e,
                            reason: 'PAYMENT_DATA_INVALID'
                        }
                    });
                });
        });
    }

    function processPayment(googlePaymentData) {
        var deferred = $q.defer();
        var paymentData = getPaymentData();

        usSpinnerService.spin('spinner-1');
        $http({
            url: me.apiUrl + 'api/SmartPay/ProcessGooglePayPayment',
            method: 'POST',
            data: {
                amount: paymentData.amount,
                accountNumber: paymentData.accountNumber,
                collectionFee: paymentData.collectionFee,
                hasCollectionFee: paymentData.hasCollectionFee,
                tokenTimestamp: paymentData.tokenTimestamp,
                email: paymentData.email,
                phoneNumber: paymentData.phoneNumber,
                paymentData: googlePaymentData,
                notificationLogId: paymentData.notificationLogId,
                orderId: paymentData.orderId,
                wantSmsReceipt: paymentData.wantSmsReceipt,
                wantEbill: paymentData.wantEbill
            }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                deferred.reject($rootScope._t("Unexpected error."));
                return;
            }
            if (response.HasErrors) {
                deferred.reject(response.Errors[0]);
            }
            else {
                response.Data.WalletCardInfo = googlePaymentData.paymentMethodData.description;
                response.Data.MethodId = utilli.paymentMethods.Google;
                deferred.resolve(response.Data)
            }
        }).error(function (error) {
            deferred.reject(error);
            usSpinnerService.stop('spinner-1');
            console.error(error);
        });

        return deferred.promise;
    }

    function isPayButtonSupported() {
        return supportButtonPromise.promise;
    }

    function getGoogleTransactionInfo() {
        if (!getPaymentData) {
            console.error('getPaymentData not specified.')
            ModalServiceExt.showError($rootScope._t('Unexpected error. See dev console for the details.'));
        }
        let paymentData = getPaymentData();
        let amount = Number(paymentData.amount);
        if (paymentData.hasCollectionFee) {
            amount += Number(paymentData.collectionFee);
        }
        amount = Number(amount).toFixed(2);
        return {
            countryCode: 'US',
            currencyCode: 'USD',
            totalPriceStatus: 'FINAL',
            totalPrice: amount
        };
    }

    return {
        init: init,
        isPayButtonSupported: isPayButtonSupported,
        onGooglePaymentButtonClicked: onGooglePaymentButtonClicked
    };
}]);
'use strict';
var app = angular.module('utilliApp');
app.controller('SmartPayController', ["$scope", "$window", "$state", "$http", "usSpinnerService", "$timeout", "ServiceProvidersService", "ModalServiceExt", "SmartPayStateService", "SmartPayLayoutService", "GooglePayService", "ApplePayService", "$q", function ($scope, $window, $state, $http, usSpinnerService,
    $timeout, ServiceProvidersService, ModalServiceExt, SmartPayStateService, SmartPayLayoutService,
    GooglePayService, ApplePayService, $q) {
        
    $scope.phoneNumberMask = Config.phoneNumberMask;
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    //utilli.savePayUrl($state.params.token);// commented out because of WGLCX-697
    
    var model = SmartPayStateService.model;
    $scope.model = model;
    model.resetPaymentOptionsAttributes();
    model.isCvvConfirmationTypeActive = true;
    model.enrollInEbillVisible = false;
    model.wantEbill = false; // will be set to default true in case if we show the checbox
    model.nonEbillEmailsCount = 0;
    model.isEligibleForIp = false;
    model.isEligibleForBbp = false;
    model.dunningVariant = 0;
    $scope.currentDate = new Date();

    $scope.savedBankAccounts = [];
    $scope.savedCards = [];
    $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
    $scope.total = 0;
    model.nudgeMessage = '';
    model.hideUi = true;

    $scope.pin = null;
    fixDropDownFromClickToHover();

    function initWallets(apiUrl) { 
        var getPaymentInfoForApple = function () {
            model.amount = Number(model.amount).toFixed(2);
            return {
                amount: model.amount,
                hasCollectionFee: $scope.fee,
                tokenTimestamp: $scope.tokenTimestamp,
                collectionFee: $scope.feeAmount,
                accountNumber: model.contractAccountNumber,
                email: model.email,
                phoneNumber: model.phoneNumber,
                notificationLogId: $state.params.emailId,
                wantSmsReceipt: model.wantSmsReceipt,
                wantEbill: model.wantEbill
            }
        };
        ApplePayService.init(apiUrl, processPayResult, getPaymentInfoForApple);

        var getPaymentInfoForGoogle = function () {
            model.amount = Number(model.amount).toFixed(2);
            return {
                amount: model.amount,
                hasCollectionFee: $scope.fee,
                tokenTimestamp: $scope.tokenTimestamp,
                collectionFee: $scope.feeAmount,
                accountNumber: model.contractAccountNumber,
                email: model.email,
                phoneNumber: model.phoneNumber,
                notificationLogId: $state.params.emailId,
                orderId: model.orderId,
                wantSmsReceipt: model.wantSmsReceipt,
                wantEbill: model.wantEbill
            };
        }

        GooglePayService.init(getPaymentInfoForGoogle, apiUrl, processPayResult);
    
        $scope.startApplePaySession = function () { 
            if(!ApplePayService.isPayButtonSupported())
            {
                ModalServiceExt.showInfo($scope._t("Your browser doesn't support Apple Pay"));
                return;
            }
            $scope.payForm.$setSubmitted();
            if(!$scope.payForm.$valid)
                return;
            ApplePayService.onClickEvent();
        }

        $scope.startGooglePaySession = function () {
            $scope.payForm.$setSubmitted();
            
            if(!$scope.payForm.$valid)
                return;
            
            usSpinnerService.spin('spinner-1');
            GooglePayService.isPayButtonSupported()
            .then(function () { 
                usSpinnerService.stop('spinner-1');
                GooglePayService.onGooglePaymentButtonClicked(model.orderId);
            }, function () { 
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showInfo($scope._t("Your browser doesn't support Google Pay"));
            })
        }
    }

    usSpinnerService.spin('spinner-1');
    var apiUrl;
    ServiceProvidersService.getCurrentProvider()
        .then(function (providerData) {
            apiUrl = providerData.ApiUrl;
            utilli.resolveServiceProviderApiDeffered(providerData.ApiUrl);
            initWallets(apiUrl);
            init();
        })
        .catch(function(){
            ModalServiceExt.showServerError();
            utilli.rejectServiceProviderApiDeffered();
            usSpinnerService.stop('spinner-1');
        });

    $scope.validateAmount = function() {
        // !model.amount because I don't want invalidAmount fire together with required
        var validAmount = !model.amount || Number(model.amount).toFixed(2) > 0 ? true : false;
        $scope.payForm.amount.$setValidity('invalidAmount', validAmount);
    };

    $scope.onPhoneNumberChange = function () {
        model.hasPhoneNumberConsent = hasPhoneNumberConsent(model.phoneNumber);
    }

    $scope.validateBankAccount = function(){
        var bankAccountPattern = /^[0-9]{1,20}$/;
        if (model.bankAccountNumber)
            $scope.payForm.bankAccountNumber.$setValidity('pattern',
                !!model.bankAccountNumber.match(bankAccountPattern));
        if (model.reenterBankAccountNumber)
            $scope.payForm.reenterBankAccountNumber.$setValidity('pattern',
                !!model.reenterBankAccountNumber.match(bankAccountPattern));
        $scope.payForm.reenterBankAccountNumber.$setValidity('match',
            model.reenterBankAccountNumber == model.bankAccountNumber);
    }

    $scope.validateExpirationDate = function(){
        var value = $scope.payForm.expirationDate.$viewValue;
        if ($scope.payForm.expirationDate.$error.required){
            // show only Required
            $scope.payForm.expirationDate.$setValidity('invalidDate', true);
            $scope.payForm.expirationDate.$setValidity('expired', true);
            return;
        }
        if ($scope.payForm.expirationDate.$error.mask || value.split('/')[0] > 12 || value.split('/')[0] == 0){
            // show only Invalid date
            $scope.payForm.expirationDate.$setValidity('invalidDate', false);
            $scope.payForm.expirationDate.$setValidity('expired', true);
            return;
        }
        $scope.payForm.expirationDate.$setValidity('invalidDate', true);
        var mm = value.split('/')[0];
        var yy = value.split('/')[1];
        var date = new Date('20'+yy, mm);
        $scope.payForm.expirationDate.$setValidity('expired', date > new Date());
    }

    $scope.emailPattern = utilli.emailPattern;
    $scope.phoneNumberMask = Config.phoneNumberMask;
    $scope.expirationDateMask = "99/99";
    $scope.smsCodeMask = "9999";
    $scope.fee = false;
    $scope.amountBlocked = false;
    $scope.feeAmount = 0.0;
    $scope.feeAmountString = ($scope.feeAmount).toFixed(2);
    $scope.dunningAmount = 0.0;
    $scope.isUsedLink = false;
    $scope.tokenTimestamp = null;

    function init(){
        model.nudgeMessage = "Redirecting... Please, do not close the page.";
        var payload = utilli.getPayload($state.params.token);
        model.email = payload.Email;
        $http({
            url: apiUrl + 'api/SmartPay/GetSmartPayInfo',
            method: "GET",
            params: { smartPayToken: $state.params.token }
        })
        .apiThen(function (smartPayInfo){
            if (smartPayInfo.NudgePaymentLink) {
                $window.location.href = smartPayInfo.NudgePaymentLink;
                model.nudgeMessage = smartPayInfo.NudgePaymentLinkMessage;
            } else {
                model.nudgeMessage = "Cannot complete redirection. Please, refresh the page";
                return;
            }
            if (smartPayInfo.FailedInBackend) {
                model.failedInBackend = true;
                model.enrollInEbillVisible = false;
                model.wantEbill = false;
            } else {
                model.allPhoneNumbers = smartPayInfo.AllPhoneNumbers;
                model.allPhoneNumbers.forEach(function (ph) {
                    ph.HasConsent = !ph.IsVerified || ph.HasConsent
                });

                if (smartPayInfo.ShowEnrollInEbillCheckbox) {
                    model.enrollInEbillVisible = true;
                    model.wantEbill = true;
                }
                model.installmentPlanToken = smartPayInfo.InstallmentPlanToken;
                model.budgetBillingPlanToken = smartPayInfo.BudgetBillingPlanToken;
                model.isEligibleForIp = !!smartPayInfo.InstallmentPlanToken;
                model.isEligibleForBbp = !!smartPayInfo.BudgetBillingPlanToken;
            }
            model.amount = smartPayInfo.DueAmount;
            if (payload.HasCollectionFee === true) {
                $scope.fee = payload.HasCollectionFee;
                $scope.feeAmount = smartPayInfo.CollectionFee;
                $scope.feeAmountString = Number($scope.feeAmount).toFixed(2);
                $scope.dunningAmount = smartPayInfo.DunningAmount;
                $scope.amountBlocked = smartPayInfo.CollectionFee;
                model.amount = $scope.dunningAmount;
                $scope.isUsedLink = smartPayInfo.IsUsedLink;
                if ($scope.isUsedLink) {
                    ModalServiceExt.showError($scope._t("Sorry, You already made the payment using this link"));
                }
                $scope.tokenTimestamp = smartPayInfo.TokenTimestamp;
            }
            model.contractAccountNumber = smartPayInfo.ContractAccountNumber;
            // save the CA# into local storage so that we do Account/ClearCache on a page refresh
            localStorage.setItem("CurrentAccountNumber", smartPayInfo.ContractAccountNumber);
            // if the phone number is not verified then we assume that it's preferred.
            // that is the check box on UI should be checked by default
            setPhoneNumber(smartPayInfo.PhoneNumber);
            $scope.formatAmount();
            setSavedPaymentOptions(smartPayInfo);

            model.nonEbillEmailsCount = smartPayInfo.NonEbillEmailsCount;
        }, ModalServiceExt)
        .fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    function setPhoneNumber(phoneNumber) {
        model.phoneNumber = phoneNumber;
        model.hasPhoneNumberConsent = hasPhoneNumberConsent(phoneNumber);
    }

    function hasPhoneNumberConsent(phoneNumber) {
        var phone = _.filter(model.allPhoneNumbers, function (p) {
            return p.PhoneNumber == phoneNumber;
        });
        if (phone.length == 0) {
            // by default new phone numbers are preferred
            return true;
        }
        else {
            return phone[0].HasConsent;
        }
    }

    function updateBankIcon() {
        $scope.showBankLogo = false;
        if(model.routingNumber == undefined || model.routingNumber.length != 9)
        {
            return;
        }
        var requestResult = false;
        $http({
            url: apiUrl + 'api/SmartPay/GetBankLogo',
            method: "GET",
            params: { routingNumber: model.routingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                $scope.showBankLogo = false;
            }
            else {
                requestResult = response.Data;
                if(response.Data.Logo != ''){
                    $scope.currentBankLogoImage = response.Data.Logo;
                    $scope.showBankLogo = true;
                    $scope.plaidBankName = response.Data.Name;
                    $scope.plaidBankUrl = response.Data.Url;
                } else {
                    $scope.showBankLogo = false;
                }
            }
        }).error(function () {
            console.log("UpdateBankIcon error. GetBankLogo.");
        });
    }

    $scope.updateBankIconLogo = function() {
        updateBankIcon();
    }


    var getSavedBankAccountLogos = function () {
        $scope.savedBankAccounts.forEach(setSavedBankAccountLogo);
    }

    function setSavedBankAccountLogo(item, index) {
        getBankLogo(item);
    }

    function getBankLogo(item) {
        $http({
            url: apiUrl + 'api/SmartPay/GetBankLogo',
            method: "GET",
            params: { routingNumber: item.RoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                var result = {};
                result.hasLogo = false;
                item.bankLogoInfo = result;
                return result;
            }
            else {
                  if(response.Data.Logo != ''){
                    var result = {};
                    result.plaidBankName = response.Data.Name;
                    result.plaidBankUrl = response.Data.Url;
                    result.logo = response.Data.Logo;
                    result.hasLogo = true;
                    item.bankLogoInfo = result;

                    return result;
                } else {
                    var result = {};
                    result.hasLogo = false;
                    item.bankLogoInfo = result;
                    return result;
                }
            }
        }).error(function () {
            console.log("UpdateBankIcon error. GetBankLogo.");
        });
    }

    function setSavedPaymentOptions(smartPayInfo) {
        setSavedBankAccounts(smartPayInfo.UserBankAccounts);
        setSavedCards(smartPayInfo.UserCards);
        
        if (model.useSavedCard) {
            setPhoneNumber(model.currentSavedCard.PhoneNumber);
        }

        // if the user doesn't have saved cards but has saved checks then automatically select pay by check option
        if (!model.useSavedCard && model.useSavedBankAccount){
            model.paymentMethod = 'eCheck';
            setPhoneNumber(model.currentSavedBankAccount.PhoneNumber);
        }
    }

    function setSavedCards(data) {
        if (data == null || data.length == 0) {
            model.useSavedCard = false;
            return;
        }
        model.useSavedCard = true;
        var now = new Date();
        for (var i = 0; i < data.length; i++){
            var card = data[i];
            // month param starts from 0 so it is equivalent to +1 that is correct for expiration date-time
            var expDate = new Date("20" + card.ExpYear, card.ExpMonth, 1);
            card.isExpired = expDate < now;
            $scope.savedCards.push(card);
        }
        model.currentSavedCard = $scope.savedCards[0];
    };

    function setSavedBankAccounts(data) {
        if (data == null || data.length == 0) {
            model.useSavedBankAccount = false;
            return;
        }
        model.useSavedBankAccount = true;
        $scope.savedBankAccounts = data;
        model.currentSavedBankAccount = $scope.savedBankAccounts[0];

        getSavedBankAccountLogos();
    }

    
    $scope.formatAmount = function () {
        if (model.amount == undefined || isNaN(parseFloat(model.amount))) {
            model.amount = '';
            $scope.validateAmount();
            return;
        }
        model.amount = utilli.formatDecimal(parseFloat(model.amount));
        $scope.validateAmount();
    }

    $scope.getSelectedPaymentMethodClass = function(methodName){
        return { 'selected-payment-method': methodName == model.paymentMethod };
    }

    $scope.selectPaymentMethod = function(methodName){
        model.paymentMethod = methodName;

        if(model.isPayByCard() && model.useSavedCard)
            setPhoneNumber(model.currentSavedCard.PhoneNumber);
        if(model.isPayByCheck() && model.useSavedBankAccount)
            setPhoneNumber(model.currentSavedBankAccount.PhoneNumber);
        
        model.resetResendButton();
        model.verificationCode = '';
        
    }

    $scope.prepareWalletPayment = function () {
        if(model.orderId)
            return;
        
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/SmartPay/PrepareWalletPayment',
            method: "POST",
            data: {
                token: $state.params.token
            }
        })
        .apiThen(function (orderId) {
            model.orderId = orderId;
        }, ModalServiceExt)
        .fixedFinally(function (data) {
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.needPhoneNumberVerification = function(){
        return model.isPayBySavedCard() || model.isPayAndSaveCardWithConfirmation()
            || model.isPayAndSaveCheckWithConfirmation() || model.isPayBySavedCheck();
    }

    $scope.isPhoneNumberRequired = function () {
        return model.wantSmsReceipt || model.isPayBySavedCard() || model.isPayBySavedCheck()
            || (model.isPayByCard() && model.saveThisCard)
            || (model.isPayByCheck() && model.saveThisBankAccount);
    }

    $scope.isIosMobile = isMobileOrRipple() && iOS();

    $scope.pay = function(){
        if (usSpinnerService.isSpinning()) {
            ModalServiceExt.showError("Unexpected error. Your request is in progress...");
            return;
        }
        $scope.payForm.$setSubmitted();
        if (!$scope.payForm.$valid){
            // if (model.isCvvConfirmationTypeActive && model.currentSavedCard && model.amount > 0)
            // {
            //     ModalServiceExt.showError('Please provide pin to proceed.');
            //     return;
            // }
            ModalServiceExt.showError('Please enter required fields to proceed.');
            return;
        }
        if (!$scope.isSupportedCardType()){
            ModalServiceExt.showError('We support only Visa, Mastercard and Discover cards.');
            return;
        }
        if (model.isPayByCard())
            payByCard();
        else
            payByCheck();
    }

    $scope.payByEmail = function(){
        if (usSpinnerService.isSpinning()) {
            ModalServiceExt.showError("Unexpected error. Your request is in progress...");
            return;
        }
        if (model.email == '') {
            ModalServiceExt.showError("Please add your email address to receive OTP...");
            return;
        }
        if (!$scope.isSupportedCardType()){
            ModalServiceExt.showError('We support only Visa, Mastercard and Discover cards.');
            return;
        }
        // model.verificationCode = "";
        if (model.isPayByCard())
        {
            $scope.payForm.$setSubmitted();
            if (!$scope.payForm.email.$valid || !$scope.payForm.phoneNumber.$valid || !$scope.payForm.cardNumber.$valid
                || !$scope.payForm.nameOnCard.$valid || !$scope.payForm.expirationDate.$valid){
                ModalServiceExt.showError('Please enter required fields to proceed.');
                return;
            }
            payByCardEmail();
        }
        else
        {
            $scope.payForm.$setSubmitted();
            if (!$scope.payForm.email.$valid || !$scope.payForm.phoneNumber.$valid || !$scope.payForm.nameOnAccount.$valid
                || !$scope.payForm.routingNumber.$valid || !$scope.payForm.bankAccountNumber.$valid){
                ModalServiceExt.showError('Please enter required fields to proceed.');
                return;
            }
            payByCheckEmail();
        }
    }

    $scope.isSupportedCardType = function (){
        var ccType = $scope.payForm.cardNumber.$ccType;
        return ccType === undefined || ['MasterCard', 'Visa', 'Discover'].indexOf(ccType) >= 0;
    }

    $scope.removeBankAccount = function (bankAccount) { 
        ModalServiceExt.showYesNoMessage($scope._t("Delete Bank Account"), 
            $scope._t("Are you sure you want to delete this bank account?"), function () {
                usSpinnerService.spin('spinner-1');
                $http({
                    url: apiUrl + 'api/SmartPay/DeleteBankAccount',
                    method: "POST",
                    data: {
                        token: $state.params.token,
                        bankAccountId: bankAccount.Id,
                    }
                })
                .apiThen(function (result) {
                    $scope.savedBankAccounts = _.filter($scope.savedBankAccounts, function(item){
                        return item.Id != bankAccount.Id;
                    });
                    if (!$scope.savedBankAccounts.length){
                        model.useSavedBankAccount = false;
                    }
                    else {
                        if (model.currentSavedBankAccount.Id == bankAccount.Id)
                            model.currentSavedBankAccount = $scope.savedBankAccounts[0];
                    }
                }, ModalServiceExt)
                .fixedFinally(function (data) {
                    usSpinnerService.stop('spinner-1');
                });
            });
    }

    $scope.isSavedBankAccountActive = function (bankAccount) {
        var result = bankAccount.Id == model.currentSavedBankAccount.Id;
        return result;
    }
    
    $scope.removeCard = function (card) {
        ModalServiceExt.showYesNoMessage($scope._t("Delete Card"), 
            $scope._t("Are you sure you want to delete this card?"), function () {
                sendRemoveCardRequest(card);
                return;
            });
    }

    var sendRemoveCardRequest = function (card) { 
        usSpinnerService.spin('spinner-1');
            $http({
                method: 'POST',
                url: apiUrl + '/api/SmartPay/RemoveSavedCard',
                data: {
                    PaymentOptionId: card.Id,
                    Token: $state.params.token,
                }
            })
            .success(function(response) {
                usSpinnerService.stop('spinner-1');
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    return;
                }
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    ModalServiceExt.showInfo($scope._t("Card successfully removed."));
                    $scope.savedCards = _.reject($scope.savedCards, function(c) { 
                        return c.Id == card.Id;
                    });
                    if($scope.savedCards.length > 0) {
                        if (model.currentSavedCard.Id == card.Id)
                            model.currentSavedCard = $scope.savedCards[0];
                    }
                    else {
                        model.useSavedCard = false;
                        model.currentSavedCard = null;
                    }
                }
            })
            .error(function(error) {
                console.log(error);
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.useSavedCardClicked = function(){
        setPhoneNumber(model.currentSavedCard.PhoneNumber);
    }

    $scope.setDunning = function(dunningVariant) {
        switch (dunningVariant) {
            case 0:
                model.amount = ($scope.dunningAmount);
                $scope.amountBlocked = true;
                break;
            case 1:
                model.amount = ($scope.dunningAmount / 100 * 75);
                $scope.amountBlocked = true;
                break;
            case 2:
                model.amount = ($scope.dunningAmount);
                $scope.amountBlocked = false;
                break;
        }
        model.amount = (model.amount).toFixed(2);
    }

    $scope.getTotal = function () {
        let amount = Number(model.amount) + Number($scope.feeAmount);
        if (isNaN(amount))
            amount = 0;
        return Number(amount).toFixed(2);
    }

    $scope.savedCardChanged = function (card) {
        model.useSavedCard = true;
        model.currentSavedCard = card;
        setPhoneNumber(model.currentSavedCard.PhoneNumber);
    }

    $scope.isSavedCardActive = function (card) {
        var result = card.Id == model.currentSavedCard.Id;
        return result;
    }

    $scope.useSavedBankAccountClicked = function(){
        setPhoneNumber(model.currentSavedBankAccount.PhoneNumber);
    }

    $scope.savedBankAccountChanged = function (bankAccount) {
        model.useSavedBankAccount = true;
        model.currentSavedBankAccount = bankAccount;
        setPhoneNumber(model.currentSavedBankAccount.PhoneNumber);
    }

    $scope.areBankDetailsRequired = function () {
        return model.isPayByCheck() && !model.useSavedBankAccount;
    }

    $scope.areCardDetailsRequired = function () {
        return model.isPayByCard() && !model.useSavedCard;
    }

    function payByCheckEmail() {
        if(!model.isConfirmationCodeKnown() && $scope.needPhoneNumberVerification()) {
            sendBankAccountPaymentEmailCode();
            return;
        }
        // if (model.useSavedBankAccount){
        //     payBySavedCheck();
        //     return;
        // }
        sendBankAccountPaymentEmailCode();
    }

    function payByCheck() {
        if(!model.isConfirmationCodeKnown() && $scope.needPhoneNumberVerification()) {
            sendBankAccountPaymentSmsCode();
            return;
        }
        if (model.useSavedBankAccount){
            payBySavedCheck();
            return;
        }
        usSpinnerService.spin('spinner-1');
        model.amount = Number(model.amount).toFixed(2);
        var paymentObject = {
            accountNumber: model.contractAccountNumber,
            userId: -1,
            amountToPay: model.amount,
            hasCollectionFee: $scope.fee,
            tokenTimestamp: $scope.tokenTimestamp,
            phone: model.phoneNumber,
            email: model.email,
            nameOnAccount: model.nameOnAccount,
            bankRoutingNumber: model.routingNumber,
            checkingAccountNumber: model.bankAccountNumber,
            companyCode: 0,
            notificationLogId: $state.params.emailId,
            eBillToken: $state.params.token,
            needToSave: model.saveThisBankAccount,
            paymentPage: 1,
            ConfirmationCode: model.verificationCode,
            hasPhoneNumberConsent: model.hasPhoneNumberConsent,
            wantSmsReceipt: model.wantSmsReceipt,
            wantEbill: model.wantEbill
        };
        $http({
            url: apiUrl + 'api/SmartPay/PayByNewCheck',
            method: "POST",
            data: paymentObject
        }).success(function (payResult) {
            usSpinnerService.stop('spinner-1');
            processPayResult(payResult);
        }).error(function (data) {
            ModalServiceExt.showServerError();
            usSpinnerService.stop('spinner-1');
        });
    }

    function payBySavedCheck() {
        usSpinnerService.spin('spinner-1');
        model.amount = Number(model.amount).toFixed(2);
        var paymentObject = {
            token: $state.params.token,
            bankAccountId: model.currentSavedBankAccount.Id,
            amount: model.amount,
            hasCollectionFee: $scope.fee,
            tokenTimestamp: $scope.tokenTimestamp,
            phone: model.phoneNumber,
            email: model.email,
            notificationLogId: $state.params.emailId,
            confirmationCode: model.verificationCode,
            hasPhoneNumberConsent: model.hasPhoneNumberConsent,
            wantSmsReceipt: model.wantSmsReceipt,
            wantEbill: model.wantEbill
        };
        $http({
            url: apiUrl + 'api/SmartPay/PayBySavedCheck',
            method: "POST",
            data: paymentObject
        }).success(function (payResult) {
            usSpinnerService.stop('spinner-1');
            processPayResult(payResult);
        }).error(function (data) {
            ModalServiceExt.showServerError();
            usSpinnerService.stop('spinner-1');
        });
    }

    function processPayResult(payResult, isWalletPayment) {
        if (!payResult) {
            ModalServiceExt.showServerError();
            return;
        }
        if (!payResult.IsSuccessful || payResult.IsBankAccountExistsError || payResult.IsPaymentOptionExistsError) {
            if(payResult.ConfirmationRemainedTime) {
                model.currentSavedCard.cvvAttemptsError = true;
                model.currentSavedCard.cvvTimeout = payResult.ConfirmationRemainedTime;
                cvvTickTimer();
            }

            if (payResult.Message && payResult.Message.includes('Errors: Payment failed. ')) {
                console.log(payResult.Message)
                payResult.Message = payResult.Message.replace('Errors: Payment failed. ', '');
            }
            if (payResult.WellsFargoResult === "Unverified")
                ModalServiceExt.showOkMessage($scope._t("Just a moment") + "!", payResult.Message);
             else
                 ModalServiceExt.showErrorRed(payResult.Message);
            return;
        }
        
        model.receipt = {};
        model.receipt.paymentGuid = payResult.UtilliGuid;
        let amount = Number(model.amount) + Number($scope.feeAmount);
        model.receipt.amountString = utilli.formatCurrency(amount);
        model.receipt.contractAccountNumber = model.contractAccountNumber;
        model.receipt.contractAccountNumber = model.contractAccountNumber;
        model.receipt.remittanceId = payResult.RemittanceId;
        model.receipt.paymentTime = payResult.PaymentDateTimeString;
        model.receipt.paymentMethod = model.paymentMethod;
        model.receipt.enrollmentInEbillDone = payResult.EnrollmentInEbillDone; 
        if (model.isPayByCard()) {
            if (model.useSavedCard) {
                model.receipt.cardNumberStarred = "**** **** **** " + model.currentSavedCard.LastPart;
                model.receipt.nameOnCard = model.currentSavedCard.HolderName;
            }
            else {
                model.receipt.nameOnCard = model.nameOnCard;
                var last4 = model.cardNumber.substr(model.cardNumber.length - 4, 4);
                model.receipt.cardNumberStarred = ''.padStart((model.cardNumber.length - 4) * 5 / 4, '**** ') + last4;
            }
        }
        else {
            if (model.useSavedBankAccount){
                model.receipt.nameOnAccount = model.currentSavedBankAccount.NameOnAccount;
                model.receipt.bankAccountNumberStarred = 'XXXXXX' + model.currentSavedBankAccount.BankAccountNumber;
            }
            else {
                model.receipt.nameOnAccount = model.nameOnAccount;
                var last4 = model.bankAccountNumber.substr(model.bankAccountNumber.length - 4, 4);
                model.receipt.bankAccountNumberStarred = 'XXXXXX' + last4;
            }
        }
        model.receipt.warning = payResult.Warning;
        if(isWalletPayment) {
            model.receipt.walletCardInfo = payResult.WalletCardInfo;
        }
        
        $state.go('SmartPayLayout.SmartPayResult', { paymentGuid: payResult.UtilliGuid });
    }

    $scope.goToPreferences = function () {
        $state.go('SmartPayLayout.Preferences', { token: $state.params.token });
    }

    function payByCard() {
        if(!model.isConfirmationCodeKnown() && $scope.needPhoneNumberVerification()) {
            sendCardPaymentSmsCode();
            return;
        }

        if(model.useSavedCard && model.currentSavedCard.cvvAttemptsError) {
            return;
        }

        if(model.useSavedCard)
            payBySavedCard();
        else 
            payByNewCard();
    };

    function payByCardEmail() {
        if(!model.isConfirmationCodeKnown() && $scope.needPhoneNumberVerification()) {
            sendCardPaymentEmailCode();
            return;
        }

        if(model.useSavedCard && model.currentSavedCard.cvvAttemptsError) {
            return;
        }

        sendCardPaymentEmailCode();
        // if(model.useSavedCard)
        //     payBySavedCard();
        // else 
        //     payByNewCard();
    };

    function payBySavedCard() {
        usSpinnerService.spin('spinner-1');
        model.amount = Number(model.amount).toFixed(2);
        var paymentObject = {
            accountNumber: model.contractAccountNumber,
            amountToPay: model.amount,
            hasCollectionFee: $scope.fee,
            tokenTimestamp: $scope.tokenTimestamp,
            phone: model.phoneNumber,
            email: model.email,
            paymentPage: 1,
            needToSave: model.saveThisCard && !model.useSavedCard,
            eBillToken: $state.params.token,
            notificationLogId: $state.params.emailId,
            companyCode: 0,
            invoiceNumber: -1,
            confirmationCode: !model.isCvvConfirmationTypeActive 
                ? model.verificationCode
                : null,
            cardId: model.currentSavedCard.Id,
            // cvv: model.isCvvConfirmationTypeActive 
            //     ? model.verificationCode
            //     : null,
            pin: model.isCvvConfirmationTypeActive 
            ? model.verificationCode
            : null,
            hasPhoneNumberConsent: model.hasPhoneNumberConsent,
            wantSmsReceipt: model.wantSmsReceipt,
            wantEbill: model.wantEbill
        };
        
        $http({
            url: apiUrl + 'api/SmartPay/PayBySavedCard',
            method: "POST",
            data: paymentObject
        }).success(function (payResult) {
            usSpinnerService.stop('spinner-1');
            processPayResult(payResult);
        }).error(function (data) {
            ModalServiceExt.showServerError();
            usSpinnerService.stop('spinner-1');
        });
    }

    function payByNewCard () {
        usSpinnerService.spin('spinner-1');
        model.amount = Number(model.amount).toFixed(2);
        var paymentObject = {
            accountNumber: model.contractAccountNumber,
            amountToPay: model.amount,
            hasCollectionFee: $scope.fee,
            tokenTimestamp: $scope.tokenTimestamp,
            phone: model.phoneNumber,
            email: model.email,
            paymentPage: 1,
            needToSave: model.saveThisCard && !model.useSavedCard,
            eBillToken: $state.params.token,
            notificationLogId: $state.params.emailId,
            companyCode: 0,
            invoiceNumber: -1,
            confirmationCode: model.verificationCode,
            hasPhoneNumberConsent: model.hasPhoneNumberConsent,
            wantSmsReceipt: model.wantSmsReceipt,
            wantEbill: model.wantEbill
        };
        
        var expirationYear = '20' + model.expirationDate.substr(2, 2);
        var expirationMonth = model.expirationDate.substr(0, 2);
    
        paymentObject.cardNumber = model.cardNumber;
        paymentObject.nameOnCard = model.nameOnCard;
        paymentObject.expirationDateYear = expirationYear;
        paymentObject.expirationDateMonth = expirationMonth;
       
        $http({
            url: apiUrl + 'api/SmartPay/PayByNewCard',
            method: "POST",
            data: paymentObject
        }).success(function (payResult) {
            usSpinnerService.stop('spinner-1');
            processPayResult(payResult);
        }).error(function (data) {
            ModalServiceExt.showServerError();
            usSpinnerService.stop('spinner-1');
        });
    }

    function startSmsConfirmationTimer(remainedTime) {
        if(remainedTime)
            model.timeout = remainedTime;
        else
            model.timeout = 31;

        tickTimer();
    }

    var tickTimer = function () {
        if (model.timeout != 0) {
            model.timeout--;
            $timeout(tickTimer, 1000);
        } else {
            model.canRequestVerificationCode = true;
            model.canShowTimer = false;
            return;
        }

        var secInMinute = 60;
        model.canShowTimer = true;
        model.timeoutStr = '' + (model.timeout % secInMinute); //60 seconds in 1 minute
        if (model.timeoutStr.length < 2) {
            model.timeoutStr = '0' + model.timeoutStr;
        }
        model.timeoutStrMinutes = '' + Math.floor(model.timeout / secInMinute);
        if (model.timeoutStrMinutes.length < 1) {
            model.timeoutStrMinutes = '0';
        }
    }

    var cvvTickTimer = function () {
        if($scope.savedCards.length == 0)
            return;

        var useTimeoutFlag = false;
        $scope.savedCards.forEach(function (item) {
            if (item.cvvTimeout != 0) {
                item.cvvTimeout--;
                useTimeoutFlag = true;
            } else {
                item.cvvAttemptsError = false;
                return;
            }
    
            var secInMinute = 60;
            item.cvvTimeoutStr = '' + (item.cvvTimeout % secInMinute); //60 seconds in 1 minute
            if (item.cvvTimeoutStr.length < 2) {
                item.cvvTimeoutStr = '0' + item.cvvTimeoutStr;
            }
            item.cvvTimeoutStrMinutes = '' + Math.floor(item.cvvTimeout / secInMinute);
            if (item.cvvTimeoutStrMinutes.length < 1) {
                item.cvvTimeoutStrMinutes = '0';
            }
        })
        if(useTimeoutFlag)
            $timeout(cvvTickTimer, 1000);
    }

    $scope.isSmsCodeErrorVisible = function () {
        var regex = model.needToUseCvvValidation()
            ? /^(\d{4})?$|^$/ 
            : /^(\d{4})?$|^$/;
        
        return model.isConfirmationCodeKnown() && $scope.needPhoneNumberVerification() 
            && ($scope.payForm.verificationCode.$invalid || !regex.test(model.verificationCode)) 
            && $scope.payForm.$submitted;
    }

    function sendBankAccountPaymentSmsCode () {
        if (!model.canRequestVerificationCode)
            return;

        model.smsCodeSubmitted = true;
        model.sendSmsCodeError = null;
        model.canShowTimer = false;
        
        model.smsCodeSubmitted = false;
        model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url = model.useSavedBankAccount 
            ? apiUrl + '/api/SmartPay/SendPaymentConfirmationSmsForCheck'
            : apiUrl + '/api/SmartPay/SendNewPhoneConfirmationSmsForCheck'
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token
        };
        if (model.useSavedBankAccount) {
            requestData.BankAccountId = model.currentSavedBankAccount.Id;
        }
        else {
            requestData.nameOnAccount = model.nameOnAccount;
            requestData.bankRoutingNumber = model.routingNumber;
            requestData.bankAccountNumber = model.bankAccountNumber;
        }
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    model.smsCodeSent = true;
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                model.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                $scope.payForm.$setPristine();//reset submitted flag

                var successMessage = model.useSavedBankAccount
                    ? $scope._t("One-time SMS confirmation code has been sent to your mobile number %phoneNumber% that" 
                        + " was used to register this bank account. Use the confirmation code to proceed with your" 
                        + " bank account payment").replace('%phoneNumber%', 
                        utilli.getMaskedPhoneNumberValue(model.currentSavedBankAccount.PhoneNumber))
                    : $scope._t("SMS code successfully sent.")

                ModalServiceExt.showInfo(successMessage);
                model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function sendBankAccountPaymentEmailCode () {
        if (!model.canRequestVerificationCode)
            return;

        model.smsCodeSubmitted = true;
        model.sendSmsCodeError = null;
        model.canShowTimer = false;
        
        model.smsCodeSubmitted = false;
        model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url = model.useSavedBankAccount 
            ? apiUrl + '/api/SmartPay/SendPaymentConfirmationEmailForCheck'
            : apiUrl + '/api/SmartPay/SendNewPhoneConfirmationEmailForCheck'
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token,
            Email: model.email,
        };
        if (model.useSavedBankAccount) {
            requestData.BankAccountId = model.currentSavedBankAccount.Id;
        }
        else {
            requestData.nameOnAccount = model.nameOnAccount;
            requestData.bankRoutingNumber = model.routingNumber;
            requestData.bankAccountNumber = model.bankAccountNumber;
        }
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    model.smsCodeSent = true;
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                model.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                $scope.payForm.$setPristine();//reset submitted flag

                var successMessage = model.useSavedBankAccount
                    ? $scope._t("One-time Email confirmation code has been sent to your email address %email%." 
                        + " Use the confirmation code to proceed with your" 
                        + " bank account payment").replace('%email%', model.email)
                    : $scope._t("Email code successfully sent.")

                ModalServiceExt.showInfo(successMessage);
                model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function sendCardPaymentSmsCode () {
        if (!model.canRequestVerificationCode)
            return;

        model.smsCodeSubmitted = true;
        model.sendSmsCodeError = null;
        model.canShowTimer = false;
        
        model.smsCodeSubmitted = false;
        model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url = model.useSavedCard 
            ? apiUrl + '/api/SmartPay/SendPaymentConfirmationSms'
            : apiUrl + '/api/SmartPay/SendNewPhoneConfirmationSms'
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token
        };
        if (model.useSavedCard) {
            requestData.CardId = model.currentSavedCard.Id;
        }
        else {
            var expirationYear = model.expirationDate.substr(2,2);
            var expirationMonth = model.expirationDate.substr(0, 2);

            requestData.CardNumber = model.cardNumber;
            requestData.ExpirationDateYear = expirationYear;
            requestData.ExpirationDateMonth = expirationMonth;
        }
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    model.smsCodeSent = true;
                    $scope.payForm.$setPristine();//reset submitted flag
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                model.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                $scope.payForm.$setPristine();//reset submitted flag

                var successMessage = model.useSavedCard 
                    ? $scope._t("One-time SMS confirmation code has been sent to your mobile number %phoneNumber% that"
                    + " was used to register this card. Use the confirmation code to proceed with your card payment.")
                        .replace('%phoneNumber%', utilli.getMaskedPhoneNumberValue(model.currentSavedCard.PhoneNumber))
                    : $scope._t("SMS code successfully sent.")
                ModalServiceExt.showInfo(successMessage);
                model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function sendCardPaymentEmailCode () {
        if (!model.canRequestVerificationCode)
            return;

        model.smsCodeSubmitted = true;
        model.sendSmsCodeError = null;
        model.canShowTimer = false;
        
        model.smsCodeSubmitted = false;
        model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url = model.useSavedCard 
            ? apiUrl + '/api/SmartPay/SendPaymentConfirmationEmail'
            : apiUrl + '/api/SmartPay/SendEmailConfirmationEmail'
        var requestData = {
            PhoneNumber: model.phoneNumber,
            EmailAddress: model.email,
            Token: $state.params.token
        };
        if (model.useSavedCard) {
            requestData.CardId = model.currentSavedCard.Id;
        }
        else {
            var expirationYear = model.expirationDate.substr(2,2);
            var expirationMonth = model.expirationDate.substr(0, 2);

            requestData.CardNumber = model.cardNumber;
            requestData.ExpirationDateYear = expirationYear;
            requestData.ExpirationDateMonth = expirationMonth;
        }
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    model.smsCodeSent = true;
                    $scope.payForm.$setPristine();//reset submitted flag
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                model.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                $scope.payForm.$setPristine();//reset submitted flag

                var successMessage = model.useSavedCard 
                    ? $scope._t("One-time Email confirmation code has been sent to your email address %email%."
                    + " Use the confirmation code to proceed with your card payment.")
                        .replace('%email%', model.email)
                    : $scope._t("Email code successfully sent.")
                ModalServiceExt.showInfo(successMessage);
                model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function sendPinSmsCode (pin) {
        // if (!model.canRequestVerificationCode)
        //     return;

        // model.smsCodeSubmitted = true;
        // model.sendSmsCodeError = null;
        // model.canShowTimer = false;
        
        // model.smsCodeSubmitted = false;
        // model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url =  apiUrl + '/api/SmartPay/SendPinVerificationSms';
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token,
            Pin: pin,
            CardId: model.currentSavedCard.Id
        };
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    // model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    // model.smsCodeSent = true;
                    // $scope.payForm.$setPristine();//reset submitted flag
                    // startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                // model.canRequestVerificationCode = true;
            }
            else {
                // startSmsConfirmationTimer();
                // $scope.payForm.$setPristine();//reset submitted flag
                var successMessage = model.useSavedCard 
                    ? $scope._t("One-time SMS confirmation code has been sent to your mobile number %phoneNumber% that"
                    + " was used to register this card. Use the confirmation code to proceed with your card payment.")
                        .replace('%phoneNumber%', utilli.getMaskedPhoneNumberValue(model.currentSavedCard.PhoneNumber))
                    : $scope._t("SMS code successfully sent.")
                // ModalServiceExt.showInfo(successMessage);
                // model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function sendPinEmailCode (pin) {
        // if (!model.canRequestVerificationCode)
        //     return;

        // model.smsCodeSubmitted = true;
        // model.sendSmsCodeError = null;
        // model.canShowTimer = false;
        
        // model.smsCodeSubmitted = false;
        // model.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        
        var url =  apiUrl + '/api/SmartPay/SendPinVerificationEmail';
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token,
            Pin: pin,
            CardId: model.currentSavedCard.Id,
            Email: model.email,
        };
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.IsPaymentOptionExistsError) {
                    // model.canRequestVerificationCode = true;
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }
                if(response.Data && response.Data.RemainedTime) {
                    // model.smsCodeSent = true;
                    // $scope.payForm.$setPristine();//reset submitted flag
                    // startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                model.sendSmsCodeError =  response.Errors[0];
                // model.canRequestVerificationCode = true;
            }
            else {
                // startSmsConfirmationTimer();
                // $scope.payForm.$setPristine();//reset submitted flag
                var successMessage = model.useSavedCard 
                    ? $scope._t("One-time Email confirmation code has been sent to your email address %email%."
                    + " Use the confirmation code to proceed with your card payment.")
                        .replace('%email%', model.email)
                    : $scope._t("Email code successfully sent.")
                // ModalServiceExt.showInfo(successMessage);
                // model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            model.canRequestVerificationCode = true;
        });
    }

    function savePinSmsCode (otp) {

        usSpinnerService.spin('spinner-1');
        
        var url =  apiUrl + '/api/SmartPay/SaveCardPin';
        var requestData = {
            PhoneNumber: model.phoneNumber,
            Token: $state.params.token,
            Pin: $scope.pin,
            CardId: model.currentSavedCard.Id,
            Otp: otp,
            Email: model.email,
        };
        $http({
            method: 'POST',
            url: url,
            data: requestData
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                model.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                
                ModalServiceExt.showPinError(response.Errors[0]);
                    return;
                // model.sendSmsCodeError =  response.Errors[0];
                // model.canRequestVerificationCode = true;
            }
            else {
                // startSmsConfirmationTimer();
                // $scope.payForm.$setPristine();//reset submitted flag
                var successMessage = model.useSavedCard 
                    ? $scope._t("Your PIN has been successfully saved.")
                    : $scope._t("Your PIN has been successfully saved.");
                ModalServiceExt.close();
                ModalServiceExt.showInfo(successMessage);
                $state.reload();
                // model.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            model.sendSmsCodeError = utilli.errors.serverErrorMessage;
            // model.canRequestVerificationCode = true;
        });
    }

    $scope.cancelPayment = function(){
        $state.go('SmartPayLayout.SmartPayLeave', { notificationLogId: $state.params.emailId, 
            installmentPlanToken: $scope.model.installmentPlanToken });
    }

    $scope.getPayButtonText = function () {
        var isSendSmsAction = (model.isPayAndSaveCardWithConfirmation() 
            || model.isPayBySavedCard() 
            || model.isPayAndSaveCheckWithConfirmation() 
            || model.isPayBySavedCheck()) && !model.isConfirmationCodeKnown();
        let amount = $scope.getTotal();
        if (amount === '0.00')
            amount = '';
        else
            amount = " $" + amount;
        if(isSendSmsAction)
            return $scope._t('Send SMS');
        else 
            return $scope._t('Pay' + amount);
    }

    $scope.getCardTypeClass = function(card){
        var ngClass = {};
        var cardTypeName = card && card.CardType ? card.CardType.toLowerCase() : 'visa';
        ngClass[cardTypeName] = true;
        return ngClass;
    }

    $scope.useOtp = function () {
        model.timeout = 0;
        model.isCvvConfirmationTypeActive = false;
        model.verificationCode = '';
    }

    $scope.setPin = function (title) { 
        // ModalServiceExt.showInfo($scope._t("Your browser doesn't support Apple Pay"));
        ModalServiceExt.showCreatePin(
            $scope._t(title),
            $scope._t("PIN"),
            function (res, type) { createPinSendOtp(res, type); },
            function (res) { saveOtp(res); });

        return;
    }

    $scope.useCvv = function () {
        model.isCvvConfirmationTypeActive = true;
        model.verificationCode = '';
    }

    $scope.resendSms = function () {
        if(model.isResendTimerVisible())
            return;
        if (model.isPayByCard())
            sendCardPaymentSmsCode();
        else
            sendBankAccountPaymentSmsCode();
    }

    $scope.goToIpPage = function () {
        $state.go('SmartPayLayout.InstallmentPlan', { token: model.installmentPlanToken });
    }
    
    $scope.goToBbpPage = function () {
        $state.go('SmartPayLayout.BudgetBillingWglcx', { 
            token: model.budgetBillingPlanToken,
            directSrc: 'SmartPay'
        });
    }

    function fixDropDownFromClickToHover() { 
        $(".dropdown-menu" ).css('margin-top',0);

        $(".customer-preferences-btn.dropdown")
            .on('mouseover', function() {
                $( this ).addClass('show').attr('aria-expanded',"true");
                $( this ).find('.dropdown-menu').addClass('show');
            })
            .on('mouseout', function() {
                $( this ).removeClass('show').attr('aria-expanded',"false");
                $( this ).find('.dropdown-menu').removeClass('show');
            });
    }

    function createPinSendOtp(pin, type) {
        $scope.pin = pin;
        if (type == 'email') {
            sendPinEmailCode(pin);
        }
        else {
            sendPinSmsCode(pin);
        }
    }

    function saveOtp(otp) { 
        savePinSmsCode(otp);
    }
}]);
'use strict';
var app = angular.module('utilliApp');
app.controller('SmartPayLeaveController', ["$scope", "$window", "usSpinnerService", "$state", "$http", "ServiceProvidersService", "ModalServiceExt", function ($scope, $window, usSpinnerService, $state,
    $http, ServiceProvidersService, ModalServiceExt) {
    var _t = $scope._t;

    $scope.installmentPlanToken = $state.params.installmentPlanToken;
    $scope.goToInstallmentPlan = function(){
        $state.go("SmartPayLayout.InstallmentPlan", {
            token: $scope.installmentPlanToken
        });
    }

    // scroll to the top of the page so that if there is a Payment Arrangement button then the user will see it
    $window.scrollTo(0,0);

    $scope.reasons = [
        {
            id: 'anotherTime',
            text: _t('I’ll pay my bill another time'),
            checked: false
        },
        {
            id: 'securityConcern',
            text: _t('I have a security concern'),
            checked: false
        },
        {
            id: 'otherChannels',
            text: _t('I prefer other payment channels'),
            checked: false
        },
        {
            id: 'otherMethods',
            text: _t('I prefer other payment methods'),
            checked: false
        },
        {
            id: 'technicalIssues',
            text: _t('I am having technical issues'),
            checked: false
        },
        {
            id: 'other',
            text: _t('Other:'),
            checked: false
        },
    ];

    $scope.back = function () {
        $window.history.back();
    }

    $scope.submit = function() {
        var checked = _.filter($scope.reasons, function(r) { return r.checked; });
        if (!checked.length){
            ModalServiceExt.showError(_t('Please select at least one reason.'));
            return;
        }
        var ids = _.map(checked, function(r) { return r.id; });

        usSpinnerService.spin('spinner-1');
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                var apiUrl = providerData.ApiUrl;
                $http({
                    url: apiUrl + 'api/SmartPay/Leave',
                    method: "POST",
                    data: { 
                        notificationLogId: $state.params.notificationLogId,
                        reasons: ids,
                        otherReasonText: $scope.otherReasonText
                    }
                }).success(function (payResult) {
                    $scope.showThankYou = true;
                    usSpinnerService.stop('spinner-1');
                }).error(function () {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                });
            })
            .catch(function (e) {
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }
}]);



'use strict';
var app = angular.module('utilliApp');
app.controller('SmartPayPreferencesController', ["$scope", "$window", "usSpinnerService", "$state", "$http", "ServiceProvidersService", "ModalServiceExt", function ($scope, $window, usSpinnerService, $state,
    $http, ServiceProvidersService, ModalServiceExt) {
    
    $scope.phoneNumberMask = Config.phoneNumberMask;
    $scope.applyToAllAccounts = false;

    $scope.emailTimer = utilli.createResendTimer($scope);
    $scope.smsTimer = utilli.createResendTimer($scope);
     
    usSpinnerService.spin('spinner-1');
    var apiUrl;
    ServiceProvidersService.getCurrentProvider()
        .then(function (providerData) {
            apiUrl = providerData.ApiUrl;
            utilli.resolveServiceProviderApiDeffered(providerData.ApiUrl);
            loadCustomerInfo();
        })
        .catch(function(){
            ModalServiceExt.showServerError();
            utilli.rejectServiceProviderApiDeffered();
            usSpinnerService.stop('spinner-1');
        });

    $scope.goBack = function () { 
        $window.history.back();
    }

    $scope.save = function () {
        usSpinnerService.spin('spinner-1');
        var permissions = _.reject($scope.permissions, function(p){ return p.isGroupHeader; });
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/UpdateCustomerPreferences',
            data: {
                authToken: $state.params.token,
                permission: permissions,
                applyToAllAccounts: $scope.applyToAllAccounts
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                ModalServiceExt.showInfo($scope._t("Changes successfully saved."));
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    function setEmailsAndPhoneNumbers(response) { 
        var clientUtilliIdCounter = 0;
        if(response.Data.MobileNumbers) {
            $scope.mobilePhones = response.Data.MobileNumbers;
            $scope.mobilePhones.forEach(function(mobilePhone) {
                mobilePhone.clientUtilliId = clientUtilliIdCounter;
                clientUtilliIdCounter++;
            });
        }
        else {
            $scope.mobilePhones = [];
        }

        if(response.Data.Emails) {
            clientUtilliIdCounter = 0;
            $scope.emails = response.Data.Emails;
            $scope.emails.forEach(function(email) {
                email.clientUtilliId = clientUtilliIdCounter;
                clientUtilliIdCounter++;
            });
        }
        else {
            $scope.emails = [];
        }
    }

    $scope.verifyEmail = function (emailInfo) {
        if(emailInfo.NotSaved) {
            emailInfo.isSubmitted = true;
            if(!$scope.emailForm["email" + emailInfo.clientUtilliId].$valid)
                return;
        }

        $scope.isEmailConfirmationBoxVisible = true;
        $scope.emailForVerification = emailInfo.Email;
        $scope.sendEmailVerificationCode();
    }

    $scope.closeEmailConfirmationBox = function () { 
        $scope.isEmailConfirmationBoxVisible = false;
    }

    $scope.sendEmailVerificationCode = function () {
        if($scope.emailTimer.isResendTimerVisible())
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/SendEmailVerificationConfirmationCode',
            data: {
                authToken: $state.params.token,
                email: $scope.emailForVerification
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                $scope.isEmailConfirmationBoxVisible = false;
                $scope.sendSmsCodeError = utilli.errors.serverErrorMessage;
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.RemainedTime) {
                    $scope.emailTimer.isCodeSent = true;
                    $scope.emailTimer.startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }

                ModalServiceExt.showError(response.Errors[0]);
                $scope.sendSmsCodeError = response.Errors[0];
            }
            else {
                $scope.hasEmailVerificationCodeSent = true;
                $scope.emailTimer.startSmsConfirmationTimer();
                $scope.emailTimer.isCodeSent = true;
                // ModalServiceExt.showInfo($scope._t("The confirmation code was successfully sent on your email."));
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    $scope.checkEmailVerificationCode = function () {
        $scope.emailVerificationForm.$submitted = true;
        if(!$scope.emailVerificationForm.$valid) 
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/CheckEmailVerificationCode',
            data: {
                authToken: $state.params.token,
                email: $scope.emailForVerification,
                verificationCode: $scope.emailVerificationCode
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                ModalServiceExt.showInfo($scope._t("The email was successfully verified."));
                $scope.isEmailConfirmationBoxVisible = false;
                $scope.emailVerificationCode = '';
                for (var i = 0; i < $scope.emails.length; i++) {
                    if($scope.emails[i].Email == $scope.emailForVerification) {
                        $scope.emails[i].IsVerified = true;
                        $scope.emails[i].NotSaved = false;
                        $scope.emails[i].Id = response.Data;
                        $scope.emails[i].Preferred = $scope.emails.length == 1;
                        break;
                    }
                }
            }
        })
        .error(function(error) {
            ModalServiceExt.showError(error);
            console.log(error);
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.verifyMobilePhone = function (mobilePhone) {
        if(mobilePhone.NotSaved) {
            mobilePhone.isSubmitted = true;
            if(!$scope.phoneForm["mobilePhone" + mobilePhone.clientUtilliId].$valid)
                return;
        }

        $scope.isMobilePhoneConfirmationBoxVisible = true;
        $scope.mobilePhoneForVerification = utilli.getMaskedPhoneNumberValue(mobilePhone.PhoneNumber);
        $scope.mobilePhoneInfoForVerification = mobilePhone;
        $scope.sendPhoneNumberVerificationCode(mobilePhone.PhoneNumber);
    }

    $scope.closeMobilePhoneConfirmationBox = function () {
        $scope.isMobilePhoneConfirmationBoxVisible = false;
    }

    $scope.sendPhoneNumberVerificationCode = function () {
        if($scope.smsTimer.isResendTimerVisible())
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/SendPhoneNumberVerificationConfirmationCode',
            data: {
                authToken: $state.params.token,
                phoneNumber: $scope.mobilePhoneInfoForVerification.PhoneNumber
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                $scope.isMobilePhoneConfirmationBoxVisible = false;
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.RemainedTime) {
                    $scope.smsTimer.isCodeSent = true;
                    $scope.smsTimer.startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }

                $scope.isMobilePhoneConfirmationBoxVisible = false;
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                $scope.smsTimer.startSmsConfirmationTimer();
                $scope.smsTimer.isCodeSent = true;
                $scope.hasMobilePhoneVerificationCodeSent = true;
                // ModalServiceExt.showInfo($scope._t("The confirmation code was successfully sent on phone number."));
            }
        })
        .error(function(error) {
            ModalServiceExt.showError(error);
            console.log(error);
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.checkPhoneNumberVerificationCode = function () {
        $scope.pnVerificationForm.$submitted = true;
        if(!$scope.pnVerificationForm.$valid)
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/CheckPhoneNumberVerificationCode',
            data: {
                authToken: $state.params.token,
                phoneNumber: $scope.mobilePhoneInfoForVerification.PhoneNumber,
                verificationCode: $scope.mobilePhoneVerificationCode
            }
        })
        .success(function(response) {
            $scope.pnVerificationForm.$submitted = false;
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.RemainedTime) {
                    $scope.smsTimer.isCodeSent = true;
                    $scope.smsTimer.startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }

                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                $scope.smsTimer.isCodeSent = true;
                $scope.smsTimer.startSmsConfirmationTimer();
                ModalServiceExt.showInfo($scope._t("The phone number was successfully verified."));
                $scope.isMobilePhoneConfirmationBoxVisible = false;
                $scope.mobilePhoneVerificationCode = '';
                for (var i = 0; i < $scope.mobilePhones.length; i++) {
                    if($scope.mobilePhones[i].PhoneNumber == $scope.mobilePhoneInfoForVerification.PhoneNumber) {
                        $scope.mobilePhones[i].IsVerified = true;
                        $scope.mobilePhones[i].NotSaved = false;
                        $scope.mobilePhones[i].Id = response.Data;
                        $scope.mobilePhones[i].Preferred = $scope.mobilePhones.length == 1;
                        break;
                    }
                }
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    $scope.addMobilePhoneNumber = function () {
        if ($scope.mobilePhones.length >= 5){
            ModalServiceExt.showError("We can't add more than 5 numbers.");
            return;
        }
        var maxId = 0;
        $scope.mobilePhones.forEach(function (mobilePhone) {
            if (mobilePhone.clientUtilliId >= maxId)
            {
                maxId = mobilePhone.clientUtilliId + 1;
            }
        });

        $scope.mobilePhones.push({ 
            PhoneNumber: '', 
            clientUtilliId: maxId,
            NotSaved: true,
            Verified: false });
    }

    $scope.removeMobilePhone = function (mobilePhone) {
        if(mobilePhone.NotSaved) {
            var remainMobilePhones = _.reject($scope.mobilePhones, 
                function(p){ return p.clientUtilliId == mobilePhone.clientUtilliId; });
            $scope.mobilePhones = remainMobilePhones;
            return;
        }

        if ($scope.mobilePhones.length == 1) {
            ModalServiceExt.showError("You cannot remove last phone number.");
        }
        else {
            ModalServiceExt.showYesNoMessage(
                $scope._t('Attention'),
                $scope._t("Are you sure you want to delete phone number " + utilli.getMaskedPhoneNumberValue(mobilePhone.PhoneNumber) + "?"),
                function () {    
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: apiUrl + 'api/SmartPayPreferences/RemovePhoneNumber/',
                        data: {
                            authToken: $state.params.token,
                            phoneNumber: mobilePhone.PhoneNumber
                        }
                    })
                    .success(function(response) {
                        usSpinnerService.stop('spinner-1');
                        utilli.handleAjaxResponse(response,
                            ModalServiceExt,
                            function() {
                                ModalServiceExt.showInfo($scope._t("Phone number successfully deleted."), function () {
                                    var remainMobilePhones = _.reject($scope.mobilePhones, 
                                        function(mp){ return mp.PhoneNumber == mobilePhone.PhoneNumber; });
                                    $scope.mobilePhones = remainMobilePhones;
                                });
                            });
                    })
                    .error(function(error) {
                        console.error(error);
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                }
            );
        }
    }

    $scope.addEmail = function () {
        if ($scope.emails.length >= 5) {
            ModalServiceExt.showError("We can't add more than 5 emails.");
            return;
        }
        var maxId = 0;
        $scope.emails.forEach(function (email) {
            if (email.clientUtilliId >= maxId)
            {
                maxId = email.clientUtilliId + 1;
            }
        });

        $scope.emails.push({ 
            Email: '', 
            clientUtilliId: maxId,
            NotSaved: true,
            Verified: false 
        });
    }

    $scope.removeEmail = function (emailInfo) {
        if(emailInfo.NotSaved) {
            var remainEmails = _.reject($scope.emails, 
                function(e){ return e.clientUtilliId == emailInfo.clientUtilliId; });
            $scope.emails = remainEmails;
            return;
        }

        if ($scope.emails.length == 1) {
            ModalServiceExt.showError("You cannot remove last email.")
        }
        else {
            ModalServiceExt.showYesNoMessage(
                $scope._t('Attention'),
                $scope._t("Are you sure you want to delete email " + emailInfo.Email + "?"),
                function () {    
                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: apiUrl + 'api/SmartPayPreferences/RemoveEmail/',
                        data: {
                            authToken: $state.params.token,
                            Email: emailInfo.Email
                        }
                    })
                    .success(function(response) {
                        usSpinnerService.stop('spinner-1');
                        utilli.handleAjaxResponse(response,
                            ModalServiceExt,
                            function() {
                                ModalServiceExt.showInfo($scope._t("Email successfully deleted."), function () {
                                    var remainEmails = _.reject($scope.emails, 
                                        function(e){ return e.Email == emailInfo.Email; });
                                    $scope.emails = remainEmails;
                                });
                            });
                    })
                    .error(function(error) {
                        console.error(error);
                        usSpinnerService.stop('spinner-1');
                        ModalServiceExt.showServerError();
                    });
                }
            );
        }
    }

    function loadCustomerInfo () { 
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/SmartPayPreferences/GetCustomerPreferences/',
            method: "GET",
            params: { 
                authToken: $state.params.token
            }
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined || !response.Data) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showInfo($scope._t("Service is unavailable now. Try again later."));
                return;
            }
            if (response.HasErrors) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showInfo(response.Errors[0]);
            }
            else {
                usSpinnerService.stop('spinner-1');
                $scope.accountNumber = response.Data.AccountNumber;
                $scope.zipCode = response.Data.ZipCode;
                $scope.fullOrCompanyName = response.Data.FullOrCompanyName;

                $scope.permissions = response.Data.Permission;

                var permissionsUi = [];

                for (var i = 0; i < $scope.permissions.length; i++) {
                    var p = $scope.permissions[i];
                    if(needShowGroupHeader(p, i))
                        permissionsUi.push({
                            isGroupHeader: true,
                            groupName: p.GroupName
                        });
                    
                    if(needShowGroupHeader(p, i) || needShowOffsetForGroupHeader(p, i))
                        p.isGroupItem = true;
                    permissionsUi.push(p);
                }

                $scope.permissions = permissionsUi;
                setEmailsAndPhoneNumbers(response);
            }
            
        }).error(function () {
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
            usSpinnerService.stop('spinner-1');
        });
    }

    function needShowGroupHeader(permission, $index) {
        if(!permission.GroupName)
            return false;

        if($index == null && permission.GroupName != null)
            return true;

        if($index > 0 && permission.GroupName != $scope.permissions[$index - 1].GroupName)
            return true;

        return false;
    }

    function needShowOffsetForGroupHeader(permission, $index) {
        if(!permission.GroupName)
            return false;

        if($index > 0 && permission.GroupName != null
            && permission.GroupName == $scope.permissions[$index - 1].GroupName) {
                return true;
            }

        return false;
    }

    $scope.toggleEmailPreference = function (p) {
        if (!p.IsEmailEditable)
            return;

        p.EmailAllowed = !p.EmailAllowed;
    }

    $scope.toggleSmsPreference = function (p) {
        if(_.where($scope.mobilePhones, { IsVerified: true }).length == 0) {
            ModalServiceExt.showInfo($scope._t('You have to add at least one verified mobile phone number.'));
            return;
        }
            
        p.SmsAllowed = !p.SmsAllowed;
    }

    $scope.toggleVoicePreference = function (p) {
        p.VoiceAllowed = !p.VoiceAllowed;
    }

    $scope.setEmailPreferred = function (emailInfo) {
        if (!emailInfo.IsVerified)
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/MakeEmailPreferred',
            data: {
                authToken: $state.params.token,
                email: emailInfo.Email
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                $scope.emails.forEach(function(email) {
                    email.Preferred = email.Email == emailInfo.Email;
                });
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }

    $scope.setPhoneNumberPreferred = function (phoneNumberInfo) {
        if (!phoneNumberInfo.IsVerified)
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/SmartPayPreferences/MakePhoneNumberPreferred',
            data: {
                authToken: $state.params.token,
                phoneNumber: phoneNumberInfo.PhoneNumber
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                $scope.mobilePhones.forEach(function(pni) {
                    pni.Preferred = pni.PhoneNumber == phoneNumberInfo.PhoneNumber;
                });
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showServerError();
        });
    }
}]);
'use strict';
var app = angular.module('utilliApp');
app.controller('SmartPayResultController', ["$scope", "SmartPayStateService", "$window", "$state", "usSpinnerService", "$http", "ServiceProvidersService", "ModalServiceExt", function ($scope, SmartPayStateService, $window, $state, usSpinnerService,
    $http, ServiceProvidersService, ModalServiceExt) {
    var model = SmartPayStateService.model.receipt;
    $scope.model = model;
    var apiUrl;
    // if we got here not by navigation from the payment page (entered URL into the address bar)
    if (!model.contractAccountNumber || model.paymentGuid != $state.params.paymentGuid){
        model.paymentGuid = $state.params.paymentGuid;
        usSpinnerService.spin('spinner-1');
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                apiUrl = providerData.ApiUrl;
                init();
            })
            .catch(function (e) {
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    function getPaymentMethod(methodId){
        if (methodId == utilli.paymentMethods.Card) {
            return 'card';
        }
        if (methodId == utilli.paymentMethods.Check) {
            return 'eCheck';
        }
        return 'wallet';
    }

    function init(){
        $http({
            url: apiUrl + 'api/SmartPay/GetPaymentResult',
            method: "GET",
            params: { paymentGuid: $state.params.paymentGuid }
        })
        .apiThen(function (payResult) {
            model.amountString = utilli.formatCurrency(payResult.Amount);
            model.contractAccountNumber = payResult.ContractAccountNumber;
            model.remittanceId = payResult.RemittanceId;
            model.paymentTime = payResult.PaymentDateTimeString;
            model.paymentMethod = getPaymentMethod(payResult.MethodId);
            model.nameOnCard = payResult.NameOnCard;
            model.cardNumberStarred = "**** **** **** " + payResult.CardNumber;
            model.nameOnAccount = payResult.NameOnAccount;
            model.bankAccountNumberStarred = payResult.BankAccountNumber;
            model.warning = payResult.Warning;
            if (payResult.MethodId == utilli.paymentMethods.Apple ||
                payResult.MethodId == utilli.paymentMethods.Google){
                model.walletCardInfo = payResult.CardType + " **** " + payResult.CardNumber;
            }
        }, ModalServiceExt)
        .fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.getReceiptSentMessage = function(){
        return model.warning 
            ? $scope._t('Payment Confirmation will be also sent to email address on file once the payment is posted on your' 
                + ' account.')
            : $scope._t('Payment Confirmation was also sent to email address on file.');
    }

    $scope.print = function () {
        $window.print();
    }

    $scope.isPayByCard = function () {
        return model.paymentMethod === 'card';
    }

    $scope.isPayByCheck = function () {
        return model.paymentMethod === 'eCheck';
    }
    
    $scope.isPayByWallet = function () {
        return model.paymentMethod === 'wallet';
    }

    $scope.hideEbillWarning = function () {
        model.enrollmentInEbillDone = false;
        $scope.model.enrollmentInEbillDone = false;
    }
}]);


'use strict';
var app = angular.module('utilliApp');

app.controller('DocuSignController', ['$scope', '$timeout', '$state', '$http', 'usSpinnerService', 'LeftMenuService',
    'CommonDataService', '$q', 'ServiceProvidersService', 'ModalServiceExt', 'PaymentVerificationService', '$window',
    function ($scope, $timeout, $state, $http, usSpinnerService, LeftMenuService, CommonDataService, $q, 
        ServiceProvidersService, ModalServiceExt, PaymentVerificationService, $window) {

    LeftMenuService.setCurrentTab('DocuSign');
    $scope.phoneNumberMask = Config.phoneNumberMask;
    var apiUrl = '';
    $scope.savedCards = [];

    $scope.isDocumentSigned = (($state.params.event == "signing_complete") || ($state.params.event == "viewing_complete"));

    $scope.docusingAmountToPay = 1 * $state.params.billAmount;

    $scope.bcaId = $state.params.bcaId;
    $scope.bcaManagerEmail = $state.params.bcaManagerEmail;

    $scope.email = $state.params.email ? $state.params.email : '';

    $scope.showDocuSignError = false;
    $scope.docuSignErrorText = '';

    $scope.orderNumber = $state.params.orderNumber ? $state.params.orderNumber : localStorage.getItem("last_order_number");


    $scope.docuSignExplainOnlyCheckPaymentAvailable = false;

    $scope.showBankLogo = false;

    function setCurrentSavedCardAttributes() {
        $scope.nameOnCard = $scope.currentSavedCard.card.HolderName;
        $scope.cardExpiryMonth = $scope.currentSavedCard.card.ExpMonth;
        $scope.cardExpiryYear = "20" + $scope.currentSavedCard.card.ExpYear;
    }

    $scope.savedCardChanged = function () {
        setCurrentSavedCardAttributes();
    }

    $scope.useSavedCardChanged = function () {
        if ($scope.useSavedCard) {
            $scope.currentSavedCard = $scope.savedCards[0];
            for (var i = 0; i < $scope.savedCards.length; i++) {
                var cardInfo = $scope.savedCards[i];
                if (cardInfo.card.IsPrimary) {
                    $scope.currentSavedCard = cardInfo;
                    break;
                }
            }

            setCurrentSavedCardAttributes();
        } else {
            clearSaveCardData();
        }
    };

    function clearSaveCardData () {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';
    }

    function initPage() {
        $scope.imagesPath = utilli.isAdmin
            ? "../Images"
            : "Images";

        $scope.isWglcx = utilli.isWglcx();
        $scope.isAdmin = utilli.isAdmin;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.zip = '';

        $scope.address = {};

        $scope.onlyNumbers = /^\d+$/;
        $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
        $scope.emailPattern = utilli.emailPattern;

        $scope.stepName = 'selectPaymentOption';
        $("#cardCodeCvv").mask("999?9", { placeholder: "" });

        $scope.isFeeEnabled = false;
        
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {

                apiUrl = providerData.ApiUrl;
                
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                    $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                    $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                    $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                    $scope.paymentInfoText = commonData.FeeInformation;
                    $scope.commomData = commonData;

                    if ($scope.docusingAmountToPay > commonData.MaxPaymentAmount) {
                        $scope.stepName = 'payByBankAccount';
                        $scope.isBackButtonDisabled = true;
                        $scope.docuSignExplainOnlyCheckPaymentAvailable = true;
                    }

                    $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                    $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                    $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                    $scope.quickPayValidationType = commonData.QuickPayValidationType;
                    $scope.isFeeEnabled = commonData.IsFeeEnabled;

                    if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                        $scope.quickPayValidationCaption = _t('Customer Number');
                    }
                },
                function () {
                    ModalServiceExt.showServerError();
                });


                // cancel - the recipient decides to finish later
                // decline - the recipient declines signing
                // exception - a processing error occurs during the signing session
                // fax_pending - if the recipient choses to print, sign and fax back
                // id_check_failed - if authentication was added to the document, this is when the recipient fails
                // session_timeout - the signing session times out when recipient goes idle
                // signing_complete - the recipient completed signing
                // ttl_expired - the token was not used within the timeout period or the token was already accessed
                // viewing_complete - a recipient that does not need to sign completes the viewing ceremony

                if($state.params.event == "cancel" ||
                    $state.params.event == "exception" || 
                    $state.params.event == "fax_pending" ||
                    $state.params.event == "id_check_failed" ||
                    $state.params.event == "session_timeout" ||
                    $state.params.event == "ttl_expired" ) {

                    $scope.docuSignExplainOnlyCheckPaymentAvailable = false;
                    $scope.showDocuSignError = true;
                    $scope.docuSignErrorText = '';

                    if($state.params.event == "cancel") {
                        $scope.docuSignErrorText = 'You have selected the option to sign document later. Thank you.';
                    } else if ($state.params.event == "exception") {
                        $scope.docuSignErrorText = 'Please try again later. Sorry for the Inconvenience. Error: Processing error occurs during the signing session.';
                    } else if ($state.params.event == "fax_pending") {
                        $scope.docuSignErrorText = 'Error: The recipient choses to print, sign and fax back.';
                    } else if ($state.params.event == "id_check_failed") {
                        $scope.docuSignErrorText = 'Please try again later. Sorry for the Inconvenience. Error: Authentication was added to the document, this is when the recipient fails.';
                    } else if ($state.params.event == "session_timeout") {
                        $scope.docuSignErrorText = 'Please try again later. Sorry for the Inconvenience. Error: The signing session times out when recipient goes idle.';
                    } else if ($state.params.event == "ttl_expired") {
                        $scope.docuSignErrorText = 'Please try again later. Sorry for the Inconvenience. Error: the token was not used within the timeout period or the token was already accessed.';
                    } 
                    return;
                }

                // if user paid and refreshes the page - he must not be able to pay again WGLCX-338
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: apiUrl + 'api/DocuSign/IsOrderAlreadyPaid',
                    params: { orderNumber: $scope.orderNumber }
                })
                .success(function(response) {
                    usSpinnerService.stop('spinner-1');
                    
                    if(response.Data != 'Payment required')
                    {
                        $scope.docusingAmountToPay = 0 // No payments for this. Don't show controls. 
                        return;
                    }
                })
                .error(function(error) {
                    console.log(error);
                    usSpinnerService.stop('spinner-1');
                    return;// codereview@Yuriy: why do you use these returns if they do nothing?
                });


                // if user declined to sign
                if(!$scope.isDocumentSigned) { 
                    if($state.params.event == "decline") {
                        $scope.docuSignExplainOnlyCheckPaymentAvailable = false;
                        usSpinnerService.spin('spinner-1');
                        $http({
                            method: 'POST',
                            url: apiUrl + 'api/DocuSign/DocusignSetDeclined',
                            params: { orderNumber: $scope.orderNumber }
                        })
                        .success(function(response) {
                            usSpinnerService.stop('spinner-1');

                            $scope.showDocuSignError = true;
                            $scope.docuSignErrorText = 'Document had been voided and Sales Order has been cancelled.';

                            return;
                        })
                        .error(function(error) {
                            console.log(error);
                            usSpinnerService.stop('spinner-1');
                            return;
                        });
                    }
                }
                
                // if user signed but no need to pay
                if($scope.isDocumentSigned && $scope.docusingAmountToPay == 0) {

                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: apiUrl + '/api/DocuSign/DocusignUploadSignedPdf',
                        params: {
                            orderNumber: $scope.orderNumber,
                        }
                    })
                    .success(function(response) {
                        usSpinnerService.stop('spinner-1');

                        return;
                    })
                    .error(function(error) {
                        console.log(error);
                        usSpinnerService.stop('spinner-1');
                        return;
                    });
                }
            },
            function() {
                // todo: implement error handling
                //$moduleServices.setError(utilli.errors.serverErrorMessage);
            }
        );

        if ($state.params.contractAccountNumber) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                    apiUrl = providerData.ApiUrl;
                    var searchRequest = {
                        accountNumber: $state.params.contractAccountNumber,
                        isAdmin: $scope.isAdmin,
                        billAccessToken: $state.params.token,
                        isNonCommodity: true
                    };
                    CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        usSpinnerService.spin('spinner-1');
                        var url = apiUrl + 'api/Payment/FindAccounts';
                        $http({
                            url: url,
                            method: "GET",
                            params: searchRequest
                        }).success(function (data) {
                            if (!data.length){
                                usSpinnerService.stop('spinner-1');
                                $scope.errorFromServerReturned = true;
                                $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                                return;
                            }
                            $scope.selectAccount(data[0]);
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            $scope.errorFromServerReturned = true;
                            $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                        });
                    });
            });
        }
    }

    initPage();

    $scope.back = function () {
        $state.goRelativeTo('QuickPay', 'Step1');
    };

    $scope.cancel = function () {
        $state.goToWelcome();
    };

    $scope.clear = function () {
        $scope.findResultVisible = false;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
        $scope.showBankLogo = false;
    };

    $scope.selectAccount = function (account) {
        clearPaymentSettings();
        $scope.isAuthForEBill = account.AuthorizedForEBill;
        $scope.currentAccount = account;
        if ($scope.stepName != 'payByBankAccount')
            $scope.stepName = 'selectPaymentOption';

        // account.PhoneNumber may be empty if wglcx user is not authorized to view bills.
        // phone number is used for bills authorization and we don't disclose the phone number
        // to those users who have not passed authorization yet.
        $scope.phone = account.PhoneNumber ? account.PhoneNumber : $scope.phone;

        // Do not fill email here. email filled with billToEmail from params for docusign
        //$scope.email = account.Email ? account.Email : $scope.email;

        initAddress(account);

        usSpinnerService.spin('spinner-1'); // stop - inside of function getConvFeeInfo
        getConvFeeInfo(account);

        $scope.amountDue = $state.params.billAmount;
        updateConvinienceFee();

        if ($scope.amountDue < 0) {
            $scope.amountDue = 0;
            $scope.totalAmount = "";
        } else {
            $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
        }

        $scope.formatTotalAmount();
    }
    
    function initAddress (account) { 
        $scope.address.HouseNumber = account.MailHouseNumber,
        $scope.address.Street = account.MailStreet,
        $scope.address.City = account.MailCity,
        $scope.address.HouseNoSupplement = account.MailHouseNoSupplement,
        $scope.address.State = account.MailRegion,
        $scope.address.Zip = account.MailCityPostalCode
    }

    $scope.onAmountChange = function () {
        if ($scope.amountDue == '-') {
            return;
        }
        if ($scope.amountDue == '' || $scope.amountDue == undefined) {
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        if ($scope.amountDue.slice(-1) == '.') {
            return;
        }

        if (isNaN($scope.amountDue) || isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        updateConvinienceFee();

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
    }

    $scope.cancelPaymentOptionSelection = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.selectPayByCard = function () {
        $scope.stepName = 'payByCard';
        updateConvinienceFee();
    }

    $scope.selectPayByBankAccount = function () {
        $scope.stepName = 'payByBankAccount';
        updateConvinienceFee();
    }

    $scope.formatTotalAmount = function () {
        if ($scope.amountDue == undefined) {
            $scope.totalAmount = '';
            return;
        }

        if (isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            return;
        }
        $scope.amountDue = formatDecimal(parseFloat($scope.amountDue));
    }

    $scope.cancelPayment = function () {
        $scope.bankAccountFormSubmitted = false;
        $scope.cardFormSubmitted = false;
        $scope.clear();
        clearPaymentSettings();
        $scope.stepName = 'selectPaymentOption';
    }

    $scope.payNow = function () {
        $scope.stepName = 'processingPayment';
        usSpinnerService.spin('spinner-1');
        $scope.$apply();
        $timeout(function () {
            usSpinnerService.stop('spinner-1');
            $scope.stepName = 'paymentResult';
        }, 3000);
    }

    function checkPaymentAmountWglcx() {
        //not on docusign, please
        return true;
    }
    
    var tickTimer = function () {
        if ($scope.timeout != 0) {
            $scope.timeout--;
            $timeout(tickTimer, 1000);
        } else {
            $scope.canRequestVerificationCode = true;
            $scope.canShowTimer = false;
            return;
        }

        $scope.canShowTimer = true;
        $scope.timeoutStr = '' + $scope.timeout;
        if ($scope.timeoutStr.length < 2) {
            $scope.timeoutStr = '0' + $scope.timeoutStr;
        }
    }

    function startSmsConfirmationTimer(remainedTime) {
        if(remainedTime)
            $scope.timeout = remainedTime;
        else
            $scope.timeout = 31;

        tickTimer();
    }

    $scope.canRequestVerificationCode = true;

    $scope.removeCard = function () { 
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: localStorage.getItem('ApiUrl') + '/api/Payment/RemoveQuickPaySavedCard',
            data: {
                CardId: $scope.currentSavedCard.card.Id,
                Token: $state.params.token
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(response,
                ModalServiceExt,
                function () {
                    ModalServiceExt.showInfo($scope._t("Card successfully removed."));
                    $scope.savedCards = _.reject($scope.savedCards, function(cardInfo) { 
                        return cardInfo.card.Id == $scope.currentSavedCard.card.Id 
                    });
                    $scope.savedCardsVisible = $scope.savedCards.length > 0;
                    if($scope.savedCards.length > 0) {
                        $scope.currentSavedCard = $scope.savedCards[0];
                        $scope.savedCardsVisible = true; 
                    }
                    else {
                        $scope.savedCardsVisible = false;
                        $scope.currentSavedCard = null;
                        $scope.useSavedCard = false;
                        clearSaveCardData();
                    }
                });
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.sendSmsCode = function () {
        if (!$scope.canRequestVerificationCode)
            return;
        $scope.smsCodeSubmitted = true;
        $scope.sendSmsCodeError = null;
        $scope.canShowTimer = false;
        if(isFormNotValid()) {
            $timeout(function ( ){
                utilli.scrollToFirstError();
            },0);
            return;
        }
        $scope.smsCodeSubmitted = false;
        $scope.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: localStorage.getItem('ApiUrl') + '/api/Payment/SendPaymentConfirmationSms',
            data: {
                PhoneNumber: $state.params.id,
                CardNumber: 1,
                PaymentAmount: 11, 
                Token: $state.params.token
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.RemainedTime) {
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                $scope.sendSmsCodeError =  response.Errors[0];
                $scope.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                ModalServiceExt.showInfo($scope._t("SMS code successfully sent."));
                $scope.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            $scope.sendSmsCodeError = utilli.errors.serverErrorMessage;
            $scope.canRequestVerificationCode = true;
        });
    }

    $scope.isCreditCardTypeNotValid = function () {
        var result = $scope.payCardAccount_form.cardNumber.$ccType == 'JCB'
            || ($scope.isWglcx && $scope.payCardAccount_form.cardNumber.$ccType == 'American Express')
            || $scope.payCardAccount_form.cardNumber.$ccType == 'Diners Club';
        return result;
    }

    function isFormNotValid () { 
        if($scope.useSavedCard) {
            var result = !$scope.payCardAccount_form.email.$valid
                || !$scope.payCardAccount_form.phone.$valid
                || !$scope.payCardAccount_form.amountDue.$valid
                || $scope.isCreditCardTypeNotValid()
                || $scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled
                || $scope.smsCodeSent && !$scope.smsCodeSubmitted && !$scope.payCardAccount_form.confirmationCode.$valid;
            return result;
        }
        var result = !$scope.payCardAccount_form.$valid
            || $scope.isCreditCardTypeNotValid()
            || $scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled
            || utilli.isAdmin && $scope.proceededWithoutSearch && $scope.selectedCompany.companyCode == "0";
        return result;
    }

    $scope.payNowCard = function () {
        $scope.cardFormSubmitted = true;

        if (isFormNotValid())
            return;

        if(!checkPaymentAmountWglcx())
            return;

        $scope.cardFormSubmitted = false;

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                PaymentVerificationService.verifyPaymentInfoNew(commonData, $scope.amountDue, 
                    function(){
                        if ($scope.useSavedCard)
                            payBySavedCard();
                        else
                            payByCreditCardInternal();
                    });
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.payNowBankAccount = function () {
        if (!$scope.payBankAccount_form.$valid
            || $scope.bankCheckingAccountNumber != $scope.bankCheckingAccountNumber2
            || $scope.isPaymentInfoAgreeBank == false && $scope.isFeeEnabled
            || $scope.payBankAccount_form.bankRoutingNumber == $scope.payBankAccount_form.bankCheckingAccountNumber) {
            return;
        }

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                //Please, please, please no max amount validation for eChecks.

                validateRoutingNumberAndPayByCheck();
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    function validateRoutingNumberAndPayByCheck () {
        usSpinnerService.spin('spinner-1');
        validateRoutingNumber().then(function (isRoutingNumberValid) {
            $scope.routNumError = !isRoutingNumberValid;
            if ($scope.routNumError){
                ModalServiceExt.showMessage($scope._t('Error'), 
                    $scope._t('Invalid Routing Number.'));
                usSpinnerService.stop('spinner-1');
                return;
            }
            bankAccountPay();
        });
    }

    $scope.paymentOk = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.printConfirmation = function () {
        window.print();
    }

    $scope.viewUnderstandYourBill = function () {
        var viewurl = apiUrl + 'api/Bills/GetUnderstandMyBill';
        window.open(viewurl, '_blank');
    }

    $scope.proceedToRegistration = function () {
        $state.go('TopMenuLayout.SignUp.Step1', { 
            accountnumber: $scope.currentAccount.AccountNumber, 
            customerfullname: $scope.currentAccount.CustomerFullName, 
            zip: $scope.currentAccount.Zip.substring(0, 5) 
        });
    }

    function clearPaymentSettings() {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';

        $scope.billToAddress = '';
        $scope.billToCity = '';
        $scope.billToState = '';
        $scope.billToZip = '';
        $scope.cardCode = '';

        $scope.checkNameOnAccount = '';
        $scope.bankRoutingNumber = '';
        $scope.bankCheckingAccountNumber = '';
        $scope.bankCheckingAccountNumber2 = '';
        $scope.driversLicenseNumber = '';
        $scope.checkPaymentState = '';
        
        $scope.phone = $state.params.phoneNumber;
        $scope.email = $state.params.email ? $state.params.email : '';
    }

    function getConvFeeInfo (account) {
        if (!$scope.isFeeEnabled){
            usSpinnerService.stop('spinner-1');
            return;
        }
        var searchObject = {
            accountNumber: account.AccountNumber,
        };
        $http({
            url: apiUrl + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: searchObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.convFeeInfo = jsondata;
                updateConvinienceFee();
                if ($scope.convFeeInfo.Disconnected == $scope._t('Account Disconnected')) {
                    ModalServiceExt.showMessage($scope._t('Account is disconnected'), 
                    $scope._t('Your account is currently disconnected. After making the payment please contact Customer Service at')
                    + ' ' 
                    + $scope.convFeeInfo.SupportPhoneNumber);
                }
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (data) {
            ModalServiceExt.showMessage($scope._t('Error'), $scope._t('Server error. Please, try again later.'));
            $scope.stepName = 'find';
            usSpinnerService.stop('spinner-1');
        });
    }

    function updateConvinienceFee() {
        if ($scope.amountDue == null || isNaN($scope.amountDue) || $scope.amountDue == '') {
            $scope.convinienceFee = '';
            return;
        }

        var info = $scope.convFeeInfo;

        if ($scope.isFeeEnabled) {
        if ($scope.stepName == 'payByCard') {
            if (info.FeeType == "percent") {
                $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmount);
            } else if (info.FeeType == "flat") {
                $scope.convinienceFee = formatDecimal(info.FeeAmount);
            }
            } else if ($scope.stepName == 'payByBankAccount') {
                if (info.FeeTypeAch == "percent") {
                    $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmountAch);
                } else if (info.FeeTypeAch == "flat") {
                    $scope.convinienceFee = formatDecimal(info.FeeAmountAch);
                }
            }
        }
        else {
            $scope.convinienceFee = 0;
        }

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));

    }

    function formatDecimal (decimal) {

        var formated = Math.round(parseFloat(decimal) * 100) / 100;

        formated = formated.toString();
        if (formated.indexOf('.') == -1) formated += '.';
        while (formated.length < formated.indexOf('.') + 3) formated += '0';

        return formated;
    }

    function validateRoutingNumber() {
        var deferred = $q.defer();
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/RoutingNumberValidate',
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                alert(response.Errors[0]);
                deferred.reject(requestResult);
            }
            else {
                requestResult = response.Data;
                deferred.resolve(response.Data);
            }
            $scope.stepName = 'payByBankAccount';
        }).error(function () {
            alert("Server error. Try again later.");
            deferred.resolve(requestResult);
            $scope.stepName = 'payByBankAccount';
        });
        return deferred.promise;
    }

    function updateBankIcon() {
        $scope.showBankLogo = false;
        if($scope.bankRoutingNumber == undefined || $scope.bankRoutingNumber.length != 9)
        {
            return;
        }
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/GetBankLogo',
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                $scope.showBankLogo = false;
            }
            else {
                requestResult = response.Data;
                if(response.Data.Logo != ''){
                    $('#bank-logo-icon').css('background-image', response.Data.Logo);
                    $scope.showBankLogo = true;
                    $scope.plaidBankName = response.Data.Name;
                    $scope.plaidBankUrl = response.Data.Url;
                } else {
                    $scope.showBankLogo = false;
                }
            }
        }).error(function () {
            console.log("UpdateBankIcon error. GetBankLogo.");
        });
    }

    $scope.updateBankIconLogo = function() {
        updateBankIcon();
    }

    function bankAccountPay() {
        $scope.bankAccountFormSubmitted = false;

        var companyCode = $scope.currentAccount.CompanyCode;
        if ($scope.proceededWithoutSearch) {
            companyCode = $scope.selectedCompany.companyCode;
        }

        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            nameOnAccount: $scope.checkNameOnAccount,
            bankRoutingNumber: $scope.bankRoutingNumber,
            checkingAccountNumber: $scope.bankCheckingAccountNumber,
            companyCode: companyCode,

            bcaId: $scope.bcaId,
            OrderNumber: $scope.orderNumber
        };

        if (utilli.isAdmin) {
            paymentObject.PaymentPage = 3;
        }
        else {
            paymentObject.PaymentPage = 1;
        }

        $http({
            url: apiUrl + 'api/Payment/DocuSignQuickPayByBankAccount',
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            }
        }).error(function (data) {
            $scope.paymentResult = data.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    }
    
    function payByCreditCardInternal() {
        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            cardNumber: $scope.cardNumber,
            nameOnCard: $scope.nameOnCard,
            expirationDateYear: $scope.cardExpiryYear,
            expirationDateMonth: $scope.cardExpiryMonth,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            billToAddress: $scope.billToAddress,
            billToCity: $scope.billToCity,
            billToState: $scope.billToState,
            billToZip: $scope.billToZip,
            cardCode: $scope.cardCode,
            invoiceNumber: '0',
            PaymentPage: utilli.isAdmin ? 3 : 1,
            NeedToSave: $scope.saveThisCard,
            EBillToken: $state.params.token,
            bcaId: $scope.bcaId,
            OrderNumber: $scope.orderNumber
        };

        $http({
            url: apiUrl + 'api/Payment/DocusignPayUsingCard',
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            }
        }).error(function (data) {
            var jsondata = data;
            $scope.paymentResult = jsondata.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    };

    function payBySavedCard() {
        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            cardId: $scope.currentSavedCard.card.Id,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            billToAddress: $scope.billToAddress,
            billToCity: $scope.billToCity,
            billToState: $scope.billToState,
            billToZip: $scope.billToZip,
            cardCode: $scope.cardCode,
            invoiceNumber: '0',
            PaymentPage: utilli.isAdmin ? 3 : 1,
            EBillToken: $state.params.token,
            ConfirmationCode: $scope.confirmationCode
        };

        $http({
            url: apiUrl + 'api/Payment/DocusignPayUsingCard',
            method: "POST",
            data: paymentObject
        }).success(function (jsondata) {
            usSpinnerService.stop('spinner-1');
            if(jsondata.IsSmsCodeNotValid) {
                $scope.sendSmsCodeError = jsondata.Message;
                $scope.canRequestVerificationCode = true;
                return;
            }
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
            }
        }).error(function (data) {
            var jsondata = data;
            $scope.paymentResult = jsondata.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    };
}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('DocuSignStartController', ['$scope', '$state', '$http', 'usSpinnerService', 
    'CommonDataService', 'ServiceProvidersService', 'ModalServiceExt', '$window',
    function ($scope, $state, $http, usSpinnerService, CommonDataService, 
        ServiceProvidersService, ModalServiceExt, $window) {
            
    
            var apiUrl = '';

    function initPage() {
        $scope.imagesPath = utilli.isAdmin
            ? "../Images"
            : "Images";

        $scope.isWglcx = utilli.isWglcx();
        $scope.isAdmin = utilli.isAdmin;
        $scope.accountNumber = '';

        $scope.showInfo = false;
        $scope.info = '';

        $scope.onlyNumbers = /^\d+$/;
        $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
        $scope.emailPattern = utilli.emailPattern;

        $scope.stepName = 'find';
        $("#cardCodeCvv").mask("999?9", { placeholder: "" });
        $scope.quickPayValidationType = 'InvoiceNumber'; // Can be: InvoiceNumber, BusinessPartnerNumber
        $scope.quickPayValidationCaption = $scope._t('Invoice Number');

        $scope.isFeeEnabled = false;
        
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {

                apiUrl = providerData.ApiUrl;
                
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                    $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                    $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                    $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                    $scope.paymentInfoText = commonData.FeeInformation;
                    $scope.commomData = commonData;

                    $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                    $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                    $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                    $scope.quickPayValidationType = commonData.QuickPayValidationType;
                    $scope.isFeeEnabled = commonData.IsFeeEnabled;

                    if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                        $scope.quickPayValidationCaption = _t('Customer Number');
                    }
                },
                function () {
                    ModalServiceExt.showServerError();
                });
            },
            function() {
                // codereview@Yuriy: implement error handling
                //$moduleServices.setError(utilli.errors.serverErrorMessage);
            }
        );

        if ($state.params.contractAccountNumber) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                    apiUrl = providerData.ApiUrl;
                    var searchRequest = {// codereview@Yuriy: variable seems to be not used
                        accountNumber: $state.params.contractAccountNumber,
                        isAdmin: $scope.isAdmin,
                        billAccessToken: $state.params.token
                    };

                    localStorage.setItem("last_order_number", $state.params.orderNumber);

                    var docusignObject = {
                        contractAccountNumber: $state.params.contractAccountNumber,
                        billAmount: $state.params.billAmount,
                        email: $state.params.email,
                        phoneNumber: $state.params.phoneNumber,
                        bcaId: $state.params.bcaId,
                        bcaManagerEmail: $state.params.bcaManagerEmail,
                        orderNumber: $state.params.orderNumber,
                        pageType: 'DocuSign'
                    };
                    // codereview@Yuriy: the next line results in that there 2 ajax requests to get common data
                    CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        var url = apiUrl + 'api/DocuSign/DocuSignStart';
                        $http({
                            url: url,
                            method: "POST",
                            data: docusignObject
                        }).success(function (data) {
                            // codereview@Yuriy: don't leave commented code
                            //$window.location.href = data.Data;
                            
                            if(data.HasErrors) {
                                usSpinnerService.stop('spinner-1');
                                // ModalServiceExt.showInfo(data.Errors[0]);
                                $scope.showInfo = true;
                                $scope.info = data.Errors[0];
                            } else {
                                $window.location.href = data.Data.RedirectUrl;
                            }

                        }).error(function (e) {
                            usSpinnerService.stop('spinner-1');
                            var message = e.data.ExceptionMessage ? e.data.ExceptionMessage : e.data.Message;
                            if (message)
                                ModalServiceExt.showError("Error: " + message);
                            else 
                                ModalServiceExt.showServerError();
                        });
                    });
            });
        }
    }
    // codereview@Yuriy: no need for initPage function
    initPage();

}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('AdobeSignController', ['$scope', '$timeout', '$state', '$http', 'usSpinnerService', 'LeftMenuService',
    'CommonDataService', '$q', 'ServiceProvidersService', 'ModalServiceExt', 'PaymentVerificationService', '$window',
    function ($scope, $timeout, $state, $http, usSpinnerService, LeftMenuService, CommonDataService, $q, 
        ServiceProvidersService, ModalServiceExt, PaymentVerificationService, $window) {

    LeftMenuService.setCurrentTab('AdobeSign');
    $scope.phoneNumberMask = Config.phoneNumberMask;
    var apiUrl = '';
    $scope.savedCards = [];

    $scope.isDocumentSigned = true;

    $scope.docusingAmountToPay = 1 * $state.params.billAmount;

    $scope.bcaId = $state.params.bcaId;
    $scope.bcaManagerEmail = $state.params.bcaManagerEmail;

    $scope.email = $state.params.email ? $state.params.email : '';

    $scope.showDocuSignError = false;
    $scope.docuSignErrorText = '';

    $scope.orderNumber = $state.params.orderNumber ? $state.params.orderNumber : localStorage.getItem("last_order_number");


    $scope.docuSignExplainOnlyCheckPaymentAvailable = false;

    $scope.showBankLogo = false;

    function setCurrentSavedCardAttributes() {
        $scope.nameOnCard = $scope.currentSavedCard.card.HolderName;
        $scope.cardExpiryMonth = $scope.currentSavedCard.card.ExpMonth;
        $scope.cardExpiryYear = "20" + $scope.currentSavedCard.card.ExpYear;
    }

    $scope.savedCardChanged = function () {
        setCurrentSavedCardAttributes();
    }

    $scope.useSavedCardChanged = function () {
        if ($scope.useSavedCard) {
            $scope.currentSavedCard = $scope.savedCards[0];
            for (var i = 0; i < $scope.savedCards.length; i++) {
                var cardInfo = $scope.savedCards[i];
                if (cardInfo.card.IsPrimary) {
                    $scope.currentSavedCard = cardInfo;
                    break;
                }
            }

            setCurrentSavedCardAttributes();
        } else {
            clearSaveCardData();
        }
    };

    function clearSaveCardData () {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';
    }

    function initPage() {
        $scope.imagesPath = utilli.isAdmin
            ? "../Images"
            : "Images";

        $scope.isWglcx = utilli.isWglcx();
        $scope.isAdmin = utilli.isAdmin;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.zip = '';

        $scope.address = {};

        $scope.onlyNumbers = /^\d+$/;
        $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
        $scope.emailPattern = utilli.emailPattern;

        $scope.stepName = 'selectPaymentOption';
        $("#cardCodeCvv").mask("999?9", { placeholder: "" });

        $scope.isFeeEnabled = false;
        
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {

                apiUrl = providerData.ApiUrl;
                
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                    $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                    $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                    $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                    $scope.paymentInfoText = commonData.FeeInformation;
                    $scope.commomData = commonData;

                    if ($scope.docusingAmountToPay > commonData.MaxPaymentAmount) {
                        $scope.stepName = 'payByBankAccount';
                        $scope.isBackButtonDisabled = true;
                        $scope.docuSignExplainOnlyCheckPaymentAvailable = true;
                    }

                    $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                    $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                    $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                    $scope.quickPayValidationType = commonData.QuickPayValidationType;
                    $scope.isFeeEnabled = commonData.IsFeeEnabled;

                    if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                        $scope.quickPayValidationCaption = _t('Customer Number');
                    }
                },
                function () {
                    ModalServiceExt.showServerError();
                });

                // if user paid and refreshes the page - he must not be able to pay again WGLCX-338
                usSpinnerService.spin('spinner-1');
                $http({
                    method: 'POST',
                    url: apiUrl + 'api/DocuSign/IsOrderAlreadyPaid',
                    params: { orderNumber: $scope.orderNumber }
                })
                .success(function(response) {
                    usSpinnerService.stop('spinner-1');
                    
                    if(response.Data != 'Payment required')
                    {
                        $scope.docusingAmountToPay = 0 // No payments for this. Don't show controls. 
                        return;
                    }
                })
                .error(function(error) {
                    console.log(error);
                    usSpinnerService.stop('spinner-1');
                    return;// codereview@Yuriy: why do you use these returns if they do nothing?
                });


                // if user signed but no need to pay
                if($scope.isDocumentSigned && $scope.docusingAmountToPay == 0) {

                    usSpinnerService.spin('spinner-1');
                    $http({
                        method: 'POST',
                        url: apiUrl + '/api/DocuSign/AdobesignUploadSignedPdf',
                        params: {
                            orderNumber: $scope.orderNumber,
                        }
                    })
                    .success(function(response) {
                        usSpinnerService.stop('spinner-1');

                        return;
                    })
                    .error(function(error) {
                        console.log(error);
                        usSpinnerService.stop('spinner-1');
                        return;
                    });
                }
            },
            function() {
                // todo: implement error handling
                //$moduleServices.setError(utilli.errors.serverErrorMessage);
            }
        );

        if ($state.params.contractAccountNumber) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                    apiUrl = providerData.ApiUrl;
                    var searchRequest = {
                        accountNumber: $state.params.contractAccountNumber,
                        isAdmin: $scope.isAdmin,
                        billAccessToken: $state.params.token,
                        isNonCommodity: true
                    };
                    CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        usSpinnerService.spin('spinner-1');
                        var url = apiUrl + 'api/Payment/FindAccounts';
                        $http({
                            url: url,
                            method: "GET",
                            params: searchRequest
                        }).success(function (data) {
                            if (!data.length){
                                usSpinnerService.stop('spinner-1');
                                $scope.errorFromServerReturned = true;
                                $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                                return;
                            }
                            $scope.selectAccount(data[0]);
                        }).error(function () {
                            usSpinnerService.stop('spinner-1');
                            $scope.errorFromServerReturned = true;
                            $scope.serverErrorInformation = $scope._t('Server error. Try again later.');
                        });
                    });
            });
        }
    }

    initPage();

    $scope.back = function () {
        $state.goRelativeTo('QuickPay', 'Step1');
    };

    $scope.cancel = function () {
        $state.goToWelcome();
    };

    $scope.clear = function () {
        $scope.findResultVisible = false;
        $scope.accountNumber = '';
        $scope.houseNumber = '';
        $scope.streetName = '';
        $scope.appartment = '';
        $scope.state = '';
        $scope.zip = '';
        $scope.informationMessage = '';
        $scope.isInformationMessageShown = false;
        $scope.errorFromServerReturned = false;
        $scope.isPaymentInfoAgreeBank = false;
        $scope.isPaymentInfoAgreeCard = false;
        $scope.showBankLogo = false;
    };

    $scope.selectAccount = function (account) {
        clearPaymentSettings();
        $scope.isAuthForEBill = account.AuthorizedForEBill;
        $scope.currentAccount = account;
        if ($scope.stepName != 'payByBankAccount')
            $scope.stepName = 'selectPaymentOption';

        // account.PhoneNumber may be empty if wglcx user is not authorized to view bills.
        // phone number is used for bills authorization and we don't disclose the phone number
        // to those users who have not passed authorization yet.
        $scope.phone = account.PhoneNumber ? account.PhoneNumber : $scope.phone;

        // Do not fill email here. email filled with billToEmail from params for docusign
        //$scope.email = account.Email ? account.Email : $scope.email;

        initAddress(account);

        usSpinnerService.spin('spinner-1'); // stop - inside of function getConvFeeInfo
        getConvFeeInfo(account);

        $scope.amountDue = $state.params.billAmount;
        updateConvinienceFee();

        if ($scope.amountDue < 0) {
            $scope.amountDue = 0;
            $scope.totalAmount = "";
        } else {
            $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
        }

        $scope.formatTotalAmount();
    }
    
    function initAddress (account) { 
        $scope.address.HouseNumber = account.MailHouseNumber,
        $scope.address.Street = account.MailStreet,
        $scope.address.City = account.MailCity,
        $scope.address.HouseNoSupplement = account.MailHouseNoSupplement,
        $scope.address.State = account.MailRegion,
        $scope.address.Zip = account.MailCityPostalCode
    }

    $scope.onAmountChange = function () {
        if ($scope.amountDue == '-') {
            return;
        }
        if ($scope.amountDue == '' || $scope.amountDue == undefined) {
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        if ($scope.amountDue.slice(-1) == '.') {
            return;
        }

        if (isNaN($scope.amountDue) || isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            updateConvinienceFee();
            return;
        }

        updateConvinienceFee();

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));
    }

    $scope.cancelPaymentOptionSelection = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.selectPayByCard = function () {
        $scope.stepName = 'payByCard';
        updateConvinienceFee();
    }

    $scope.selectPayByBankAccount = function () {
        $scope.stepName = 'payByBankAccount';
        updateConvinienceFee();
    }

    $scope.formatTotalAmount = function () {
        if ($scope.amountDue == undefined) {
            $scope.totalAmount = '';
            return;
        }

        if (isNaN(parseFloat($scope.amountDue))) {
            $scope.amountDue = '';
            $scope.totalAmount = '';
            return;
        }
        $scope.amountDue = formatDecimal(parseFloat($scope.amountDue));
    }

    $scope.cancelPayment = function () {
        $scope.bankAccountFormSubmitted = false;
        $scope.cardFormSubmitted = false;
        $scope.clear();
        clearPaymentSettings();
        $scope.stepName = 'selectPaymentOption';
    }

    $scope.payNow = function () {
        $scope.stepName = 'processingPayment';
        usSpinnerService.spin('spinner-1');
        $scope.$apply();
        $timeout(function () {
            usSpinnerService.stop('spinner-1');
            $scope.stepName = 'paymentResult';
        }, 3000);
    }

    function checkPaymentAmountWglcx() {
        //not on docusign, please
        return true;
    }
    
    var tickTimer = function () {
        if ($scope.timeout != 0) {
            $scope.timeout--;
            $timeout(tickTimer, 1000);
        } else {
            $scope.canRequestVerificationCode = true;
            $scope.canShowTimer = false;
            return;
        }

        $scope.canShowTimer = true;
        $scope.timeoutStr = '' + $scope.timeout;
        if ($scope.timeoutStr.length < 2) {
            $scope.timeoutStr = '0' + $scope.timeoutStr;
        }
    }

    function startSmsConfirmationTimer(remainedTime) {
        if(remainedTime)
            $scope.timeout = remainedTime;
        else
            $scope.timeout = 31;

        tickTimer();
    }

    $scope.canRequestVerificationCode = true;

    $scope.removeCard = function () { 
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: localStorage.getItem('ApiUrl') + '/api/Payment/RemoveQuickPaySavedCard',
            data: {
                CardId: $scope.currentSavedCard.card.Id,
                Token: $state.params.token
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');
            utilli.handleAjaxResponse(response,
                ModalServiceExt,
                function () {
                    ModalServiceExt.showInfo($scope._t("Card successfully removed."));
                    $scope.savedCards = _.reject($scope.savedCards, function(cardInfo) { 
                        return cardInfo.card.Id == $scope.currentSavedCard.card.Id 
                    });
                    $scope.savedCardsVisible = $scope.savedCards.length > 0;
                    if($scope.savedCards.length > 0) {
                        $scope.currentSavedCard = $scope.savedCards[0];
                        $scope.savedCardsVisible = true; 
                    }
                    else {
                        $scope.savedCardsVisible = false;
                        $scope.currentSavedCard = null;
                        $scope.useSavedCard = false;
                        clearSaveCardData();
                    }
                });
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.sendSmsCode = function () {
        if (!$scope.canRequestVerificationCode)
            return;
        $scope.smsCodeSubmitted = true;
        $scope.sendSmsCodeError = null;
        $scope.canShowTimer = false;
        if(isFormNotValid()) {
            $timeout(function ( ){
                utilli.scrollToFirstError();
            },0);
            return;
        }
        $scope.smsCodeSubmitted = false;
        $scope.canRequestVerificationCode = false;
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: localStorage.getItem('ApiUrl') + '/api/Payment/SendPaymentConfirmationSms',
            data: {
                PhoneNumber: $state.params.id,
                CardNumber: 1,
                PaymentAmount: 11, 
                Token: $state.params.token
            }
        })
        .success(function(response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.sendSmsCodeError = utilli.errors.serverErrorMessage;
                return;
            }
            if (response.HasErrors) {
                if(response.Data && response.Data.RemainedTime) {
                    startSmsConfirmationTimer(response.Data.RemainedTime);
                    return;
                }
                $scope.sendSmsCodeError =  response.Errors[0];
                $scope.canRequestVerificationCode = true;
            }
            else {
                startSmsConfirmationTimer();

                ModalServiceExt.showInfo($scope._t("SMS code successfully sent."));
                $scope.smsCodeSent = true;
            }
        })
        .error(function(error) {
            console.log(error);
            usSpinnerService.stop('spinner-1');
            $scope.sendSmsCodeError = utilli.errors.serverErrorMessage;
            $scope.canRequestVerificationCode = true;
        });
    }

    $scope.isCreditCardTypeNotValid = function () {
        var result = $scope.payCardAccount_form.cardNumber.$ccType == 'JCB'
            || ($scope.isWglcx && $scope.payCardAccount_form.cardNumber.$ccType == 'American Express')
            || $scope.payCardAccount_form.cardNumber.$ccType == 'Diners Club';
        return result;
    }

    function isFormNotValid () { 
        if($scope.useSavedCard) {
            var result = !$scope.payCardAccount_form.email.$valid
                || !$scope.payCardAccount_form.phone.$valid
                || !$scope.payCardAccount_form.amountDue.$valid
                || $scope.isCreditCardTypeNotValid()
                || $scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled
                || $scope.smsCodeSent && !$scope.smsCodeSubmitted && !$scope.payCardAccount_form.confirmationCode.$valid;
            return result;
        }
        var result = !$scope.payCardAccount_form.$valid
            || $scope.isCreditCardTypeNotValid()
            || $scope.isPaymentInfoAgreeCard == false && $scope.isFeeEnabled
            || utilli.isAdmin && $scope.proceededWithoutSearch && $scope.selectedCompany.companyCode == "0";
        return result;
    }

    $scope.payNowCard = function () {
        $scope.cardFormSubmitted = true;

        if (isFormNotValid())
            return;

        if(!checkPaymentAmountWglcx())
            return;

        $scope.cardFormSubmitted = false;

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                PaymentVerificationService.verifyPaymentInfoNew(commonData, $scope.amountDue, 
                    function(){
                        if ($scope.useSavedCard)
                            payBySavedCard();
                        else
                            payByCreditCardInternal();
                    });
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.payNowBankAccount = function () {
        if (!$scope.payBankAccount_form.$valid
            || $scope.bankCheckingAccountNumber != $scope.bankCheckingAccountNumber2
            || $scope.isPaymentInfoAgreeBank == false && $scope.isFeeEnabled
            || $scope.payBankAccount_form.bankRoutingNumber == $scope.payBankAccount_form.bankCheckingAccountNumber) {
            return;
        }

        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData()
            .then(function (commonData) {
                //Please, please, please no max amount validation for eChecks.

                validateRoutingNumberAndPayByCheck();
            },function (e) { 
                console.error(e);
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
    }

    function validateRoutingNumberAndPayByCheck () {
        usSpinnerService.spin('spinner-1');
        validateRoutingNumber().then(function (isRoutingNumberValid) {
            $scope.routNumError = !isRoutingNumberValid;
            if ($scope.routNumError){
                ModalServiceExt.showMessage($scope._t('Error'), 
                    $scope._t('Invalid Routing Number.'));
                usSpinnerService.stop('spinner-1');
                return;
            }
            bankAccountPay();
        });
    }

    $scope.paymentOk = function () {
        $scope.clear();
        $scope.stepName = 'find';
    }

    $scope.printConfirmation = function () {
        window.print();
    }

    $scope.viewUnderstandYourBill = function () {
        var viewurl = apiUrl + 'api/Bills/GetUnderstandMyBill';
        window.open(viewurl, '_blank');
    }

    $scope.viewSignedDocument = function () {
        var viewurl = apiUrl + 'api/DocuSign/ViewSignedDocument?orderNumber=' + $scope.orderNumber;
        window.open(viewurl, '_blank');
    }

    $scope.proceedToRegistration = function () {
        $state.go('TopMenuLayout.SignUp.Step1', { 
            accountnumber: $scope.currentAccount.AccountNumber, 
            customerfullname: $scope.currentAccount.CustomerFullName, 
            zip: $scope.currentAccount.Zip.substring(0, 5) 
        });
    }

    function clearPaymentSettings() {
        $scope.cardNumber = '';
        $scope.nameOnCard = '';
        $scope.cardExpiryMonth = '';
        $scope.cardExpiryYear = '';

        $scope.billToAddress = '';
        $scope.billToCity = '';
        $scope.billToState = '';
        $scope.billToZip = '';
        $scope.cardCode = '';

        $scope.checkNameOnAccount = '';
        $scope.bankRoutingNumber = '';
        $scope.bankCheckingAccountNumber = '';
        $scope.bankCheckingAccountNumber2 = '';
        $scope.driversLicenseNumber = '';
        $scope.checkPaymentState = '';
        
        $scope.phone = $state.params.phoneNumber;
        $scope.email = $state.params.email ? $state.params.email : '';
    }

    function getConvFeeInfo (account) {
        if (!$scope.isFeeEnabled){
            usSpinnerService.stop('spinner-1');
            return;
        }
        var searchObject = {
            accountNumber: account.AccountNumber,
        };
        $http({
            url: apiUrl + 'api/Payment/GetConvFeeInfo/',
            method: "GET",
            params: searchObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.convFeeInfo = jsondata;
                updateConvinienceFee();
                if ($scope.convFeeInfo.Disconnected == $scope._t('Account Disconnected')) {
                    ModalServiceExt.showMessage($scope._t('Account is disconnected'), 
                    $scope._t('Your account is currently disconnected. After making the payment please contact Customer Service at')
                    + ' ' 
                    + $scope.convFeeInfo.SupportPhoneNumber);
                }
            }
            usSpinnerService.stop('spinner-1');
        }).error(function (data) {
            ModalServiceExt.showMessage($scope._t('Error'), $scope._t('Server error. Please, try again later.'));
            $scope.stepName = 'find';
            usSpinnerService.stop('spinner-1');
        });
    }

    function updateConvinienceFee() {
        if ($scope.amountDue == null || isNaN($scope.amountDue) || $scope.amountDue == '') {
            $scope.convinienceFee = '';
            return;
        }

        var info = $scope.convFeeInfo;

        if ($scope.isFeeEnabled) {
        if ($scope.stepName == 'payByCard') {
            if (info.FeeType == "percent") {
                $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmount);
            } else if (info.FeeType == "flat") {
                $scope.convinienceFee = formatDecimal(info.FeeAmount);
            }
            } else if ($scope.stepName == 'payByBankAccount') {
                if (info.FeeTypeAch == "percent") {
                    $scope.convinienceFee = formatDecimal($scope.amountDue / 100 * info.FeeAmountAch);
                } else if (info.FeeTypeAch == "flat") {
                    $scope.convinienceFee = formatDecimal(info.FeeAmountAch);
                }
            }
        }
        else {
            $scope.convinienceFee = 0;
        }

        $scope.totalAmount = formatDecimal(parseFloat($scope.amountDue) + parseFloat($scope.convinienceFee));

    }

    function formatDecimal (decimal) {

        var formated = Math.round(parseFloat(decimal) * 100) / 100;

        formated = formated.toString();
        if (formated.indexOf('.') == -1) formated += '.';
        while (formated.length < formated.indexOf('.') + 3) formated += '0';

        return formated;
    }

    function validateRoutingNumber() {
        var deferred = $q.defer();
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/RoutingNumberValidate',
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                alert(response.Errors[0]);
                deferred.reject(requestResult);
            }
            else {
                requestResult = response.Data;
                deferred.resolve(response.Data);
            }
            $scope.stepName = 'payByBankAccount';
        }).error(function () {
            alert("Server error. Try again later.");
            deferred.resolve(requestResult);
            $scope.stepName = 'payByBankAccount';
        });
        return deferred.promise;
    }

    function updateBankIcon() {
        $scope.showBankLogo = false;
        if($scope.bankRoutingNumber == undefined || $scope.bankRoutingNumber.length != 9)
        {
            return;
        }
        var requestResult = false;
        $http({
            url: apiUrl + 'api/Payment/GetBankLogo',
            method: "GET",
            params: { routingNumber: $scope.bankRoutingNumber }
        }).success(function (response) {
            if (response.Errors && response.Errors.length > 0) {
                $scope.showBankLogo = false;
            }
            else {
                requestResult = response.Data;
                if(response.Data.Logo != ''){
                    $('#bank-logo-icon').css('background-image', response.Data.Logo);
                    $scope.showBankLogo = true;
                    $scope.plaidBankName = response.Data.Name;
                    $scope.plaidBankUrl = response.Data.Url;
                } else {
                    $scope.showBankLogo = false;
                }
            }
        }).error(function () {
            console.log("UpdateBankIcon error. GetBankLogo.");
        });
    }

    $scope.updateBankIconLogo = function() {
        updateBankIcon();
    }

    function bankAccountPay() {
        $scope.bankAccountFormSubmitted = false;

        var companyCode = $scope.currentAccount.CompanyCode;
        if ($scope.proceededWithoutSearch) {
            companyCode = $scope.selectedCompany.companyCode;
        }

        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            nameOnAccount: $scope.checkNameOnAccount,
            bankRoutingNumber: $scope.bankRoutingNumber,
            checkingAccountNumber: $scope.bankCheckingAccountNumber,
            companyCode: companyCode,

            bcaId: $scope.bcaId,
            OrderNumber: $scope.orderNumber
        };

        if (utilli.isAdmin) {
            paymentObject.PaymentPage = 3;
        }
        else {
            paymentObject.PaymentPage = 1;
        }

        $http({
            url: apiUrl + 'api/Payment/AdobeSignQuickPayByBankAccount',
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            }
        }).error(function (data) {
            $scope.paymentResult = data.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    }
    
    function payByCreditCardInternal() {
        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            cardNumber: $scope.cardNumber,
            nameOnCard: $scope.nameOnCard,
            expirationDateYear: $scope.cardExpiryYear,
            expirationDateMonth: $scope.cardExpiryMonth,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            billToAddress: $scope.billToAddress,
            billToCity: $scope.billToCity,
            billToState: $scope.billToState,
            billToZip: $scope.billToZip,
            cardCode: $scope.cardCode,
            invoiceNumber: '0',
            PaymentPage: utilli.isAdmin ? 3 : 1,
            NeedToSave: $scope.saveThisCard,
            EBillToken: $state.params.token,
            bcaId: $scope.bcaId,
            OrderNumber: $scope.orderNumber
        };

        $http({
            url: apiUrl + 'api/Payment/AdobesignPayUsingCard',
            method: "POST",
            data: paymentObject
        }).success(function (data) {
            var jsondata = data;
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
                usSpinnerService.stop('spinner-1');
            }
        }).error(function (data) {
            var jsondata = data;
            $scope.paymentResult = jsondata.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    };

    function payBySavedCard() {
        var paymentObject = {
            accountNumber: $scope.currentAccount.AccountNumber,
            userId: -1,
            amountToPay: $scope.amountDue,
            phone: $scope.phone,
            email: $scope.email,
            cardId: $scope.currentSavedCard.card.Id,
            companyCode: $scope.proceededWithoutSearch 
                ? $scope.selectedCompany.companyCode
                : $scope.currentAccount.CompanyCode,
            billToAddress: $scope.billToAddress,
            billToCity: $scope.billToCity,
            billToState: $scope.billToState,
            billToZip: $scope.billToZip,
            cardCode: $scope.cardCode,
            invoiceNumber: '0',
            PaymentPage: utilli.isAdmin ? 3 : 1,
            EBillToken: $state.params.token,
            ConfirmationCode: $scope.confirmationCode
        };

        $http({
            url: apiUrl + 'api/Payment/DocusignPayUsingCard',
            method: "POST",
            data: paymentObject
        }).success(function (jsondata) {
            usSpinnerService.stop('spinner-1');
            if(jsondata.IsSmsCodeNotValid) {
                $scope.sendSmsCodeError = jsondata.Message;
                $scope.canRequestVerificationCode = true;
                return;
            }
            if (jsondata) {
                $scope.paymentResult = jsondata.Message;
                $scope.stepName = 'paymentResult';
                document.title = $scope._t('Utilli Transaction Record');
            }
        }).error(function (data) {
            var jsondata = data;
            $scope.paymentResult = jsondata.Message;
            $scope.stepName = 'paymentResult';
            usSpinnerService.stop('spinner-1');
        });
    };
}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('AdobeSignStartController', ['$scope', '$state', '$http', 'usSpinnerService', 
    'CommonDataService', 'ServiceProvidersService', 'ModalServiceExt', '$window',
    function ($scope, $state, $http, usSpinnerService, CommonDataService, 
        ServiceProvidersService, ModalServiceExt, $window) {
            
    
            var apiUrl = '';

    function initPage() {
        $scope.imagesPath = utilli.isAdmin
            ? "../Images"
            : "Images";

        $scope.isWglcx = utilli.isWglcx();
        $scope.isAdmin = utilli.isAdmin;
        $scope.accountNumber = '';

        $scope.showInfo = false;
        $scope.info = '';

        $scope.onlyNumbers = /^\d+$/;
        $scope.firstLastNamePattern = /^(\S)+( \S+)+$/;
        $scope.emailPattern = utilli.emailPattern;

        $scope.stepName = 'find';
        $("#cardCodeCvv").mask("999?9", { placeholder: "" });
        $scope.quickPayValidationType = 'InvoiceNumber'; // Can be: InvoiceNumber, BusinessPartnerNumber
        $scope.quickPayValidationCaption = $scope._t('Invoice Number');

        $scope.isFeeEnabled = false;
        
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {

                apiUrl = providerData.ApiUrl;
                
                CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                    $scope.largeConvenienceFeeBorder = commonData.LargeConvenienceFeeBorder;
                    $scope.smallConvenienceFee = commonData.SmallConvenienceFee;
                    $scope.largeConvenienceFee = commonData.LargeConvenienceFee;
                    $scope.paymentInfoText = commonData.FeeInformation;
                    $scope.commomData = commonData;

                    $scope.isBankAccountPaymentsEnabled = commonData.IsBankAccountPaymentsEnabled;
                    $scope.isCreditCardCvvEnabled = commonData.IsCreditCardCvvEnabled == 'True';
                    $scope.isCreditCardBillingAddressEnabled = commonData.IsCreditCardBillingAddressEnabled == 'True';
                    $scope.quickPayValidationType = commonData.QuickPayValidationType;
                    $scope.isFeeEnabled = commonData.IsFeeEnabled;

                    if ($scope.quickPayValidationType == 'BusinessPartnerNumber') {
                        $scope.quickPayValidationCaption = _t('Customer Number');
                    }
                },
                function () {
                    ModalServiceExt.showServerError();
                });
            },
            function() {
                // codereview@Yuriy: implement error handling
                //$moduleServices.setError(utilli.errors.serverErrorMessage);
            }
        );

        if ($state.params.contractAccountNumber) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                    apiUrl = providerData.ApiUrl;
                    var searchRequest = {// codereview@Yuriy: variable seems to be not used
                        accountNumber: $state.params.contractAccountNumber,
                        isAdmin: $scope.isAdmin,
                        billAccessToken: $state.params.token
                    };

                    localStorage.setItem("last_order_number", $state.params.orderNumber);

                    var docusignObject = {
                        contractAccountNumber: $state.params.contractAccountNumber,
                        billAmount: $state.params.billAmount,
                        email: $state.params.email,
                        phoneNumber: $state.params.phoneNumber,
                        bcaId: $state.params.bcaId,
                        bcaManagerEmail: $state.params.bcaManagerEmail,
                        orderNumber: $state.params.orderNumber,
                        pageType: 'AdobeSign'
                    };
                    // codereview@Yuriy: the next line results in that there 2 ajax requests to get common data
                    CommonDataService.getCommonData(apiUrl).then(function (commonData) {
                        var url = 'https://nudgeqa.washgas.com/api/v2/Test/RedirectUrlNonCom';
                        if (DeploymentSettings.deploymentEnvironment == "Prod")
                        {
                            url = 'https://nudge.washgas.com/api/v2/Test/RedirectUrlNonCom';
                        }
                        else
                        {
                            url = 'https://nudgeqa.washgas.com/api/v2/Test/RedirectUrlNonCom';
                        }                        
                        $http({
                            url: url,
                            method: "GET",
                            params: { 
                                recipientId: $state.params.contractAccountNumber,
                                billAmount: $state.params.billAmount,
                                email: $state.params.email,
                                orderNumber: $state.params.orderNumber,
                             }
                        }).success(function (response) {
                            usSpinnerService.stop('spinner-1');
                            console.log(response)
                            $window.location.href = response;
                        }).error(function (error) {
                            usSpinnerService.stop('spinner-1');
                            ModalServiceExt.showError(error.Message);
                        });
                        // var url = apiUrl + 'api/DocuSign/DocuSignStart'; // this is ok. DocuSign method for both AdobeSign and DocuSign
                        // $http({
                        //     url: url,
                        //     method: "POST",
                        //     data: docusignObject
                        // }).success(function (data) {
                        //     // codereview@Yuriy: don't leave commented code
                        //     //$window.location.href = data.Data;
                            
                        //     if(data.HasErrors) {
                        //         usSpinnerService.stop('spinner-1');
                        //         // ModalServiceExt.showInfo(data.Errors[0]);
                        //         $scope.showInfo = true;
                        //         $scope.info = data.Errors[0];
                        //     } else {
                        //         $window.location.href = data.Data.RedirectUrl;
                        //     }

                        // }).error(function (e) {
                        //     usSpinnerService.stop('spinner-1');
                        //     var message = e.data.ExceptionMessage ? e.data.ExceptionMessage : e.data.Message;
                        //     if (message)
                        //         ModalServiceExt.showError("Error: " + message);
                        //     else 
                        //         ModalServiceExt.showServerError();
                        // });
                    });
            });
        }
    }
    // codereview@Yuriy: no need for initPage function
    initPage();

}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('LinkShortenerController', ['$state', '$http', 'usSpinnerService', 'ServiceProvidersService', 
    'ModalServiceExt', '$window',
    function ($state, $http, usSpinnerService, ServiceProvidersService, ModalServiceExt, $window) {

        if (!$state.params.key){
            ModalServiceExt.showError('Redirection link is missing.');
            return;
        }

        usSpinnerService.spin('spinner-1');
        ServiceProvidersService.getCurrentProvider()
            .then(function (providerData) {
                $http({
                    url: providerData.ApiUrl + 'api/LinkShortener/GetLongLink',
                    method: "GET",
                    params: { key: $state.params.key }
                }).apiThen(function (longLink) {
                    $window.location.href = longLink;
                }, ModalServiceExt)
                .fixedFinally(function () {
                    usSpinnerService.stop('spinner-1');
                });
            });
}]);
'use strict';
var app = angular.module('utilliApp');

app.factory('moduleServices',
    ["$rootScope", function ($rootScope) {
        return {
            hideKeyboard: function () {
                //hide keyboard
                document.activeElement.blur();
                //$("input").blur(); Yuriy Sokha: with operation leads to error in brouser console; todo
            },

            setError: function (message) {
                $rootScope.errors = [{ Message: message }];
            },

            setErrors: function (errors) {
                $rootScope.errors = errors;
            }
        };
    }]);

app.controller('ForgotUserIdController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.cancel = function () {
            $state.goToWelcome();
        };
        $rootScope.SecureData = {
            userNameOrEmail: ''
        };
        $rootScope.serviceUrl = '';
    }]);

app.controller('ForgotUserIdStep1Controller', ['$scope', '$rootScope', '$http', '$state', 'moduleServices',
    'ServiceProvidersService', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $moduleServices, ServiceProvidersService, usSpinnerService) {

        // this hack fixes a select element behavior in mobile (changing selected options).
        var allSelectElements = document.getElementsByTagName('select');
        for (var i = 0; i < allSelectElements.length; i++) {
            allSelectElements[i].addEventListener('touchstart', function (e) {
                //This is the important line
                e.stopPropagation();
            }, false);
        }

        $scope.showCsrLink = DeploymentSettings.currentServiceProvider != Config.hcProviderName;
        $scope.providers = [];
        $scope.provider = {};
        $rootScope.errors = [];

        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        if ($scope.isProviderListVisible) {
            ServiceProvidersService.getProviders()
                .then(
                    function(allProviders) {
                        $scope.providers = allProviders;
                        $scope.provider = allProviders[0];
                    },
                    function() {
                        $moduleServices.setError(utilli.errors.serverErrorMessage);
                    }
                );
        }
        else{
            ServiceProvidersService.getCurrentProvider()
                .then(
                function(providerData){
                    $scope.provider = providerData;
                },
                function(){
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.CheckUserInfoFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');

            $rootScope.serviceUrl = $scope.provider.ApiUrl;
            $rootScope.appUrl = $scope.provider.ApiUrl;
            $rootScope.SecureData.userNameOrEmail = $.trim($scope.Email);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.serviceUrl + 'api/Account/CheckForgotUserIdStep1/',
                method: "GET",
                params: {
                    email: $.trim($scope.Email),
                    zip: $.trim($scope.ZipCode)
                }
            }).success(function (response) {
                if (response) {
                    if (response.ERROR_LIST && response.ERROR_LIST.length > 0) {
                        $moduleServices.setErrors(response.ERROR_LIST);
                    } else {
                        $rootScope.SecurityQuestion = response.SecurityQuestions[0].Message;
                        $state.go('^.Step2');
                    }
                } else {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotUserIdStep2Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ModalServiceExt) {

        usSpinnerService.stop('spinner-1');
        $rootScope.errors = [];

        $scope.SecurityQuestion = $rootScope.SecurityQuestion;
        $scope.CheckSecurityAnswerFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmSecurityAnswer.$valid) {
                $scope.submitted = true;
                return;
            }
            usSpinnerService.spin('spinner-1');
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $rootScope.errors = [];
            $http({
                url: $rootScope.serviceUrl + 'api/Account/CheckForgotUserIdStep2/',
                method: "GET",
                params: {
                    email: $rootScope.SecureData.userNameOrEmail,
                    securityAnswer: $.trim($scope.SecurityAnswer)
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    $rootScope.errors = [{Message: response.Errors[0]}];
                    return;
                }

                $state.go('^.Success');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotUserIdSuccessController', ['$scope', '$rootScope', 'CommonDataService', 'usSpinnerService',
    '$http', 'moduleServices',
    function ($scope, $rootScope, CommonDataService, usSpinnerService, $http, $moduleServices) {
        $rootScope.errors = [];
        usSpinnerService.spin('spinner-1');
        CommonDataService.getCommonData($rootScope.appUrl, true)
            .then(function (commonData) {
                $scope.contactPhoneNumber = commonData.SupportPhone;
                $scope.workingHours = commonData.WorkingHours;
                $scope.billingEmailTo = commonData.BillingEmailTo;
                $scope.serviceProviderName = commonData.CompanyName;
                $scope.billingDepartment = commonData.BillingDepartment;
                usSpinnerService.stop('spinner-1');
            }, function () {
                $moduleServices.setError("utilli.errors.serverErrorMessage");
                usSpinnerService.stop('spinner-1');
            });
    }]);
'use strict';
var app = angular.module('utilliApp');

app.directive("repeatPassword",
    function() {
        return {
            require: "ngModel",
            link: function (scope, elem, attrs, ctrl) {
                var otherInput = elem.inheritedData("$formController")[attrs.repeatPassword];

                ctrl.$parsers.push(function (value) {
                    if (value === otherInput.$viewValue) {
                        ctrl.$setValidity("confirm", true);
                        return value;
                    }
                    ctrl.$setValidity("confirm", false);
                });

                otherInput.$parsers.push(function (value) {
                    ctrl.$setValidity("confirm", value === ctrl.$viewValue);
                    return value;
                });
            }
        };
    });

app.factory('moduleServices',
    ["$rootScope", function ($rootScope) {
        return {
            hideKeyboard: function () {
                //hide keyboard
                document.activeElement.blur();
                //$("input").blur(); Yuriy Sokha: with operation leads to error in brouser console; todo
            },

            setError: function (message) {
                $rootScope.errors = [{Message: message}];
            },

            setErrors: function (errors) {
                $rootScope.errors = errors;
            }
        };
    }]);

app.controller('ForgotPasswordController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.cancel = function () {
            $state.goToWelcome();
        };

        $scope.goToCsr = function (){
            $state.go('ForgotPasswordCsr');
        }

        $scope.SecureData = {
            userNameOrEmail: '',
            zipCode: '',
            pstrAccountNumber: '',
            securityAnswer: '',
            password: '',
            confirmpassword: '',
            actionEvent: 'ForgotPassword'
        };

        $rootScope.serviceUrl = '';
        $rootScope.webServicesUrl = '';
    }]);

app.controller('ForgotPasswordStep1Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'ServiceProvidersService', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $moduleServices, ServiceProvidersService, usSpinnerService) {

        // this hack fixes a select element behavior in mobile (changing selected options).
        var allSelectElements = document.getElementsByTagName('select');
        for (var i = 0; i < allSelectElements.length; i++) {
            allSelectElements[i].addEventListener('touchstart', function (e) {
                //This is the important line
                e.stopPropagation();
            }, false);
        }

        $scope.showCsrLink = DeploymentSettings.currentServiceProvider != Config.hcProviderName;
        $scope.providers = [];
        $scope.provider = {};
        $rootScope.errors = [];
        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        if ($scope.isProviderListVisible) {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviders()
                .then(
                function(allProviders){
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.provider = allProviders[0];
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }
        else{
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
                .then(
                function(providerData){
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.CheckUserInfoFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');
            $rootScope.webServicesUrl = $scope.provider.ApiUrl;
            $scope.SecureData.userNameOrEmail = $.trim($scope.SecureData.userNameOrEmail);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.webServicesUrl + 'api/Account/CheckForgotPasswordStep1/',
                method: "GET",
                params: {
                    userNameOrEmail: $.trim($scope.SecureData.userNameOrEmail),
                    zip: $.trim($scope.SecureData.zipCode)
                }
            }).success(function (response) {
                if (response) {
                    if (response.ERROR_LIST && response.ERROR_LIST.length > 0) {
                        $moduleServices.setErrors(response.ERROR_LIST);
                    } else {
                        $scope.SecureData.securityQuestion = response.SecurityQuestions[0].Message;

                        $state.go('^.Step2');
                    }
                } else {
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);

app.controller('ForgotPasswordStep2Controller', ['$scope', '$rootScope', '$http', '$state',
    'moduleServices', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $moduleServices, usSpinnerService, ModalServiceExt) {

        usSpinnerService.stop('spinner-1');
        $rootScope.errors = [];

        $scope.CheckSecurityAnswerFormSubmit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmSecurityAnswer.$valid) {
                $scope.submitted = true;
                return;
            }
            $rootScope.errors = [];
            usSpinnerService.spin('spinner-1');
            $scope.SecureData.securityAnswer = $.trim($scope.SecureData.securityAnswer);
            forgotPasswordValidation();
        };

        function forgotPasswordValidation() {
            $http({
                url: $rootScope.webServicesUrl + 'api/Account/CheckForgotPasswordStep2/',
                method: "GET",
                params: {
                    userNameOrEmail: $scope.SecureData.userNameOrEmail,
                    securityAnswer: $scope.SecureData.securityAnswer
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                $state.go('^.Success');
            }).error(function () {
                $moduleServices.setError(utilli.errors.serverErrorMessage);
                usSpinnerService.stop('spinner-1');
            });
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('ForgotPasswordByEmailController', ['$scope', '$rootScope', '$window', '$state', 'CommonHeaderService',
    function ($scope, $rootScope, $window, $state, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.model = {
            from: '',
            userId: '',
            securityQuestion: '',
            securityAnswer: '',
            provider: {}
        };

        $scope.cancel = function () {
            if ($scope.model.from)
                $state.go($scope.model.from);
            else if (utilli.isWglcx())
                $state.go('TopMenuLayout.SignIn.Credentials');
            else
                $state.goToWelcome();
        };
}])
.controller('ForgotPasswordByEmailStep1Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams',
    'ServiceProvidersService', 'moduleServices', 'ModalServiceExt', 'usSpinnerService',
    function ($scope, $rootScope, $http, $state, $stateParams, ServiceProvidersService, $moduleServices, ModalServiceExt, usSpinnerService) {

        $scope.model.from = $stateParams.from;

        if (!DeploymentSettings.currentServiceProvider) {
            usSpinnerService.spin('spinner-1');

            ServiceProvidersService.getProviders()
                .then(
                function (allProviders) {
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.model.provider = allProviders[0];
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        } else {
            ServiceProvidersService.getCurrentProvider()
                .then(
                function (providerData) {
                    usSpinnerService.stop('spinner-1');
                    $scope.model.provider = providerData;
                },
                function () {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showServerError();
                });
        }
        
        $scope.submit = function () {
            $moduleServices.hideKeyboard();
            if (!$scope.frmCheckUserInfo.$valid) {
                $scope.submitted = true;
                return;
            }

            usSpinnerService.spin('spinner-1');
            $http({
                url: $scope.model.provider.ApiUrl + 'api/Account/CheckForgotPasswordByEmail/',
                method: "GET",
                params: {
                    userName: $.trim($scope.UserId),
                    email: $.trim($scope.Email)
                }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.HasErrors) {
                    ModalServiceExt.showError(response.Errors[0]);
                }
                else {
                    $scope.model.userId = $scope.UserId;
                    $scope.model.securityQuestion = response.Data;
                    $state.go('TopMenuLayout.ForgotPasswordByEmail.Success');
                }
                
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        };
}])
.controller('ForgotPasswordByEmailSuccessController', ['$scope', '$state', function ($scope, $state) {
    $scope.goToWelcome = function () {
        if ($scope.model.from)
            $state.go($scope.model.from);
        else if (utilli.isWglcx())
            $state.go('TopMenuLayout.SignIn.Credentials');
        else
            $state.goToWelcome();
    }
}]);
'use strict';
var app = angular.module('utilliApp');

app.controller('ForgotUserIdByEmailController', ['$scope', 'CommonHeaderService',
    function ($scope, CommonHeaderService) {
        CommonHeaderService.hideMenuToggleButton();
        $scope.Model = { from: '' };
    }]);

app.controller('ForgotUserIdByEmailStep1Controller', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'moduleServices',
    'ServiceProvidersService', 'usSpinnerService', 'ModalServiceExt',
    function ($scope, $rootScope, $http, $state, $stateParams, $moduleServices, ServiceProvidersService, usSpinnerService, ModalServiceExt) {

        $scope.Model.from = $stateParams.from;
        $scope.isProviderListVisible = !DeploymentSettings.currentServiceProvider;
        
        if (!DeploymentSettings.currentServiceProvider) {
           usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviders()
                .then(
                function(allProviders){
                    usSpinnerService.stop('spinner-1');
                    $scope.providers = allProviders;
                    $scope.provider = allProviders[0];
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }
        else {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getCurrentProvider()
                .then(function(providerData){
                    usSpinnerService.stop('spinner-1');
                    $scope.provider = providerData;
                },
                function(){
                    usSpinnerService.stop('spinner-1');
                    $moduleServices.setError(utilli.errors.serverErrorMessage);
                }
            );
        }

        $scope.submit = function () {
            $rootScope.errors = null;
            $scope.submitted = true;
            if (!$scope.frmCheckUserInfo.$valid)
                return;
            usSpinnerService.spin('spinner-1');
            $http({
                url: $scope.provider.ApiUrl + 'api/Account/CheckForgotUserIdData/',
                method: "GET",
                params: {
                    lastName: $.trim($scope.lastName),
                    email: $.trim($scope.Email)
                }
            })
            .success(function (response) {
                if (response == undefined || response.HasErrors == undefined) {
                    ModalServiceExt.showServerError();
                    usSpinnerService.stop('spinner-1');
                    return;
                }
                if (response.HasErrors) {
                    $rootScope.errors = [{ Message: response.Errors[0] }];
                }
                else {
                    $state.go('TopMenuLayout.ForgotUserIdByEmail.Success');
                }
                usSpinnerService.stop('spinner-1');
            }).error(function () {
                ModalServiceExt.showServerError();
                usSpinnerService.stop('spinner-1');
            });
        }

        $scope.cancel = function () {
            if ($scope.Model.from)
                $state.go($scope.Model.from);
            else if (utilli.isWglcx())
                $state.go('TopMenuLayout.SignIn.Credentials');
            else
                $state.goToWelcome();
        };
    }]);

app.controller('ForgotUserIdByEmailSuccessController', ['$scope', '$state',
    function ($scope, $state) {
        $scope.goToWelcome = function () {

            if ($scope.Model.from)
                $state.go($scope.Model.from);
            else if (utilli.isWglcx())
                $state.go('TopMenuLayout.SignIn.Credentials');
            else
                $state.goToWelcome();
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('ResetPasswordController', ['$scope', '$http', '$state', '$stateParams', 'usSpinnerService',
        'CommonDataService', 'ServiceProvidersService', 'ModalServiceExt',
function ($scope, $http, $state, $stateParams, usSpinnerService, CommonDataService, ServiceProvidersService,
    ModalServiceExt) {
    var _t = $scope._t;
    usSpinnerService.spin('spinner-1');

    $scope.togglePassword = function (pswId, iconId) {
        utilli.togglePasswordVisibility(pswId, iconId);
    }

    var apiUrl = '';
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                apiUrl = providerData.ApiUrl;
                CommonDataService.getCommonData(providerData.ApiUrl).then(function (data) {
                    $scope.passRequirements = data.PasswordRequirements;
                    $scope.paswdMinLength = data.PasswordLength;
                    usSpinnerService.stop('spinner-1');
                }, function () {
                    usSpinnerService.stop('spinner-1');
                    $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
                });
            },
            function () {
                usSpinnerService.stop('spinner-1');
                $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
            });
    
    $scope.errors = {};

    if (!$stateParams.token) {
        $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
        return;
    }

    $scope.model = {};
    $scope.model.newPassword = '';
    $scope.model.confirmNewPassword = '';

    resetErrors();

    $scope.passRequirements = [$scope._t('Loading...')];

    $scope.changePassword = function () {
        resetErrors();

        if (!validate()) {
            utilli.scrollTop();
            return;
        }

        usSpinnerService.spin('spinner-1');

        var url = apiUrl + 'api/User/ResetPassword';
        var requestData = {
            Token: $stateParams.token,
            NewPassword: $scope.model.newPassword,
            ConfirmPassword: $scope.model.confirmNewPassword
        };

        $http({
            url: url,
            method: 'POST',
            data: requestData
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');

            if (data.Errors != null && data.Errors.length > 0)
                $scope.errors.serverErrors = data.Errors;
            else {
                ModalServiceExt.showInfo(_t('Password was successfully changed.'), function () {
                    if (utilli.hasAgentRole($stateParams.token)){
                        $state.goToAgentsWelcome();
                    } 
                    else if (utilli.isWglcx())
                        $state.go('TopMenuLayout.SignIn.Credentials');
                    else{
                        $state.goToWelcome();
                    }
                });
            }
        }).error(function () {
            $scope.errors.serverErrors = [$scope._t("Service is unavailable now. Try again later.")];
            usSpinnerService.stop('spinner-1');
        });
    };

    function find(list, key) {
        return _.find(list, function (item) { return item.Key === key; });
    }

    function validate() {
        resetErrors();

        var valid = true;
        var requirement = find($scope.passRequirements, 'PasswordLength');
        if (requirement && (!$scope.model.newPassword || $scope.model.newPassword.length < $scope.paswdMinLength)) {
            $scope.errors.newPasswordLength = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'DigitsNumber')) && !utilli.hasDigits($scope.model.newPassword)) {
            $scope.errors.newPasswordNoDigits = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'Letters')) && (!utilli.hasLowerCaseLetters($scope.model.newPassword) || !utilli.hasUpperCaseLetters($scope.model.newPassword))) {
            $scope.errors.newPasswordNoLetters = requirement.ErrorText;
            valid = false;
        }
        else if ((requirement = find($scope.passRequirements, 'SpecialSymbols')) && !utilli.hasSpecialSymbols($scope.model.newPassword)) {
            $scope.errors.newPasswordNoSpecialSymbols = requirement.ErrorText;
            valid = false;
        }

        if (!$scope.model.confirmNewPassword || $scope.model.confirmNewPassword != $scope.model.newPassword) {
            $scope.errors.passwordsDontMatch = true;
            valid = false;
        }

        if (localStorage.getItem('current_user') == $scope.model.newPassword) {
            $scope.errors.pswSameAsUserNameError = $scope._t('Passwords cannot be your User ID.');
            valid = false;
        }

        return valid;
    };

    function resetErrors() {
        $scope.errors.serverErrors = null;
        $scope.errors.newPasswordEmpty = null;
        $scope.errors.passwordsDontMatch = null;
        $scope.errors.newPasswordLength = null;
        $scope.errors.newPasswordNoDigits = null;
        $scope.errors.newPasswordNoLetters = null;
        $scope.errors.newPasswordNoSpecialSymbols = null;
        $scope.errors.pswSameAsUserNameError = null;
    };
}]);

'use strict';
angular.module('utilliApp')
.controller('UsageController', ['$scope', '$http', '$rootScope', 'usSpinnerService',
    'LeftMenuService', 'CommonHeaderService', 'ModalServiceExt', '$state', 'UnitsService', 'GetAccountsService',
// ReSharper disable InconsistentNaming
function ($scope, $http, $rootScope, usSpinnerService, LeftMenuService, CommonHeaderService, ModalServiceExt, $state,
    UnitsService, GetAccountsService) {
    var _t = $scope._t;
    // ReSharper restore InconsistentNaming

    $scope.isHc = utilli.isHc();

    $scope.units = UnitsService;
    $scope.config = Config;
    if ($state.current.name == 'MainLayout.Usage') {
        LeftMenuService.setCurrentTab('Usage');
    }
    CommonHeaderService.setUpNotificationButton();

    $scope.isExportToExcelButtonVisible = !isMobileOrRipple();

    $scope.isMultipleMeters = false;
    $scope.meterNum = '';

    $scope.meterOptions = [];

    $scope.currentMeter = "";
    $scope.currentPage = 0;
    $scope.pageSize = 12;

    $scope.previousPage = function () {
        if (!$scope.disablePrev) {
            $scope.currentPage++;
            getGraph();
        }
    };

    $scope.nextPage = function () {
        if (!$scope.disableNext) {
            $scope.currentPage--;
            getGraph();
        }
    };

    $scope.tableData = [];

    function showChartLoading(){
        $scope.chart.showLoading('<img src="Styles/Material/loading-image.gif">');
    }

    $scope.currentAccountNumber = '';
    $scope.getMeterDataGraph = function (accountNumber) {
        $scope.currentAccountNumber = accountNumber;
        // build empty chart so that loading.gif will be visible while data is being loaded via ajax call
        processGraphData({Count: 0, PageData: []});
        showChartLoading();

        startSpin();
        var apiUrl = localStorage.getItem('ApiUrl');
            $http({
            url: apiUrl + 'api/Consumption/GetMeterInfo/',
            method: "GET",
            params: { AccountNumber: accountNumber }
        }).success(function (jsonData) {
            stopSpin();
            if (jsonData) {
                if (isGetMetersError(jsonData)) {
                    ModalServiceExt.showError(jsonData[0].ERROR_LIST[0].Message);
                    return;
                }
                useMeterData(jsonData);
            } else {
                ModalServiceExt.showError(utilli.errors.serverErrorMessage);
            }
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    };

    $scope.getExcelData = function () {
        var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateConsumptionDataExcel/'
           + '?AccountNumber=' + localStorage.getItem('CurrentAccountNumber')
           + '&meterNumber=' + $scope.meterNum;
        startSpin();
        $http({
            url: apiUrl,
            method: "GET",
            params: { }
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                stopSpin();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                var url = utilli.getFileUrlWithToken(response.Data);
                utilli.downloadFile(url, "Payments.xlsx");
            }
            stopSpin();
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    }

    $scope.getGreenButtonData = function () {
        var apiUrl = localStorage.getItem('ApiUrl') + 'api/Consumption/GenerateGreenButtonData/'
           + '?AccountNumber=' + localStorage.getItem('CurrentAccountNumber')
           + '&meterNumber=' + $scope.meterNum;
        startSpin();
        $http({
            url: apiUrl,
            method: "GET",
            params: {}
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                stopSpin();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                var url = utilli.getFileUrlWithToken(response.Data);
                utilli.downloadFile(url, "Payments.xlsx");
            }
            stopSpin();
        }).error(function (error) {
            stopSpin();
            ModalServiceExt.showError(error.Message);
        });
    }

    function isGetMetersError(jsonData) {
        return jsonData.length && jsonData.length == 1 && jsonData[0].ERROR_LIST && jsonData[0].ERROR_LIST.length > 0;
    }

    function useMeterData (jsonObject) {
        if (jsonObject.length > 0) {
            if (jsonObject.length == 1)
                useSingleMeterData(jsonObject);
            else
                useMiltipleMetersData(jsonObject);
        }
        getGraph();
    };

    function useSingleMeterData(jsonObject) {
        var jsonMeterNumIs = jsonObject[0].MeterNum;
        if (jsonMeterNumIs == "" || jsonMeterNumIs == null) {
            $scope.isMultipleMeters = false;
        }
        else {
            $scope.isMultipleMeters = false;
            setCurrentMeter(jsonObject[0]);
        }
    }

    function useMiltipleMetersData(jsonObject) {
        $scope.isMultipleMeters = true;
        $scope.meterOptions = [];

        if (jsonObject.length > 0) {
            fillMeterOptions(jsonObject);
            setCurrentMeter(jsonObject[0]);
        }
    }

    function fillMeterOptions(jsonObject) {
        for (var i = 0; i < jsonObject.length; i++) {
            $scope.meterOptions.push(jsonObject[i]);
        }
    }

    function setCurrentMeter(meterInfo) {
        $scope.currentMeter = meterInfo;
        $scope.meterNum = meterInfo.MeterNum;
        var selectedAccountAndMeter = {
            AccountNumber: localStorage.getItem('CurrentAccountNumber'),
            meterNumber: meterInfo.MeterNum
        };
    }

    /***
     * Enables/disables next/prev controls depending on current page and pointsTotalCount
     * @param pointsTotalCount count of available points for graph including those not visible on the current page
     */
    function analyzePointsTotalCount(pointsTotalCount) {
        // (currentPage + 1) because counting starts from zero
        $scope.disablePrev = ($scope.currentPage + 1) * $scope.pageSize >= pointsTotalCount;
        $scope.disableNext = $scope.currentPage == 0;
    }

    $scope.selectMeter = function () {
        $scope.currentPage = 0;
        setCurrentMeter($scope.currentMeter);
        getGraph();
    }

    $scope.isFirstGraphLoad = true;
    /***
     * does everything needed to re-plot the chart with current parameters (page number, consumption units)
     */
    function getGraph() {
        var currentAccountNumber = $scope.currentAccountNumber;
        var apiUrl = localStorage.getItem('ApiUrl');
        showChartLoading();

        $http({
            url: apiUrl + 'api/Consumption/GetConsumptionGraphPageForUsage/',
            method: "GET",
            params: {
                accountNumber: currentAccountNumber,
                meterNumber: $scope.currentMeter.MeterNum,
                skip: $scope.currentPage * $scope.pageSize,// currentPage starts with 0
                pageSize: $scope.pageSize
            }
        }).success(function (graphPageJson) {
            $scope.chart.hideLoading();
            if (graphPageJson) {
                if (graphPageJson.Errors && graphPageJson.Errors.length > 0) {
                    ModalServiceExt.showError(graphPageJson.Errors[0]);
                }
                else {
                    if ($scope.isFirstGraphLoad && graphPageJson.PageData.length > 0) {
                        $scope.isFirstGraphLoad = false;
                        $scope.units.setSelectedUnits(graphPageJson.PageData[0].Unit);
                    }
                    processGraphData(graphPageJson);
                }
            } else {
                ModalServiceExt.showError($scope._t("Error occurred during getting of consumptions."));
            }
        }).error(function (error) {
            $scope.chart.hideLoading();
            ModalServiceExt.showError(error.Message);
        });
    };

    /**
     * prepares data for the chart and the table below the chart
     * @param graphPageJson json with data received from our back-end
     */
    function processGraphData(graphPageJson) {

        if (graphPageJson.PageData == undefined)
            return;

        analyzePointsTotalCount(graphPageJson.Count);

        // points for the graph must be reset and filled with data in json
        $scope.graphPoints = graphPageJson.PageData;
        $scope.tableData = [];

        var tableData = convertChartUnits($scope.graphPoints);
        if (!$scope.currentRegisterNumber)
            $scope.currentRegisterNumber = tableData.length ? tableData[0].RegisterNumber : null;
        $scope.registerNumbers = $scope.currentRegisterNumber ? [$scope.currentRegisterNumber] : [];
        for (var i = 0; i < tableData.length; i++) {
            var reading = tableData[i];
            if (reading.RegisterNumber != $scope.currentRegisterNumber) {
                // add register number into the list of register numbers if it isn't already added
                if (!_.contains($scope.registerNumbers, reading.RegisterNumber))
                    $scope.registerNumbers.push(reading.RegisterNumber);
                continue;
            }
            // add item in the table under the chart
            var tableDataItem = {};
            tableDataItem.date = reading.ReadingDateForTable;
            tableDataItem.amountString = utilli.formatCurrency(reading.Amount);
            tableDataItem.registerNum = reading.RegisterNumber;
            tableDataItem.consumption = reading.Consumption;
            tableDataItem.averageMonthlyTemperature = reading.MonthAverageTemperature;
            if (tableDataItem.averageMonthlyTemperature == "-99") {
                tableDataItem.averageMonthlyTemperature = "";
                reading.AverageMonthlyTemperature = null;
            }
            tableDataItem.unit = reading.Unit;
            // insert tableDataItem to the beginning of the array because elements were sorted by ReadingDate desc.
            $scope.tableData.unshift(tableDataItem);
        }

        $scope.createChart();
    };

    $scope.getConsumptionString = function(consumptionHistoryItem){
        var selectedFraction = Config.getConsumptionUnitFraction($scope.units.selectedUnitsType.name);
        var sourceFraction = Config.getConsumptionUnitFraction(consumptionHistoryItem.unit)
        var number = consumptionHistoryItem.consumption * selectedFraction / sourceFraction;
        return utilli.formatNumber(number);
    }

    /**
     * converts consumption units for the graph data
     * (for example ccf -> gallons)
     * @param graphPoints points for the chart
     * @param targetUnitsType target type of the consumption units
     * @param sourceUnitsType source type of the consumption units
     * @returns {Array|*} cloned graphPoints with converted consumption values
     */
    function convertUnits(graphPoints, targetUnitsType, sourceUnitsType) {
        var consumptionUnits = $scope.units.currentUnits;
        var targetFraction = consumptionUnits[targetUnitsType];
        var sourceFraction = consumptionUnits[sourceUnitsType];
        var coefficient = targetFraction / sourceFraction;
        var graphData = $.map(graphPoints, function (item) {
            var clone = $.extend({}, item);
            var stringFixed = (clone.Consumption * coefficient).toFixed(2);
            clone.Consumption = parseFloat(stringFixed);
            clone.Unit = targetUnitsType;
            return clone;
        });
        return graphData;
    }

    var convertChartUnits = function(graphPoints){
        if (!$scope.graphPoints || $scope.graphPoints.length === 0)
            return [];
        var unitsType = $scope.units.getSelectedUnitsTypeName();
        var sourceUnitsType = $scope.graphPoints[0].Unit;
        return convertUnits(graphPoints, unitsType, sourceUnitsType);
    }

    var buildSeries = function(){
        var result = [
            {
                name: 'Consumption',
                data: [],
                tooltip: {
                    headerFormat: '',
                    pointFormatter: function (){
                        return '<span>' + _t('Register') +': ' + this.register + '</span><br/>'
                            + '<span>' + this.unit + ': ' +  utilli.formatNumber(this.y) +'</span>';
                    }
                },
                yAxis: 1
            },
            {
                type: 'spline',
                name: 'Amount',
                data: [],
                tooltip: {
                    pointFormatter: function () {
                        return utilli.formatCurrency(this.y);
                    },
                    headerFormat: ''
                }
            }
        ];
        if(!$scope.isHc) {
            result.push({
                type: 'spline',
                name: 'Average Temperature',
                data: [],
                tooltip: {
                    pointFormat: '{point.y}F (' + _t('Range') + ': {point.low}F-{point.high}F)',
                    headerFormat: ''
                },
                yAxis: 2
            });
            result.push({
                name: 'Temperature Range',
                type: 'errorbar',
                data: [],
                enableMouseTracking: false,
                yAxis: 2
            });
        }
        return result;
    }

    var buildChart = function (series) {
        $scope.chart = Highcharts.chart('chart', {
            credits: {
                enabled: false
            },
            lang: {
                drillUpText: '◁ Back'
            },
            chart: {
                spacingTop: 40,
                spacingBottom: 100,
                type: 'column',
                events: {
                    drilldown: function (e) {
                        if (!e.seriesOptions) {
                            var chart = this;
                            chart.showLoading('Loading ...');
                            var isMonthDrillDown =e.point.name.indexOf('-') > 0;
                            var url = isMonthDrillDown 
                                ? localStorage.getItem('ApiUrl') + 'api/Consumption/GetDailyConsumption/'
                                : localStorage.getItem('ApiUrl') + 'api/Consumption/GetHourlyConsumption/';
                            $http({
                                url: url,
                                method: "GET",
                                params: {
                                    date: e.point.name
                                }
                            }).apiThen(function(data){
                                chart.hideLoading();

                                var series = {
                                    name: 'Consumption',
                                    data: _.map(data, function (i) { return {
                                        name: i[0], 
                                        y: i[1] * 1,
                                        drilldown: isMonthDrillDown}; 
                                    }),
                                    tooltip: {
                                        headerFormat: '',
                                        pointFormatter: function () {
                                            return '<span>kWh: ' + utilli.formatNumber(this.y) + '</span>';
                                        }
                                    },
                                    yAxis: 1
                                };
                                chart.addSingleSeriesAsDrilldown(e.point, series);

                                var amounts = {
                                    type: 'spline',
                                    name: 'Amount',
                                    data: _.map(data, function (i) {
                                        return {
                                            name: i[0],
                                            y: i[1] * 0.12,
                                            drilldown: isMonthDrillDown
                                        };
                                    }),
                                    tooltip: {
                                        pointFormatter: function () {
                                            return utilli.formatCurrency(this.y);
                                        },
                                        headerFormat: ''
                                    }
                                };
                                chart.addSingleSeriesAsDrilldown(e.point, amounts);

                                chart.applyDrilldown();
                            }, ModalServiceExt);
                        }
                    }
                },
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'category', labels: { rotation: 270 }
            },
            yAxis: [
                {
                    labels: {
                        formatter: function () {
                            return utilli.formatCurrency(this.value);
                        }
                    },
                    title: {
                        text: _t('Amount')
                    },
                    min: 0
                },
                {
                    labels: {
                        formatter: function () {
                            return utilli.formatNumber(this.value) + ' ' + $scope.units.getSelectedUnitsTypeName();
                        }
                    },
                    title: {
                        text: _t('Consumption')
                    },
                    opposite: true
                },
            {
                labels: {
                    format: ''
                },
                title: {
                    text: ''
                },
                min: 0,
                visible: false
            }
        ],
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                y: 80,
                floating: true,
                backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                shared: false,
                useHTML: true
            },
            plotOptions: {
                series: {
                    cursor: 'pointer'
                }
            },
            exporting: {
                enabled: false
            },
            series: series,
        });
    }

    /**
     * plots the chart using data points from the $scope
     */
    $scope.createChart = function() {
        var graphData = convertChartUnits($scope.graphPoints);
        
        var consumptionReadingIndex = 0;
        var amountIndex = 1;
        var averageTemperatureIndex = 2;
        var temperatureRangeIndex = 3;

        var series = buildSeries();

        var categories = [];
        var uom = $scope.units.getSelectedUnitsTypeName();

        graphData.forEach(function (item) {
            categories.push(item.ReadingDateForGraphCategory);

            series[consumptionReadingIndex].data.push({
                name: item.ReadingDateForGraphCategory,
                y: item.Consumption,
                // custom data
                register: item.RegisterNumber,
                unit: uom,
                drilldown: uom == "kWh" // enable drilldown only for demo
            });

            series[amountIndex].data.push({
                name: item.ReadingDateForGraphCategory,
                y: item.Amount
            });

            if(!$scope.isHc) {
                series[averageTemperatureIndex].data.push({
                    name: item.ReadingDateForGraphCategory,
                    y: item.MonthAverageTemperature,
                    low: item.MonthMinTemperature,
                    high: item.MonthMaxTemperature
                });

                series[temperatureRangeIndex].data.push({
                    name: item.ReadingDateForGraphCategory,
                    low: item.MonthMinTemperature,
                    high: item.MonthMaxTemperature
                });
            }
        });

        buildChart(series);
    }

    var startSpin = function () {
        usSpinnerService.spin('spinner-1');
    };

    var stopSpin = function () {
        usSpinnerService.stop('spinner-1');
    };

    setTimeout(function () {
        // render chart after left menu. otherwise the width of the chart will be calculated wrong
        var accountNumber = localStorage.getItem('CurrentAccountNumber');
        $scope.getMeterDataGraph(accountNumber);
    }, 100);

    if (DeploymentSettings.deploymentEnvironment == "Demo") {
        $scope.selectAccount = function (account) {
            $scope.model.selectedContractAccountNumber = account.AccountNumber;
            $scope.currentRegisterNumber = null;
            localStorage.setItem('CurrentUtilityType', account.UtilityType);
            $scope.units.updateUnits();
            $scope.isFirstGraphLoad = true;
            $scope.currentPage = 0;
            $scope.getMeterDataGraph(account.AccountNumber);
        }
        usSpinnerService.spin('spinner-1');
        GetAccountsService.getAccounts(true).then(function (response) {
            usSpinnerService.stop('spinner-1');
            if (response.Errors && response.Errors.length > 0) {
                ModalServiceExt.showError(response.Errors[0].Message);
                return;
            }
            $scope.accounts = response.Accounts;
            $scope.model = {};
            $scope.model.selectedContractAccountNumber = localStorage.getItem('CurrentAccountNumber');
        }).catch(function (e) {
            usSpinnerService.stop('spinner-1');
            console.log(e);
        });
    }
}]);
'use strict';
angular.module('utilliApp')
    .service('UnitsService', function() {
        var svc = {
            selectedUnitsType: { name: '' },
            dropDownItems: [{name: ''}]
        };
        svc.setSelectedUnits = function (unitsTypeName) {
            svc.selectedUnitsType = _.find(svc.dropDownItems, function (item) {
                return item.name === unitsTypeName;
            });
            if (!svc.selectedUnitsType)
                svc.selectedUnitsType = { name: unitsTypeName };
        }
        /**
         * Sets selected unit types if nothing is currently selected
         */
        svc.setSelectedUnitsIfEmpty = function (unitsTypeName) {
            if (svc.selectedUnitsType.name == null || svc.selectedUnitsType.name == '') {
                svc.setSelectedUnits(unitsTypeName);
            }
        }
        // updates values in the units drop down based on currently loaded account data
        svc.updateUnits = function() {
            svc.currentUnits = Config.getCurrentConsumptionUnits();
            svc.dropDownItems = $.map(svc.currentUnits, function(element, index) {
                return { name: index };
            });
        };
        svc.getSelectedUnitsTypeName = function(){
            return svc.selectedUnitsType ? svc.selectedUnitsType.name : '';
        }
        // set default units
        svc.updateUnits();
        /**
         * Get multiplier to convert given uom into currently selected uom.
         * @param {} uom source uom
         * @returns {} multiplier
         */
        svc.getCoefficient = function(uom) {
            var consumptionUnits = Config.getCurrentConsumptionUnits();
            var targetFraction = consumptionUnits[svc.selectedUnitsType.name];
            var sourceFraction = consumptionUnits[uom];
            var coefficient = targetFraction / sourceFraction;
            return coefficient;
        }
        return svc;
    });
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .service('PropertyListService',
        [
            '$http', 'ModalServiceExt', '$timeout', '$state', '$q',
// ReSharper disable InconsistentNaming
            function($http, ModalServiceExt, $timeout, $state, $q) {
                var _t = utilli._t;
// ReSharper restore InconsistentNaming
                var svc = {};
                svc.updateProperties = function(data, existingPropertyList) {
                    var areTherePropertiesInProgress = false;
                    if (data) {
                        _.each(data,
                            function(p) {
                                var existingProperty = _.find(existingPropertyList,
                                    function(ep) {
                                        return ep.Id === p.Id;
                                    });
                                if (!existingProperty)
                                    return;
                                existingProperty.Status = p.Status;
                                existingProperty.IsSyncInProcess = p.IsSyncInProcess;
                                existingProperty.DisplayedStatus = p.DisplayedStatus;
                                existingProperty.EnergyStarScore = p.EnergyStarScore;
                                existingProperty.CurrentConsumption = p.CurrentConsumption;

                                if (existingProperty.EnergyStarScore == 0)
                                {
                                    existingProperty.EnergyStarScore = 'N/A';
                                }

                                if (p.IsSyncInProcess) {
                                    areTherePropertiesInProgress = true;
                                }
                            });
                    }
                    return areTherePropertiesInProgress;
                };
                svc.getPropertyList = function(withoutDelegated) {
                    var requestData = { withoutDelegated: withoutDelegated ? true : false };
                    utilli.addUserName($state, requestData);
                    return $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyList/',
                        method: "GET",
                        params: requestData
                    });
                };
                svc.loadPropertyList = function ($scope, response) {
                    if (svc.timeout) {
                        $timeout.cancel(svc.timeout);
                    }
                    if (response.Data) {
                        var areTherePropertiesInProgress = false;
                        // ReSharper disable once UndeclaredGlobalVariableUsing
                        _.each(response.Data,
                            function(p) {
                                if (p.IsSyncInProcess) {
                                    areTherePropertiesInProgress = true;
                                }
                            });
                        $scope.propertyList = response.Data;
                        if (areTherePropertiesInProgress) {
                            svc.timeout = $timeout(function() {
                                    svc.reloadPropertylist($scope, $state.current.name);
                                },
                                utilli.propertyRefreshTimeout);
                        }
                    } else {
                        $scope.propertyList = [];
                    }
                }
                svc.refreshScore = function ($scope, property) {
                    //Refresh score button should be always clickable GNIS-2303
                    //if (property.isLoading)
                    //    return;
                    property.isLoading = true;
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RefreshPropertyScore/',
                        method: "POST",
                        params: { propertyId: property.Id }
                    })
                    .then(ModalServiceExt.checkApiResponseError, ModalServiceExt.catchAjaxError)
                    .then(function () {
                        svc.reloadPropertylist($scope, $state.current.name);
                    }, function (error) {
                        if (error === "PropertyIsNotCompleteError") {
                            // todo: add a link to the edit property page
                            ModalServiceExt.showError("Please complete property creation process.");
                        }
                        property.isLoading = false;
                    });
                }
                svc.reloadPropertylist = function($scope, stateName) {
                    // if the state is changed then stop updates
                    if ($state.current.name !== stateName)
                        return;
                    svc.getPropertyList().success(function(response) {
                        // ReSharper disable once VariableUsedInInnerScopeBeforeDeclared
                        if (response.Data) {
                            var areTherePropertiesInProgress =
                                svc.updateProperties(response.Data, $scope.propertyList);
                            if (areTherePropertiesInProgress) {
                                svc.timeout = $timeout(function () {
                                        svc.reloadPropertylist($scope, stateName);
                                    },
                                    utilli.propertyRefreshTimeout);
                            }
                        } else {
                            $scope.propertyList = [];
                        }
                    }).error(function(e) {
                        // i don't want to show user a new error popup every 5 seconds
                        console.log(e);
                    });
                }

                return svc;
            }
        ]);
'use strict';
// ReSharper disable once UndeclaredGlobalVariableUsing
angular.module('utilliApp')
    .service('PropertyService', ['$http', 'ModalServiceExt', '$timeout', '$state', 'usSpinnerService',
// ReSharper disable InconsistentNaming
            function ($http, ModalServiceExt, $timeout, $state, usSpinnerService) {
                var _t = utilli._t;
// ReSharper restore InconsistentNaming
                var svc = {};
                svc.updateProperty = function(freshProperty, existingProperty) {
                    if (!freshProperty|| !existingProperty)
                            return false;
                    existingProperty.Status = freshProperty.Status;
                    existingProperty.IsSyncInProcess = freshProperty.IsSyncInProcess;
                    existingProperty.DisplayedStatus = freshProperty.DisplayedStatus;
                    existingProperty.EnergyStarScore = freshProperty.EnergyStarScore;

                    if (existingProperty.EnergyStarScore == 0)
                    {
                        existingProperty.EnergyStarScore = 'N/A';
                    }

                    localStorage.setItem('currentAggregation', JSON.stringify(existingProperty));
                    return existingProperty.IsSyncInProcess;
                };
                svc.GetPropertyStatus = function (propertyId) {
                    return $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyStatus/',
                        method: "GET",
                        params: { propertyId: propertyId }
                    });
                };
                svc.goToDashboard = function(property, state) {
                    if (property.MetersCount < Config.maxMetersOnStackedDashboard) {
                        state.goMainLayout('PropertyStackedDashboard');
                    } else {
                        state.goMainLayout('PropertyBarDashboard');
                    }
                }
                svc.deleteMeter = function (meters, clientUtilliId, callback) {
                    var meter = null;
                    meters.forEach(
                        function (mtr) {
                            if (mtr.clientUtilliId === clientUtilliId)
                            {
                                meter = mtr;
                            }
                        })
                    //var meter = meters[index];
                    // if it's not saved meter then just delete it
                    if (meter.Id === 0) {
                        meters.splice(meters.indexOf(meter), 1);
                        return;
                    }
                    // if this is a saved meter then confirm
                    ModalServiceExt.showYesNoMessage(
                        _t('Delete meter'),
                        _t('Are you sure you want to delete this meter?'),
                        function () {
                            usSpinnerService.spin('spinner-1');
                            var params = { meterId: meter.Id };
                            utilli.addUserName($state, params);
                            $http({
                                method: "POST",
                                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteMeter/',
                                params: params
                            }).success(function (response) {
                                usSpinnerService.stop('spinner-1');
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showServerError();
                                    return;
                                }
                                meters.splice(meters.indexOf(meter), 1);
                                if (callback)
                                    callback();
                            }).error(function () {
                                usSpinnerService.stop('spinner-1');
                                ModalServiceExt.showServerError();
                            });
                        });
                }

                svc.verifyAllAddresses = function(propertyId, meters, callback) {
                    ModalServiceExt.showYesNoMessage(
                        _t('Verify all meters'),
                        _t('Are you sure you want to verify all selected meters?'),
                        function () {
                            usSpinnerService.spin('spinner-1');
                            var selectedMeters = _.filter(meters, function (m) { return m.checked; });
                            var selectedIds = _.map(selectedMeters, function(m) { return m.Id; });
                            $http({
                                method: "POST",
                                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/MassVerifyServiceAddress/',
                                data: {
                                    PropertyId: propertyId,
                                    MeterIds: selectedIds,
                                    UserName: $state.params.userId
                                }
                            }).success(function (response) {
                                usSpinnerService.stop('spinner-1');
                                if (response.Errors && response.Errors.length > 0) {
                                    ModalServiceExt.showServerError();
                                    return;
                                }
                                if (callback)
                                    callback();
                            }).error(function () {
                                usSpinnerService.stop('spinner-1');
                                ModalServiceExt.showServerError();
                            });
                        });

                }

                svc.canMassVerifyServiceAddress = function(meters) {
                    return _.some(meters, function (m) {
                        return m.ErrorCode === utilli.pm.meterErrorCodes.serviceAddressMismatch
                            && !m.HasMultipleAddresses;
                    });
                }

                svc.deleteMeterWithoutConfirmation = function (meters, clientUtilliId, callback) {
                    var meter = null;
                    meters.forEach(
                        function(mtr) {
                            if (mtr.clientUtilliId === clientUtilliId) {
                                meter = mtr;
                            }
                        });
                    //var meter = meters[index];
                    // if it's not saved meter then just delete it
                    if (meter.Id === 0) {
                        meters.splice(meters.indexOf(meter), 1);
                        return;
                    }

                    var params = { meterId: meter.Id };
                    utilli.addUserName($state, params);
                    $http({
                        method: "POST",
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/DeleteMeter/',
                        params: params
                    }).success(function (response) {
                        usSpinnerService.stop('spinner-1');
                        if (response.Errors && response.Errors.length > 0) {
                            ModalServiceExt.showServerError();
                            return;
                        }
                        meters.splice(meters.indexOf(meter), 1);
                        if (callback)
                            callback();
                    }).error(function () {
                        ModalServiceExt.showServerError();
                    });
                }

                svc.refreshScore = function (property, reloadFinishCallback) {
                    //Refresh score button should be always clickable GNIS-2303
                    //if (property.IsSyncInProcess)
                    //    return;
                    property.IsSyncInProcess = true;
                    $http({
                        url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/RefreshPropertyScore/',
                        method: "POST",
                        params: { propertyId: property.Id }
                    })

                    .then(ModalServiceExt.checkApiResponseError, ModalServiceExt.catchAjaxError)
                    .then(function () {
                            svc.reloadProperty(property, $state.current.name, reloadFinishCallback);
                    }, function (error) {
                        if (error === "PropertyIsNotCompleteError") {
                            // todo: add a link to the edit property page
                            ModalServiceExt.showError("Please complete property creation process.");
                        }
                        property.IsSyncInProcess = false;
                    });
                }
                /**
                 * Initiates things that are necessary to automatically update property status.
                 * @param {} property The property where status needs to be updated.
                 * @param {} reloadFinishCallback The callback that is called once property refresh is 
                 * completed (status changes to Completed)
                 * @returns {} void
                 */
                svc.loadProperty = function (property, reloadFinishCallback) {
                    if (svc.timeout) {
                        $timeout.cancel(svc.timeout);
                    }
                    if (property.IsSyncInProcess) {
                        svc.timeout = $timeout(function() {
                                svc.reloadProperty(property, $state.current.name, reloadFinishCallback);
                            },
                            utilli.propertyRefreshTimeout);
                    }
                }
                svc.reloadProperty = function (property, stateName, reloadFinishCallback) {
                    // if the state is changed then stop updates
                    if ($state.current.name !== stateName)
                        return;
                    svc.GetPropertyStatus(property.Id).success(function (response) {
                        // ReSharper disable once VariableUsedInInnerScopeBeforeDeclared
                        if (response.Data) {
                            svc.updateProperty(response.Data, property);
                            if (response.Data.IsSyncInProcess) {
                                svc.timeout = $timeout(function() {
                                        svc.reloadProperty(property, stateName, reloadFinishCallback);
                                    },
                                    utilli.propertyRefreshTimeout);
                            } else {
                                // if update is finished then call calback (to reload the chart on the dashboard)
                                if (reloadFinishCallback) {
                                    reloadFinishCallback();
                                }
                            }
                        }
                    }).error(function(e) {
                        // i don't want to show user a new error popup every 5 seconds
                        console.log(e);
                    });
                }
                return svc;
            }
        ]);
'use strict';
angular.module('utilliApp').service('PaymentVerificationService', ['CommonDataService', 'ModalServiceExt',
    'usSpinnerService',
    function (CommonDataService, ModalServiceExt, usSpinnerService) {
        var _t = utilli._t;
        var svc = {};
        /** checks that payment amount is not beyond max limit */
        
        // use verifyPaymentInfoNew instead of verifyPaymentInfo, it give the more understanding 
        // when we need to use usSpinnerService
        svc.verifyPaymentInfo = function (amount, callback) {
            CommonDataService.getCommonData().then(function (data) {
                if (amount > data.MaxPaymentAmount) {
                    usSpinnerService.stop('spinner-1');
                    if (data.CanConfirmMaxPaymentAmount) {
                        ModalServiceExt.showYesNoMessage(_t("Please Confirm"), data.MaxPaymentAmountWarningText, callback);
                    }
                    else {
                        ModalServiceExt.showError(data.MaxPaymentAmountErrorText);
                    }
                }
                else {
                    callback();
                }
            });
        };
        // use this function instead of verifyPaymentInfo, it give the more understanding 
        // when we need to use usSpinnerService
        svc.verifyPaymentInfoNew = function (commonData, amount, callback) {
            if (amount > commonData.MaxPaymentAmount) {
                if (commonData.CanConfirmMaxPaymentAmount) {
                    ModalServiceExt.showYesNoMessage(_t("Please Confirm"), 
                        commonData.MaxPaymentAmountWarningText, callback);
                    
                    usSpinnerService.stop('spinner-1');
                }
                else {
                    ModalServiceExt.showError(commonData.MaxPaymentAmountErrorText);
                    usSpinnerService.stop('spinner-1');
                }
            }
            else {
                callback()
            }
        };
        return svc;
    }]);
'use strict';
var app = angular.module('utilliApp');
app.controller('NoConnectionController', ['$scope', '$timeout', '$sce', function ($scope, $timeout, $sce) {

    $scope.buttonMessage = 'Try to connect again';
    $scope.busy = false;

    $scope.getLogo = function () {
        return $sce.trustAsUrl(utilli.logoBase64);
    }

    $scope.getLogoText = function () {
        if (DeploymentSettings.providersGroupShortName === 'wgl'
         || DeploymentSettings.providersGroupShortName === 'wglcx')
            return '';

        return "Utilli";
    }

    $scope.getText = function () {
        if (DeploymentSettings.providersGroupShortName === 'wgl')
            return 'WGL Property Manager by Utilli does not work without internet connection. Restore your connection in order to continue.';

        return "This website does not work without internet connection";
    }

    $scope.tryPing = function () {
        $scope.busy = true;
        $scope.buttonMessage = 'Checking connection...'
        $.ajax({
            url: DeploymentSettings.providersServiceUrl + 'Version/Ping',
            method: 'GET'
        }).done(function (d) {
            utilli.setWindowLocation(window.location.origin + window.location.pathname);
        }).fail(function (e) {
            // timeout here to have time to display 'Checking connection...' to user. 
            // Because it is confused for users to press button without some visual response to their actions.
            $timeout(function () {
                $scope.busy = false;
                $scope.buttonMessage = 'Try to connect again';
                console.log(e);
            }, 1000);
        });
    }
}]);

'use strict';
angular.module('utilliApp').controller('MaintenanceController', ['$scope', '$http', '$state', '$q', 'usSpinnerService', 
    '$window', '$timeout', 'ServiceProvidersService', '$sce', 'SmartPayLayoutService', function ($scope, $http, $state, 
        $q, usSpinnerService, $window, $timeout, ServiceProvidersService, $sce, SmartPayLayoutService) {
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    var intervalId = -1;
    $scope.isLoading = true;
    initProviders();

    function getProviderNamesFor(shortGroupName) {
        var result = [];
        for (var providerName in Config.providers) {
            var shortName = Config.providers[providerName].providersGroupShortName;
            if(shortName && shortName == shortGroupName)
                result.push(providerName);
        }
        return result;
    } 
    
    function initProviders() {
        if(!isMobileOrRipple()){
            getContactPhones(DeploymentSettings.currentServiceProvider);
            return;
        }
        $scope.providers = getProviderNamesFor(DeploymentSettings.providersGroupShortName);
        if($scope.providers.length == 1)
            getContactPhones($scope.providers[0]);
    }

    $timeout(function () {//todo: refactor it - now $timeout is used to the spinner can work
        initPing();
    }, 0);

    function initPing() {
        // set checking interval 1 minute.
        intervalId = setInterval($scope.check, 60000);
        ping();
    }

    $scope.providerChanged = function () { 
        if($scope.serviceProvider){
            getContactPhones($scope.serviceProvider);
            return;
        }
        $scope.contactsInfo = null;
    }

    function ping() {
        $scope.check();
    }

    function getContactPhones(serviceProvider) {
        usSpinnerService.spin('spinner-1');
        var url = DeploymentSettings.providersServiceUrl
            + 'StaticData/GetContactPhonesHtml/?serviceProvider='
            + serviceProvider;
        $http({
            url: url,
            notCancelled: true
        }).success(function (data) {
            usSpinnerService.stop('spinner-1');
            $scope.contactsInfo = $sce.trustAsHtml(data);
            $scope.phoneLoaded = true;
            $scope.hasContacts = true;
            $scope.isLoading = false;
        }).error(function () {
            usSpinnerService.stop('spinner-1');
            $scope.failedAttempt = true;
            $scope.isLoading = false;
            $scope.hasContacts = false;
        });
    }

    function getPayUrl(){
        return localStorage.getItem('PayUrl');
    }

    $scope.pay = function(){
        $window.location = getPayUrl();
        //$state.go('SmartPayLayout.SmartPay');
    }

    $scope.check = function () {
        if ($state.current.name !== "SmartPayLayout.Maintenance" && intervalId != -1){
            clearInterval(intervalId);
            return;
        }
        var url = localStorage.getItem('ApiUrl');
        if (!url && isMobileOrRipple()) {
            if (intervalId != -1)
                clearInterval(intervalId);
            // if we are running in a phone then we might not have ApiUrl because the user hasn't ever login yet.
            // hence we need to use providersApiUrl to check for maintenance. but providers web api we can't put 
            // on maintenance using AppOffline.htm approach because we need it to be working to get support phone
            // number. hence we change compatible version to '-2' in UtilliConfig.json for providers web api
            // and catch it here.
            usSpinnerService.spin('spinner-1');

            $http.get(DeploymentSettings.providersServiceUrl + "Version/IsProvidersWebApiOnMaintenance")
                .then(function (result) {
                    if (!result.data){
                        //$state.goToSignIn();
                        $window.history.back();
                    }
                }).fixedFinally(function() {
                usSpinnerService.stop('spinner-1');
            });
            return;
        }
        else if (url) {
            usSpinnerService.spin('spinner-1');
            makeChecking(url)
                .then(function () {
                    usSpinnerService.stop('spinner-1');
                });
        }
        else {
            usSpinnerService.spin('spinner-1');
            ServiceProvidersService.getProviderApiUrl()
                .then(function (apiUrl) {
                    usSpinnerService.stop('spinner-1');
                    return makeChecking(apiUrl);
                })
                .then(function () {
                    usSpinnerService.stop('spinner-1');
                });
        }
    }

    function setIsPaymentAvailable(isMaintenanceOn){
        var payUrl = getPayUrl();
        var value = isMaintenanceOn && payUrl;
        $timeout(function () {
            $scope.isPaymentAvailable = value;
            $scope.$apply();
        }, 0);
    }

    function makeChecking(apiUrl) {
        // use jquery instead of $http to not allow interceptors to catch 503 response and loop redirect to maintenance
        return $.ajax({
            url: apiUrl + 'api/Admin/GetMaintenanceStatus',
            method: 'GET'
        }).then(function(response){
            if (response.Data.IsMaintenanceOn) {
                setIsPaymentAvailable(true);
                return;
            }
            if (intervalId != -1)
                clearInterval(intervalId);
            var token = localStorage.getItem('SecurityToken');
            var account = localStorage.getItem('CurrentAccountNumber');
            if (!token || !account || utilli.isWglcx()) {
                $window.history.back();
            }
            if (!utilli.isPropertyManagerApp())
                $state.goMainLayout('Dashboard');
            else
                $state.goMainLayout('PropertyStackedDashboard');
        }, function(error){
            setIsPaymentAvailable(false);
            console.error(error);
        });
    }
}]);
'use strict';
angular.module('utilliApp')
.controller('LanguagesController', ['$scope', '$http', '$state', 'usSpinnerService', 'LeftMenuService',
    'CommonHeaderService', '$resource', 'ModalServiceExt', '$window', 'CommonDataService',
// ReSharper disable InconsistentNaming
    function ($scope, $http, $state, usSpinnerService, LeftMenuService, CommonHeaderService, $resource,
        ModalServiceExt, $window, CommonDataService) {
// ReSharper restore InconsistentNaming
        if (!utilli.isLanguagePackEnabled()) {
            $window.history.back();
            return;
        }

        if (utilli.isAuthorized()) {
            LeftMenuService.setCurrentTab('Profile');
        }
        
        CommonHeaderService.setUpBackButton($scope._t('Languages'), true);

        $scope.languages = utilli.languages[DeploymentSettings.providersGroupShortName.toLowerCase()];

        $scope.selectLanguage = function (index) {
            usSpinnerService.spin('spinner-1');

            try {
                var language = $scope.languages[index].abbreviation;
                utilli.changeLanguage($resource, language, saveLanguage);
                CommonDataService.refresh();
            }
            catch (e) {
                usSpinnerService.stop('spinner-1');
            }
        }

        function saveLanguage(language) {
            if (!utilli.isAuthorized()) {
                usSpinnerService.stop('spinner-1');
                back();
                return;
            }

            var apiUrl = localStorage.getItem('ApiUrl');
            $http({
                method: 'POST',
                url: apiUrl + 'api/Profile/SaveLanguage',
                data: { 'Language': language, 'UserName': '' }
            }).success(function (response) {
                usSpinnerService.stop('spinner-1');
                if (response.Errors && response.Errors.length > 0) {
                    ModalServiceExt.showError(response.Errors[0]);
                    return;
                }

                back();
            }).error(function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        function back() {
            // if Languages page is opened by a direct link in chrome then $window.history.length is 2
            // chrome starts counter from 1 and the first page is the empty page
            if ($window.history.length > 2) {
                $window.history.back();
            } else {
                $state.goToWelcome();
            }
        }
    }]);
'use strict';
angular.module('utilliApp')
.controller('SubscriptionController', ['$scope', '$http', '$state', '$stateParams', 'usSpinnerService',
        'CommonDataService', 'ServiceProvidersService', 'ModalServiceExt',
function ($scope, $http, $state, $stateParams, usSpinnerService, CommonDataService, ServiceProvidersService,
    ModalServiceExt) {
    var _t = $scope._t;

    //Unsubscribe or change your email preferences.

    $scope.isDataLoaded = false;

    $scope.email = _t('loading...');
    $scope.accountNumber = _t('loading...');
    $scope.loadingError = _t('loading...');
    $scope.wasSubscribed = false;

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                usSpinnerService.stop('spinner-1');
                apiUrl = providerData.ApiUrl;
                initPage();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
            });

    $scope.applyChanges = function () { 
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + ($scope.wasSubscribed 
                ? 'api/Notification/Unsubscribe/'
                : 'api/Notification/Subscribe/'),
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            utilli.handleAjaxResponse(response,
                ModalServiceExt,
                function() {
                    $scope.operationResult = $scope.wasSubscribed 
                        ? $scope._t("You have successfully unsubscribed.")
                        : $scope._t("You have successfully subscribed.");
                    $scope.wasSubscribed = !$scope.wasSubscribed;
                });
        }).error(function () {
            ModalServiceExt.showError(_t("Service is unavailable now. Try again later."));
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.back = function () {
        $scope.operationResult = null;
    }

    function initPage() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/Notification/ValidateSubscriptionToken/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            else  {
                $scope.email = response.Data.Email;
                $scope.accountNumber = response.Data.AccountNumber;
                $scope.wasSubscribed = response.Data.Subscribed;
                $scope.isDataLoaded = true;
                $scope.loadingError = false;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

}]);

'use strict';
angular.module('utilliApp')
.controller('VerifyEmailController', ['$scope', '$http', '$state', 'usSpinnerService',
        'ServiceProvidersService',
function ($scope, $http, $state, usSpinnerService, ServiceProvidersService) {
    var _t = $scope._t;

    $scope.isDataLoaded = false;
    $scope.loadingError = _t('loading...');

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                usSpinnerService.stop('spinner-1');
                apiUrl = providerData.ApiUrl;
                initPage();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
            });
            
    $scope.back = function () {
        $scope.operationResult = null;
    }

    function initPage() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/VerifyEmail/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            else  {
                $scope.isDataLoaded = true;
                $scope.loadingError = false;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }
}]);

'use strict';

angular.module('utilliApp').controller('ViewBillAccessController', ["$scope", "$http", "$state", "$stateParams", "usSpinnerService", "ServiceProvidersService", "ModalServiceExt", "$timeout", "SmartPayLayoutService", function ($scope, $http, $state, $stateParams, 
    usSpinnerService, ServiceProvidersService, ModalServiceExt, $timeout, SmartPayLayoutService) {
    var _t = $scope._t;
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    $scope.step = 'loading';
    $scope.phoneNumberMask = Config.phoneNumberMask;
    $scope.isPhoneNumberPreferred = true;
    $scope.notUsePhoneNumber = false;
    utilli.savePayUrl($state.params.token);

    $scope.isPhoneNumberVerificationStep = function(){
        return $scope.step == 'phone-verification';
    }

    $scope.sendSms = function(){
        $scope.phoneNumberVerificationForm.$submitted = true;
        if (!$scope.phoneNumberVerificationForm.$valid)
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + '/api/SmartPay/SendPhoneNumberVerificationSms',
            data: {
                phoneNumber: $scope.phoneNumber,
                token: $state.params.token
            }
        })
        .apiThen(function(data){
            $scope.smsCodeSent = true;
            $scope.phoneNumberVerificationForm.$setPristine();//reset submitted flag
            startSmsConfirmationTimer(data ? data.RemainedTime : null);
            $scope.sendSmsSuccessMessage = $scope._t("SMS verification code has been sent to your mobile number %phoneNumber%."
                    + " Please use the code to verify your phone number.")
                    .replace('%phoneNumber%', utilli.getMaskedPhoneNumberValue($scope.phoneNumber));
        }, ModalServiceExt)
        .fixedFinally(function(error){
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.confirmPhone = function () {
        $scope.phoneNumberVerificationForm.$submitted = true;
        if (!$scope.phoneNumberVerificationForm.$valid)
            return;
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEbill/ConfirmPhoneNumber/',
            method: "POST",
            data: {
                token: $stateParams.token,
                phoneNumber: $scope.phoneNumber,
                confirmationCode: $scope.verificationCode,
                consent: $scope.isPhoneNumberPreferred,
                name: $scope.name,
                houseNumber: $scope.houseNumber,
                zip: $scope.zip
            }
        }).apiThen(function (hasAccess) {
            $state.go("ViewBill", {
                token: $stateParams.token,
                emailId: $stateParams.emailId
            });
        }, ModalServiceExt).fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    function startSmsConfirmationTimer(remainedTime) {
        if (remainedTime)
            $scope.timeout = remainedTime;
        else
            $scope.timeout = 31;

        tickTimer();
    }

    var tickTimer = function () {
        if ($scope.timeout == 0) {
            $scope.showTimer = false;
            return;
        }
        $scope.showTimer = true;
        $scope.timeout--;
        $timeout(tickTimer, 1000);
        var secInMinute = 60;
        var seconds = '' + ($scope.timeout % secInMinute); //60 seconds in 1 minute
        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }
        var minutes = '' + Math.floor($scope.timeout / secInMinute);
        if (minutes.length < 1) {
            minutes = '0';
        }
        $scope.timeoutStr = _t('Resend code in %timeout%').replace('%timeout%', minutes + ':' + seconds);
    }

    $scope.next = function (){ 
        $scope.billAccessForm.$submitted = true;
        if (!$scope.billAccessForm.$valid)
            return;
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEbill/VerifyBillAccess/',
            method: "POST",
            data: { 
                token: $stateParams.token,
                name: $scope.name,
                phoneNumber: $scope.phoneNumber,
                houseNumber: $scope.houseNumber,
                zip: $scope.zip
            }
        }).apiThen(function (hasAccess) {
            if (hasAccess) {
                if ($scope.zip) {
                    $scope.step = 'phone-verification';
                }
                else {
                    $state.go("ViewBill", {
                        token: $stateParams.token,
                        emailId: $stateParams.emailId
                    });
                }
            }
            else {
                if ($scope.zip){
                    ModalServiceExt.showError("We could not authenticate the information entered. Re-enter valid"
                        + " information to proceed. Please note that First Name/Last Name/Name of Organization," 
                        + " House Number, Zip Code must match the information on record with Washington Gas."
                        + " For assistance, call 844-WASHGAS (844-927-4427).");
                } else {
                    ModalServiceExt.showError("We could not authenticate the information entered. Re-enter valid"
                        + " information to proceed. Please note that telephone/mobile number and house number must"
                        + " match the information on record with Washington Gas."
                        + " For assistance, call 844-WASHGAS (844-927-4427).");
                }
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'bill_view_access',
                    eventAction: 'authorization_failure',
                    eventLabel: ''
                });
            }
        }, ModalServiceExt).fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                usSpinnerService.stop('spinner-1');
                apiUrl = providerData.ApiUrl;
                utilli.resolveServiceProviderApiDeffered(providerData.ApiUrl);
                initPage();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
            });

    function initPage() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEbill/HasUserViewBillAccess/',
            method: "GET",
            params: { token: $state.params.token }
        }).apiThen(function (data) {
            if (data.HasUserAccess) {
                $state.go("ViewBill", {
                    token: $stateParams.token,
                    emailId: $stateParams.emailId
                });
                return;
            }
            if (!data.HasHouseNumber) {
                $scope.step = 'missing-data';
                return;
            }
            $scope.step = 'verification';
            $scope.hasPhoneNumber = data.HasPhoneNumber;
        }, ModalServiceExt).fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.getTopWording = function(){
        return $scope.hasPhoneNumber
            ? _t('To ensure privacy of your account, we need to perform a one-time validation. ' +
                'Please enter house number of the property and either telephone or mobile phone number on record ' + 
                    'with Washington Gas to continue. Also provide the acknowledgment below.')
            : _t('To ensure privacy of your account, we need to perform a one-time validation. ' +
                'Please enter first name or last name, or name of organization, house number of service address ' +
                'and zip code of service address on record with Washington Gas to continue. ' +
                'Also provide the acknowledgment below.');
    }

    $scope.confirmWithoutPhoneNumber = function () {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEbill/ConfirmWithoutMobileNumber/',
            method: "POST",
            data: {
                token: $stateParams.token,
                phoneNumber: $scope.phoneNumber,
                consent: $scope.isPhoneNumberPreferred,
                name: $scope.name,
                houseNumber: $scope.houseNumber,
                zip: $scope.zip
            }
        }).apiThen(function () {
            $state.go("ViewBill", {
                token: $stateParams.token,
                emailId: $stateParams.emailId
            });
        }, ModalServiceExt).fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }
}]);

'use strict';
angular.module('utilliApp')
.controller('ViewBillController', ["$scope", "$state", "$http", "usSpinnerService", "$stateParams", "ModalServiceExt", "ServiceProvidersService", "$rootScope", function ($scope, $state, $http, usSpinnerService, $stateParams, ModalServiceExt,
    ServiceProvidersService, $rootScope) {

    $scope.isWebPushBellBoxVisible = function () {
        var result = (utilli.isFirefox && Notification.permission == "default")
            || (utilli.isSafari 
                && 'safari' in window 
                && 'pushNotification' in window.safari
                && utilli.getSafariPushNotificationPermissionData().permission === 'default');
        
        return result;
    };
    
    $rootScope.getBodyClass = function () {
        return { 'smart-pay': false };
    }

    var payload = utilli.getPayload($stateParams.token);
    $scope.isPayNowVisible = payload.IsPayNowVisible;
    usSpinnerService.spin('spinner-1');

    $scope.invoiceData = {
        contractAccountNumber: payload.AccountNumber,
        invoiceNumber: payload.InvoiceNumber
    };

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
        .then(function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            utilli.resolveServiceProviderApiDeffered(providerData.ApiUrl);
            initPage();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
        });

    $scope.payNow = function () {
        $state.go("SmartPayLayout.SmartPay", { 
            contractAccountNumber: $scope.invoiceData.AccountNumber,
            invoiceNumber: $scope.invoiceData.InvoiceNumber,
            token: $stateParams.token,
            emailId: $stateParams.emailId
        });
    }

    function showEbillEnroll() {
        var lastEbillEnrollMarketingMessageNum = localStorage.getItem('lastEbillEnrollMarketingMessageNum');
        if(lastEbillEnrollMarketingMessageNum) {
            lastEbillEnrollMarketingMessageNum++;
            if(lastEbillEnrollMarketingMessageNum > 4) {
                lastEbillEnrollMarketingMessageNum = 1;
            }
        }
        else {
            lastEbillEnrollMarketingMessageNum = 1;
        }
        localStorage.setItem("lastEbillEnrollMarketingMessageNum", lastEbillEnrollMarketingMessageNum);

        ModalServiceExt.showYesNoMessage('','',
            function () {
                var url = $state.href('EnrollEBillAfterNotification', 
                { 
                    token: $stateParams.token
                });
                window.open(url,'_blank');
            },
            null, true, null, lastEbillEnrollMarketingMessageNum
        );
    }

    function initPage() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEBill/HasUserViewBillAccess/',
            method: "GET",
            params: { 
                token: $stateParams.token,
                withInvoiceData: true
            }
        }).success(function (response) {
            if (response == undefined || response.HasErrors == undefined || !response.Data) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showInfo($scope._t("Service is unavailable now. Try again later."));
                return;
            }
            if (response.HasErrors) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showInfo(response.Errors[0]);
            }
            else {
                if (!response.Data.HasUserAccess){
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showInfo($scope._t("No authorization to view bill."));
                    return;
                }
                if (response.Data.NoPdfMessage) {
                    $scope.noPdfMessage = response.Data.NoPdfMessage;
                    usSpinnerService.stop('spinner-1');
                } else {
                    initIFrame(response.Data.BillPdfUrl);
                }
                $scope.invoiceData = response.Data.InvoiceData;
                $scope.loadingError = false;

                if(response.Data.ShowEnrollInEbill) {
                    usSpinnerService.stop('spinner-1');
                    showEbillEnroll();
                }
            }
            
        }).error(function () {
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
            usSpinnerService.stop('spinner-1');
        });
    }

    function initIFrame (billUrl) {
        var url = utilli.isMobileBrowserNotCordova()
            ? utilli.getRootUrl() + '/pdf/web/viewer.html?file=' + encodeURIComponent(billUrl)
            : billUrl;
        var iframe =  $('<iframe>', {
            src: url,
            frameborder: 0,
            style: "width:100%; height: calc(100% - 67px);"
        });
        iframe.load(function(){
            usSpinnerService.stop('spinner-1');
        });
        iframe.appendTo('#view-bill-wrp');
    }

    $scope.askPermissionsForWebPush = function () { 
        if ('safari' in window && 'pushNotification' in window.safari) {
            utilli.checkSafariRemotePermission($scope, apiUrl, $state.params.token);
        }
    }
}]);

'use strict';
angular.module('utilliApp').controller('InstallmentPlanController', ['$scope', '$http', '$state', 'usSpinnerService', "$location", "$window",
    'ServiceProvidersService', 'SmartPayLayoutService', 'ModalServiceExt', 'CommonDataService', '$resource', '$rootScope',
    function ($scope, $http, $state, usSpinnerService, $location, $window,
        ServiceProvidersService, SmartPayLayoutService, ModalServiceExt, CommonDataService, $resource, $rootScope) {
        var _t = $scope._t;
        SmartPayLayoutService.hideNoAdditionalCharge = true;
        utilli.savePayUrl($state.params.token);

        // bbp === true if we need to propose the user to enroll in installment plan before he can
        // proceed with enrollment in budget billing plan
        $scope.bbp = $state.params.bbp;
        $scope.isDirectEmail = $state.params.directSrc === 'directemail';
        $scope.consentCheckBox = true;

        var apiUrl = '';
        usSpinnerService.spin('spinner-1');
        ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
            function (providerData) {
                apiUrl = providerData.ApiUrl;
                initPage();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
            });

        function initPage() {
            var language = localStorage.getItem('language');
            if ($state.params.lang != undefined) {
                localStorage.setItem('language', $state.params.lang);
                language = $state.params.lang;
                utilli.registerLocalization($rootScope, $resource);
            }
            if (language == "es") {
                $scope.url = "./Images/smart-pay/Deferred-Payment-Spanish.jpg";

            }
            else {
                $scope.url = "./Images/smart-pay/deferred-payments-banner.jpg";

            }
            $rootScope.$broadcast("languageChangedOutside", $state.params.lang);
            $rootScope.$broadcast("enableLanguageSwitch", true);

            $rootScope.$on("languageChanged", function (evt, data) {
                if (data == "es") {
                    $scope.url = "./Images/smart-pay/Deferred-Payment-Spanish.jpg";
                }
                else {
                    $scope.url = "./Images/smart-pay/deferred-payments-banner.jpg";
                }
                var requestParams = {
                    token: $state.params.token
                };
                requestParams.source = $state.params.src ? $state.params.src : '';
                if ($state.params.directSrc)
                    requestParams.source = $state.params.directSrc;
                requestParams.communicationType = $state.params.ct ? $state.params.ct : '';
                $http({
                    url: apiUrl + 'api/InstallmentPlan/GetInstallmentPlan/',
                    method: "GET",
                    params: requestParams
                })
                    .apiThen(function (data) {
                        if (data.NudgeLink) {
                            $window.location.href = data.NudgeLink;
                            return;
                        }
                        $scope.months = data.PaymentsByMonth;
                        $scope.monthCount = $scope.months.length;
                        if ($scope.months.length > 0) {
                            $scope.monthlyPayment = $scope.months[0].AmountString;
                            $scope.finalPayment = $scope.months[$scope.months.length - 1].AmountString;
                        }
                        $scope.requestToPayMessage = _t("Request to pay your balance in %month_count% monthly installments as"
                            + " per the below schedule.")
                            .replace('%month_count%', $scope.months.length);
                        $scope.contractAccountNumber = data.ContractAccountNumber;
                        $scope.accountBalance = data.AccountBalance;
                        $scope.accountBalanceString = data.AccountBalanceString;
                        $scope.step = 'enroll';
                    }, function (e) {
                        $scope.step = 'error';
                    })
                    .fixedFinally(function () {
                        usSpinnerService.stop('spinner-1');
                    });
            });
            var requestParams = {
                token: $state.params.token
            };
            requestParams.source = $state.params.src ? $state.params.src : '';
            if ($state.params.directSrc)
                requestParams.source = $state.params.directSrc;
            requestParams.communicationType = $state.params.ct ? $state.params.ct : '';
            $http({
                url: apiUrl + 'api/InstallmentPlan/GetInstallmentPlan/',
                method: "GET",
                params: requestParams
            })
                .apiThen(function (data) {
                    if (data.NudgeLink) {
                        $window.location.href = data.NudgeLink;
                        return;
                    }
                    $scope.months = data.PaymentsByMonth;
                    $scope.monthCount = $scope.months.length;
                    if ($scope.months.length > 0) {
                        $scope.monthlyPayment = $scope.months[0].AmountString;
                        $scope.finalPayment = $scope.months[$scope.months.length - 1].AmountString;
                    }
                    $scope.requestToPayMessage = _t("Request to pay your balance in %month_count% monthly installments as"
                        + " per the below schedule.")
                        .replace('%month_count%', $scope.months.length);
                    $scope.contractAccountNumber = data.ContractAccountNumber;
                    $scope.accountBalance = data.AccountBalance;
                    $scope.accountBalanceString = data.AccountBalanceString;
                    $scope.step = 'enroll';
                }, function (e) {
                    $scope.step = 'error';
                })
                .fixedFinally(function () {
                    usSpinnerService.stop('spinner-1');
                });
        }

        $scope.continue = function () {
            if (!$scope.consentCheckBox) {
                ModalServiceExt.showError(_t('Please confirm your enrollment by checking the checkbox.'));
                return;
            }
            usSpinnerService.spin('spinner-1');
            var requestParams = {
                token: $state.params.token
            };
            if ($state.params.src)
                requestParams.source = $state.params.src;
            if ($state.params.directSrc)
                requestParams.source = $state.params.directSrc;
            if ($state.params.ct)
                requestParams.communicationType = $state.params.ct;
            $http({
                url: apiUrl + 'api/InstallmentPlan/SetInstallmentPlan/',
                method: "POST",
                data: requestParams
            })
                .apiThen(function (data) {
                    if ($scope.bbp) {
                        ModalServiceExt.showInfo(_t('You are successfully enrolled in Deferred Payment Program.'), function () {
                            var params = {
                                token: $state.params.token
                            };
                            // if the user navigated to this page with tracking params then pass them to BBP page
                            if ($state.params.src)
                                params.src = $state.params.src;
                            if ($state.params.ct)
                                params.ct = $state.params.ct;
                            if ($state.params.directSrc)
                                params.directSrc = $state.params.directSrc;
                            $state.go('SmartPayLayout.BudgetBillingWglcx', params);
                            return;
                        });
                        return;
                    }
                    $scope.step = 'thank-you';
                }, ModalServiceExt)
                .fixedFinally(function () {
                    usSpinnerService.stop('spinner-1');
                });
        }
    }]);
    app.filter('titleCase', function () {
        return function (input) {
            input = input || '';
            return input.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        };
    })
'use strict';
angular.module('utilliApp').controller('BudgetBillingWglcxController', ["$scope", "$location", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", "TimeService", "$window", "$rootScope", "$resource", function ($scope, $location, $http, $state, usSpinnerService,
    ModalServiceExt, ServiceProvidersService, SmartPayLayoutService, TimeService, $window, $rootScope, $resource) {
    var _t = $scope._t;
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    utilli.savePayUrl($state.params.token);

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
        function (providerData) {
            apiUrl = providerData.ApiUrl;
            initPage();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
        });

    function initPage() {

        var language = localStorage.getItem('language');
            if ($state.params.lang != undefined) {
                localStorage.setItem('language', $state.params.lang);
                language = $state.params.lang;
                utilli.registerLocalization($rootScope, $resource);
            }
            if (language == "es") {
                $scope.url = "./Images/smart-pay/WG.SpanishHeaders2.jpg";

            }
            else {
                $scope.url = "./Images/smart-pay/BBP_confirmation_banner.jpg";

            }
            $rootScope.$broadcast("languageChangedOutside", $state.params.lang);
            $rootScope.$broadcast("enableLanguageSwitch", true);

            $rootScope.$on("languageChanged", function (evt, data) {
                if (data == "es") {
                    $scope.url = "./Images/smart-pay/WG.SpanishHeaders2.jpg";
                }
                else {
                    $scope.url = "./Images/smart-pay/BBP_confirmation_banner.jpg";
                }
            });
        var requestParams = {
            token: $state.params.token
        };
        // directSrc - we use this parameter when we come to this page directly from
        // an email or the SmartPage page. In this case we add a visit into the visit tracking table.
        // We use src and we don't use directSrc when we come from the Budget page and we don't add visit into 
        // tracking table because it was already added on the Budget page.
        // 'src' param we use for tracking enrollments.
        requestParams.src = $state.params.directSrc ? $state.params.directSrc : '';
        $scope.canGoBack = $state.params.directSrc && $state.params.directSrc != 'SmartPay' ? false : true;
        if($state.params.ct)
            requestParams.communicationType = $state.params.ct;

        $http({
            url: apiUrl + 'api/BudgetBilling/GetBudgetBillingWglcx/',
            method: "POST",
            data: requestParams
        })
            .apiThen(function (data) {
                if (data.NudgeLink) {
                    $window.location.href = data.NudgeLink;
                    return;
                }
                if (data.ShouldRedirectToIpPage){

                    var params = {
                        token: data.InstallmentPlanToken,
                        bbp: true
                    };
                    if ($state.params.src)
                        params.src = $state.params.src;
                    if ($state.params.ct)
                        params.ct = $state.params.ct;
                    if ($state.params.directSrc)
                        params.directSrc = $state.params.directSrc;

                    $state.go('SmartPayLayout.InstallmentPlan', params);
                    return;
                }
                $scope.contractAccountNumber = data.ContractAccountNumber;
                $scope.budgetEstimate = utilli.formatCurrency(data.BudgetEstimate).replace(' ', '');
                $scope.months = data.Items;
                $scope.months.forEach(function(m) {
                    m.BillAmountString = utilli.formatCurrency(m.BillAmount).replace(' ', '');
                    m.UsageString = utilli.formatNumber(m.Usage);
                    m.UsageFromDateString = TimeService.dateFormat(m.UsageFromDate, 'mmm dd, yyyy');
                    m.UsageToDateString = TimeService.dateFormat(m.UsageToDate, 'mmm dd, yyyy');
                });
                if (data.Items && data.Items.length) {
                    var firstBill = _.min(data.Items, function (bill) { return new Date(bill.UsageFromDate); });
                    var lastBill = _.max(data.Items, function (bill) { return new Date(bill.UsageToDate); });
                    $scope.fromTo = TimeService.dateFormat(firstBill.UsageFromDate, 'mmm dd, yyyy') + ' - '
                        + TimeService.dateFormat(lastBill.UsageToDate, 'mmm dd, yyyy');
                    var maxBill = _.max($scope.months, function (bill) { return bill.BillAmount; });
                    $scope.maxBillString = utilli.formatCurrency(maxBill.BillAmount).replace(' ', '');
                    var avgBill = _.reduce($scope.months, function (memo, v) {
                            return memo + v.BillAmount;
                        }, 0) / $scope.months.length;
                    $scope.avgBillString = utilli.formatCurrency(avgBill).replace(' ', '');
                } else {
                    $scope.fromTo = 'N/A';
                    $scope.maxBillString = 'N/A';
                    $scope.avgBillString = 'N/A';
                }
                $scope.step = 'enroll';
            }, function(e){
                $scope.step = 'error';
                
            })
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.goBack = function() {
        $window.history.back();
    }

    $scope.enroll = function(){
        var requestParams = { 
            token: $state.params.token, 
            enroll: true 
        };
        if ($state.params.src)
            requestParams.trackingSrc = $state.params.src;
        if ($state.params.directSrc)
            requestParams.trackingSrc = $state.params.directSrc;
        if($state.params.ct)
            requestParams.trackingCt = $state.params.ct;
    
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/BudgetBilling/SetBudgetBillingPlanWglcx/',
            method: "POST",
            data: requestParams
        })
            .apiThen(function () {
                $scope.step = 'thank-you';
            }, ModalServiceExt)
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.unenroll = function () {
        usSpinnerService.spin('spinner-1');
        var requestParams = { 
            token: $state.params.token, 
            enroll: false 
        };
        if ($state.params.src)
            requestParams.trackingSrc = $state.params.src;
        if ($state.params.directSrc)
            requestParams.trackingSrc = $state.params.directSrc;
        if($state.params.ct)
            requestParams.trackingCt = $state.params.ct;
    
        $http({
            url: apiUrl + 'api/BudgetBilling/SetBudgetBillingPlanWglcx/',
            method: "POST",
            data: requestParams
        })
            .apiThen(function () {
                $scope.step = 'thank-you-unenrolled';
            }, ModalServiceExt)
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

}]);
'use strict';
angular.module('utilliApp').controller('BudgetBillingWglcxUnenrollmentController', ["$scope", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", function ($scope, $http, $state, usSpinnerService,
    ModalServiceExt, ServiceProvidersService, SmartPayLayoutService) {
    var _t = $scope._t;
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    utilli.savePayUrl($state.params.token);

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
        function (providerData) {
            apiUrl = providerData.ApiUrl;
            unenroll();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
        });

    function unenroll() {
        usSpinnerService.spin('spinner-1');
        var requestParams = { 
            token: $state.params.token, 
            enroll: false 
        };
        if($state.params.src)
            requestParams.trackingSrc = $state.params.src;
        if($state.params.ct)
            requestParams.trackingCt = $state.params.ct;
    
        $http({
            url: apiUrl + 'api/BudgetBilling/SetBudgetBillingPlanWglcx/',
            method: "POST",
            data: requestParams
        })
            .apiThen(function () {
                $scope.step = 'thank-you-unenrolled';
            }, function(e) {
                console.error(e);
                $scope.step = 'error';
            })
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }
}]);
'use strict';
angular.module('utilliApp').controller('BudgetController', ["$scope", "$location", "$window", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", "$rootScope", "$resource", function ($scope, $location, $window, $http, $state, usSpinnerService,
    ModalServiceExt, ServiceProvidersService, SmartPayLayoutService, $rootScope, $resource) {

    SmartPayLayoutService.hideNoAdditionalCharge = true;
    utilli.savePayUrl($state.params.token);
    $scope.accountMaxLength = Config.contractAccountMaxLength;
    var _t = $scope._t;
    
    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    var isProd = DeploymentSettings.isProd();
    var baseUrl = "https://nudgeqa.washgas.com/";
    if (isProd) {
        baseUrl = "https://nudge.washgas.com/";
    }
    baseUrl += "budget";
    var searchObject = $location.search();
    console.log(searchObject);
    if (searchObject.src) {
        baseUrl += "?source=" + searchObject.src;
    }
    if (searchObject.src && searchObject.lang) {
        baseUrl += "&lang=" + searchObject.lang;
    }
    $window.location.href = baseUrl;
    return;

    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
        function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            logTrackingSrc();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
        });


    $scope.accNo=_t('Enter Account Number');
    $scope.hNo=_t('Enter House Number');
    if ($state.params.lang != undefined) {
        localStorage.setItem('language', $state.params.lang);

        utilli.registerLocalization($rootScope, $resource);
        if($state.params.lang == "es")
        {
            $scope.accNo='El número de cuenta';
            $scope.hNo='El número de residencia';
        }
        else
        {
            $scope.accNo='Enter Account Number';
            $scope.hNo='Enter House Number';
        }
    }
    $rootScope.$on("languageChanged", function (evt, data) {
        utilli.registerLocalization($rootScope, $resource);
        if(data == "es")
        {
            $scope.accNo='El número de cuenta';
            $scope.hNo='El número de residencia';
        }
        else
        {
            $scope.accNo='Enter Account Number';
            $scope.hNo='Enter House Number';
        }
    });
    
    $rootScope.$broadcast("languageChangedOutside", $state.params.lang);
    $rootScope.$broadcast("enableLanguageSwitch", true);

    $scope.submit = function () {
        $scope.bbEnrollForm.$submitted = true;
        if (!$scope.bbEnrollForm.$valid) {
            return;
        }


        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/AuthorizeUser',
            data: {
                accountNumber: $scope.contractAccountNumber,
                houseNumber: $scope.houseNumber
            }
        })
            .success(function (response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response,
                    ModalServiceExt,
                    function () {
                        var params = {
                            token: response.Data.Token
                        };
                        if ($state.params.src)
                            params.src = $state.params.src;
                        if ($state.params.ct)
                            params.ct = $state.params.ct;
                        if (response.Data.ShouldRedirectToInstallmentPlan) {
                            params.bbp = true;
                            $state.go('SmartPayLayout.InstallmentPlan', params);
                        }
                        else {
                            $state.go('SmartPayLayout.BudgetBillingWglcx', params);
                        }
                    });
            })
            .error(function (error) {
                console.log(error);
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
    }

    function logTrackingSrc() {
        if (!$state.params.src)
            return;

        var requestParams = {
            src: $state.params.src
        };
        if ($state.params.ct)
            requestParams.communicationType = $state.params.ct;

        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/LogTrackingSrc',
            data: requestParams
        })
            .success(function () {
                //...
            })
            .error(function (error) {
                console.log(error);
            });
    }
}]);
'use strict';
angular.module('utilliApp').controller('AgentPaymentsController',
    ["$scope", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", "$rootScope", "$resource", "$sce", function ($scope, $http, $state, usSpinnerService, ModalServiceExt, ServiceProvidersService, SmartPayLayoutService, $rootScope, $resource, $sce) {

    var apiUrl = '';

    $scope.phoneNumberMask = Config.phoneNumberMask;
    $scope.contractAccountMask = Config.contractAccountMask;
    $scope.isAccountFixed = false;
    SmartPayLayoutService.hideNoAdditionalCharge = true;
    $scope.accountMaxLength = Config.contractAccountMaxLength;
    var _t = $scope._t;

    var paymentModel = {}
    $scope.paymentModel = paymentModel;
    paymentModel.paymentGuid = null;
    paymentModel.paymentTime = null;
    paymentModel.paymentPage = null;
    paymentModel.amount = null;
    paymentModel.status = null;
    paymentModel.failureDescription = null;
    paymentModel.remitanceId = null;
    paymentModel.url = null;

    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getCurrentProvider()
        .then(function (providerData) {
            apiUrl = providerData.ApiUrl;
            init();
        })
        .catch(function () {
            ModalServiceExt.showServerError();
            utilli.rejectServiceProviderApiDeffered();
            usSpinnerService.stop('spinner-1');
        })
        .finally(function () {
        });


    function init() {
        $scope.installationId = $state.params.installationId;
        $scope.isAccountFixed = $state.params.installationId!= undefined;
        if ($scope.isAccountFixed) {
            getAccountDetails();
        } else {
            usSpinnerService.stop('spinner-1');
        }
    }

        var getAccountDetails = function () {
            let url = apiUrl + "api/CommunicationTypes/GetAccountEmailAndPhone/?installationId=";
            url += $scope.installationId;
            usSpinnerService.spin('spinner-1');
            $http.get(url)
                .success(function (response) {
                    usSpinnerService.stop('spinner-1');
                    if (response.HasErrors) {
                        ModalServiceExt.showError(response.Errors[0]);
                        $scope.isAccountFixed = false;
                    }
                    else if (response.Data.AccountNumber === '') {
                        $scope.isAccountFixed = false;
                    }
                    else {
                        $scope.contractAccountNumber = response.Data.AccountNumber;
                        $scope.email = response.Data.Email;
                        $scope.phoneNumber = response.Data.PhoneNumber;
                    }
                }, ModalServiceExt)
                .error(function (e) {
                    console.log(e);
                    usSpinnerService.stop('spinner-1');
                });
        }

    $scope.sendEmail = function () {
        if (!IsAccountValid())
            return;
        if ($scope.email === '' || $scope.email == null) {
            ModalServiceExt.showError(_t('Please, fill the Email Address first'));
            return;
        }
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/SendAgentPaymentNotification',
            data: {
                accountNumber: $scope.contractAccountNumber,
                email: $scope.email
            }
        })
            .apiThen(function (response) {
                console.log(response);
                ModalServiceExt.showInfo(_t("Email was sent successfully to " + $scope.email));
            }, ModalServiceExt)
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

    $scope.sendSms = function () {
        if (!IsAccountValid())
            return;
        if ($scope.phoneNumber === '' || $scope.phoneNumber == null) {
            ModalServiceExt.showError(_t('Please, fill the Phone Number first'));
            return;
        }

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/SendAgentPaymentNotification',
            data: {
                accountNumber: $scope.contractAccountNumber,
                phoneNumber: $scope.phoneNumber
            }
        })
            .apiThen(function (response) {
                console.log(response);
                ModalServiceExt.showInfo(_t("SMS was sent successfully to +1" + $scope.phoneNumber));
            }, ModalServiceExt)
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

    const IsAccountValid = function () {
        $scope.makePayForm.$setSubmitted();
        if(!$scope.makePayForm.$valid) {
            window.scroll(0,0)
            return false;
        }
        return true
    }

    $scope.getLastPayment = function () {
        if (!IsAccountValid()) {
            return;
        }

        paymentModel.url = null;
        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/GetLastPayment',
            data: {
                accountNumber: $scope.contractAccountNumber
            }
        })
            .apiThen(function (response) {
                usSpinnerService.stop('spinner-1');
                paymentModel.amount = response.Amount;
                paymentModel.paymentPage = response.PaymentPage;
                paymentModel.paymentTime = response.PaymentTime;
                paymentModel.remitanceId = response.RemitanceId;
                paymentModel.status = response.Status;
                paymentModel.failureDescription = response.FailureDescription;
                paymentModel.paymentGuid = response.PaymentGuid;
            }, ModalServiceExt)
            .fixedFinally(function () {
                usSpinnerService.stop('spinner-1');
            });
    }

        $scope.generatePaymentQr = function () {
            if (!IsAccountValid()) {
                return;
            }

            const reader_data = new FileReader();
            reader_data.onloadend = function () {
                paymentModel.url = $sce.trustAsResourceUrl(reader_data.result);
                usSpinnerService.stop('spinner-1');
                $scope.$apply();
            };

            usSpinnerService.spin('spinner-1');
            paymentModel.paymentGuid = null;
            let url = apiUrl + "api/CommunicationTypes/GetAgentPaymentQrLink/?contractAccountNumber=";
            url += $scope.contractAccountNumber;
            let config = {responseType: "blob"};
            $http.get(url, config).success(function (response) {
                reader_data.readAsDataURL(response);
            }).error(function (error) {
                error.data.text().then(function (text) {
                    ModalServiceExt.showError(text);
                })
                usSpinnerService.stop('spinner-1');
            });
        }
}]);
'use strict';
angular.module('utilliApp').controller('DppController', ["$scope", "$location", "$window", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", "$rootScope", "$resource", function ($scope, $location, $window, $http, $state, usSpinnerService,
    ModalServiceExt, ServiceProvidersService, SmartPayLayoutService,$rootScope,$resource) {

    SmartPayLayoutService.hideNoAdditionalCharge = true;
    utilli.savePayUrl($state.params.token);
    $scope.accountMaxLength = Config.contractAccountMaxLength;

    var _t = $scope._t;
    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    var isProd = DeploymentSettings.isProd();
    var baseUrl = "https://nudgeqa.washgas.com/";
    if (isProd) {
        baseUrl = "https://nudge.washgas.com/";
    }
    baseUrl += "dpp";
    var searchObject = $location.search();
    console.log(searchObject);
    if (searchObject.src) {
        baseUrl += "?source=" + searchObject.src;
    }
    if (searchObject.src && searchObject.lang) {
        baseUrl += "&lang=" + searchObject.lang;
    }
    $window.location.href = baseUrl;
    return;

    var language = localStorage.getItem('language');
    $scope.accNo=_t('Enter Account Number');
    $scope.hNo=_t('Enter House Number');
    if ($state.params.lang != undefined) {
        localStorage.setItem('language', $state.params.lang);
        language = $state.params.lang;
        utilli.registerLocalization($rootScope, $resource);
        
    }
    if (language == "es") {
        $scope.url = "./Images/smart-pay/Deferred-Payment-Spanish.jpg";
        $scope.accNo='El número de cuenta';
        $scope.hNo='El número de residencia';
    }
    else {
        $scope.url = "./Images/smart-pay/deferred-payments-banner.jpg";
        $scope.accNo='Enter Account Number';
        $scope.hNo='Enter House Number';
    }
    $rootScope.$broadcast("languageChangedOutside", $state.params.lang);
    $rootScope.$broadcast("enableLanguageSwitch", true);

    $rootScope.$on("languageChanged", function (evt, data) {
        if (data == "es") {
            $scope.url = "./Images/smart-pay/Deferred-Payment-Spanish.jpg";
            $scope.accNo='El número de cuenta';
            $scope.hNo='El número de residencia';
        }
        else {
            $scope.url = "./Images/smart-pay/deferred-payments-banner.jpg";
            $scope.accNo='Enter Account Number';
           $scope.hNo='Enter House Number';
        }
    });
    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
        function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            logTrackingSrc();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            ModalServiceExt.showError($scope._t("Service is unavailable now. Try again later."));
        });

    $scope.submit = function () {
        $scope.bbEnrollForm.$submitted = true;
        if (!$scope.bbEnrollForm.$valid) {
            return;
        }

        usSpinnerService.spin('spinner-1');
        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/AuthorizeUser',
            data: {
                accountNumber: $scope.contractAccountNumber,
                houseNumber: $scope.houseNumber
            }
        })
            .success(function (response) {
                usSpinnerService.stop('spinner-1');
                utilli.handleAjaxResponse(response,
                    ModalServiceExt,
                    function () {
                        var params = {
                            token: response.Data.Token
                        };
                        if ($state.params.src)
                            params.src = $state.params.src;
                        if ($state.params.ct)
                            params.ct = $state.params.ct;
                        if (response.Data.ShouldRedirectToInstallmentPlan) {
                            params.bbp = true;
                            params.directSrc="directemail";
                            $state.go('SmartPayLayout.InstallmentPlan', params);
                        }
                        else {
                            $state.go('SmartPayLayout.BudgetBillingWglcx', params);
                        }
                    });
            })
            .error(function (error) {
                console.log(error);
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
    }

    function logTrackingSrc() {
        if (!$state.params.src)
            return;

        var requestParams = {
            src: $state.params.src
        };
        if ($state.params.ct)
            requestParams.communicationType = $state.params.ct;

        $http({
            method: 'POST',
            url: apiUrl + 'api/BudgetBilling/LogTrackingSrc',
            data: requestParams
        })
            .success(function () {
                //...
            })
            .error(function (error) {
                console.log(error);
            });
    }
}]);
'use strict';
angular.module('utilliApp').controller('BudgetReportController', ["$scope", "$window", "usSpinnerService", "ServiceProvidersService", function ($scope, $window, usSpinnerService,
    ServiceProvidersService) {
    
    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider).then(
        function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            $window.location.href = apiUrl + 'api/BudgetBilling/GetExcelReport';
        },
        function (e) {
            usSpinnerService.stop('spinner-1');
            console.log(e);
        });
}]);
'use strict';
angular.module('utilliApp').controller('CustomerValidationController', ["$scope", "$http", "$state", "usSpinnerService", "ModalServiceExt", "ServiceProvidersService", "SmartPayLayoutService", "$stateParams", "CustomerValidationService", function ($scope, $http, $state, usSpinnerService,
    ModalServiceExt, ServiceProvidersService, SmartPayLayoutService, $stateParams, CustomerValidationService) {
    var _t = $scope._t;
    SmartPayLayoutService.hideNoAdditionalCharge = true;

    $scope.model = CustomerValidationService;
    var apiUrl = '';
    var providerDataPromise = ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider);
    $scope.model.step = $scope.model.step ? $scope.model.step : 'validation';

    $scope.payNow = function () {
        $state.go("SmartPayLayout.SmartPay", {
            token: $scope.model.smartPayToken
        });
    }

    $scope.next = function(){
        $scope.customerValidationForm.$submitted = true;
        if (!$scope.customerValidationForm.$valid){
            return;
        }
        if ($scope.model.step != 'validation'){
            ModalServiceExt.showError('Please choose the next step or reload the page.');
            return;
        }
        usSpinnerService.spin('spinner-1');
        providerDataPromise.then(
            function (providerData) {
                apiUrl = providerData.ApiUrl;
                validateCustomer();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showError(_t("Service is unavailable now. Try again later."));
            }
        );
    }

    function validateCustomer(){
        $http({
            url: apiUrl + 'api/CustomerValidation/ValidateCustomer/',
            method: "POST",
            data: {
                houseNumber: $scope.model.houseNumber,
                token: $stateParams.token
            }
        }).apiThen(function (validationResult) {
            if (!validationResult.IsHouseNumberValid){
                ModalServiceExt.showError(_t("Wrong house number. Please try again."));
                return;
            }
            $scope.model.smartPayToken = validationResult.SmartPayToken;
            if (!validationResult.IsEligibleForInstallmentPlan) {
                $scope.payNow();
                return;
            }
            $scope.model.step = 'choose-next-step';
            $scope.model.installmentPlanToken = validationResult.InstallmentPlanToken;
        }, ModalServiceExt).fixedFinally(function () {
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.installmentPlan = function(){
        $state.go("SmartPayLayout.InstallmentPlan", {
            token: $scope.model.installmentPlanToken
        });
    }
}]);
angular.module('utilliApp')
    .service('CustomerValidationService', function () {
        return {};
    });

'use strict';
angular.module('utilliApp')
.controller('NotMeController', ['$scope', '$http', '$state', 'usSpinnerService',
        'ServiceProvidersService',
function ($scope, $http, $state, usSpinnerService, ServiceProvidersService) {
    var _t = $scope._t;

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
            .then(function (providerData) {
                usSpinnerService.stop('spinner-1');
                apiUrl = providerData.ApiUrl;
                initPage();
            },
            function () {
                usSpinnerService.stop('spinner-1');
                
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
            });

    function initPage() {
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/WglEbill/CorrectDataClientEBillInfo/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            $scope.isDataLoaded = true;
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            else  {
                $scope.loadingError = null;
            }
            
        }).error(function () {
            $scope.isDataLoaded = true;
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

}]);

'use strict';
angular.module('utilliApp')
.controller('EnrollEBillController', ['$scope', '$window', '$http', '$state', 'usSpinnerService',
    'ServiceProvidersService', 'ModalServiceExt',
    function ($scope, $window, $http, $state, usSpinnerService, ServiceProvidersService, ModalServiceExt) {
        var _t = $scope._t;

    $scope.status = _t('loading...');
    $scope.emailPattern = Config.emailPattern;
    utilli.savePayUrl($state.params.token);
    $scope.unenrollAttemptAvailable = true;

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
        .then(function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            init();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
        });
    
    function init(){
        if (!$state.params.contractAccountNumber){
            enroll();
            return;
        }
        if ($state.params.token == "qr"){
            $scope.page = 'qr';
            $scope.qrUrl = apiUrl + 'api/CommunicationTypes/GetEBillEmailVerificationQr/?contractAccountNumber=' 
                + $state.params.contractAccountNumber;
            return;
        }
        $scope.page = 'collectEmail';
        $scope.explanation = _t('In order to enroll in EBill for contract account number %contractAccountNumber%'
            + ' please provide your email address below.')
            .replace('%contractAccountNumber%', $state.params.contractAccountNumber);
    }

    $scope.submit = function(){
        $scope.buttonPressed = true;
        if (!$scope.collectEmailForm.$valid || $scope.email != $scope.repeatedEmail)
            return;

        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/SendEBillVerificationEmail/',
            method: "POST",
            data: { token: $state.params.token, email: $scope.email }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');
            if (response == undefined || response.HasErrors == undefined) {
                ModalServiceExt.showServerError();
                return;
            }
            if (response.HasErrors) {
                ModalServiceExt.showError(response.Errors[0]);
            }
            else {
                ModalServiceExt.showInfo(_t('Last step: We have send you an email. Please verify it and you will be '
                 + ' enrolled in e-bill automatically.'), function(){
                        //window.close();
                        $state.go("TopMenuLayout.SmartPay.Step2");
                });
            }
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

    function enroll() {
        $scope.page = 'enroll';
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/EnrollEBill/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            if (response.Data.NudgeLink) {
                $window.location.href = response.Data.NudgeLink;
                return;
            }
            if(response.Data.EnrolledFlag) {
                $scope.enrolledSuccessfully = true;
            }
            else {
                $scope.status = response.Data.Message;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.unenroll = function () {
        $scope.page = 'unEnroll';
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/UnenrollEBill/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            $scope.unenrollAttemptAvailable = false;
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            if(!response.Data.EnrolledFlag) {
                $scope.unenrolledSuccessfully = true;
            }
            else {
                $scope.status = response.Data.Message;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.enrollInEbill = function() {
        enroll();
    }
}]);

'use strict';
angular.module('utilliApp')
.controller('EnrollEBillAfterNotificationController', ['$scope', '$http', '$state', 'usSpinnerService',
    'ServiceProvidersService', 'ModalServiceExt', '$rootScope',
    function ($scope, $http, $state, usSpinnerService, ServiceProvidersService, ModalServiceExt, $rootScope) {
        var _t = $scope._t;

    $scope.unenrollAttemptAvailable = true;

    $rootScope.getBodyClass = function () {
        return { 'smart-pay': false };
    }

    $scope.status = _t('loading...');
    $scope.emailPattern = Config.emailPattern;

    var apiUrl = '';
    usSpinnerService.spin('spinner-1');
    ServiceProvidersService.getProvider(DeploymentSettings.currentServiceProvider)
        .then(function (providerData) {
            usSpinnerService.stop('spinner-1');
            apiUrl = providerData.ApiUrl;
            init();
        },
        function () {
            usSpinnerService.stop('spinner-1');
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
        });
    
    function init(){
        enroll();

        var payload = utilli.getPayload($state.params.token);
        $scope.isPayNowVisible = payload.IsPayNowVisible;
        usSpinnerService.spin('spinner-1');
    
        $scope.invoiceData = {
            contractAccountNumber: payload.AccountNumber,
            invoiceNumber: payload.InvoiceNumber
        };

        $scope.email = payload.Email;

        usSpinnerService.stop('spinner-1');
    }

    function enroll() {
        $scope.page = 'enroll';
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/EnrollEBill/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            if(response.Data.EnrolledFlag) {
                $scope.enrolledSuccessfully = true;
            }
            else {
                $scope.status = response.Data.Message;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.payNow = function () {
        $state.go("SmartPayLayout.SmartPay", { 
            contractAccountNumber: $scope.invoiceData.AccountNumber,
            invoiceNumber: $scope.invoiceData.InvoiceNumber,
            token: $state.params.token,
            emailId: $scope.email
        });
    }

    
    $scope.unenroll = function () {
        $scope.page = 'unEnroll';
        usSpinnerService.spin('spinner-1');
        $http({
            url: apiUrl + 'api/CommunicationTypes/UnenrollEBill/',
            method: "POST",
            data: { '': $state.params.token }
        }).success(function (response) {
            $scope.unenrollAttemptAvailable = false;
            usSpinnerService.stop('spinner-1');

            if (response == undefined || response.HasErrors == undefined) {
                $scope.loadingError = _t("Service is unavailable now. Try again later.");
                return;
            }
            if (response.HasErrors) {
                $scope.loadingError = response.Errors[0];
            }
            if(!response.Data.EnrolledFlag) {
                $scope.unenrolledSuccessfully = true;
            }
            else {
                $scope.status = response.Data.Message;
            }
            
        }).error(function () {
            $scope.loadingError = _t("Service is unavailable now. Try again later.");
            usSpinnerService.stop('spinner-1');
        });
    }

    $scope.enrollInEbill = function() {
        enroll();
    }

}]);

'use strict';
angular.module('utilliApp')
.controller('WelcomeWglcxController', ['$scope', '$timeout', '$state',
function ($scope, $timeout, $state) {
    $scope.eserviceUrl = 'http://eservice.washgas.com/';
    $scope.currentPageUrl = window.location.href;
    $scope.intervalInSeconds = 10;

    if (utilli.goesToDefaultPage($state)) 
        return;

    var timer = $timeout(function(){
        utilli.setWindowLocation($scope.eserviceUrl);
    }, $scope.intervalInSeconds * 1000 );

    $scope.$on('$locationChangeStart', function( event ) {
        $timeout.cancel(timer);
    });
}]);
angular.module('utilliApp')
    .service('BillsService', function() {

        var currentBill = null;

        var getCurrentBill = function() {
            return currentBill;
        }

        var setCurrentBill = function(bill) {
            currentBill = bill;
        }

        return {
            getCurrentBill: getCurrentBill,
            setCurrentBill: setCurrentBill,
        };

    });

'use strict';
angular.module('utilliApp')
    .service('CustomerInfoDataService', ['$http', '$q', '$state', function ($http, $q, $state) {
        var cache = null;
        var getCustomerInfoData = function () {
            var deferred = $q.defer();

            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            var securityToken = localStorage.getItem('SecurityToken');
            var apiUrl = localStorage.getItem('ApiUrl');
            if (!apiUrl || !securityToken || !accountNumber)
            {
                $state.goToSignIn();
                return deferred.promise;
            }

            var params = { contractAccountNumber: accountNumber }
            var url = apiUrl + 'api/Customer/GetCustomerInfo/';
            $http({
                url: url,
                method: "GET",
                params: params
            }).success(function (data) {
                if (!data) {
                    deferred.reject(utilli.errors.serverErrorMessage);
                    return;
                }
                if (data.ERROR_LIST && data.ERROR_LIST.length > 0) {
                    deferred.reject(data.ERROR_LIST[0].Message);
                    return;
                }
                deferred.resolve(data);
                cache = data;
            }).error(function (errorInfo) {
                deferred.reject(errorInfo);
            });
            return deferred.promise;
        }

        return {
            getCustomerInfoData: getCustomerInfoData,
            /**
            * Cached data can be used on pages where it's not required to show fields that can be changed.
            * For example, service address or utillity type can't be changed, 
            * hence we can use cached data for this cases.
            */
            getCachedData: function () {
                // cache can be empty if user pressed F5
                if (!cache) {
                    return this.getCustomerInfoData();
                }
                var deferred = $q.defer();
                deferred.resolve(cache);
                return deferred.promise;
            }
        };
    }]);
angular.module('utilliApp')
    .service('AddPropertyService', function () {

    var currentProperty = null;

    var getCurrentProperty = function () {
        return currentProperty;
    }

    var setCurrentProperty = function (property) {
        currentProperty = property;
    }

    return {
        getCurrentProperty: getCurrentProperty,
        setCurrentProperty: setCurrentProperty
    };

});
angular.module('utilliApp')
    .service('ModalServiceExt', ['ModalService', '$window', '$rootScope', '$q', '$timeout',
    function (ModalService, $window, $rootScope, $q, $timeout) {
        var messagesQueue = [];

        var child = $rootScope.$new();
        child.test = '1234';
        var iconError = 'icon-exclamation-triangle';
        var iconInfo = 'icon-info-circle';
        var iconQuestion = 'icon-question-circle';
        var iconWarning = 'icon-exclamation-circle';

        $rootScope.pinFields = {
            p1:'',p2:'',p3:'',p4:'',cp1:'',cp2:'',cp3:'',cp4:'',pinOtp:''
        }
        $rootScope.pinError = false;
        $rootScope.cPinError = false;
        $rootScope.compareError = false;
        $rootScope.optError = "";
        $rootScope.resetTimeOut = 31;
        $rootScope.canShowTimer = false;

        var messageTypes = {
            yesNo: 'yesNo',
            ok: 'ok',
            loginRequired: 'loginRequired',
            mergeTagDialog: 'mergeTagDialog'
        }

        function addMessageToQueue(message, typeMessage, showModalCallback) {
            messagesQueue.push({
                message: message,
                messageType: typeMessage,
                showModalCallback: showModalCallback
            });
        }

        function removeMessage(message, messageType) {
            messagesQueue = _.without(messagesQueue, _.findWhere(messagesQueue, {
                message: message,
                messageType: messageType
            }));
        }

        function processQueue(message, messageType) {
            removeMessage(message, messageType);
            if (messagesQueue.length > 0)
                messagesQueue[messagesQueue.length - 1].showModalCallback();
        }

        function isMessagesQueueContains(message, messageType) {
            var result = _.some(messagesQueue, function (item) {
                return item.message === message && item.messageType === messageType;
            });
            return result;
        }

        var Service = function (isBackdropStatic) {
            //if _isBackdropStatic is false then we can close modal window 
            //by clicking on backdrop area (not modal window)
            var service = this;

            this._isBackdropStatic = isBackdropStatic || false;

            this.withStaticBackdrop = function () {
                var result = new Service(true);
                return result;
            };

            this.clear = function () {
                messagesQueue = [];
                $window.$('.modal').modal('hide');
            }

            this.showYesNoMessage = function (title, message, yesCallback, noCallback, needHideCloseButton, 
                closedCallback, eBillNotificationNumber) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.yesNo))
                    return;
                else
                    addMessageToQueue(message, messageTypes.yesNo,
                        function () { 
                            that._showYesNoMessageTask(title, message, yesCallback, noCallback, needHideCloseButton, 
                                closedCallback, eBillNotificationNumber) 
                        });

                if (messagesQueue.length === 1)
                    that._showYesNoMessageTask(title, message, yesCallback, noCallback, needHideCloseButton, 
                        closedCallback, eBillNotificationNumber);
            }

            this._showYesNoMessageTask = function (title, message, yesCallback, noCallback, needHideCloseButton, 
                closedCallback, eBillNotificationNumber) {
                var templateUrl = this._getYesNoTemplateUrl(eBillNotificationNumber);
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconQuestion;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.needToHide = needHideCloseButton;
                        $scope.close = function (action) {
                            if (action === 'Yes') {
                                if (yesCallback)
                                    yesCallback();
                            }
                            else if (action === 'No') {
                                if (noCallback)
                                    noCallback();
                            } else
                                service.showError(utilli.errors.serverErrorMessage);
                        };
                    }]
                }).then(function (modal) {
                    modal.element.modal();
                    modal.element.on('hidden.bs.modal', function () {
                        // Why this is here? I dont what No callback. We have No and Yes callback running at the same time: https://atrinova.atlassian.net/browse/GNIS-2599
                        // I see that Daniel added this when he was fixing this GNIS-2522. I can not reproduce GNIS-2522 after I commented this out:
                        //if (noCallback) {
                        //    noCallback();
                        //}
                        if (closedCallback) {
                            closedCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.yesNo);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            }
            
            this.showOkMessage = function (title, message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showOkMessageTask(title, message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showOkMessageTask(title, message, closedCallback);
            }

            this._showOkMessageTask = function (title, message, closedCallback, iconClass) {
                if (!message)
                    return;
                var that = this;
                var templateUrl = this._getSimpleOkTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconClass ? iconClass : iconInfo;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.backdrop = that._isBackdropStatic ? "static" : true;
                        $scope.close = function () { };
                    }]
                }).then(function (modal) {
                    //modal.element.modal();
                    modal.element.modal({backdrop: that._isBackdropStatic ? "static" : true });
                    modal.element.on('hidden.bs.modal', function () {
                        if (closedCallback) {
                            closedCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.ok);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this.showMergeTagsDialog = function (title, mergeTags, resolveCallback, rejectCallback) {
                var that = this;
                if (isMessagesQueueContains(mergeTags, messageTypes.mergeTagDialog))
                    return;
                else
                    addMessageToQueue(mergeTags, messageTypes.mergeTagDialog,
                        function () { that._showMergeTagsDialogTask(title, mergeTags, resolveCallback, rejectCallback) });

                if (messagesQueue.length === 1)
                    that._showMergeTagsDialogTask(title, mergeTags, resolveCallback, rejectCallback);
            }

            this._showMergeTagsDialogTask = function (title, mergeTags, resolveCallback, rejectCallback) {
                if (!mergeTags)
                    return;
                var that = this;
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: '../Pages/Modals/merge-tags.html',
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.title = title;
                        $scope.allMergeTags = mergeTags;
                        $scope.mergeTags = mergeTags;
                        $scope.backdrop = that._isBackdropStatic ? "static" : true;
                        $scope.selectTag = function (tag) {
                            resolveCallback(tag);
                        }
                        $scope.close = function () { 
                            rejectCallback()
                        };
                        $scope.resetSearch = function () { 
                            $scope.searchingText = '';
                            $scope.mergeTags = $scope.allMergeTags;
                        }
                        $scope.searchMergeTags = function () { 
                            if(!$scope.searchingText) {
                                $scope.mergeTags = $scope.allMergeTags;
                                return;
                            }
                            var searchKey = $scope.searchingText.toLowerCase()
                            $scope.mergeTags = _.filter($scope.allMergeTags, 
                                function(tag){ return tag.name.toLowerCase().indexOf(searchKey) >= 0; })
                        }
                    }]
                }).then(function (modal) {
                    //modal.element.modal();
                    modal.element.modal({backdrop: that._isBackdropStatic ? "static" : true });
                    modal.element.on('hidden.bs.modal', function () {
                        if (rejectCallback) {
                            rejectCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(mergeTags, messageTypes.mergeTagDialog);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this.showError = function (message, closedCallback) {
                console.error(message);
                if (!message){
                    this.showServerError();
                    return;
                }
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showErrorTask(message, closedCallback);
            }

            this.showErrorRed = function (message, closedCallback) {
                console.error(message);
                if (!message){
                    this.showServerError();
                    return;
                }
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showOkMessageRedTask("Error", message, closedCallback, iconError);
            }

            this._showOkMessageRedTask = function (title, message, closedCallback, iconClass) {
                if (!message)
                    return;
                var that = this;
                var templateUrl = this._getSimpleOkTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconClass ? iconClass + " red-color" : iconInfo;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.backdrop = that._isBackdropStatic ? "static" : true;
                        $scope.close = function () { };
                        $scope.titleColor = 'red-color';
                    }]
                }).then(function (modal) {
                    //modal.element.modal();
                    modal.element.modal({backdrop: that._isBackdropStatic ? "static" : true });
                    modal.element.on('hidden.bs.modal', function () {
                        if (closedCallback) {
                            closedCallback();
                        }
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.ok);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this._showErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };

            this.checkApiResponseError = function(response) {
                if (response == undefined || response.data == undefined
                    || response.data.HasErrors == undefined
                    || response.data.Errors == undefined) {
                    return $q.reject('Unexpected response format.');
                }
                if (response.data.HasErrors) {
                    return $q.reject(response.data.Errors[0]);
                }
                return $q.resolve(response);
            };
            this.catchAjaxError = function () {
                return $q.reject(utilli.errors.serverErrorMessage);
            };
            this.showAjaxError = function (error) {
                if (error)
                    console.error(error);
                service.showError(utilli.errors.serverErrorMessage);
                return $q.reject();
            };

            this.showServerError = function (closedCallback) {
                var that = this;
                var message = utilli.errors.serverErrorMessage;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showServerErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showServerErrorTask(message, closedCallback);
            }

            this._showServerErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };

            this.showUnexpectedError = function (closedCallback) {
                var that = this;
                var message = utilli._t('Unexpected error. Try to restart the application.');
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showUnexpectedErrorTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showUnexpectedErrorTask(message, closedCallback);
            }

            this._showUnexpectedErrorTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Error'), message, closedCallback, iconError);
            };
            
            this.showInfo = function (message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showInfoTask(message, closedCallback) });

                if (messagesQueue.length === 1)
                    that._showInfoTask(message, closedCallback);
            }

            this._showInfoTask = function (message, closedCallback) {
                this._showOkMessageTask(utilli._t('Info'), message, closedCallback, iconInfo);
            };

            this.close = function () {
                $window.$('.modal').modal('hide');
            }

            this.showMessage = function (title, message, closedCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.ok))
                    return;
                else
                    addMessageToQueue(message, messageTypes.ok,
                        function () { that._showOkMessageTask(title, message, closedCallback, iconInfo) });

                if (messagesQueue.length === 1)
                    that._showOkMessageTask(title, message, closedCallback, iconInfo);
            }

            this.showLoginRequired = function (title, message, loginCallback, registerCallback) {
                var that = this;
                if (isMessagesQueueContains(message, messageTypes.loginRequired))
                    return;
                else
                    addMessageToQueue(message, messageTypes.loginRequired,
                        function () { that._showLoginRequired(title, message, loginCallback, registerCallback) });
                if (messagesQueue.length === 1)
                    that._showLoginRequired(title, message, loginCallback, registerCallback);
            }

            this._showLoginRequired = function (title, message, loginCallback, registerCallback) {
                if (!message)
                    return;

                var templateUrl = this._getLoginRequiredTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconWarning;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.close = function (action) {
                            if (action === 'Login') {
                                if (loginCallback)
                                    loginCallback();
                            }
                            else if (action === 'Register') {
                                if (registerCallback)
                                    registerCallback();
                            }
                        };
                    }]
                }).then(function (modal) {
                    modal.element.modal();
                    modal.element.on('hidden.bs.modal', function () {
                        if (closeModal)
                            closeModal();
                        processQueue(message, messageTypes.loginRequired);
                    });

                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this.showCreatePin = function (title, message, loginCallback, registerCallback) {
                var that = this;
                $rootScope.pinFields = {
                    p1:'',p2:'',p3:'',p4:'',cp1:'',cp2:'',cp3:'',cp4:'',pinOtp:''
                }
                $rootScope.pinError = false;
                $rootScope.cPinError = false;
                $rootScope.compareError = false;
                $rootScope.optError = "";
                $rootScope.resetTimeOut = 0;
                $rootScope.canShowTimer = false;
                $rootScope.canRequestVerificationCode = false;
                
                if (isMessagesQueueContains(message, messageTypes.loginRequired))
                    return;
                else
                    addMessageToQueue(message, messageTypes.loginRequired,
                        function () { that._showCreatePin(title, message, loginCallback, registerCallback) });
                if (messagesQueue.length === 1)
                    that._showCreatePin(title, message, loginCallback, registerCallback);
            }

            this.showPinError = function (errorMessage) {
                $rootScope.optError = errorMessage;
            }

            var tickTimer = function () {
                if ($rootScope.resetTimeOut != 0) {
                    $rootScope.resetTimeOut--;
                    $timeout(tickTimer, 1000);
                } else {
                    $rootScope.canRequestVerificationCode = true;
                    $rootScope.canShowTimer = false;
                    return;
                }
        
                var secInMinute = 60;
                $rootScope.canShowTimer = true;
                $rootScope.timeoutStr = '' + ($rootScope.resetTimeOut % secInMinute); //60 seconds in 1 minute
                if ($rootScope.timeoutStr.length < 2) {
                    $rootScope.timeoutStr = '0' + $rootScope.timeoutStr;
                }
                $rootScope.timeoutStrMinutes = '' + Math.floor($rootScope.resetTimeOut / secInMinute);
                if ($rootScope.timeoutStrMinutes.length < 1) {
                    $rootScope.timeoutStrMinutes = '0';
                }
            }

            function handleInputPin()
            {
                var pinContainer = document.querySelector(".pin-code");
                    console.log('There is ' + pinContainer.length + ' Pin Container on the page.');
    
                    pinContainer.addEventListener('keyup', function (event) {
                        var target = event.target;
                        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
                        var myLength = target.value.length;

                        if (myLength > maxLength) {
                            target.value = target.value.charAt(myLength - 1)
                            var next = target;
                            while (next = next.nextElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }

                        if (myLength === maxLength) {
                            var next = target;
                            while (next = next.nextElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }
                        
                        if (myLength === 0) {
                            var next = target;
                            while (next = next.previousElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }
                    }, false);
    
                    pinContainer.addEventListener('keydown', function (event) {
                        if (event.keyCode == 9 || $rootScope.pinFields.p4 !== '')
                        {
                            return;
                        }
                        var target = event.target;
                        target.value = "";
                    }, false);
            }

            function comparePins() {
                var values = $rootScope.pinFields;
                if (values.p1 === '' || values.p2 === '' || values.p3 === '' || values.p4 === '' || 
                values.p1 === undefined || values.p2 === undefined || values.p3 === undefined || values.p4 === undefined)
                {
                    $rootScope.pinError = true;
                    return true;
                }
                $rootScope.pinError = false;
                if (values.cp1 === '' || values.cp2 === '' || values.cp3 === '' || values.cp4 === '' || 
                values.cp1 === undefined || values.cp2 === undefined || values.cp3 === undefined || values.cp4 === undefined)
                {
                    $rootScope.cPinError = true;
                    return true;
                }
                $rootScope.cPinError = false;
                if ((values.p1 !== values.cp1) || (values.p2 !== values.cp2) || (values.p3 !== values.cp3) || (values.p4 !== values.cp4))
                {
                    $rootScope.compareError = true;
                    return true;
                }
                
                $rootScope.compareError = false;
                return false;
            }

            function fixNumbers()
            {
                if($rootScope.pinFields.p1 == undefined)
                {
                    $rootScope.pinFields.p1 = '';
                }
                if($rootScope.pinFields.p2 == undefined)
                {
                    $rootScope.pinFields.p2 = '';
                }
                if($rootScope.pinFields.p3 == undefined)
                {
                    $rootScope.pinFields.p3 = '';
                }
                if($rootScope.pinFields.p4 == undefined)
                {
                    $rootScope.pinFields.p4 = '';
                }
                if($rootScope.pinFields.cp1 == undefined)
                {
                    $rootScope.pinFields.cp1 = '';
                }
                if($rootScope.pinFields.cp2 == undefined)
                {
                    $rootScope.pinFields.cp2 = '';
                }
                if($rootScope.pinFields.cp3 == undefined)
                {
                    $rootScope.pinFields.cp3 = '';
                }
                if($rootScope.pinFields.cp4 == undefined)
                {
                    $rootScope.pinFields.cp4 = '';
                }
            }

            function handleInputPinConfirm()
            {
                var pinContainer = document.querySelector(".pin-code-confirm");
                    console.log('There is ' + pinContainer.length + ' Pin Container on the page.');
    
                    pinContainer.addEventListener('keyup', function (event) {
                        var target = event.target;
                        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
                        var myLength = target.value.length;
    
                        if (myLength > maxLength) {
                            target.value = target.value.charAt(myLength - 1)
                            var next = target;
                            while (next = next.nextElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }
                        
                        if (myLength === maxLength) {
                            var next = target;
                            while (next = next.nextElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }
    
                        if (myLength === 0) {
                            var next = target;
                            while (next = next.previousElementSibling) {
                                if (next == null) break;
                                if (next.tagName.toLowerCase() == "input") {
                                    next.focus();
                                    break;
                                }
                            }
                        }
                    }, false);
    
                    pinContainer.addEventListener('keydown', function (event) {
                        if (event.keyCode == 9 || $rootScope.pinFields.cp4 !== '')
                        {
                            return;
                        }
                        var target = event.target;
                        target.value = "";
                    }, false);
            }

            this._showCreatePin = function (title, message, loginCallback, registerCallback) {
                if (!message)
                    return;

                var templateUrl = this._getCreatePinTemplateUrl();
                var closeModal = null;
                ModalService.showModal({
                    templateUrl: templateUrl,
                    controller: ["$scope","close", function ($scope, close) {
                        closeModal = close;
                        $scope.iconClass = iconWarning;
                        $scope.title = title;
                        $scope.message = message;
                        $scope.close = function (action, form) {
                            if (action === 'SendOtp') {
                                fixNumbers();
                                if (!form.$valid)
                                {
                                    return;
                                }
                                var result = comparePins();
                                if (result)
                                {
                                    return;
                                }
                                var pin = $rootScope.pinFields.p1.toString() + $rootScope.pinFields.p2.toString() + $rootScope.pinFields.p3.toString() +
                                $rootScope.pinFields.p4.toString();
                                if (loginCallback)
                                {
                                    $rootScope.canShowTimer = true;
                                    $rootScope.canRequestVerificationCode = true;
                                    $rootScope.resetTimeOut = 31;
                                    tickTimer();
                                    loginCallback(pin, 'sms');
                                }
                            }
                            else if (action === 'SendOtpEmail') {
                                fixNumbers();
                                if (!form.$valid)
                                {
                                    return;
                                }
                                var result = comparePins();
                                if (result)
                                {
                                    return;
                                }
                                var pin = $rootScope.pinFields.p1.toString() + $rootScope.pinFields.p2.toString() + $rootScope.pinFields.p3.toString() +
                                $rootScope.pinFields.p4.toString();
                                if (loginCallback)
                                {
                                    $rootScope.canShowTimer = true;
                                    $rootScope.canRequestVerificationCode = true;
                                    $rootScope.resetTimeOut = 31;
                                    tickTimer();
                                    loginCallback(pin, 'email');
                                }
                            }
                            else if (action === 'SaveOtp') {
                                var otp = $rootScope.pinFields.pinOtp.toString();
                                var maxLength = otp.length;
                                if (maxLength < 4)
                                {
                                    return;
                                }
                                if (registerCallback)
                                {
                                    registerCallback(otp);
                                }
                            }
                        };
                    }]
                }).then(function (modal) {
                    modal.element.modal();
                    modal.element.on('hidden.bs.modal', function () {
                        if (closeModal)
                        {
                            $rootScope.resetTimeOut = 0;
                            $rootScope.canShowTimer = false;
                            $rootScope.canRequestVerificationCode = false;
                            closeModal();
                        }
                        processQueue(message, messageTypes.loginRequired);

                    });
                 
                    handleInputPin();
                    handleInputPinConfirm();
                    modal.scope.$on('keyup', function (event, e) {
                        if (e.which == 27) {
                            modal.element.modal('hide');
                        }
                    })
                });
            };

            this._getYesNoTemplateUrl = function (eBillNotificationNumber) {
                if (eBillNotificationNumber) {
                    return 'Pages/Modals/yes-no-ebill-template' + eBillNotificationNumber + '.html';
                }
                var result = utilli.isAdmin
                            ? '../Pages/Modals/yes-no-template.html'
                            : 'Pages/Modals/yes-no-template.html';
                return result;
            }

            this._getSimpleOkTemplateUrl = function () {
                var result = utilli.isAdmin
                            ? '../Pages/Modals/simple-ok-template.html'
                            : 'Pages/Modals/simple-ok-template.html';
                return result;
            }

            this._getLoginRequiredTemplateUrl = function() {
                return 'Pages/Modals/signin-register-template.html';
            }

            this._getCreatePinTemplateUrl = function() {
                return 'Pages/Modals/create-pin-template.html';
            }

        };


        return new Service();
    }])
    .controller('ModalController', ["$scope", "close", function ($scope, close) {
        $scope._t = utilli._t;
        $scope.close = function (result) {
            close(result, 500);
        };
    }]);
angular.module('utilliApp')
	.service('StatesService', function () {
		return { states : [
			{
				"Name": "Alabama",
				"Abbreviation": "AL"
			},
			{
				"Name": "Alaska",
				"Abbreviation": "AK"
			},
			{
				"Name": "American Samoa",
				"Abbreviation": "AS"
			},
			{
				"Name": "Arizona",
				"Abbreviation": "AZ"
			},
			{
				"Name": "Arkansas",
				"Abbreviation": "AR"
			},
			{
				"Name": "California",
				"Abbreviation": "CA"
			},
			{
				"Name": "Colorado",
				"Abbreviation": "CO"
			},
			{
				"Name": "Connecticut",
				"Abbreviation": "CT"
			},
			{
				"Name": "Delaware",
				"Abbreviation": "DE"
			},
			{
				"Name": "District Of Columbia",
				"Abbreviation": "DC"
			},
			{
				"Name": "Federated States Of Micronesia",
				"Abbreviation": "FM"
			},
			{
				"Name": "Florida",
				"Abbreviation": "FL"
			},
			{
				"Name": "Georgia",
				"Abbreviation": "GA"
			},
			{
				"Name": "Guam",
				"Abbreviation": "GU"
			},
			{
				"Name": "Hawaii",
				"Abbreviation": "HI"
			},
			{
				"Name": "Idaho",
				"Abbreviation": "ID"
			},
			{
				"Name": "Illinois",
				"Abbreviation": "IL"
			},
			{
				"Name": "Indiana",
				"Abbreviation": "IN"
			},
			{
				"Name": "Iowa",
				"Abbreviation": "IA"
			},
			{
				"Name": "Kansas",
				"Abbreviation": "KS"
			},
			{
				"Name": "Kentucky",
				"Abbreviation": "KY"
			},
			{
				"Name": "Louisiana",
				"Abbreviation": "LA"
			},
			{
				"Name": "Maine",
				"Abbreviation": "ME"
			},
			{
				"Name": "Marshall Islands",
				"Abbreviation": "MH"
			},
			{
				"Name": "Maryland",
				"Abbreviation": "MD"
			},
			{
				"Name": "Massachusetts",
				"Abbreviation": "MA"
			},
			{
				"Name": "Michigan",
				"Abbreviation": "MI"
			},
			{
				"Name": "Minnesota",
				"Abbreviation": "MN"
			},
			{
				"Name": "Mississippi",
				"Abbreviation": "MS"
			},
			{
				"Name": "Missouri",
				"Abbreviation": "MO"
			},
			{
				"Name": "Montana",
				"Abbreviation": "MT"
			},
			{
				"Name": "Nebraska",
				"Abbreviation": "NE"
			},
			{
				"Name": "Nevada",
				"Abbreviation": "NV"
			},
			{
				"Name": "New Hampshire",
				"Abbreviation": "NH"
			},
			{
				"Name": "New Jersey",
				"Abbreviation": "NJ"
			},
			{
				"Name": "New Mexico",
				"Abbreviation": "NM"
			},
			{
				"Name": "New York",
				"Abbreviation": "NY"
			},
			{
				"Name": "North Carolina",
				"Abbreviation": "NC"
			},
			{
				"Name": "North Dakota",
				"Abbreviation": "ND"
			},
			{
				"Name": "Northern Mariana Islands",
				"Abbreviation": "MP"
			},
			{
				"Name": "Ohio",
				"Abbreviation": "OH"
			},
			{
				"Name": "Oklahoma",
				"Abbreviation": "OK"
			},
			{
				"Name": "Oregon",
				"Abbreviation": "OR"
			},
			{
				"Name": "Palau",
				"Abbreviation": "PW"
			},
			{
				"Name": "Pennsylvania",
				"Abbreviation": "PA"
			},
			{
				"Name": "Puerto Rico",
				"Abbreviation": "PR"
			},
			{
				"Name": "Rhode Island",
				"Abbreviation": "RI"
			},
			{
				"Name": "South Carolina",
				"Abbreviation": "SC"
			},
			{
				"Name": "South Dakota",
				"Abbreviation": "SD"
			},
			{
				"Name": "Tennessee",
				"Abbreviation": "TN"
			},
			{
				"Name": "Texas",
				"Abbreviation": "TX"
			},
			{
				"Name": "Utah",
				"Abbreviation": "UT"
			},
			{
				"Name": "Vermont",
				"Abbreviation": "VT"
			},
			{
				"Name": "Virgin Islands",
				"Abbreviation": "VI"
			},
			{
				"Name": "Virginia",
				"Abbreviation": "VA"
			},
			{
				"Name": "Washington",
				"Abbreviation": "WA"
			},
			{
				"Name": "West Virginia",
				"Abbreviation": "WV"
			},
			{
				"Name": "Wisconsin",
				"Abbreviation": "WI"
			},
			{
				"Name": "Wyoming",
				"Abbreviation": "WY"
			}
		]};
	});
'use strict';
angular.module('commonServices', [])
    .service('CommonDataService', ['$http', '$q', function ($http, $q) {

        var commonData = {};
        var hasCommonData = false;

        var hasData = function () {
            return hasCommonData;
        };

        var getCommonData = function (webServiceUrl, isNewRequest) {
            var deferred = $q.defer();
            var url = webServiceUrl 
                ? webServiceUrl + 'api/Account/GetCommonData/'
                : localStorage.getItem('ApiUrl') + 'api/Account/GetCommonData/';

            if (isNewRequest || !hasData()) {
                $http({
                    url: url,
                    method: "GET"
                }).success(function(data) {
                    if (data.Success) {
                        commonData = data.Data;
                        hasCommonData = true;
                        deferred.resolve(commonData);
                    }
                }).error(function(e) {
                    deferred.reject(e);
                });
            } else {
                deferred.resolve(commonData);
            }
            return deferred.promise;
        }

        return {
            getCommonData: getCommonData,
            refresh: function() { hasCommonData = false; }
        };
    }]);
'use strict';
angular.module('utilliApp')
.service('LeftMenuService', ['$http', '$state', '$q', 'ModalServiceExt', 'NotificationBoxService',
    '$rootScope', '$timeout',
    function ($http, $state, $q, ModalServiceExt, NotificationBoxService, $rootScope, $timeout) {
        var fullMenu = {
            Avatar: { isVisible: true },
            SignOut: { isVisible: true },
            AccountList: { isVisible: true },
            Dashboard: { isVisible: true },
            BillsAndPayments: { isVisible: true },
            Usage: { isVisible: true },
            PaymentOptions: { isVisible: true },
            MeterData: { isVisible: true },
            ChangePassword: { isVisible: true },
            Profile: { isVisible: true },
            CancelService: { isVisible: true },
            MoveService: { isVisible: true },
            OutageCenter: { isVisible: true },
            EnergyEfficiency: { isVisible: true },
            Faqs: { isVisible: true },
            AboutUs: { isVisible: true },
            Notifications: { isVisible: true },
            ProgramEnrolments: { isVisible: true },

            // Agents:
            Search: { isVisible: true },
            SearchHistory: { isVisible: true },
            AgentProfile: { isVisible: true },
            // Assistants:
            Delinquents: { isVisible: true },
            AssistantSearch: { isVisible: true },
            AssistantSearchHistory: { isVisible: true },
            AssistantProfile: { isVisible: true },
            AssistantDisconnections: { isVisible: true },
            // PropertyManagers:
            MyPropertyGroups: { isVisible: true },
            MyProperties: { isVisible: true },
            PropertyManagerProfile: { isVisible: true },
            Authorizations: { isVisible: true },
            SharedAccounts: { isVisible: true },
            PropertyManagerBills: { isVisible: true },

            // Turn Off:
            WorkCenters: { isVisible: true },
            WorkOrders: { isVisible: true },
            TurnOffMap: { isVisible: true },
            LookUp: { isVisible: true },
            LookUpLog: { isVisible: true },
            //QuickPay: { isVisible: true },
            PaymentHistory: { isVisible: true },
            Communication: { isVisible: false },
        };

        var saveAsPrimaryAccount = function (userNameId) {
            var deferred = $q.defer();
            // i removed spinner here because i think that it's not necessary here and because it interferes
            // with spinners started in other places (a page may start its own spinner but here it will be turned off)
            // in general i think that we shouldn't start spinners in LeftMenuService. if spinner is really necessary
            // here then it's better to rewrite the code to return promise, start spinner in the page controller code,
            // launch the method of LeftMenuService and stop the spinner in 'than' method of the returned promise.
            //usSpinnerService.spin('spinner-1');
            var userName = userNameId;
            if (userName == null) {
                userName = localStorage.getItem('current_user');
            }
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/SetPrimaryContractAccount/',
                method: "POST",
                params: {
                    accountNumber: localStorage.getItem('CurrentAccountNumber'),
                    userName: userName
                }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0) {
                    deferred.reject();
                }
                deferred.resolve(response);
            }).error(function () {
                deferred.reject();
            });
            return deferred.promise;
        }

        function saveContractAccountNumberInSearchHistory(contractAccountNumber){
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Agents/SaveSearchHistory/',
                method: "POST",
                params: { contractAccountNumber: contractAccountNumber }
            });
        }

        var leftMenuService = {
            isMenuItemVisible: function (menuItem) {
                return this.currentMenu[menuItem] && this.currentMenu[menuItem].isVisible;
            },
            currentMenu: fullMenu,
            setFull: function () {
                this.currentMenu = fullMenu;
            },
            currentTab: 'Dashboard',
            setCurrentTab: function (tab) {
                this.show();
                this.currentTab = tab;
                loadTop3SearchHistoryItems(leftMenuService);
            },
            isVisible: false,
            hide: function () {
                this.isVisible = false;
            },
            show: function () {
                this.isVisible = true;
            },
            firstAndLastNameOrCompanyName: $rootScope._t('loading...'),
            avatar: utilli.isAdmin ? '../Images/Icons/avatar_unknown.png' : 'Images/Icons/avatar_unknown.png',
            contractAccounts: [],
            findContractAccount: function (contractAccountNumber) {
                var self = this;
                return _.find(self.contractAccounts, function (item) {
                    return item.contractAccountNumber === contractAccountNumber;
                });
            },
            isLoadingSearchHistory: true,
            selectContractAccount: function (contractAccountNumber, state) {
                var self = this;
                var contractAccountIndex = _.findIndex(self.contractAccounts, function (item) {
                    return item.contractAccountNumber === contractAccountNumber;
                });
                if (contractAccountIndex < 0) {
                    saveContractAccountNumberInSearchHistory(contractAccountNumber);
                    self.contractAccounts.unshift({
                        contractAccountNumber: contractAccountNumber
                    });
                }
                if (self.contractAccounts.length > 3) {
                    self.contractAccounts.pop();
                }
                // We should set options.reload as state name instead of 'true', because if we set it as 'true' 
                // all the parent states of the target state will reload with their previous parameters 
                // that can be not actual for the moment (at list for the nested customer app in the admin portal) and we will have
                // tricky issues with wrong data.
                $state.goMainLayout(state ? state : "Dashboard", {}, { reload: state });

                var currentContractAccountNumber = localStorage.getItem('CurrentAccountNumber');
                // don't collapse if we click on menu items within the same contract account
                if (currentContractAccountNumber === contractAccountNumber)
                    return;
                if (currentContractAccountNumber) {
                    $('#menuItem-' + currentContractAccountNumber).collapse('hide');
                }
                localStorage.setItem('CurrentAccountNumber', contractAccountNumber);
                $timeout(function () {
                    $('#menuItem-' + contractAccountNumber).collapse('show');
                }, 100);
            },
            setContractAccountInfo: function (contractAccountInfo) {
                var self = this;
                var contractAccount = self.findContractAccount(contractAccountInfo.account.AccountNumber);
                // if menu item is not loaded from search history then add it
                if (!contractAccount){
                    contractAccount = { contractAccountNumber: contractAccountInfo.account.AccountNumber};
                    self.contractAccounts.push(contractAccount);
                }
                contractAccount.ServiceAddress = contractAccountInfo.account.ServiceAddress;
                contractAccount.CustomerFullName = contractAccountInfo.account.CustomerFullName;
                // take only HouseNumber and StreetName but skip everything else that goes after first comma.
                // for example, "8574 N HIGH ST, MINERAL CITY, OH, 44656" -> "8574 N HIGH ST"
                var addressParts = contractAccount.ServiceAddress.split(',');
                contractAccount.addressString = addressParts.length > 0 ? addressParts[0] : contractAccount.ServiceAddress;
            },
            isActive: function (contractAccountNumber, state) {
                var self = this;
                return self.currentTab === state && contractAccountNumber == localStorage.getItem('CurrentAccountNumber');
            },
            goToForAccount: function (contractAccountNumber, state) {
                var self = this;

            },
            changeAccount: function (accountNumber) {
                var self = this;
                self.avatar = utilli.isAdmin ? '../Images/Icons/avatar_unknown.png' : 'Images/Icons/avatar_unknown.png';
                self.firstAndLastNameOrCompanyName = $rootScope._t('loading...');

                var apiUrl = localStorage.getItem('ApiUrl');
                var requestData;
                var isAgent = utilli.hasAgentRole();
                if (isAgent || utilli.hasPropertyManagerRole() || utilli.hasAssistantRole()) {
                    // i removed spinner here. see comments in saveAsPrimaryAccount
                    //usSpinnerService.spin('spinner-1');
                    var isAssistant = utilli.hasAssistantRole();
                    var url = isAgent || isAssistant ? apiUrl + 'api/Agents/GetProfile'
                        : apiUrl + 'api/PropertyManagers/GetProfile';
                    requestData = {};
                    utilli.addUserName($state, requestData);
                    $http({
                        method: 'GET',
                        url: url,
                        params: { userName: $state.params.userId }
                    }).success(function (data) {
                        var userData = isAgent || isAssistant ? data.Data : data.Data.UserData;
                        self.firstAndLastNameOrCompanyName = userData.FirstName + ' ' + userData.LastName;
                        self.avatar = apiUrl + userData.AvatarPath;
                    }).error(function () {
                        ModalServiceExt.showMessage(utilli.serverErrorMessage);
                    });
                }
                else if (utilli.checkDefinedValue(accountNumber)) {
                    requestData = { accountNumber: accountNumber };
                    utilli.addUserName($state, requestData);
                    $http({
                        url: apiUrl + 'api/Profile/GetProfile/',
                        method: "GET",
                        params: requestData,
                        notCancelled: true
                    }).success(function (data) {
                        //if (data.Errors && data.Errors.length > 0) {
                        //    $moduleServices.setErrors(data.Errors);
                        //    return;
                        //}
                        if (data.AccountData) {
                            self.firstAndLastNameOrCompanyName = data.AccountData.FirstAndLastNameOrCompanyName;
                            self.avatar = apiUrl + data.AvatarURL;
                            saveAsPrimaryAccount(data.AccountData.UserId);
                            if (!utilli.hasAgentRole() && !utilli.hasPropertyManagerRole())
                                NotificationBoxService.setSubscribeSmsVisibilityServerFlag(
                                    data.AccountData.SubscribeForSmsNotification !== "1" 
                                    && data.AccountData.RemindSmsSubscription);
                        }
                    }).error(function (data) {
                        console.log(data);
                    });
                }
            },
            signOut: function () {
                if (utilli.isAdmin) {
                    ModalServiceExt.showMessage($rootScope._t('Customer sign out does not work from admin.'));
                } else {
                    $state.goToWelcome();
                    NotificationBoxService.resetSmsSubscribeNotification();
                    utilli.clearLocalStorage();
                }
            },
        };

        var isTop3MenuItemLoaded = false;
        function loadTop3SearchHistoryItems(leftMenuService) {
            // run it only once per page load and only for assistants
            if (isTop3MenuItemLoaded || !utilli.hasAssistantRole())
                return;
            isTop3MenuItemLoaded = true;
            leftMenuService.isLoadingSearchHistory = true;
            $http.get(localStorage.getItem('ApiUrl') + 'api/Agents/GetSearchHistory/', {
                params: {
                    filter: "", group: "", page: 1, pageSize: 3, sort: ""
                }
            })
                .success(function (data) {
                    leftMenuService.isLoadingSearchHistory = false;
                    if (!data || !data.Data || !data.Data.PageData)
                        return;
                    leftMenuService.contractAccounts = [];
                    data.Data.PageData.forEach(function(searchHistoryItem) {
                        var contractAccount = leftMenuService.findContractAccount(searchHistoryItem.AccountNumber);
                        // menu item may already exist, for example if it was set from dashboard with other info
                        if (contractAccount)
                            return;
                        contractAccount = {
                            contractAccountNumber: searchHistoryItem.AccountNumber
                        };
                        var address = searchHistoryItem.Address;
                        // take only HouseNumber and StreetName but skip everything else that goes after first comma.
                        // for example, "8574 N HIGH ST, MINERAL CITY, OH, 44656" -> "8574 N HIGH ST"
                        var addressParts = address.split(',');
                        contractAccount.addressString = addressParts.length > 0 ? addressParts[0] : address;
                        leftMenuService.contractAccounts.push(contractAccount);
                    });
                    // if current page is related to contract account (sub menu) then we need expand it.
                    if (leftMenuService.currentTab === 'Dashboard' 
                        || leftMenuService.currentTab === 'BillsAndPayments') {
                        var menuItemId = '#menuItem-' + localStorage.getItem('CurrentAccountNumber');
                        // timeout is required here because menu items are not rendered yet
                        $timeout(function(){
                            var menuElement = $(menuItemId);
                            menuElement.collapse();
                        }, 0);
                    }
                })
                .error(function () {
                    leftMenuService.isLoadingSearchHistory = false;
                });
        }

        return leftMenuService;
    }]
);

'use strict';
angular.module('utilliApp')
    .service('DefaultPropertyService',
    [
        '$http', '$state', '$q', 'ModalServiceExt',
// ReSharper disable InconsistentNaming
        function($http, $state, $q, ModalServiceExt) {
// ReSharper restore InconsistentNaming
            return {
                getAggregation: function(userName) {
                    var deferred = $q.defer();
                    var aggregation = utilli.getCurrentAggregation();
                    var params = { propertyId: null, userName: userName };
                    if (aggregation != null && aggregation.Type != null && aggregation.Type == utilli.aggregationTypes.group) {
                        deferred.resolve(aggregation);
                    }
                    else {
                        if (aggregation != null) {
                            params.propertyId = aggregation.Id
                        } 
                        $http({
                            url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetDefaultProperty/',
                            method: "GET",
                            params: params
                        }).success(function(response) {
                            utilli.handleAjaxResponse(response,
                                ModalServiceExt,
                                function() {
                                    var aggregation = response.Data;
                                    if(aggregation){
                                        aggregation.Type = utilli.aggregationTypes.property;
                                        localStorage.setItem('currentAggregation', JSON.stringify(aggregation));
                                        deferred.resolve(response.Data);
                                    }
                                    deferred.resolve(null);
                                });
                        }).error(function(d) {
                            ModalServiceExt.showServerError();
                            deferred.reject(d);
                        });
                    }
                    return deferred.promise;
                }
            }
        }
    ]);
'use strict';
angular.module('utilliApp')
    .factory('NotificationBoxService', ['$rootScope', '$http', '$state', 'ModalServiceExt', function ($rootScope, $http, $state, ModalServiceExt) {
        var _settingsKey = 'notificationBoxSettings';
        var observerCallbacks = [];
        var tempVisibility = false;

        var notifyObservers = function () {
            angular.forEach(observerCallbacks, function (callback) {
                callback();
            });
        };

        var defaultNotificationBoxSettings = {
            SmsSubscribeNotification: {
                isVisibleByServer: false,
                isVisibleByUser: true
            }
        };

        function getSettings () {
            var result = JSON.parse(localStorage.getItem(_settingsKey)) || defaultNotificationBoxSettings;
            return result;
        }

        function saveSettings(settings) {
            localStorage.setItem(_settingsKey, JSON.stringify(settings));
        }

        return {
            registerObserverCallback: function (callback) {
                observerCallbacks.push(callback);
            },

            isSmsSubscribeNotificationVisible: function () {
                // if (utilli.hasAssistantRole())
                //     return false;
                var settings = getSettings();
                var result = settings.SmsSubscribeNotification.isVisibleByUser 
                    && settings.SmsSubscribeNotification.isVisibleByServer;
                return result;
            },

            hideSmsSubscribeNotification: function () {
                //todo: may be we should use user id in _settingsKey
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByUser = false;
                $rootScope.$broadcast('subscribe-notification-hide');
                saveSettings(settings);
            },

            stopReminding: function () {
                $http({
                    method: 'POST',
                    url: localStorage.getItem('ApiUrl') + 'api/User/StopRemindingSmsSubscription',
                    data: { '': $state.params.userId }
                }).success(function (response) {
                    if (response.Errors && response.Errors.length > 0) {
                        ModalServiceExt.showEror(response.Errors[0]);
                        return;
                    }

                    var settings = getSettings();
                    settings.SmsSubscribeNotification.isVisibleByUser = false;
                    settings.SmsSubscribeNotification.isVisibleByServer = false;
                    saveSettings(settings);
                }).error(function (error) {
                    console.log(error);
                    ModalServiceExt.showServerError();
                });
            },

            resetSmsSubscribeNotification: function() {
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByUser = true;
                settings.SmsSubscribeNotification.isVisibleByServer = false;
                saveSettings(settings);
            },

            setSubscribeSmsVisibilityServerFlag: function (flag) {
                var settings = getSettings();
                settings.SmsSubscribeNotification.isVisibleByServer = flag;
                if (flag)
                    settings.SmsSubscribeNotification.isVisibleByUser = true;
                saveSettings(settings);
                notifyObservers();
            },
            isTemporarilyHidden: function () {
                return tempVisibility;
            },
            setTemporarilyHide: function (flag) {
                tempVisibility = flag;
                notifyObservers();
            }
        };
    }
]);
angular.module('utilliApp')
    .service('OpenFileService', ['$http', '$q', 'ModalServiceExt', 'usSpinnerService',
        function ($http, $q, ModalServiceExt, usSpinnerService) {
            var _t = utilli._t;

        var openBill = function (billNumber, accountNumber)
        {
            usSpinnerService.spin('spinner-1');
            var billTab;
            if (!isMobileOrRipple()) {
                billTab = window.open("about:blank", "_blank");
            }
            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Bills/DoesBillExists/',
                params: { accountNumber: accountNumber, invoiceNumber: billNumber },
                method: "GET"
            }).success(function (data) {
                if (data != null && data.Exists) {
                    var billUrl = data.BillPdfUrl;
                    openPdf(billUrl, billNumber, billTab).catch(function(err){ 
                        ModalServiceExt.showError(err); 
                    }).fixedFinally(function(){
                        usSpinnerService.stop('spinner-1');
                    });
                }
                else {
                    if (billTab)
                        billTab.close();
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showInfo(_t("Bill PDF does not exist yet."));
                }
            }).error(function (data) {
                usSpinnerService.stop('spinner-1');
                ModalServiceExt.showServerError();
            });
        }

        var openUnderstandBillFile = function (apiUrl)
        {
            apiUrl = apiUrl ? apiUrl : localStorage.getItem('ApiUrl');
            var url = apiUrl + 'api/Bills/GetUnderstandMyBill';
            usSpinnerService.spin('spinner-1');
            openPdf(url, 'understandYourBill').catch(function(err){ 
                ModalServiceExt.showError(err);
            }).fixedFinally(function(){
                usSpinnerService.stop('spinner-1');
            });
        }

        /**
         * Opens a PDF on any platform.
         * @param {string} url Path to the file - it can be either http:// or https:// or file://
         * @param {*} fileName optional. name of the file. it's relevant if the user will decide to save the file.
         * @param {*} billTab optional. for bills we can first check if the bill exists and if it doesn't exist then 
         * show a message. but we do it using ajax request. and the problem is that we can't run window.open from ajax
         * callback because browser will complain and show a notification to the user that the page tries to open new
         * tabs. we don't want this notification. the workaround we found is to open the new tab before starting ajax
         * request and if bill doesn't exist then close the tab. if the bill exist then we update URL of the already
         * opened tab.
         */
        function openPdf(url, fileName, billTab){
            if (!isMobileOrRipple()) {
                if (billTab){
                    billTab.location = url;
                }
                else {
                    window.open(url, '_blank');
                }
                return $q.resolve();
            }
            else if (isAndroid()) {
                return androidOpenPdf(url, fileName);
            }
            else {// iOS
                window.open(url, "_system", "location=yes,closebuttoncaption=Back");
                return $q.resolve();
            }
        }

        /** opens pdf file using cordova plugin for android */
        function androidOpenPdf(url, fileName) {
            var deferred = $q.defer();
            if(!cordova.plugins.fileOpener2) {
                var message = _t('Current version of application doesn\'t support this functionality. You need to update your app!');
                ModalServiceExt.showError(message);
                usSpinnerService.stop('spinner-1');
                deferred.reject(message);
                return deferred.promise;
            }
            checkPermissions()
            .then(function (status) {
                if(!status.hasPermission)
                    return askPermissions();
                return Promise.resolve(true);
            }, function (e) {
                console.error(e);
                deferred.reject(e);
            })
            .then(function (hasStoragePermissions) { 
                if(!hasStoragePermissions) {
                    usSpinnerService.stop('spinner-1');
                    ModalServiceExt.showError(_t("You don't have permission to access this feature"));
                    return;
                }
                var requestFileSystemSuccessFn = function (dirEntry) {
                    // if there is no fileName specified then try to get it from url
                    fileName = fileName ? fileName :
                        url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.pdf'));
                    var targetFilePath = dirEntry.toURL() + fileName + ".pdf";
                    var fileTransfer = new FileTransfer();
                    var downloadErrorFn = function (error) {
                        var errorCodeDesc = "";
                        switch (error.code) {
                            case 1:
                                errorCodeDesc = "FILE_NOT_FOUND_ERR";
                                break;
                            case 2:
                                errorCodeDesc = "INVALID_URL_ERR";
                                break;
                            case 3:
                                errorCodeDesc = "CONNECTION_ERR";
                                break;
                            default:
                                errorCodeDesc = "unknown (" + error.code + ")";
                        }
                        console.error("Error downloading PDF from URL: " + url);
                        console.error("Error code = " + errorCodeDesc + ", http_status = " + error.http_status 
                            + ", source = " + error.source + ", target = " + error.target + ", body = " + error.body);
                        deferred.reject("There was an error while downloading the file. Please try again.");
                    };
                    var downloadSuccessFn = function (entry) {
                        cordova.plugins.fileOpener2.open(
                            entry.toURL(),
                            'application/pdf',
                            {
                                error : function(e) {
                                    console.error(e);
                                    deferred.reject("There was an error while downloading the file. Please try again.");
                                },
                                success : function () {
                                    deferred.resolve();
                                    console.log('file opened successfully');
                                }
                            }
                        );
                    };
                    fileTransfer.download(url, targetFilePath, downloadSuccessFn, downloadErrorFn, true);
                }
                var requestFileSystemErrorFn = function (error) {
                    deferred.reject("There was an error while reaching to the file system. Code = " + error.code);
                }
                var androidDownloadsPath = cordova.file.externalRootDirectory + "Download/";
                window.resolveLocalFileSystemURL(androidDownloadsPath, requestFileSystemSuccessFn, requestFileSystemErrorFn);
            },function (e) {
                deferred.reject(e);
            });
            return deferred.promise;
        }

        function checkPermissions () {
            var deferred = $q.defer();
            var androidVersionOfApiLevel23 = 6;
            if(device.version.split('.')[0] < androidVersionOfApiLevel23)
            {
                deferred.resolve({
                    hasPermission: true
                });
                return deferred.promise;
            }
            var permissions = cordova.plugins.permissions;
            var successCallback = function (status) {
                console.log(status);
                deferred.resolve(status);
            };
            var errorCallback = function () {
                var errorMessage = 'Storage permission is not turned on';
                ModalServiceExt.showError(_t('Storage permission is not turned on')); 
                console.warn(errorMessage);
                deferred.reject(errorMessage);
            }
            permissions.checkPermission(permissions.WRITE_EXTERNAL_STORAGE, successCallback, errorCallback);
            return deferred.promise;
        }

        function askPermissions () {
            var deferred = $q.defer();
            var permissions = cordova.plugins.permissions;
            var successCallback = function (status) {
                console.log(status);
                deferred.resolve(status.hasPermission);
            };
            var errorCallback = function () {
                var errorMessage = 'Storage permission is not turned on';
                ModalServiceExt.showError(_t('Storage permission is not turned on')); 
                console.warn(errorMessage);
                deferred.reject(errorMessage);
            }
            permissions.requestPermission(permissions.WRITE_EXTERNAL_STORAGE, successCallback, errorCallback);
            return deferred.promise;
        }

        return {
            openBill: openBill,
            openUnderstandBillFile: openUnderstandBillFile,
            openPdf: openPdf
        };
    }]);
'use strict';
angular.module('utilliApp')
    .factory('ServiceProvidersService', ['$http', '$q', function($http, $q) {

        var isCached = false;
        var cachedData = {};
        var currentProvider = null;

        return {
            /**
             * Returns a promise with data about all service providers
             * @returns an array of objects with Name, LongName, Url
             */
            getProviders: function () {
                var deferred = $q.defer();
                if (isCached) {
                    deferred.resolve(cachedData);
                    return deferred.promise;
                }

                var url = DeploymentSettings.providersServiceUrl + 'Providers/GetAllProviders';
                $http({
                    url: url,
                    method: "GET"
                }).success(function(data) {
                    if (!data || data.length == 0) {
                        deferred.reject(utilli.errors.serverErrorMessage);
                    }
                    cachedData = data;
                    isCached = true;
                    deferred.resolve(cachedData);
                }).error(function(data) {
                    console.error(data);
                    deferred.reject(utilli.errors.serverErrorMessage);
                });
                return deferred.promise;
            },
            /**
             * Returns a promise with data about a provider
             * @param providerShortName short name of a provider as it's in specified for
             * currentServiceProvider in DeploymentSettings
             * @returns an object with Name, LongName, Url
             */
            getProvider: function (providerShortName){
                return this.getProviders()
                    .then(function(providers){
                        var providerName = Config.providers[providerShortName].Name;
                        var providersFiltered = $.grep(providers, function(item){
                            return item.Name == providerName;
                        });
                        return providersFiltered[0];
                    });
            },
            getCurrentProvider: function () {
                return currentProvider 
                    ? $q.resolve(currentProvider) 
                    : this.getProvider(DeploymentSettings.currentServiceProvider);
            },
            setCurrentProvider: function (provider){
                currentProvider = provider;
            },
            getProviderApiUrl: function () {
                var result = $q.defer();
                this.getProviders()
                    .then(function (providers) {
                        try {
                            var currentServiceProvider = DeploymentSettings.currentServiceProvider;
                            if (currentServiceProvider.length == 0) {
                                console.log("Configuration error: can't get current service provider.");
                                result.reject();
                                return;
                            }
                            var currentProviderName = Config.providers[currentServiceProvider].Name;
                            var providersFiltered = $.grep(providers, function (item) {
                                return item.Name == currentProviderName;
                            });
                            if (!providersFiltered || providersFiltered.length !== 1) {
                                console.log("Configuration error: can't get current service provider.");
                                result.reject();
                                return;
                            }
                            result.resolve(providersFiltered[0].ApiUrl);
                        }
                        catch (e) {
                            result.reject();
                            console.log(e);
                        }
                    });
                return result.promise;
            }
        };
    }]);
angular.module('utilliApp')
    .service('GetAccountsService', ['$http', '$q', '$state', function ($http, $q, $state) {

        var accounts = {};
        var hasAccounts = false;

        var getAccounts = function (forceRequest) {
            var deferred = $q.defer();

            if (hasAccounts && !forceRequest)
            {
                deferred.resolve(accounts);
                return deferred.promise;
            }

            hasAccounts = false;
            var params = { };
            utilli.addUserName($state, params);

            $http({
                url: localStorage.getItem('ApiUrl') + 'api/Account/GetAccountList/',
                method: "GET",
                params: params
            }).success(function (data) {

                if (!data)
                {
                    accounts = {}
                    accounts.Errors = [{ key: 'Error', Message: utilli.serverErrorMessage }];
                    deferred.resolve(accounts);
                }

                accounts = data;

                if (accounts.Accounts && accounts.Accounts.length > 0)
                {
                    hasAccounts = true;
                    var serviceProvider = localStorage.getItem('ServiceProviderName');

                    for (var i = 0; i < accounts.Accounts.length; i++) {
                        accounts.Accounts[i].companyName = serviceProvider;
                    }
                }
                
                deferred.resolve(accounts);
            }).error(function () {
                accounts = {};
                accounts.Errors = [{ key: 'Error', Message: utilli.serverErrorMessage }];
                deferred.resolve(accounts);
            });

            return deferred.promise;
        }

        return {
            getAccounts: getAccounts
        };

    }]);
angular.module('utilliApp')
    .service('RequestService', [
        '$q', function($q) {
            var requests = [];

            var add = function(config) {
                if (!config.url.startsWith('http://') && !config.url.startsWith('https://'))
                    return;

                var abortTimeout = $q.defer();
                config.timeout = abortTimeout.promise;
                requests.push({ timeout: abortTimeout, timestamp: new Date(), notCancelled: config.notCancelled });
            }

            /**
            * aborts all requests that were launched before the specified timestamp
            */
            var abort = function (timestamp) {
                if (!timestamp) {
                    timestamp = new Date();
                }
                var remainingRequests = [];
                requests.forEach(function (item) {
                    if (item.timestamp < timestamp && !item.notCancelled) {
                        item.timeout.promise.status = 499; //will be checked in utilliApp responseError interceptor.
                        item.timeout.resolve();
                    } else {
                        remainingRequests.push(item);
                    }
                });
                requests = remainingRequests;
            }

            var forcedAbort = function (request) {

                if (request.timeout) {
                    var remainingRequests = [];
                    requests.forEach(function (item) {
                        if (item == request) {
                            item.timeout.promise.status = 499; //will be checked in utilliApp responseError interceptor.
                            item.timeout.resolve();
                        } else {
                            remainingRequests.push(item);
                        }
                    });
                    requests = remainingRequests;
                    return;
                }

                var abortTimeout = $q.defer();
                request.timeout = abortTimeout.promise;
                abortTimeout.resolve();
            }

            return { add: add, abort: abort, forcedAbort: forcedAbort }
        }
    ]);
'use strict';
angular.module('utilliApp')
    .service('DueReminderService', function () {
        var _isReminderShown = true;

        var unmarkAsShown = function () {
            _isReminderShown = false;
        }

        var markAsShown = function () {
            _isReminderShown = true;
        }

        var isReminderShown = function () {
            return _isReminderShown;
        }

        return {
            markAsShown: markAsShown,
            unmarkAsShown: unmarkAsShown,
            isReminderShown: isReminderShown
        };

    });
angular.module('utilliApp')
    .service('CheckVersionService', ['$http', '$q', function ($http, $q) {
        var checkVersion = function () {
            var deferred = $q.defer();

            var version = Config.version.split('.')[1];
            var providersApiUrl = DeploymentSettings.providersServiceUrl;

            var url = providersApiUrl + "Version/CheckVersion?version=" + version;

            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                })
                .error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return {
            checkVersion: checkVersion,
            // the case for old api (published before 2016-Sep-3) is 
            // just to submit new app to stores.
            // we need the new app to be running while old api is still deployed
            // appreviewer user needs to be able to login. he will be using apistaging.utilli.com
            // but the check here needs to be passed so that reviewer will be 
            // able to reach the signin page
            isVersionWrong: function (versionCheckResult) {
                return versionCheckResult === 'WrongVersion'// new api after 2016-Sep-3
                    || versionCheckResult === 'error';// old api before 2016-Sep-3
            },
            isVersionCorrect: function(versionCheckResult) {
                return versionCheckResult === 'Success'// new api after 2016-Sep-3
                || versionCheckResult === 'success';// old api before 2016-Sep-3
        }
    };
    }]);

'use strict';
angular.module('utilliApp')
    .service('ServerCacheService', [
        '$http', function($http) {
            
            function getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            function getContractAccountNumber(){
                var contractAccountNumber = getParameterByName('contractAccountNumber', window.location);
                if (contractAccountNumber && contractAccountNumber != '') {
                    return contractAccountNumber;
                }

                var token = localStorage.getItem("SecurityToken");
                if (!token)
                    return null;

                var accountNumber = localStorage.getItem("CurrentAccountNumber");
                if (!accountNumber || accountNumber === "null") {
                    if (utilli.hasPropertyManagerRole()) {
                        return "propertyManager";
                    }
                }
                return accountNumber;
            }

            return {
                clearServerCache: function() {
                    // if it was refresh (F5 pressed) then send request to refresh server cache.
                    var accountNumber = getContractAccountNumber();
                    if (!accountNumber){
                        return;
                    }
                    var apiUrl = localStorage.getItem("ApiUrl");
                    var url = apiUrl + "api/Account/ClearCache";
                    $http({
                        url: url,
                        method: "POST",
                        params: { accountNumber: accountNumber }
                    })
                    .success(function () { })
                    .error(function () { });
                }
            }

        }])
'use strict';
angular.module('utilliApp').factory('HeaderServiceFactory', [
    '$window', '$state', '$rootScope', 'AccountListService', '$http', 'ModalServiceExt',
// ReSharper disable InconsistentNaming
    function ($window, $state, $rootScope, AccountListService, $http, ModalServiceExt) {
// ReSharper restore InconsistentNaming
        var getHeaderSerivce = function() {

            var backButtonClick = function() {
                $window.history.back();
            };

            var hasEmailTemplateApproverRole = utilli.hasAdminRole() && DeploymentSettings.currentServiceProvider == Config.wglcxProviderName;
            
            var loadAdminUnreadNotificationCount = function () {
                if(!hasEmailTemplateApproverRole)
                    return;
                var apiUrl = localStorage.getItem('ApiUrl');
                $http({
                    url: apiUrl + 'api/CommunicationTypes/GetNotificationsCount/',
                    method: "GET"
                }).success(function (response) {
                    utilli.handleAjaxResponse(response,
                        ModalServiceExt,
                        function() {
                            svc._unreadAdminNotificationCount = response.Data;
                        });
                }).error(function (data) {
                    console.error(utilli._t("Cannot get unread notifications count."));
                    console.error(data);
                });
            }

            if (utilli.isAdmin)
                loadAdminUnreadNotificationCount();

            var svc = {
                // i use underscore prefixes '_' because i want to emphasise that these fields should 
                // be used only for reading values from them, not for setting values. 
                // use setUp* methods if you want to set values. this will ensure absense of
                // bugs when you set a filed in one controller and forgot to set it to default
                // value in another
                _title: "",
                // _isDefaultTitle is used in css to hide default title when logo replaces it
                _isDefaultTitle: false,
                _rightButtonText: null,
                _rightButtonClick: null,
                _isRightButtonVisible: false,
                _isRightButtonAlwaysVisible: false,
                _areNotificationsVisible: false,
                _areAdminNotificationsVisible: hasEmailTemplateApproverRole,
                _isMenuToggleButtonVisible: false,
                _notificationsClick: function() {
                    $state.goMainLayout('UserNotifications');
                },
                showInsect: DeploymentSettings.deploymentEnvironment === 'Qa',
                logoClick: function () {
                    if (!this.showInsect && !utilli.hasAgentRole() && !utilli.hasPropertyManagerRole())
                        $state.goToWelcome();
                    else
                         this.showInsect = false;
                },
                _unreadNotificationCount: 0,
                _unreadAdminNotificationCount: 0,
                updateAdminUnreadNotificationCount: loadAdminUnreadNotificationCount
            };

            var loadUnreadNotificationCount = function () {
                var apiUrl = localStorage.getItem('ApiUrl');
                var dataRequest = {};
                if (utilli.hasPropertyManagerRole()) {
                    dataRequest.accountNumber = 'propertyManager';
                    dataRequest.userName = localStorage.getItem('current_user');
                } else {
                    dataRequest.accountNumber = AccountListService.getCurrentContractAccount();
                }
                utilli.addUserName($state, dataRequest);
                $http({
                    url: apiUrl + 'api/NotificationsLog/GetPortalNotificationsCount/',
                    method: "GET",
                    params: dataRequest
                }).success(function (response) {
                    utilli.handleAjaxResponse(response,
                        ModalServiceExt,
                        function() {
                            svc._unreadNotificationCount = response.Data;
                        });
                }).error(function (data) {
                    ModalServiceExt.showError(utilli._t("Cannot get unread notifications count."));
                    console.error(data);
                });
            }

            svc.setTitle = function(title) {
                this._isDefaultTitle = !title;
                this._title = title ? title : this.getDefaultTitle();
                // update page title so that when you right click browser's back button you will see page names
                var websiteName = utilli.isAdmin ? utilli._t('Utilli Admin') : utilli._t('Utilli');
                document.title = websiteName + " - " + this._title;
            };

            /**
            * Sets up header configuration.
            * title - optional, default value is defaultTitle
            * rightButtonText - optional, if not specified then the right button is not visible
            * rightButtonClick - optional
            * isRightButtonAlwaysVisible - optional, false by default. 
            * if isRightButtonAlwaysVisible is true then the button doesn't get hidden on desktop screen sizes
            */
            svc.setUp = function(title, rightButtonText, rightButtonClick, isRightButtonAlwaysVisible) {
                this.setTitle(title);
                this._rightButtonText = rightButtonText;
                // the right button is visible only if a button text is specified
                this._isRightButtonVisible = !!rightButtonText;
                this._rightButtonClick = rightButtonClick;
                this._areNotificationsVisible = false;
                this._isMenuToggleButtonVisible = true;
                // usually the right button is the back button and it needs to be visible only in mobile apps 
                // because it's possible that a mobile device doesn't have hardware back button
                // but for custom buttons such as 'Add' or 'Edit' it is required to show the button always
                this._rightButtonClass = isRightButtonAlwaysVisible
                    ? '' : isMobileOrRipple()
                    ? '' : 'visible-xs';

                if(hasEmailTemplateApproverRole && utilli.isAdmin)
                    loadAdminUnreadNotificationCount();
            };

            /**
            * Sets up a header with a back button on the right
            * title - optional, default value is defaultTitle
            * isRightButtonAlwaysVisible - optional, false by default. 
            * if isRightButtonAlwaysVisible is true then the button doesn't get hidden on desktop screen sizes
            */
            svc.setUpBackButton = function(title, isRightButtonAlwaysVisible) {
                this.setUp(title, $rootScope._t('Back'), backButtonClick, isRightButtonAlwaysVisible);
                return this;
            }

            /**
            * Sets up a header with a back button on the right.
            * The only difference from setUpBackButton is the text on the right button.
            * title - optional, default value is defaultTitle
            */
            svc.setUpCancelButton = function(title) {
                this.setUp(title, $rootScope._t('Cancel'), backButtonClick);
                return this;
            };

            /**
            * Sets up a header with a notifications button on the right.
            * title - optional, default value is defaultTitle
            */
            svc.setUpNotificationButton = function(title) {
                this.setTitle(title);
                this._isRightButtonVisible = false;
                this._areNotificationsVisible = true;
                loadUnreadNotificationCount();
                this._isMenuToggleButtonVisible = true;
                return this;
            };

            svc.hideMenuToggleButton = function() {
                this._isMenuToggleButtonVisible = false;
                return this;
            };

            // Note: getDefaultTitle is overriden in admin in AdminHeaderService
            svc.getDefaultTitle = function() {
                var serviceProviderName = localStorage.getItem('ServiceProviderName');
                return serviceProviderName ? serviceProviderName : 'Utilli';
            };

            svc.setTitle();

            return svc;
        };

        return {
            getHeaderSerivce: getHeaderSerivce
        };
    }
]);

'use strict';
angular.module('utilliApp')
.factory('TimeService', ['$q', 'CommonDataService', 'ModalServiceExt',
    function ($q, CommonDataService, ModalServiceExt) {

        function createCurrentDate(timeZoneShift) {
            var currentDate = new Date();
            var currentUtcDate = currentDate.getTime() + (currentDate.getTimezoneOffset() * 60000);
            var currentServerDate = new Date(currentUtcDate + (3600000 * timeZoneShift));
            return currentServerDate;
        }

        function getTimeZone() {
            var resultPromise = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    resultPromise.resolve(data.TimeZoneShift);
                }, function () {
                    resultPromise.reject(null);
                });

            return resultPromise.promise;
        }

        var getTimeZoneDateAndCurrentDate = function (dateString) {
            var deferred = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    
                    var currentServerDate = createCurrentDate(data.TimeZoneShift);
                    //var timeZoneDate = kendo.parseDate(dateString, data.DateTimeFormat);
                    var timeZoneDate = kendo.parseDate(dateString, data.FullDateTimeSecondsFormat);
                    
                    deferred.resolve({
                        currentServerDate: currentServerDate,
                        timeZoneDate: timeZoneDate
                    });
                });

            return deferred.promise;
        };

        var getCurrentDate = function () {
            var deferred = $q.defer();

            CommonDataService.getCommonData()
                .then(function (data) {
                    var currentServerDate = createCurrentDate(data.TimeZoneShift);
                    deferred.resolve(currentServerDate);
                });

            return deferred.promise;
        };

        var getDateString = function (date, format) {
            format = format ? format : 'dd MMM yyyy HH:mm';
            date = new Date(date); //if date is string
            var stringDate = kendo.toString(date, format);
            return stringDate;
        };

        /*
        * Date Format 1.2.3
        * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
        * MIT license
        *
        * Includes enhancements by Scott Trenda <scott.trenda.net>
        * and Kris Kowal <cixar.com/~kris.kowal/>
        *
        * Accepts a date, a mask, or a date and a mask.
        * Returns a formatted version of the given date.
        * The date defaults to the current date/time.
        * The mask defaults to dateFormat.masks.default.
        */
        var dateFormat = function () {
            var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
                timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
                timezoneClip = /[^-+\dA-Z]/g,
                pad = function (val, len) {
                    val = String(val);
                    len = len || 2;
                    while (val.length < len) val = "0" + val;
                    return val;
                };

            // Regexes and supporting functions are cached through closure
            return function (date, mask, utc) {
                var dF = dateFormat;

                // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
                if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
                    mask = date;
                    date = undefined;
                }

                // Passing date through Date applies Date.parse, if necessary
                date = date ? new Date(date) : new Date;
                if (isNaN(date)) throw SyntaxError("invalid date");

                mask = String(dF.masks[mask] || mask || dF.masks["default"]);

                // Allow setting the utc argument via the mask
                if (mask.slice(0, 4) == "UTC:") {
                    mask = mask.slice(4);
                    utc = true;
                }

                var _ = utc ? "getUTC" : "get",
                    d = date[_ + "Date"](),
                    D = date[_ + "Day"](),
                    m = date[_ + "Month"](),
                    y = date[_ + "FullYear"](),
                    H = date[_ + "Hours"](),
                    M = date[_ + "Minutes"](),
                    s = date[_ + "Seconds"](),
                    L = date[_ + "Milliseconds"](),
                    o = utc ? 0 : date.getTimezoneOffset(),
                    flags = {
                        d: d,
                        dd: pad(d),
                        ddd: dF.i18n.dayNames[D],
                        dddd: dF.i18n.dayNames[D + 7],
                        m: m + 1,
                        mm: pad(m + 1),
                        mmm: dF.i18n.monthNames[m],
                        mmmm: dF.i18n.monthNames[m + 12],
                        yy: String(y).slice(2),
                        yyyy: y,
                        h: H % 12 || 12,
                        hh: pad(H % 12 || 12),
                        H: H,
                        HH: pad(H),
                        M: M,
                        MM: pad(M),
                        s: s,
                        ss: pad(s),
                        l: pad(L, 3),
                        L: pad(L > 99 ? Math.round(L / 10) : L),
                        t: H < 12 ? "a" : "p",
                        tt: H < 12 ? "am" : "pm",
                        T: H < 12 ? "A" : "P",
                        TT: H < 12 ? "AM" : "PM",
                        Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                        o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                        S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
                    };

                return mask.replace(token, function ($0) {
                    return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
                });
            };
        }();

        // Some common format strings
        dateFormat.masks = {
            "default": "ddd mmm dd yyyy HH:MM:ss",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM:ss TT",
            longTime: "h:MM:ss TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM:ss",
            isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
        };

        // Internationalization strings
        dateFormat.i18n = {
            dayNames: [
                "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
                "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
            ],
            monthNames: [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
                "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
            ]
        };

        var getLocalDate = function (dateAsString) {
            var result = new Date(Date.parse(dateAsString));
            return result;
        }

        //parse date as date in local time zone
        function parseISOLocalDate(s) {
            var b = s.split(/\D/);
            return new Date(b[0], b[1]-1, b[2], b[3], b[4], b[5]);
        }

        return {
            // Obsolete. Use dateFormat instead.
            getCurrentDate: getCurrentDate,
            getDateString: getDateString,
            getTimeZone: getTimeZone,
            getTimeZoneDateAndCurrentDate: getTimeZoneDateAndCurrentDate,
            parseISOLocalDate: parseISOLocalDate,
            // note: 
            // I don't replace getCurrentDate because dateFormat has different conventions for formatting patterns.
            // For example, 'MMM dd yyyy' doesn't work, but works in kendo. 
            // To avoid regressions my idea is to gradually replace getCurrentDate with dateFormat.
            dateFormat: dateFormat
        }
    }]);
angular.module('utilliApp')
    .service('PushHandlerService',['$state', function ($state) {
        function redirectToUserNotifications () {
            $state.goMainLayout('UserNotifications');
        }

        return {
            redirectToUserNotifications: redirectToUserNotifications
        };
    }]);

angular.module('utilliApp')
    .service('AccountListService', ["$rootScope", "LeftMenuService", "DueReminderService", "$timeout",
     function($rootScope, LeftMenuService, DueReminderService, $timeout) {

        var changeContractAccount = function(acc, fnCallback) {
            localStorage.setItem('CurrentAccountNumber', acc.AccountNumber);
            localStorage.setItem('CurrentUtilityType', acc.UtilityType);//todo: to constants structure
            DueReminderService.unmarkAsShown();

            // update current user in left menu (avatar, name)
            LeftMenuService.changeAccount(acc.AccountNumber);

            $rootScope.showSlideAnimation = true;

            if(fnCallback)
                fnCallback();

            $timeout(function () {
                $rootScope.showSlideAnimation = false;
            }, 300);
         }

        function getCurrentContractAccount () {
            var result = localStorage.getItem('CurrentAccountNumber');
            return result;
        }

        return {
            changeContractAccount: changeContractAccount,
            getCurrentContractAccount: getCurrentContractAccount,
        };

    }]);

angular.module('utilliApp')
    .service('productTourService', ['$http', 'ModalServiceExt', function ($http, ModalServiceExt) {

        var tour = null;
        var tourOptions = null;

        function isTourActive() {
            var tour = hopscotch.getCurrTour();
            if (tour)
                return true;
            return false;
        }

        function pauseTour() {
            hopscotch.unregisterHelper('onEndTour');
            var clearCookie = false;
            hopscotch.endTour(clearCookie);
        }

        function tourClosed(tourOptions, currentStep) {
            if (currentStep === tourOptions.steps.length - 1)
                return;

            ModalServiceExt.showYesNoMessage(
                utilli._t('Close tour'),
                utilli._t('Are you sure you want to stop this product tour?'),
                function () {
                    var clearCookie = true;
                    hopscotch.endTour(clearCookie);
                    tourDone(tourOptions.id);
                },
                function () {
                    hopscotch.startTour(tourOptions, currentStep);
                }, true);
        }

        function tourDone(tourId) {
            $('#panel')[0].onscroll = null;
            $('#menu')[0].onscroll = null;

            var url = localStorage.getItem('ApiUrl') + 'api/User/ProductTourDone';
            $http({
                method: 'POST',
                url: url,
                data: { '': tourId }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0)
                    console.error('tourDone(): server returned [' + response.Errors[0] + '].');
            }).error(function (error) {
                console.error('tourDone(): error [' + err + '].');
            })
        }

        function scrollMenu() {
            var target = tour.getCurrTarget();
            var rect = target.getBoundingClientRect();
            var viewPortHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            if (rect.bottom > viewPortHeight) {
                var menuElement = $('#menu')[0];
                menuElement.scrollTop = menuElement.scrollHeight;
            }
        }

        function nextStep(tour) {
            var step = tour.getCurrStepNum();
            // for now only 4 the first tour bubbles attached to menu items that can be scrolled.
            if (step < 4) {
                return;
            }

            scrollMenu();
        }

        function startTour(tourJson) {
            tourOptions = JSON.parse(tourJson);
            tour = hopscotch.startTour(tourOptions);
            hopscotch.registerHelper('onCloseTour', function () {
                var currentStep = tour.getCurrStepNum();
                tourClosed(tourOptions, currentStep);
            });
            hopscotch.registerHelper('onEndTour', function () {
                tourDone(tourOptions.id);
            });
            hopscotch.registerHelper('onNextStep', function () {
                nextStep(tour);
            });

            $('#menu .collapse').on('hidden.bs.collapse', function () {
                tour.refreshBubblePosition();
            });
            $('#menu .collapse').on('shown.bs.collapse', function () {
                scrollMenu();
                tour.refreshBubblePosition();
            });

            $('#panel')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // step 2 for now points to notifications icon placed on top menu and should not be scrolled.
                // other following steps for now are attached to left menu and should not be scrolled with #panel.
                if (currentStep > 1)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }

            $('#menu')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // tour bubbles attached to left menu begin from 4th. Number of steps in tour is zero based.
                if (currentStep < 3)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }
        }

        return {
            startTour: startTour,
            isTourActive: isTourActive,
            pauseTour: pauseTour
        }
    }]);
angular.module('utilliApp')
    .service('propertyManagerTourService', ['$http', 'ModalServiceExt', function ($http, ModalServiceExt) {

        var tour = null;
        var tourOptions = null;
        var steps = [
            'ImportProperty',
            'AddProperty',
            'PropertyOverview',
            'PropertyTypes',
            'PropertyDetails',
            'AddMeters',
            'Authorization',
            'Dashboard',
            'Groups',
            'Profile',
            'EnergyInsights'
        ];

        function isTourActive() {
            var tourJson = localStorage.getItem("PropertyManagerTour");
            if (!utilli.checkDefinedValue(tourJson))
                return false;

            tourOptions = angular.fromJson(tourJson);
            var step = localStorage.getItem(tourOptions.id);
            if (utilli.checkDefinedValue(step))
                return true;
            return false;
        }

        function pauseTour() {
            hopscotch.unregisterHelper('onEndTour');
            localStorage.setItem(tourOptions.id, tour.getCurrStepNum());
            hopscotch.endTour();
        }

        function resumeTour(stepName) {
            if(isMobileOrRipple())
                return;
            var stepNumber = _.indexOf(steps, stepName);

            var tourJson = localStorage.getItem('PropertyManagerTour');
            var step = localStorage.getItem(tourOptions.id);
            var stepInt = parseInt(step);
            if (stepInt == stepNumber)
                startTourInternal(tourJson, stepInt);
        }

        function tourClosed(tourOptions, currentStep) {
            ModalServiceExt.showYesNoMessage(
                utilli._t('Close tour'),
                utilli._t('Are you sure you want to stop this product tour?'),
                function () {
                    var clearCookie = true;
                    hopscotch.endTour(clearCookie);
                    tourDone(tourOptions.id);
                },
                function () {
                    hopscotch.startTour(tourOptions, currentStep);
                }, true);
        }

        function tourDone(tourId) {
            $('#panel')[0].onscroll = null;

            localStorage.setItem(tourOptions.id, null);
            localStorage.setItem('PropertyManagerTour', null);

            var url = localStorage.getItem('ApiUrl') + 'api/PropertyManagers/TourDone';
            $http({
                method: 'POST',
                url: url,
                data: { '': tourId }
            }).success(function (response) {
                if (response.Errors && response.Errors.length > 0)
                    console.error('tourDone(): server returned [' + response.Errors[0] + '].');
            }).error(function (error) {
                console.error('tourDone() failed: ' + error);
            })
        }

        function nextStep(tour) {
            var step = localStorage.getItem(tourOptions.id);
            if (utilli.checkDefinedValue(step)) {
                var stepInt = parseInt(step);
                localStorage.setItem(tourOptions.id, stepInt + 1);
            } 
            else {
                step = 0;
                localStorage.setItem(tourOptions.id, step + 1);
            }

            if (tourOptions.steps[step].showSkip) {
                hopscotch.unregisterHelper('onEndTour');
                hopscotch.endTour();
            }
        }

        function startTour(callback) {
            if(isMobileOrRipple()){
                if (callback)
                    callback();
                return;
            }
            var tourJson = localStorage.getItem('PropertyManagerTour');
            if (utilli.checkDefinedValue(tourJson)) {
                var tourOptions = angular.fromJson(tourJson);
                var step = localStorage.getItem(tourOptions.id);
                if (utilli.checkDefinedValue(step)) {
                    var stepInt = parseInt(step);
                    startTourInternal(tourJson, stepInt);

                    if (callback)
                        callback();

                    return;
                }
            }

            $http({
                method: "GET",
                url: localStorage.getItem('ApiUrl') + 'api/PropertyManagers/GetPropertyManagerTour/',
            }).success(function (response) {

                if (callback)
                    callback();

                if (!response.Data)
                    return;

                startTourInternal(response.Data);
            }).error(function (error) {
                if (callback)
                    callback();

                console.error("Get property manager tour error: ", error);
            });
        }

        function startTourInternal(tourJson, step) {
            sessionStorage.clear();
            tourOptions = JSON.parse(tourJson);
            // var addPropertyStep = _.find(tourOptions.steps, function (step) { return step.title == "Add Property"});
            // addPropertyStep.onNext = function () { };

            if (step) {
                tour = hopscotch.startTour(tourOptions, step);
            } else {
                tour = hopscotch.startTour(tourOptions);
                localStorage.setItem('PropertyManagerTour', tourJson);
            }

            hopscotch.registerHelper('onCloseTour', function () {
                var currentStep = tour.getCurrStepNum();
                tourClosed(tourOptions, currentStep);
            });
            hopscotch.registerHelper('onEndTour', function () {
                tourDone(tourOptions.id);
            });
            hopscotch.registerHelper('onNextStep', function () {
                nextStep(tour);
            });

            $('#menu .collapse').on('hidden.bs.collapse', function () {
                tour.refreshBubblePosition();
            });
            $('#menu .collapse').on('shown.bs.collapse', function () {
                scrollMenu();
                tour.refreshBubblePosition();
            });

            $('#panel')[0].onscroll = function () {
                var currentStep = tour.getCurrStepNum();
                // step 5 for now points to notifications icon placed on top menu and should not be scrolled.
                // other following steps for now are attached to left menu and should not be scrolled with #panel.
                if (currentStep > 5)
                    return;

                tour.refreshBubblePosition();
                var currentTarget = tour.getCurrTarget();
                var rect = currentTarget.getBoundingClientRect();
                // Magic number 65 is height of top menu.
                if (rect.top + rect.height < 65) {
                    $('.hopscotch-bubble').hide();
                } else {
                    $('.hopscotch-bubble').show();
                }
            }
        }

        return {
            startTour: startTour,
            isTourActive: isTourActive,
            pauseTour: pauseTour,
            resumeTour: resumeTour
        }
    }]);
angular.module('utilliApp')
    .service('RegistrationInfoService', function() {
        var userInfo =  {
            accountnumber: "",
            zip: "",
            customerfullname: "",
            token: ""
        }
     
        return {
            userInfo: userInfo
        };
    });

'use strict';
angular.module('utilliApp')
.controller('MainLayoutController', [
    function () {
        InitSideMenu();
    }]);
'use strict';
angular.module('utilliApp')
    .controller('WelcomeFooterController', ['$scope', '$state',
        function ($scope, $state) {

            $scope.enableLanguagePack = utilli.isLanguagePackEnabled();
            if (!$scope.enableLanguagePack)
                return;

            var language = localStorage.getItem('language');
            var languageParams = _.find(utilli.languages[DeploymentSettings.providersGroupShortName.toLowerCase()], function (x) { return language === x.abbreviation });
            if (!languageParams)
                $scope.currentLanguage = 'English';
            else
                $scope.currentLanguage = languageParams.name;

            $scope.goToLanguages = function () {
                $state.go('TopMenuLayout.Languages');
            }

            $scope.enablePropertyManagerLink = Config.providers[DeploymentSettings.currentServiceProvider].EnablePropertyManagerLink;
            $scope.isSsoLinkVisible = DeploymentSettings.currentServiceProvider === Config.wglProviderName && !isMobileOrRipple();
        }]);
'use strict';
angular.module('utilliApp')
    .controller('LeftMenuController', ['$scope', '$interval', '$rootScope', '$http', 'LeftMenuService', '$window', '$state',
        'CommonDataService', 'RequestService', 'usSpinnerService', 'ModalServiceExt', '$timeout',
        function ($scope, $interval, $rootScope, $http, LeftMenuService, $window, $state, CommonDataService,
            RequestService, usSpinnerService, ModalServiceExt, $timeout) {
            setMenuTemplate();
            // init the left menu for a current user and a current contract account if it's already selected
            $scope.deviceIsWindowsPhone = deviceIsWindowsPhone;
            
            var accountNumber = localStorage.getItem('CurrentAccountNumber');
            LeftMenuService.changeAccount(accountNumber);

            $scope.leftMenu = LeftMenuService;
            $scope.isMenuLoaded = false;
            $scope.signOut = LeftMenuService.signOut;
            $scope.isAdmin = utilli.isAdmin;
            $scope.isPx = utilli.isPx();

            $rootScope.$on('profile-updated', function (event, args) {
                var accountNumber = localStorage.getItem('CurrentAccountNumber');
                LeftMenuService.changeAccount(accountNumber);
            })

            $scope.goTo = function (state, contractAccountNumber) {
                
                // NB!!!: this goTo is for unusual cases such as customer view in admin or for assistants where we
                // change current contract account when the user clicks on the left menu item.
                // for regular navigation we use ng-href because this way it's possible to open pages in separate tab
                // by ctrl+click or middle mouse button click.

                usSpinnerService.stop('spinner-1');
                if ($window.slideout)
                    $window.slideout.toggle();
                else
                    if ($window.snapper) {
                        $window.snapper.close();
                    }
                RequestService.abort();
                // contractAccountNumber is not empty for second level menu items in assistants
                if (contractAccountNumber){
                    LeftMenuService.selectContractAccount(contractAccountNumber, state);
                    // return because state.go happens in LeftMenuService.selectContractAccount
                    return;
                }

                if ($scope.checkAccess(state) && utilli.isAdmin) {
                    // We should set options.reload as state name instead of 'true', because if we set it as 'true' 
                    // all the parent states of the target state will reload with their previous parameters 
                    // that can be not actual for the moment (at list for the nested customer app in the admin portal) 
                    // and we will have tricky issues with wrong data.
                    $state.goMainLayout(state, {}, { reload: state });
                } else {
                    $state.goMainLayout(state, {}, { reload: state });
                }
            };

            var mapping = {
                'AccountList': '#account-manager-menu-items',
                'Profile': '#account-manager-menu-items',
                'ChangePassword': '#account-manager-menu-items',

                'PayNow': '#bill-payment-menu-items',
                'PaymentOptions': '#bill-payment-menu-items',
                'BillsAndPayments': '#bill-payment-menu-items',
                'PropertyManagerBills': '#bill-payment-menu-items',

                'Messages': '#notifications-menu-items',
                'Preferences': '#notifications-menu-items',

                'ReportOutage': '#outage-center-menu-items',
                'OutageMap': '#outage-center-menu-items',
                'OutageList': '#outage-center-menu-items',
                'OutageCenter': '#outage-center-menu-items',

                'MeterData': '#service-center-menu-items',
                'MoveService': '#service-center-menu-items',
                'CancelService': '#service-center-menu-items',
            }

            var expandCurrentMenuItem = function () {
                var menuElement;
                // don't expand for sub-menu-items for assistants because we do it right after loading
                // top 3 search history items in LeftMenuService.loadTop3SearchHistoryItems
                if (utilli.hasAssistantRole() && (LeftMenuService.currentTab === 'Dashboard' 
                    || LeftMenuService.currentTab === 'BillsAndPayments')) {
                    return;
                }
                menuElement = $(mapping[LeftMenuService.currentTab]);
                menuElement.collapse();
            };
            // includeContentLoaded here because left menu is loaded via ngInclude
            $scope.$on('$includeContentLoaded', function(){
                // nest function here for easy debug
                expandCurrentMenuItem(); 
            });

            $scope.checkAccess = function (e, stateName) {
                var isAccountDataValid = utilli.localStorageItemNotNull('CurrentAccountNumber') && utilli.localStorageItemNotNull('CurrentUtilityType'); 
                if (utilli.hasAgentRole() && isProtectedPage(stateName) && !isAccountDataValid) {
                    e.preventDefault();
                    ModalServiceExt.showInfo($scope._t("You need to choose a contract account (by search or search history pages)."));
                    return false;
                }

                return true;
            }

            function isProtectedPage (stateName) {
                var result = stateName == 'Dashboard' || stateName  == 'BillsAndPayments' || stateName  == 'MeterData';
                return result;
            }

            function itemNotNull(name) {
                var result = localStorage.getItem(name) != null && localStorage.getItem(name) != "null";
                return result;
            }

            $scope.getStateRef = function (stateName) {
                if (utilli.isAdmin) {
                    return '';
                } else {
                    return $state.href('MainLayout.' + stateName);
                }
            }

            CommonDataService.getCommonData()
                .then(function (commonData) {
                    LeftMenuService.currentMenu.OutageCenter.isVisible = commonData.EnableOutageMap;
                    LeftMenuService.currentMenu.CancelService.isVisible = commonData.EnableCancelService;
                    LeftMenuService.currentMenu.MoveService.isVisible = commonData.EnableMoveService;
                    LeftMenuService.currentMenu.MeterData.isVisible = commonData.EnableMeterDataPage;
                    LeftMenuService.currentMenu.EnergyEfficiency.isVisible = commonData.EnableEnergyEfficiencyPage;
                    LeftMenuService.currentMenu.ProgramEnrolments.isVisible = commonData.EnableProgramEnrolments;
                    $scope.isMenuLoaded = true;
                },
                    function () {
                        $scope.isMenuLoaded = true;
                        // error handling happens in other places for getCommonData
                    }
                );

            function setMenuTemplate() {
                if (utilli.hasAgentRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/Agents/LeftMenu.html' : 'Pages/Agents/LeftMenu.html';
                else if (utilli.hasAssistantRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/Assistants/LeftMenu.html' : 'Pages/Assistants/LeftMenu.html';
                else if (utilli.hasPropertyManagerRole())
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/PropertyManagers/LeftMenu.html' : 'Pages/PropertyManagers/LeftMenu.html';
                else if (utilli.hasFieldServiceEngineerRole()) {
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/FieldServiceEngineer/LeftMenu.html' : 'Pages/FieldServiceEngineer/LeftMenu.html';

                    // todo: remove the code below from left menu. and make sure that it doesn't lead to errors in console for regular users
                    // var sendCurrentPositionToServer = function ()
                    // {
                    //     navigator.geolocation.getCurrentPosition(function (location) {
                    //         console.log(location.coords.latitude);
                    //         console.log(location.coords.longitude);
                    //         console.log(location.coords.accuracy);

                    //         $http({
                    //             url: localStorage.getItem('ApiUrl') + 'api/TurnOffService/ReportCoordinates/',
                    //             method: "POST",
                    //             params: {
                    //                 Id: 1,
                    //                 Longitude: location.coords.longitude,
                    //                 Latitude: location.coords.latitude
                    //             }
                    //         }).success(function (response) {
                    //         }).error(function () {
                    //         });
                    //     });
                    // }
                    // var updateWorkCentersPositionsInterval = $interval(sendCurrentPositionToServer, 1500);
                    //setInterval(sendCurrentPositionToServer, 5000);
                }
                else
                    $scope.menuTemplate = utilli.isAdmin ? '../Pages/LeftMenu.html' : 'Pages/LeftMenu.html';
            }

            // $scope.$on("$destroy", function () {
            //     $interval.cancel(updateWorkCentersPositionsInterval);
            // });
        }]);